import React, { useContext, useEffect, useState } from "react";
import ErrorField from "../../../Components/ErrorField";
import {
  DiscontinuationReason,
  HTTPResponse,
  PageDesignConstants,
  RRMMCohortTreatment,
  SideMenuItems,
  ToastMessageType,
  ToastMessages,
} from "../../../Helpers/Enums";
import SideBarMenu from "../../../Components/SideBarMenu";
import dayjs from "dayjs";
import {
  AllowNumericWithDecimal,
  AllowOnlyNonZeroNumeric,
  CheckDateValidationQ36,
  DateInRange,
  GetLocalStorageData,
  GetLoggedInUserID,
  GetOrdinal,
  IsAdmin,
  IsDateAfter,
  IsDateLessThanThirtyDays,
  IsLessOrEqual,
  isStringEmpty,
  IsValidDateValue,
  isValidNumberRange,
  ValidateQ26LastAdministrationMatch,
} from "../../../Helpers/Utilities";
import PatientDetails from "../../../Components/PatientInformation";
import SaveAndNavigate from "../../../Components/SaveAndNavigate";
import {
  CommonError_Msgs,
  ELCharacteristics_MSGS,
  hyperlinkTextQ36Elrexfio,
  hyperlinkTextQ36Linvoseltamab,
  hyperlinkTextLineOfTherapy,
} from "../../../Helpers/HelperText";
import { AppContext } from "../../../Contexts/AppContextProvider";
import { AdditionalTreatmentService } from "../../../WebApiServices/AdditionalTreatment.service";

import InfoPopUp from "../../../Components/InfoPopUp";
import DatePickerComponent from "../../../Components/DatePickerComponent";

const ELCharacteristics = () => {
  const storedData = GetLocalStorageData("CohortTreatment");
  const pid = GetLocalStorageData("patientId") ?? 0;

  const [isNewEcrfA, setIsNewEcrfA] = useState(false);

  const [ndmmAvailable, setNdmmAvailable] = useState(false);

  const [elrexDuplicateDates, setElrexDuplicateDates] = useState(false);
  const [linvoDuplicateDates, setLinvoDuplicateDates] = useState(false);

  const [isElrexvayliSelected, setElrexvayliSelected] = useState(false);
  const [isLinvoveySelected, setLinvoveySelected] = useState(false);

  const [indexDateRRMM_elrHard, setIndexDateRRMM_elrHard] = useState(null);
  const [indexDateRRMM_linvoHard, setIndexDateRRMM_linvoHard] = useState(null);

  const [elrNumberofAdministrator, setElrNumberofAdministrator] =
    useState(null);
  const [linvoNumberofAdministrator, setLinvoNumberofAdministrator] =
    useState(null);

  const [elrHospDateChainInvalid, setElrHospDateChainInvalid] = useState(false);
  const [linvoHospDateChainInvalid, setLinvoHospDateChainInvalid] =
    useState(false);

  const [
    elrNumberofAdministratorMatching,
    setElrNumberofAdministratorMatching,
  ] = useState(false);
  const [
    linvoNumberofAdministratorMatching,
    setLinvoNumberofAdministratorMatching,
  ] = useState(false);

  const [isElrLastAdminDateValid, setIsElrLastAdminDateValid] = useState(true);
  const [isLinvoLastAdminDateValid, setIsLinvoLastAdminDateValid] =
    useState(true);

  const [elrvayliDateRRMM, setElrvayliDateRRMM] = useState(
    "[Bispecifics/CAR-T end of follow up]",
  );
  const [linvoveyDateRRMM, setLinvoveyDateRRMM] = useState(
    "[Bispecifics/CAR-T end of follow up]",
  );

  const [Q39ElrexConditionMet, setQ39ElrexConditionMet] = useState(false);
  const [Q39LinvoConditionMet, setQ39LinvoConditionMet] = useState(false);

  // Q36 Warnings
  const [elrexfioDuplicatePhaseWarning, setElrexfioDuplicatePhaseWarning] =
    useState(null);
  const [linvoDuplicatePhaseWarning, setLinvoDuplicatePhaseWarning] =
    useState(null);
  const [elrexfioMissingStepUpWarning, setElrexfioMissingStepUpWarning] =
    useState(false);
  const [linvoMissingStepUpWarning, setLinvoMissingStepUpWarning] =
    useState(false);

  // Q36.1 - Warning for missing hospitalization when inpatient setting exists
  const [elrInpatientHospMissing, setElrInpatientHospMissing] = useState(false);
  const [linvoInpatientHospMissing, setLinvoInpatientHospMissing] =
    useState(false);

  const [rrmmAvailable, setRRMMAvailable] = useState(false);

  const [elrexIndexDate, setElrexIndexDate] = useState("");
  const [linvoIndexDate, setLinvoIndexDate] = useState("");
  const [endOfFollowUpDate, setEndOfFollowUpDate] = useState("");
  const [elrexfioLOTStartDate, setElrexfioLOTStartDate] = useState("");
  const [linvoseltamabLOTStartDate, setLinvoseltamabLOTStartDate] =
    useState("");
  const [patientDeathDate, setPatientDeathDate] = useState(null);

  const [
    showHideHyperlinkModalQ36Tecvayli,
    setShowHideHyperlinkModalQ36Tecvayli,
  ] = useState(false);
  const [
    showHideHyperlinkModalQ36Linvoseltamab,
    setShowHideHyperlinkModalQ36Linvoseltamab,
  ] = useState(false);

  const Q26AllRecords = {
    bispecificQ26ModelId: 0,
    cohorttreatmentid: 0,
    lotNumber: null,

    firstAdministrationDt: null,
    lastAdministrationDt: null,
  };

  const Q331AAllRecords = {
    bispecificQ26ModelId: 0,
    cohorttreatmentid: 0,
    lotNumber: null,

    firstAdministrationDt: null,
    lastAdministrationDt: null,
  };

  const NdmmAllRecords = {
    ndmmModelId: 0,
    cohorttreatmentid: 0,
    lotNumber: null,

    startLotDt: null,
    endLotDt: null,
  };

  const [bispecificQ26Data, setBispecificQ26Data] = useState([Q26AllRecords]);
  const [bispecificQ331AData, setBispecificQ331AData] = useState([
    Q331AAllRecords,
  ]);

  const [bispecificQ31Q32Data, setBispecificQ31Q32Data] = useState([
    Q26AllRecords,
  ]);

  const [ndmmLotData, setNdmmLotData] = useState([NdmmAllRecords]);

  const [showLineOfTherapyModal, setShowLineOfTherapyModal] = useState(false);

  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    isSideMenuActive,
    setIsSideMenuActive,
  } = useContext(AppContext);

  const [showTopErrMsg, setShowTopErrMsg] = useState(false);

  let cohortTreatmentModelListt = [];
  if (storedData) {
    cohortTreatmentModelListt = JSON.parse(storedData);
  }
  const TTIsPresent = cohortTreatmentModelListt.some(
    (treatment) =>
      (treatment.cohortTreatmentID === 9 ||
        treatment.cohortTreatmentID === 10) &&
      treatment.isEligible === true,
  );

  const navigatePaths = {
    prevPage: TTIsPresent
      ? "/TTCharacteristics"
      : ndmmAvailable
        ? "/NDMMSCTCharacteristics"
        : "/NonCohortDefiningTreatment",
    currPage: "/ELCharacteristics",
    nextPage: rrmmAvailable ? "/CarTCharacteristics" : "/IMWGReporting",
  };

  const ElrexvayliRow = {
    elrexlinvodosagebridgeid: 0,
    cohorttreatmentid: isElrexvayliSelected ? RRMMCohortTreatment.ELREXFIO : 0, // GetLocalStorageData("elrexvayliID") || 0

    //ELREXFIO
    dose_administration_elr: null,
    dosing_phase_elr: null,
    siteofcare_elr: null,
    // dt_admission_elr: null,
    //dt_discharge_elr: null,
    elr_dose_strength_rbl: null,
    elr_dose_strength_mg: "",
    elr_dose_strength_mg_kg: "",
    elr_dose_strength_mgm: "",
    elr_dose_strength_mg_kgHard: false,
    elr_dose_strength_mg_kgRange: false,

    dose_administration_elr_dt: "",
    dt_admission_elr_dt: "",
    dt_discharge_elr_dt: "",

    dosing_phase_elrHard_othEmpty: false,
    dose_administration_elrHard: false,
    dosing_phase_elrHard: false,
    siteofcare_elrHard: false,
    dt_admission_elrHard: false,
    dt_discharge_elrHard: false,

    dose_administration_elrHard_dt: false,
    Invalid_dose_administration_elr_dt: false,
    dt_admission_elrHard_dt: false,
    dt_discharge_elrHard_dt: false,
    dt_admission_elrHard_dt_check: false,
    dt_discharge_elrHard_dt_check: false,
    dose_administration_elr_dt_before_eof: false,
    // dt_elr_greater_prevCheck: false,
    dt_elr_date_out_of_bound: false,

    Q36ElrexConditionMet: false,

    //new
    dosing_phase_oth_txt_elr: "",
  };

  const LinvoveyRow = {
    elrexlinvodosagebridgeid: 0,
    cohorttreatmentid: isLinvoveySelected
      ? RRMMCohortTreatment.Linvoseltamab
      : 0, //GetLocalStorageData("linvoveyID") || 0

    //LINVOSELTAMAB

    dose_administration_linvo: null,
    dosing_phase_linvo: null,
    siteofcare_linvo: null,
    //dt_admission_linvo: null,
    // dt_discharge_linvo: null,
    linvo_dose_strength_rbl: null,
    linvo_dose_strength_mg: "",
    linvo_dose_strength_mg_kg: "",
    linvo_dose_strength_mgm: "",
    linvo_dose_strength_mg_kgHard: false,
    linvo_dose_strength_mg_kgRange: false,

    dose_administration_linvo_dt: "",
    Invalid_dose_administration_linvo_dt: false,
    dt_admission_linvo_dt: "",
    dt_discharge_linvo_dt: "",

    dose_administration_linvoHard: false,
    dosing_phase_linvoHard: false,
    siteofcare_linvoHard: false,
    dt_admission_linvoHard: false,
    dt_discharge_linvoHard: false,

    dose_administration_linvoHard_dt: false,
    dt_admission_linvoHard_dt: false,
    dt_discharge_linvoHard_dt: false,

    dt_admission_linvoHard_dt_check: false,
    dt_discharge_linvoHard_dt_check: false,

    // dt_linvo_greater_prevCheck: false,
    dt_linvo_date_out_of_bound: false,

    //Q36LinvoConditionMet: false,
    dosing_phase_oth_txt_linvo: "",
    dosing_phase_linvoHard_othEmpty: false,

    duplicateDateCheck: false,
    sequentialLOTError: false,
  };
  //36.1
  const HospitalizationRow = {
    elrexlinvohospitalizationbridgeid: 0,
    elrexlinvodosagebridgeid: 0,
    cohorttreatmentid: 0,
    //B
    dt_admission: null,
    dt_admission_dt: "",
    dt_admission_Hard: false,
    dt_admission_Hard_dt: false,
    // dt_admission_Hard_dt_check: false,
    dt_admission_out_of_bound: false,
    Invalid_admission_Hard_dt: false,
    dt_admission_before_eof: false,

    //C
    dt_discharge: null,
    dt_discharge_dt: "",
    dt_discharge_Hard: false,
    dt_discharge_Hard_dt: false,
    dt_discharge_Hard_dt_check: false,
    dt_discharge_out_of_bound: false,
    dateRangeThirty: false,
    Invalid_dt_discharge_Hard: false,
    dt_discharge_before_eof: false,
    //D
    hospReason1: false,
    hospReason2: false,
    hospReason3: false,
    hospReason4: false,
    hospReason5: false,
    hospReason6: false,
    hosp_reason_oth_txt: "",
    hospReasonUnk: false,
    hospReasonEmptyHard: false,
    hospReasonTxtEmpty: false,
  };

  const Q37ElrexRow = {
    elrexlinvocharacteristicsid: 0,
    cohorttreatmentid: isElrexvayliSelected ? RRMMCohortTreatment.ELREXFIO : 0, //GetLocalStorageData("elrexvayliID") || 0
    Q37ElrexvayliRd: null,

    q37ElrexvayliEmpty: false,

    q37_Elr_Dose_week_frquencyRd: null,
    q37_Elr_Dose_week_frquency_txt: "",
    q37_Elr_Dose_week_frquencyRd_Empty: false,
    q37_Elr_Dose_week_frquency_txt_Empty: false,
    q37_Elr_Dose_week_freq_range: false,
    q37SubsequentDoseConflict: false,

    q37ElrDosageRd: null, // 1 = 76 mg, 2 = Other, 99 = Unknown
    q37ElrDosageOtherTxt: "",
    q37ElrDosageRdEmpty: false,
    q37ElrDosageOtherTxtEmpty: false,

    //40
    Q40dosingfreqRd: null,
    Q40IgILevelRd: null,
    Q40init_dt_Rd: null,
    Q40init_dt: "",
    primaryProf: false,
    secondaryProf: false,
    otherReson: false,
    InvalidQ40init_dt: false,
    init_dt_before_eof: false,

    dosing_freq_oth_txt: "",
    showDateRedFreqElr: false,

    //40 validations state
    Q40DosingFreqEmptyHard: false,
    Q40DosingFreqTxtEmptyHard: false,
    Q40IgGEmptyHard: false,
    Q40Init_dtHard: false,
    Q40Init_RdHard: false,
    Q40ReasonEmptyHard: false,

    //39
    tocilizumab_elr: false,
    Granulocyte: false,
    noneoftheabove_elr: null,
    SteroidsElr: false,

    //39 - 1.1
    cytokin_elr: false,
    secondary_prophylactic_crs_elr: false,
    crs_elr: false,
    neurotoxicity_elr: false,
    secondary_neurotoxicity_elr: false,
    tmt_neurotoxicity_elr: false,
    tmt_elr_unknown: false,
    Q39elrReasonHard: false,

    // New Phase 39.2
    steroid_pre_tmt_elr: false,
    cytokin_elr_steroids: false,
    secondary_prophylactic_elr_steroids: false,
    crs_elr_steroids: false,
    neurotoxicity_elr_steroids: false,
    secondary_neurotoxicity_elr_steroids: false,
    tmt_neurotoxicity_elr_steroids: false,
    tmt_steroids_elr_unknown: false,

    //Tecvayli New column
    betamethasone_elr: false,
    betamethasone_elrNum: "",

    betamethasone_elr_txtEmpty: false,

    dexamethasone_elr: false,
    dexamethasone_elrNum: "",

    dexamethasone_elr_txtEmpty: false,

    hydrocortisone_elr: false,
    hydrocortisone_elrNum: "",

    hydrocortisone_elr_txtEmpty: false,

    methylprednisolone: false,
    methylprednisoloneNum: "",
    methylprednisolone_txtEmpty: false,

    prednisolone_elr: false,
    prednisolone_elrNum: "",
    prednisolone_elr_txtEmpty: false,

    prednisone_elr: false,
    prednisone_elrNum: "",

    prednisone_elr_txtEmpty: false,

    triamcinolone_elr: false,
    triamcinolone_elrNum: "",
    triamcinolone_elr_txtEmpty: false,

    dose_name_elr_unknown: false,

    name_dose_steroidsHardEmpty: false,
    steroids_elr_txtEmpty: false,

    //39.3
    prophylactic_use_elr: false,
    secondary_prophylactic_use_elr: false,
    oth_use_elr: false,
    unknown_elr: null,

    Q39ElrEmptyHard: false,
    Q39elrGranduloEmptyHard: false,

    Q39elrSteroidsEmptyHard: false,
  };

  // Q39.1.A
  const q391AElrRow = {
    cohorttreatmentid: RRMMCohortTreatment.ELREXFIO,
    tocilizumabmedicationid: 0,
    patientid: 0,
    //checkbox
    primaryProphylacticCrs_elr: false,
    secondaryProphylacticCrs_elr: false,
    supportiveCareCrs_elr: false,
    primaryProphylacticNeurologic_elr: false,
    secondaryProphylacticNeurologic_elr: false,
    supportiveCareNeurologic_elr: false,
    medicationReasonUnk_elr: false,
    q39ElrReasonEmpty: false,

    //date
    administrationDate_elr: null,
    administrationDateRD_elr: null,
    q39ElrInvalidAdministrationDate: false,
    q39ElrAdministrationDateEmpty: false,
    q39ElrAdministrationRDEmpty: false,
  };

  const q391ALinvoRow = {
    cohorttreatmentid: RRMMCohortTreatment.Linvoseltamab,
    tocilizumabmedicationid: 0,
    patientid: 0,
    //checkbox
    primaryProphylacticCrs_linvo: false,
    secondaryProphylacticCrs_linvo: false,
    supportiveCareCrs_linvo: false,
    primaryProphylacticNeurologic_linvo: false,
    secondaryProphylacticNeurologic_linvo: false,
    supportiveCareNeurologic_linvo: false,
    medicationReasonUnk_linvo: false,
    q39LinvoReasonEmpty: false,

    //date
    administrationDate_linvo: null,
    administrationDateRD_linvo: null,
    q39LinvoInvalidAdministrationDate: false,
    q39LinvoAdministrationDateEmpty: false,
    q39LinvoAdministrationRDEmpty: false,
  };

  const Q37LinvoRow = {
    elrexlinvocharacteristicsid: 0,
    cohorttreatmentid: isLinvoveySelected
      ? RRMMCohortTreatment.Linvoseltamab
      : 0, //GetLocalStorageData("linvoveyID") || 0
    Q37LinvoveyRd: null,

    q37LinvoveyEmpty: false,

    showDateRedFreqLinvo: false,

    //New Column Q37
    q37_Linvo_Dose_week_frquencyRd: null,
    q37_Linvo_Dose_week_frquency_txt: "",
    q37_Linvo_Dosage_Rd: null,
    q37_Linvo_Dosage_OtherTxt: "",

    q37_Linvo_Dose_week_frquencyRd_Empty: false,
    q37_Linvo_Dose_week_frquency_txt_Empty: false,
    q37_Linvo_Dose_week_freq_range: false,

    q37LinvoSubsequentDoseConflict: false,

    q37_Linvo_Dosage_Rd_Empty: false,
    q37_Linvo_Dosage_OtherTxt_Empty: false,

    //linvoseltamab new column
    betamethasone_linvo: false,
    betamethasone_linvoNum: "",

    dexamethasone_linvo: false,
    dexamethasone_linvoNum: "",

    hydrocortisone_linvo: false,
    hydrocortisone_linvoNum: "",

    methylprednisolone_linvo: false,
    methylprednisolone_linvoNum: "",

    prednisolone_linvo: false,
    prednisolone_linvoNum: "",

    prednisone_linvo: false,
    prednisone_linvoNum: "",

    triamcinolone_linvo: false,
    triamcinolone_linvoNum: "",

    dose_name_linvo_unknown: false,

    name_dose_steroids_linvoHardEmpty: false,
    steroids_linvo_txtEmpty: false,

    //39
    tocilizumab_linvo: false,
    Steroids: false,
    granulocyte_linvo: false,
    noneoftheabove_linvo: null,

    //39.1
    cytokin_linvo: false,
    secondary_prophylactic_crs_linvo: false,
    crs_linvo: false,
    neurotoxicity_linvo: false,
    secondary_neurotoxicity_linvo: false,
    tmt_neurotoxicity_linvo: false,
    tmt_linvoseltamab_unknown: false,

    //39.2
    steroid_pre_tmt_linvo: false,
    cytokin_linvo_steroids: false,
    secondary_prophylactic_linvo_steroids: false,

    crs_linvo_steroids: false,
    neurotoxicity_linvo_steroids: false,
    secondary_neurotoxicity_linvo_steroids: false,
    tmt_neurotoxicity_linvo_steroids: false,
    tmt_linvo_unknown: false,

    //Q39.3
    prophylactic_use_linvo: false,
    secondary_prophylactic_use_linvo: false,
    oth_use_linvo: false,
    unknown_linvo: null,

    Q39LinvoEmptyHard: false,
    Q39linvoReasonHard: false,
    Q39linvoSteroidsEmptyHard: false,
    Q39linvoGranduloEmptyHard: false,

    //40
    q40DosingFreqRd_linvo: null,
    q40IgILevelRd_linvo: null,
    q40Init_Dt_Rd_linvo: null,
    q40Init_Dt_linvo: "",
    primaryProf_linvo: false,
    secondaryProf_linvo: false,
    otherReson_linvo: false,
    invalidQ40Init_dt_linvo: false,
    init_dt_before_eof_linvo: false,

    dosing_Freq_Oth_Txt_linvo: "",

    //40 validations state
    Q40LinvoDosingFreqEmptyHard: false,
    Q40LinvoDosingFreqTxtEmptyHard: false,
    Q40LinvoIgGEmptyHard: false,
    Q40LinvoInit_dtHard: false,
    Q40LinvoInit_RdHard: false,
    Q40LinvoReasonEmptyHard: false,
  };

  const Q38ElrexRow = {
    elrexlinvodosefrequencybridgeid: 0,
    cohorttreatmentid: isElrexvayliSelected ? RRMMCohortTreatment.ELREXFIO : 0, //GetLocalStorageData("elrexvayliID") || 0

    Q38ElrexvayliRd: null,
    dt_dosefreq_elr_dt: "",
    Invalid_dt_dosefreq_elr_dt: false,

    Q38ElrexEmptyHard: false,
    Q38DateEmpty: false,
    Q38ElrexDateInvalid: false,

    q38_Elr_Dose_week_frquencyRd: null,
    q38_Elr_Dose_week_frquency_txt: "",

    q38_Elr_Dose_week_frquencyRd_Empty: false,
    q38_Elr_Dose_week_frquency_txt_Empty: false,
    q38ElrDoseFrequencyConflict: false,
  };

  const Q38LinvoRow = {
    elrexlinvodosefrequencybridgeid: 0,
    cohorttreatmentid: isLinvoveySelected
      ? RRMMCohortTreatment.Linvoseltamab
      : 0, //GetLocalStorageData("linvoveyID") || 0

    Q38LinvoveyRd: null,
    dt_dosefreq_linvo_dt: "",

    InvalidQ38Linvoveydate: false,

    Q39LinvoDateInvalid: false,

    Q38LinvoEmptyHard: false,
    Q38LinvoDateEmpty: false,
    Q38LinvoDateInvalid: false,

    q38_Linvo_Dose_week_frquencyRd: null,
    q38_Linvo_Dose_week_frquency_txt: "",
    q38_Linvo_Dosage_Rd: null,
    q38_Linvo_Dosage_OtherTxt: "",

    q38_Linvo_Dose_week_frquencyRd_Empty: false,
    q38_Linvo_Dose_week_frquency_txt_Empty: false,
    q38_Linvo_Dosage_Rd_Empty: false,
    q38_Linvo_Dosage_OtherTxt_Empty: false,
    q38LinvoDoseFrequencyConflict: false,
  };

  // Q38.1.A

  const Q381AElrexRow = {
    teclistamatalquetamabdosefrequencyinfobridgeid: 0,
    cohorttreatmentid: isElrexvayliSelected ? RRMMCohortTreatment.ELREXFIO : 0,

    // Column B - Type of change
    changeType: null, // 1=No changes, 2=Frequency, 3=Strength, 99=Unknown
    changeTypeDoseFrequency: null, // 1=Increase, 2=Decrease
    changeTypeDoseStrength: null, // 1=Increase, 2=Decrease

    // Column C - Reasons (multi-select arrays)
    selectedReasons: [], // Array of bispecifictreatmentdiscontinuationreasonid
    selectedAEReasons: [], // Array of bispecifictreatmentdiscontinuationreasonaeid
    reasonOtherText: "", // For "Other" reason (ID=14)
    reasonUnknown: false,
    neurologicAEReasonList: [],
    // Column D - Pattern BEFORE change
    patterBeforeChangeDoseFrequency: null, // 1=times/week, 2=every X weeks, 99=Unknown
    patterBeforeChangeDoseFrequencyTimesPerWeek: "",

    patterBeforeChangeDoseFrequencyWeek: "", // Integer 0-10
    patterBeforeChangeDoseStrength: null, // 1=mg, 2=mg/kg, 3=mg/m², 99=Unknown

    patterBeforeChangeDoseStrengthMg: "", // For radio value 1
    patterBeforeChangeDoseStrengthMgKg: "", // For radio value 2
    patterBeforeChangeDoseStrengthMgM2: "", // For radio value 3

    // Column E - Pattern AFTER change
    patterAfterChangeDoseFrequency: null,
    patterAfterChangeDoseFrequencyWeek: "",
    patterAfterChangeDoseFrequencyTimesPerWeek: "",
    patterAfterChangeDoseStrength: null,

    patterAfterChangeDoseStrengthMg: "", // For radio value 1
    patterAfterChangeDoseStrengthMgKg: "", // For radio value 2
    patterAfterChangeDoseStrengthMgM2: "", // For radio value 3

    // Column F - Date of change
    dateChangeRd: null, // 1=Date provided, 99=Unknown
    dateChange: "",

    // ========================================
    // VALIDATION FLAGS - HARD ERRORS
    // ========================================
    // Column B validations
    changeTypeEmpty: false,
    changeTypeDoseFrequencyEmpty: false,
    changeTypeDoseStrengthEmpty: false,

    // Column C validations
    reasonEmpty: false,
    deathDtWarning: false,
    reasonOtherTextEmpty: false,
    aeSubReasonEmpty: false,
    neuroReasonEmpty: false,
    neuroOtherTextEmpty: false,

    // Column D validations (Pattern BEFORE)
    patternBeforeFrequencyEmpty: false,
    patternBeforeFrequencyRangeInvalid: false,

    patternBeforeStrengthEmpty: false,
    patternAfterFrequencyRangeInvalid: false,

    // Column E validations (Pattern AFTER)
    patternAfterFrequencyEmpty: false,
    patternAfterStrengthEmpty: false,
    patternAfterStrengthRangeInvalid: false,

    // Column F validations
    dateChangeRdEmpty: false,
    dateChangeEmpty: false,
    invalidDateChange: false,
    dateChangeOutOfBound: false,
    dateChangeBeforeEOF: false,

    // ========================================
    // CONFLICT VALIDATIONS (HARD ERRORS)
    // ========================================
    frequencyIncreaseConflict: false,
    frequencyDecreaseConflict: false,
    strengthIncreaseConflict: false,
    strengthDecreaseConflict: false,

    // ========================================
    // WARNING FLAGS
    // ========================================
    patternBeforeUnknownWarning: false,
    patternAfterUnknownWarning: false,
  };

  const [Q381AElrexDetails, setQ381AElrexDetails] = useState([Q381AElrexRow]);
  const Q381ALinvoRow = {
    teclistamatalquetamabdosefrequencyinfobridgeid: 0,
    cohorttreatmentid: isLinvoveySelected
      ? RRMMCohortTreatment.Linvoseltamab
      : 0,

    // Column B - Type of change
    changeType: null, // 1=No changes, 2=Frequency change, 3=Strength change, 99=Unknown
    changeTypeDoseFrequency: null, // 1=Increase, 2=Decrease (only if changeType === 2)
    changeTypeDoseStrength: null, // 1=Increase, 2=Decrease (only if changeType === 3)

    // Column C - Reasons for change (multi-select)
    selectedReasons: [],
    selectedAEReasons: [],
    neurologicAEReasonList: [],
    reasonOtherText: "",
    reasonUnknown: false,
    reasonList: [],
    // Column D - Pattern BEFORE change
    patterBeforeChangeDoseFrequency: null,
    patterBeforeChangeDoseFrequencyTimesPerWeek: "",

    patterBeforeChangeDoseFrequencyWeek: "",
    patterBeforeChangeDoseStrength: null,

    patterBeforeChangeDoseStrengthMg: "",
    patterBeforeChangeDoseStrengthMgKg: "",
    patterBeforeChangeDoseStrengthMgM2: "",

    // Column E - Pattern AFTER change
    patterAfterChangeDoseFrequency: null,
    patterAfterChangeDoseFrequencyTimesPerWeek: "",
    patterAfterChangeDoseFrequencyWeek: "",
    patterAfterChangeDoseStrength: null,

    patterAfterChangeDoseStrengthMg: "",
    patterAfterChangeDoseStrengthMgKg: "",
    patterAfterChangeDoseStrengthMgM2: "",

    // Column F - Date of change
    dateChangeRd: null, // 1=Date provided, 99=Unknown
    dateChange: "", // DateTime

    // Validation flags
    changeTypeEmpty: false,
    changeTypeDoseFrequencyEmpty: false,
    changeTypeDoseStrengthEmpty: false,
    reasonEmpty: false,
    deathDtWarning: false,
    reasonOtherTextEmpty: false,
    patternBeforeFrequencyEmpty: false,
    patternBeforeFrequencyRangeInvalid: false,
    patternBeforeStrengthEmpty: false,
    patternAfterFrequencyEmpty: false,
    patternAfterFrequencyRangeInvalid: false,
    patternAfterStrengthEmpty: false,
    patternAfterStrengthRangeInvalid: false,
    dateChangeEmpty: false,
    dateChangeRdEmpty: false,
    invalidDateChange: false,
    dateChangeOutOfBound: false,
    dateChangeBeforeEOF: false,
    aeSubReasonEmpty: false,
    neuroReasonEmpty: false,
    neuroOtherTextEmpty: false,

    // Conflict validations
    frequencyIncreaseConflict: false,
    frequencyDecreaseConflict: false,
    strengthIncreaseConflict: false,
    strengthDecreaseConflict: false,

    // Warning flags
    patternBeforeUnknownWarning: false,
    patternAfterUnknownWarning: false,
  };

  const [Q381ALinvoDetails, setQ381ALinvoDetails] = useState([Q381ALinvoRow]);

  // Q38.2.A
  const Q382AElrexRow = {
    teclistamatalquetamabdosefrequencyinfobridgeid: 0,
    cohorttreatmentid: isElrexvayliSelected ? RRMMCohortTreatment.ELREXFIO : 0,

    // Column B - Type of change
    changeType: null, // 1=No changes, 2=dose interruption, 99=Unknown

    // Column C - Reasons (multi-select arrays)
    selectedReasons: [], // Array of bispecifictreatmentdiscontinuationreasonid
    selectedAEReasons: [], // Array of bispecifictreatmentdiscontinuationreasonaeid
    reasonOtherText: "", // For "Other" reason (ID=14)
    reasonUnknown: false,
    neurologicAEReasonList: [],

    // Column D - Pattern BEFORE change
    startDateChangeRd: null, // 1=Date provided, 99=Unknown
    startDateChange: "",

    // Column E - Date of change
    endDateChangeRd: null, // 1=Date provided, 99=Unknown
    endDateChange: "",

    // ========================================
    // VALIDATION FLAGS - HARD ERRORS
    // ========================================
    // Column B validations
    changeTypeEmpty: false,

    // Column C validations
    reasonEmpty: false,
    deathDtWarning: false,
    reasonOtherTextEmpty: false,
    aeSubReasonEmpty: false,
    neuroReasonEmpty: false,
    neuroOtherTextEmpty: false,

    // Column D validations
    startDateChangeRdEmpty: false,
    startDateChangeEmpty: false,
    invalidStartDateChange: false,
    startDateChangeOutOfBound: false,

    // Column E validations
    endDateChangeRdEmpty: false,
    endDateChangeEmpty: false,
    invalidEndDateChange: false,
    endDateChangeOutOfBound: false,

    // ========================================
    // WARNING FLAGS
    // ========================================
    interruptionStartDateUnknownWarning: false,
    interruptionEndDateUnknownWarning: false,
  };

  const [Q382AElrexDetails, setQ382AElrexDetails] = useState([Q382AElrexRow]);
  const Q382ALinvoRow = {
    teclistamatalquetamabdosefrequencyinfobridgeid: 0,
    cohorttreatmentid: isLinvoveySelected
      ? RRMMCohortTreatment.Linvoseltamab
      : 0,

    // Column B - Type of change
    changeType: null, // 1=No changes, 2=Frequency change, 3=Strength change, 99=Unknown

    // Column C - Reasons for change (multi-select)
    selectedReasons: [],
    selectedAEReasons: [],
    neurologicAEReasonList: [],
    reasonOtherText: "",
    reasonUnknown: false,
    reasonList: [],

    // Column D - start date change
    startDateChangeRd: null, // 1=Date provided, 99=Unknown
    startDateChange: "",

    // Column E - end Date of change
    endDateChangeRd: null, // 1=Date provided, 99=Unknown
    endDateChange: "", // DateTime

    // Validation flags
    changeTypeEmpty: false,

    reasonEmpty: false,
    deathDtWarning: false,
    reasonOtherTextEmpty: false,
    aeSubReasonEmpty: false,
    neuroReasonEmpty: false,
    neuroOtherTextEmpty: false,

    // Column D validations
    startDateChangeRdEmpty: false,
    startDateChangeEmpty: false,
    invalidStartDateChange: false,
    startDateChangeOutOfBound: false,

    // Column E validations
    endDateChangeRdEmpty: false,
    endDateChangeEmpty: false,
    invalidEndDateChange: false,
    endDateChangeOutOfBound: false,

    // Warning flags
    interruptionStartDateUnknownWarning: false,
    interruptionEndDateUnknownWarning: false,
  };

  const [Q382ALinvoDetails, setQ382ALinvoDetails] = useState([Q382ALinvoRow]);

  const stateResolver = {
    "381A": {
      [RRMMCohortTreatment.ELREXFIO]: [Q381AElrexDetails, setQ381AElrexDetails],
      [RRMMCohortTreatment.Linvoseltamab]: [
        Q381ALinvoDetails,
        setQ381ALinvoDetails,
      ],
    },
    "382A": {
      [RRMMCohortTreatment.ELREXFIO]: [Q382AElrexDetails, setQ382AElrexDetails],
      [RRMMCohortTreatment.Linvoseltamab]: [
        Q382ALinvoDetails,
        setQ382ALinvoDetails,
      ],
    },
  };

  // Static data from DB
  const [reasonsList, setReasonsList] = useState([]); // bispecifictreatmentdiscontinuationreason
  const [aeReasonsList, setAEReasonsList] = useState([]); // bispecifictreatmentdiscontinuationreason_ae

  const [Q37ElrexDetails, setQ37ElrexDetails] = useState([Q37ElrexRow]);
  const [Q37LinvoDetails, setQ37LinvoDetails] = useState([Q37LinvoRow]);

  const [Q38ElrexDetails, setQ38ElrexDetails] = useState([Q38ElrexRow]);
  const [Q38LinvoDetails, setQ38LinvoDetails] = useState([Q38LinvoRow]);

  const [elrexvayliDetails, setElrexvayliDetails] = useState([ElrexvayliRow]);
  const [linvoveyDetails, setLinvoveyDetails] = useState([LinvoveyRow]);
  // const [hardErrList, setHardErrList] = useState(InitialHardErrList);
  //36.1
  const [elrHospDetails, setElrHospDetails] = useState([HospitalizationRow]);
  const [linvoHospDetails, setLinvoHospDetails] = useState([
    HospitalizationRow,
  ]);

  const [dt_elr_2L_3L_date_conditions, setDt_elr_2L_3L_date_conditions] =
    useState(false);
  const [dt_lino_2L_3L_date_conditions, setDt_lino_2L_3L_date_conditions] =
    useState(false);

  //39.1.A
  const [q391AElrTocilzumabList, setQ391AElrTocilzumabList] = useState([
    q391AElrRow,
  ]);
  const [q391ALinvoTocilzumabList, setQ391ALinvoTocilzumabList] = useState([
    q391ALinvoRow,
  ]);
  const [
    q391AElrAdministrationDateOutOfRange,
    setQ391AElrAdministrationDateOutOfRange,
  ] = useState(false);

  const [
    q391ALinvoAdministrationDateOutOfRange,
    setQ391ALinvoAdministrationDateOutOfRange,
  ] = useState(false);

  // ADD/DELETE ELREXFIO ROWS
  const DeleteElrexvayliRow = (id) => {
    const newArray = [...elrexvayliDetails];
    newArray.splice(id, 1);
    setElrexvayliDetails(newArray);
  };
  const AddElrexvayliRow = () => {
    setElrexvayliDetails((prev) => [
      ...prev,
      {
        ...ElrexvayliRow,
      },
    ]);
  };
  //36.1 Tec
  const DeleteElrHospRow = (id) => {
    const newArray = [...elrHospDetails];
    newArray.splice(id, 1);
    setElrHospDetails(newArray);
  };
  const AddElrHospRow = () => {
    setElrHospDetails((prev) => [
      ...prev,
      {
        ...HospitalizationRow,
        cohorttreatmentid: isElrexvayliSelected
          ? RRMMCohortTreatment.ELREXFIO
          : 0, //GetLocalStorageData("elrexvayliID") || 0
      },
    ]);
  };

  // ADD/DELETE LINVOSELTAMAB ROWS
  const DeleteLinvoveyRow = (id) => {
    const newArray = [...linvoveyDetails];
    newArray.splice(id, 1);
    setLinvoveyDetails(newArray);
  };
  const AddLinvoveyRow = () => {
    setLinvoveyDetails((prev) => [
      ...prev,
      {
        ...LinvoveyRow,
      },
    ]);
  };
  //36.1 Linvo
  const DeleteLinvoHospRow = (id) => {
    const newArray = [...linvoHospDetails];
    newArray.splice(id, 1);
    setLinvoHospDetails(newArray);
  };
  const AddLinvoHospRow = () => {
    setLinvoHospDetails((prev) => [
      ...prev,
      {
        ...HospitalizationRow,
        cohorttreatmentid: isLinvoveySelected
          ? RRMMCohortTreatment.Linvoseltamab
          : 0, //GetLocalStorageData("linvoveyID") || 0
      },
    ]);
  };

  // Q38

  // ADD/DELETE ELREXFIO ROWS
  const DeleteQ38ElrexvayliRow = (id) => {
    const newArray = [...Q38ElrexDetails];
    newArray.splice(id, 1);
    setQ38ElrexDetails(newArray);
  };
  const AddQ38ElrexvayliRow = () => {
    setQ38ElrexDetails((prev) => [
      ...prev,
      {
        ...Q38ElrexRow,
      },
    ]);
  };

  // ADD/DELETE LINVOSELTAMAB ROWS
  const DeleteQ38LinvoveyRow = (id) => {
    const newArray = [...Q38LinvoDetails];
    newArray.splice(id, 1);
    setQ38LinvoDetails(newArray);
  };
  const AddQ38LinvoveyRow = () => {
    setQ38LinvoDetails((prev) => [
      ...prev,
      {
        ...Q38LinvoRow,
      },
    ]);
  };

  // ========================================
  // Q38.1.A ELREXFIO - ADD/DELETE ROWS
  // ========================================
  const DeleteQ381AElrexRow = (id) => {
    const newArray = [...Q381AElrexDetails];
    newArray.splice(id, 1);
    setQ381AElrexDetails(newArray);
  };

  // Q38.1.A ELREXFIO - ADD ROW
  const AddQ381AElrexRow = () => {
    setQ381AElrexDetails((prev) => {
      const templateReasonList =
        prev.length > 0 && prev[0].reasonList?.length > 0
          ? prev[0].reasonList.map((reason) => ({
              ...reason,
              isSelected: false,
              reasonText: "",
              aeSubReasons:
                reason.aeSubReasons?.map((ae) => ({
                  ...ae,
                  isSelected: false,
                })) || [],
            }))
          : [];

      return [
        ...prev,
        {
          ...Q381AElrexRow,
          cohorttreatmentid: isElrexvayliSelected
            ? RRMMCohortTreatment.ELREXFIO
            : 0,
          reasonList: templateReasonList,
          neurologicAEReasonList:
            prev.length > 0 && prev[0].neurologicAEReasonList
              ? resetNeurologicReasons(prev[0].neurologicAEReasonList)
              : [],
        },
      ];
    });
  };

  // Q38.1.A LINVOSELTAMAB - ADD ROW
  const AddQ381ALinvoRow = () => {
    setQ381ALinvoDetails((prev) => {
      const templateReasonList =
        prev.length > 0 && prev[0].reasonList?.length > 0
          ? prev[0].reasonList.map((reason) => ({
              ...reason,
              isSelected: false,
              reasonText: "",
              aeSubReasons:
                reason.aeSubReasons?.map((ae) => ({
                  ...ae,
                  isSelected: false,
                })) || [],
            }))
          : [];

      return [
        ...prev,
        {
          ...Q381ALinvoRow,
          cohorttreatmentid: isLinvoveySelected
            ? RRMMCohortTreatment.Linvoseltamab
            : 0,
          reasonList: templateReasonList,
          neurologicAEReasonList:
            prev.length > 0 && prev[0].neurologicAEReasonList
              ? resetNeurologicReasons(prev[0].neurologicAEReasonList)
              : [],
        },
      ];
    });
  };

  // ========================================
  // Q38.1.A LINVOSELTAMAB - ADD/DELETE ROWS
  // ========================================
  const DeleteQ381ALinvoRow = (id) => {
    const newArray = [...Q381ALinvoDetails];
    newArray.splice(id, 1);
    setQ381ALinvoDetails(newArray);
  };

  const DeleteQ391ARow = (id, cohortId) => {
    if (!id || !cohortId) return;
    if (cohortId === RRMMCohortTreatment.ELREXFIO) {
      const newArray = [...q391AElrTocilzumabList];
      newArray.splice(id, 1);
      setQ391AElrTocilzumabList(newArray);
    } else if (cohortId === RRMMCohortTreatment.Linvoseltamab) {
      const newArray = [...q391ALinvoTocilzumabList];
      newArray.splice(id, 1);
      setQ391ALinvoTocilzumabList(newArray);
    }
  };

  const AddQ391ARow = (cohortId) => {
    if (!cohortId) return;

    const baseRow =
      cohortId === RRMMCohortTreatment.ELREXFIO
        ? q391AElrRow
        : cohortId === RRMMCohortTreatment.Linvoseltamab
          ? q391ALinvoRow
          : null;

    if (!baseRow) return;

    const newRow = {
      ...baseRow,
      patientid: pid,
    };

    cohortId === RRMMCohortTreatment.ELREXFIO
      ? setQ391AElrTocilzumabList((prev) => [...prev, newRow])
      : setQ391ALinvoTocilzumabList((prev) => [...prev, newRow]);
  };

  const resetNeurologicReasons = (neuroList) =>
    neuroList?.map((x) => ({
      ...x,
      isSelected: false,
      reasonUnk: false,
      reasonText: "",
    })) ?? [];

  const SavePage = async (validate) => {
    try {
      ToggleLoader(true);
      let isValid = validate ? ValidateForm() : true;

      if (isValid) {
        setShowTopErrMsg(false);

        const ElrexfioData = elrexvayliDetails.map((test) => ({
          Elranatamablinvoseltamabdosagebridgeid: test.elrexlinvodosagebridgeid,
          Cohorttreatmentid: test.cohorttreatmentid,
          DoseAdministrationDate:
            test.dose_administration_elr_dt != "Invalid Date" &&
            test.dose_administration_elr_dt
              ? test.dose_administration_elr_dt
              : "",
          DoseAdministrationDateUnk:
            test.dose_administration_elr === 99 ? true : null,
          DosePhase: test.dosing_phase_elr,
          SiteOfCare: test.siteofcare_elr,
          DosingPhaseOthTxt: test.dosing_phase_oth_txt_elr,
          DoseStrengthmg: test.elr_dose_strength_mg,
          DoseStrengthmgkg: test.elr_dose_strength_mg_kg,
          DoseStrengthmgm: test.elr_dose_strength_mgm,
          DoseStrengthUnk: test.elr_dose_strength_rbl === 99 ? 99 : null,

          InpatientAdmissionDate: test.dt_admission_elr_dt
            ? test.dt_admission_elr_dt
            : "",
          // InpatientAdmissionDateUnk:
          //   test.dt_admission_elr === 99 ? true : null,

          InpatientDischargeDate: test.dt_discharge_elr_dt
            ? test.dt_discharge_elr_dt
            : "",
          // InpatientDischargeUnk: test.dt_discharge_elr === 99 ? true : null,
          // PatientStillHospilinvoized: test.dt_discharge_elr,
        }));
        //36.1 Elran
        const ElrexfioHospitalizationData = elrHospDetails.map((test) => ({
          Teclistamatalquetamabhospitalizationbridgeid:
            test.elrexlinvohospitalizationbridgeid,

          Cohorttreatmentid: test.cohorttreatmentid,
          // Teclistamatalquetamabdosagebridgeid: test.elrexlinvodosagebridgeid,

          HospitalizationAdmissionDate:
            test.dt_admission_dt && test.dt_admission_dt != "Invalid Date"
              ? test.dt_admission_dt
              : "",
          HospitalizationAdmissionDateUnk: test.dt_admission === 99,
          NoHospitalizationDosage: test.dt_admission === 2,
          HospitalizationDischargeDate:
            test.dt_discharge_dt && test.dt_discharge_dt != "Invalid Date"
              ? test.dt_discharge_dt
              : "",
          HospitalizationDischargeUnk: test.dt_discharge === 99,
          PatientStillHospitalized: test.dt_discharge === 2,
          HospitalizationReasonAdministration: test.hospReason1,
          HospitalizationReasonMonitorAe: test.hospReason2,
          HospitalizationReasonCrs: test.hospReason3,
          HospitalizationReasonIcans: test.hospReason4,
          HospitalizationReasonOtherae: test.hospReason5,
          HospitalizationReasonOtnernonae: test.hospReason6,
          HospitalizationReasonUnknown: test.hospReasonUnk,
          HospitalizationReasonOthernonaeTxt: test.hosp_reason_oth_txt,
        }));
        const LinvoseltamabData = linvoveyDetails.map((test) => ({
          Teclistamatalquetamabdosagebridgeid:
            test.elranatamablinvoseltamabdosagebridgeid,
          Cohorttreatmentid: test.cohorttreatmentid,

          DoseAdministrationDate:
            test.dose_administration_linvo_dt &&
            test.dose_administration_linvo_dt != "Invalid Date"
              ? test.dose_administration_linvo_dt
              : "",
          DoseAdministrationDateUnk:
            test.dose_administration_linvo === 99 ? true : null,
          DosePhase: test.dosing_phase_linvo,
          SiteOfCare: test.siteofcare_linvo,
          DosingPhaseOthTxt: test.dosing_phase_oth_txt_linvo,
          DoseStrengthmg: test.linvo_dose_strength_mg,
          DoseStrengthmgkg: test.linvo_dose_strength_mg_kg,
          DoseStrengthmgm: test.linvo_dose_strength_mgm,
          DoseStrengthUnk: test.linvo_dose_strength_rbl === 99 ? 99 : null,
          InpatientAdmissionDate: test.dt_admission_linvo_dt
            ? test.dt_admission_linvo_dt
            : "",

          InpatientDischargeDate: test.dt_discharge_linvo_dt
            ? test.dt_discharge_linvo_dt
            : "",
        }));
        //36.1 Linvo
        const LinvoseltamabHospitalizationData = linvoHospDetails.map(
          (test) => ({
            Teclistamatalquetamabhospitalizationbridgeid:
              test.elrexlinvohospitalizationbridgeid,
            Cohorttreatmentid: test.cohorttreatmentid,

            HospitalizationAdmissionDate:
              test.dt_admission_dt && test.dt_admission_dt != " Invalid Date"
                ? test.dt_admission_dt
                : "",
            HospitalizationAdmissionDateUnk: test.dt_admission === 99,
            NoHospitalizationDosage: test.dt_admission === 2,

            HospitalizationDischargeDate:
              test.dt_discharge_dt && test.dt_discharge_dt != "Invalid Date"
                ? test.dt_discharge_dt
                : "",
            HospitalizationDischargeUnk: test.dt_discharge === 99,
            PatientStillHospitalized: test.dt_discharge === 2,

            HospitalizationReasonAdministration: test.hospReason1,
            HospitalizationReasonMonitorAe: test.hospReason2,
            HospitalizationReasonCrs: test.hospReason3,
            HospitalizationReasonIcans: test.hospReason4,
            HospitalizationReasonOtherae: test.hospReason5,
            HospitalizationReasonOtnernonae: test.hospReason6,
            HospitalizationReasonUnknown: test.hospReasonUnk,
            HospitalizationReasonOthernonaeTxt: test.hosp_reason_oth_txt,
          }),
        );

        //Q37 and Q40 Payload
        const Q37ElrDetail = Q37ElrexDetails.map((test) => ({
          Teclistamabcharacteristicsid: test.elrexlinvocharacteristicsid,

          Cohorttreatmentid: isElrexvayliSelected
            ? RRMMCohortTreatment.ELREXFIO
            : 0, //test.cohorttreatmentid,

          Dosefrequencyreduced: test.Q37ElrexvayliRd,

          TreatmentInitialDoseFrequency: test.q37_Elr_Dose_week_frquencyRd,
          TreatmentInitialDoseFrequencyText:
            test.q37_Elr_Dose_week_frquency_txt,
          TreatmentInitialDosage: test.q37ElrDosageRd,
          TreatmentInitialDosageOthtext: test.q37ElrDosageOtherTxt,

          //40

          IvigDosageFrequency: test.Q40dosingfreqRd,
          LastIgglevel: test.Q40IgILevelRd,
          IvigInitiationDateUnk: test.Q40init_dt_Rd === 99 ? true : null,
          IvigInitiationDate:
            test.Q40init_dt && test.Q40init_dt !== "Invalid Date"
              ? test.Q40init_dt
              : "",
          MedicationReasonPrimaryProphylactic: test.primaryProf,
          MedicationReasonSecondaryProphylactic: test.secondaryProf,
          MedicationReasonOth: test.otherReson,

          IvigDosageFrequencyOthTxt: test.dosing_freq_oth_txt,

          //39

          MedicationTocilizumab: test.tocilizumab_elr,
          MedicationGcsf: test.Granulocyte,
          MedicationNone: test.noneoftheabove_elr,
          MedicationSteroids: test.SteroidsElr,
          //39 - 1.1
          DosageusageReasonProphylacticCrs: test.cytokin_elr,
          DosageusageReasonSecondaryProphylacticCrs:
            test.secondary_prophylactic_crs_elr,
          DosagusageReasonTreatmentsupportiveCrs: test.crs_elr,
          DosagusageReasonProphylacticneurotoxicity: test.neurotoxicity_elr,
          DosagusageReasonSecondaryProphylacticNeurotoxicity:
            test.secondary_neurotoxicity_elr,
          DosagusageReasonTreatmentsupportiveNeurotoxicity:
            test.tmt_neurotoxicity_elr,
          DosagusageReasonTreatmentUnknown: test.tmt_elr_unknown,
          //39 - 1.3
          GcsfUsageReasonProphylactic: test.prophylactic_use_elr,
          GcsfUsageReasonSecondaryProphylactic:
            test.secondary_prophylactic_use_elr,
          GcsfUsageReasonOth: test.oth_use_elr,
          GcsfUsageReasonUnk: test.unknown_elr === 99 ? true : null,

          //39.2
          SteroidUsageReasonTreatmentRecommendation: test.steroid_pre_tmt_elr,
          SteroidsUsageReasonProphylacticCrs: test.cytokin_elr_steroids,
          SteroidsUsageReasonSecondaryProphylacticCrs:
            test.secondary_prophylactic_elr_steroids,
          SteroidsUsageReasonTreatmentsupportiveCrs: test.crs_elr_steroids,
          SteroidsUsageReasonProphylacticneurotoxicity:
            test.neurotoxicity_elr_steroids,
          SteroidsUsageReasonSecondaryProphylacticNeurologic:
            test.secondary_neurotoxicity_elr_steroids,
          SteroidsUsageReasonTreatmentsupportiveNeurotoxicity:
            test.tmt_neurotoxicity_elr_steroids,

          SteroidUsageReasonUnknown: test.tmt_steroids_elr_unknown,

          SteroidNameBetamethasone: test.betamethasone_elr,
          SteroidDoseBetamethasone: test.betamethasone_elrNum,

          SteroidNameDexamethasone: test.dexamethasone_elr,
          SteroidDoseDexamethasone: test.dexamethasone_elrNum,

          SteroidNameHydrocortisone: test.hydrocortisone_elr,
          SteroidDoseHydrocortisone: test.hydrocortisone_elrNum,

          SteroidNameMethylprednisolone: test.methylprednisolone,
          SteroidDoseMethylprednisolone: test.methylprednisoloneNum,

          SteroidNamePrednisolone: test.prednisolone_elr,
          SteroidDosePrednisolone: test.prednisolone_elrNum,

          SteroidNamePrednisone: test.prednisone_elr,
          SteroidDosePrednisone: test.prednisone_elrNum,

          SteroidNameTriamcinolone: test.triamcinolone_elr,
          SteroidDoseTriamcinolone: test.triamcinolone_elrNum,

          SteroidDoseNameUnknown: test.dose_name_elr_unknown,
        }));

        const Q37LinvoDetail = Q37LinvoDetails.map((test) => ({
          Teclistamabcharacteristicsid: test.teclistamabcharacteristicsid,

          Cohorttreatmentid: isLinvoveySelected
            ? RRMMCohortTreatment.Linvoseltamab
            : 0, //test.cohorttreatmentid,

          Dosefrequencyreduced: test.Q37LinvoveyRd,

          TreatmentInitialDoseFrequency: test.q37_Linvo_Dose_week_frquencyRd,

          TreatmentInitialDoseFrequencyText:
            test.q37_Linvo_Dose_week_frquency_txt,
          TreatmentInitialDosage: test.q37_Linvo_Dosage_Rd,
          TreatmentInitialDosageOthtext: test.q37_Linvo_Dosage_OtherTxt,

          //39

          MedicationTocilizumab: test.tocilizumab_linvo,
          MedicationSteroids: test.Steroids,
          MedicationNone: test.noneoftheabove_linvo,
          MedicationGcsf: test.granulocyte_linvo,

          //39.1
          DosageusageReasonProphylacticCrs: test.cytokin_linvo,
          DosageusageReasonSecondaryProphylacticCrs:
            test.secondary_prophylactic_crs_linvo,
          DosagusageReasonTreatmentsupportiveCrs: test.crs_linvo,
          DosagusageReasonProphylacticneurotoxicity: test.neurotoxicity_linvo,
          DosagusageReasonSecondaryProphylacticNeurotoxicity:
            test.secondary_neurotoxicity_linvo,
          DosagusageReasonTreatmentsupportiveNeurotoxicity:
            test.tmt_neurotoxicity_linvo,
          DosagusageReasonTreatmentUnknown: test.tmt_linvoseltamab_unknown,
          IvigInitiationDateUnk:
            test.administrationDateRD_linvo === 99 ? true : null,
          IvigInitiationDate:
            test.q40Init_Dt_linvo && test.q40Init_Dt_linvo !== "Invalid Date"
              ? test.q40Init_Dt_linvo
              : "",

          //39 - 1.3
          GcsfUsageReasonProphylactic: test.prophylactic_use_linvo,
          GcsfUsageReasonSecondaryProphylactic:
            test.secondary_prophylactic_use_linvo,
          GcsfUsageReasonOth: test.oth_use_linvo,
          GcsfUsageReasonUnk: test.unknown_linvo === 99 ? true : null,

          // //1.2
          SteroidUsageReasonTreatmentRecommendation: test.steroid_pre_tmt_linvo,
          SteroidsUsageReasonProphylacticCrs: test.cytokin_linvo_steroids,
          SteroidsUsageReasonSecondaryProphylacticCrs:
            test.secondary_prophylactic_linvo_steroids,
          SteroidsUsageReasonTreatmentsupportiveCrs: test.crs_linvo_steroids,
          SteroidsUsageReasonProphylacticneurotoxicity:
            test.neurotoxicity_linvo_steroids,
          SteroidsUsageReasonSecondaryProphylacticNeurologic:
            test.secondary_neurotoxicity_linvo_steroids,
          SteroidsUsageReasonTreatmentsupportiveNeurotoxicity:
            test.tmt_neurotoxicity_linvo_steroids,
          SteroidUsageReasonUnknown: test.tmt_linvo_unknown,

          SteroidNameBetamethasone: test.betamethasone_linvo,
          SteroidDoseBetamethasone: test.betamethasone_linvoNum,

          SteroidNameDexamethasone: test.dexamethasone_linvo,
          SteroidDoseDexamethasone: test.dexamethasone_linvoNum,

          SteroidNameHydrocortisone: test.hydrocortisone_linvo,
          SteroidDoseHydrocortisone: test.hydrocortisone_linvoNum,

          SteroidNameMethylprednisolone: test.methylprednisolone_linvo,
          SteroidDoseMethylprednisolone: test.methylprednisolone_linvoNum,

          SteroidNamePrednisolone: test.prednisolone_linvo,
          SteroidDosePrednisolone: test.prednisolone_linvoNum,

          SteroidNamePrednisone: test.prednisone_linvo,
          SteroidDosePrednisone: test.prednisone_linvoNum,

          SteroidNameTriamcinolone: test.triamcinolone_linvo,
          SteroidDoseTriamcinolone: test.triamcinolone_linvoNum,

          SteroidDoseNameUnknown: test.dose_name_linvo_unknown,

          //40

          IvigDosageFrequency: test.q40DosingFreqRd_linvo,
          LastIgglevel: test.q40IgILevelRd_linvo,
          IvigInitiationDateUnk: test.q40Init_Dt_Rd_linvo === 99 ? true : null,
          IvigInitiationDate:
            test.q40Init_Dt_linvo && test.q40Init_Dt_linvo !== "Invalid Date"
              ? test.q40Init_Dt_linvo
              : "",
          MedicationReasonPrimaryProphylactic: test.primaryProf_linvo,
          MedicationReasonSecondaryProphylactic: test.secondaryProf_linvo,
          MedicationReasonOth: test.otherReson_linvo,
          IvigDosageFrequencyOthTxt: test.dosing_Freq_Oth_Txt_linvo,
        }));

        // Q38Elr payload
        const q38ElrexfioData = Q38ElrexDetails.map((test) => ({
          Elranatamablinvoseltamabdosefrequencybridgeid:
            test.elrexlinvodosefrequencybridgeid,
          Cohorttreatmentid: test.cohorttreatmentid,

          DosefreqReductionDateUnk: test.Q38ElrexvayliRd,
          DosefreqReductionDate:
            test.dt_dosefreq_elr_dt != "Invalid Date" && test.dt_dosefreq_elr_dt
              ? test.dt_dosefreq_elr_dt
              : "",

          TreatmentInitialDoseFrequency: test.q38_Elr_Dose_week_frquencyRd,

          TreatmentInitialDoseFrequencyText:
            test.q38_Elr_Dose_week_frquency_txt,
        }));

        // Q38linvoseltamabData
        const q38LinvoseltamabData = Q38LinvoDetails.map((test) => ({
          Elranatamablinvoseltamabdosefrequencybridgeid:
            test.elrexlinvodosefrequencybridgeid,
          Cohorttreatmentid: test.cohorttreatmentid,

          DosefreqReductionDateUnk: test.Q38LinvoveyRd,
          DosefreqReductionDate:
            test.dt_dosefreq_linvo_dt != "Invalid Date" &&
            test.dt_dosefreq_linvo_dt
              ? test.dt_dosefreq_linvo_dt
              : "",

          TreatmentInitialDoseFrequency: test.q38_Linvo_Dose_week_frquencyRd,
          TreatmentInitialDoseFrequencyText:
            test.q38_Linvo_Dose_week_frquency_txt,
          TreatmentInitialDosageOthtext: test.q38_Linvo_Dosage_OtherTxt,
          TreatmentInitialDosage: test.q38_Linvo_Dosage_Rd,
        }));

        // Q38.1.A ELREXFIO Payload
        const Q381AElrexfioData = Q381AElrexDetails.map((test) => ({
          Teclistamatalquetamabdosefrequencyinfobridgeid:
            test.teclistamatalquetamabdosefrequencyinfobridgeid || 0,
          Cohorttreatmentid: test.cohorttreatmentid || 11,
          Patientid: pid,

          // Column B - Type of change
          ChangeType: test.changeType,
          ChangeTypeDoseFrequency: test.changeTypeDoseFrequency,
          ChangeTypeDoseStrength: test.changeTypeDoseStrength,

          // Column C - Reasons
          SelectedReasons: test.selectedReasons || [],
          SelectedAEReasons: test.selectedAEReasons || [],
          NeurologicAEReasonList: test.neurologicAEReasonList || [],
          ReasonOtherText: test.reasonOtherText || "",
          BispecifictreatmentdiscontinuationreasonUnk:
            test.reasonUnknown || false,

          // Column D - Pattern BEFORE
          PatternBeforeChangeDoseFrequency:
            test.patterBeforeChangeDoseFrequency,
          PatternBeforeChangeDoseFrequencyWeek:
            test.patterBeforeChangeDoseFrequency === 1
              ? Number(test.patterBeforeChangeDoseFrequencyTimesPerWeek) || null
              : test.patterBeforeChangeDoseFrequency === 2
                ? Number(test.patterBeforeChangeDoseFrequencyWeek) || null
                : null,

          PatternBeforeChangeDoseStrength: test.patterBeforeChangeDoseStrength,
          PatternBeforeChangeDoseStrengthUnit:
            test.patterBeforeChangeDoseStrength == 1
              ? test.patterBeforeChangeDoseStrengthMg
              : test.patterBeforeChangeDoseStrength == 2
                ? test.patterBeforeChangeDoseStrengthMgKg
                : test.patterBeforeChangeDoseStrength == 3
                  ? test.patterBeforeChangeDoseStrengthMgM2
                  : null,

          // Column E - Pattern AFTER
          PatternAfterChangeDoseFrequency: test.patterAfterChangeDoseFrequency,
          PatternAfterChangeDoseFrequencyWeek:
            test.patterAfterChangeDoseFrequency === 1
              ? Number(test.patterAfterChangeDoseFrequencyTimesPerWeek) || null
              : test.patterAfterChangeDoseFrequency === 2
                ? Number(test.patterAfterChangeDoseFrequencyWeek) || null
                : null,
          PatternAfterChangeDoseStrength: test.patterAfterChangeDoseStrength,
          PatternAfterChangeDoseStrengthUnit:
            test.patterAfterChangeDoseStrength == 1
              ? test.patterAfterChangeDoseStrengthMg
              : test.patterAfterChangeDoseStrength == 2
                ? test.patterAfterChangeDoseStrengthMgKg
                : test.patterAfterChangeDoseStrength == 3
                  ? test.patterAfterChangeDoseStrengthMgM2
                  : null,

          // Column F - Date of change
          DateChange:
            test.dateChange && test.dateChange !== "Invalid Date"
              ? test.dateChange
              : "",
          DateChangeUnk: test.dateChangeRd === 99,
        }));

        // Q38.1.A LINVOSELTAMAB Payload
        const Q381ALinvoData = Q381ALinvoDetails.map((test) => ({
          Teclistamatalquetamabdosefrequencyinfobridgeid:
            test.teclistamatalquetamabdosefrequencyinfobridgeid || 0,
          Cohorttreatmentid: test.cohorttreatmentid || 12,
          Patientid: pid,

          // Column B
          ChangeType: test.changeType,
          ChangeTypeDoseFrequency: test.changeTypeDoseFrequency,
          ChangeTypeDoseStrength: test.changeTypeDoseStrength,

          // Column C
          SelectedReasons: test.selectedReasons || [],
          SelectedAEReasons: test.selectedAEReasons || [],
          NeurologicAEReasonList: test.neurologicAEReasonList || [],
          ReasonOtherText: test.reasonOtherText || "",
          BispecifictreatmentdiscontinuationreasonUnk:
            test.reasonUnknown || false,

          // Column D
          PatternBeforeChangeDoseFrequency:
            test.patterBeforeChangeDoseFrequency,
          PatternBeforeChangeDoseFrequencyWeek:
            test.patterBeforeChangeDoseFrequency === 1
              ? Number(test.patterBeforeChangeDoseFrequencyTimesPerWeek) || null
              : test.patterBeforeChangeDoseFrequency === 2
                ? Number(test.patterBeforeChangeDoseFrequencyWeek) || null
                : null,

          PatternBeforeChangeDoseStrength: test.patterBeforeChangeDoseStrength,
          PatternBeforeChangeDoseStrengthUnit:
            test.patterBeforeChangeDoseStrength == 1
              ? test.patterBeforeChangeDoseStrengthMg
              : test.patterBeforeChangeDoseStrength == 2
                ? test.patterBeforeChangeDoseStrengthMgKg
                : test.patterBeforeChangeDoseStrength == 3
                  ? test.patterBeforeChangeDoseStrengthMgM2
                  : null,

          // Column E
          PatternAfterChangeDoseFrequency: test.patterAfterChangeDoseFrequency,
          PatternAfterChangeDoseFrequencyWeek:
            test.patterAfterChangeDoseFrequency === 1
              ? Number(test.patterAfterChangeDoseFrequencyTimesPerWeek) || null
              : test.patterAfterChangeDoseFrequency === 2
                ? Number(test.patterAfterChangeDoseFrequencyWeek) || null
                : null,
          PatternAfterChangeDoseStrength: test.patterAfterChangeDoseStrength,
          PatternAfterChangeDoseStrengthUnit:
            test.patterAfterChangeDoseStrength == 1
              ? test.patterAfterChangeDoseStrengthMg
              : test.patterAfterChangeDoseStrength == 2
                ? test.patterAfterChangeDoseStrengthMgKg
                : test.patterAfterChangeDoseStrength == 3
                  ? test.patterAfterChangeDoseStrengthMgM2
                  : null,

          // Column F
          DateChange:
            test.dateChange && test.dateChange !== "Invalid Date"
              ? test.dateChange
              : "",
          DateChangeUnk: test.dateChangeRd === 99,
        }));

        //  Q38.2.A
        const Q382AElrexfioData = Q382AElrexDetails.map((row) => ({
          Teclistamatalquetamabdosedelaybridgeid:
            row.teclistamatalquetamabdosefrequencyinfobridgeid, // UI id
          Cohorttreatmentid: row.cohorttreatmentid,
          InterruptType: row.changeType,
          SelectedReasons: row.selectedReasons || [],
          SelectedAEReasons: row.selectedAEReasons || [],
          NeurologicAEReasonList: row.neurologicAEReasonList || [],
          ReasonOtherText: row.reasonOtherText,
          BispecifictreatmentdiscontinuationreasonUnk:
            row.reasonUnknown === true,
          InterruptStartDate:
            row.startDateChangeRd === 1 ? row.startDateChange : null,
          InterruptStartDateUnk: row.startDateChangeRd === 99,
          InterruptEndDate:
            row.endDateChangeRd === 2 && row.endDateChange !== "Invalid Date"
              ? row.endDateChange
              : null,
          InterruptEndOngoingUnk: row.endDateChangeRd,
        }));

        // Q38.2.A LINVOSELTAMAB Payload
        const Q382ALinvoseltamabData = Q382ALinvoDetails.map((test) => ({
          Teclistamatalquetamabdosedelaybridgeid:
            test.teclistamatalquetamabdosefrequencyinfobridgeid ?? 0, // UI id used as key
          Cohorttreatmentid: test.cohorttreatmentid ?? 12,
          Patientid: pid,

          // Column B - Type of change
          InterruptType: test.changeType,

          // Column C - Reasons
          SelectedReasons: test.selectedReasons ?? [],
          SelectedAEReasons: test.selectedAEReasons ?? [],
          NeurologicAEReasonList: test.neurologicAEReasonList || [],
          ReasonOtherText: test.reasonOtherText,
          BispecifictreatmentdiscontinuationreasonUnk:
            test.reasonUnknown === true,

          // Column D - Start date of interruption/delay
          InterruptStartDate:
            test.startDateChangeRd === 1 &&
            test.startDateChange !== "Invalid Date"
              ? test.startDateChange
              : null,
          InterruptStartDateUnk: test.startDateChangeRd === 99,

          // Column E - End date / ongoing / unknown
          InterruptEndDate:
            test.endDateChangeRd === 2 && test.endDateChange !== "Invalid Date"
              ? test.endDateChange
              : null,
          //
          InterruptEndOngoingUnk: test.endDateChangeRd,
        }));

        //39.1.A

        const elrexfioQ391AData = q391AElrTocilzumabList.map((itm) => ({
          Tocilizumabmedicationid: itm.tocilizumabmedicationid ?? 0,
          Cohorttreatmentid: itm.cohorttreatmentid,
          Patientid: itm.patientid,
          TocilizumabAdministrationDate:
            itm.administrationDate_elr &&
            itm.administrationDate_elr !== "Invalid Date"
              ? itm.administrationDate_elr
              : "",
          TocilizumabAdministrationDateUnk: itm.administrationDateRD_elr === 99,
          PrimaryProphylacticCrs: itm.primaryProphylacticCrs_elr,
          SecondaryProphylacticCrs: itm.secondaryProphylacticCrs_elr,
          SupportiveCareCrs: itm.supportiveCareCrs_elr,
          PrimaryProphylacticNeurologic: itm.primaryProphylacticNeurologic_elr,
          SecondaryProphylacticNeurologic:
            itm.secondaryProphylacticNeurologic_elr,
          SupportiveCareNeurologic: itm.supportiveCareNeurologic_elr,
          MedicationReasonUnk: itm.medicationReasonUnk_elr,
        }));

        const linvoQ391AData = q391ALinvoTocilzumabList.map((itm) => ({
          Tocilizumabmedicationid: itm.tocilizumabmedicationid ?? 0,
          Cohorttreatmentid: itm.cohorttreatmentid,
          Patientid: itm.patientid,
          TocilizumabAdministrationDate:
            itm.administrationDate_linvo &&
            itm.administrationDate_linvo !== "Invalid Date"
              ? itm.administrationDate_linvo
              : "",
          TocilizumabAdministrationDateUnk:
            itm.administrationDateRD_linvo === 99,
          PrimaryProphylacticCrs: itm.primaryProphylacticCrs_linvo,
          SecondaryProphylacticCrs: itm.secondaryProphylacticCrs_linvo,
          SupportiveCareCrs: itm.supportiveCareCrs_linvo,
          PrimaryProphylacticNeurologic:
            itm.primaryProphylacticNeurologic_linvo,
          SecondaryProphylacticNeurologic:
            itm.secondaryProphylacticNeurologic_linvo,
          SupportiveCareNeurologic: itm.supportiveCareNeurologic_linvo,
          MedicationReasonUnk: itm.medicationReasonUnk_linvo,
        }));

        const ELCharModel = {
          Patientid: pid,
          UserId: GetLoggedInUserID(),
          isValidated: validate,
          IsAdmin: IsAdmin(),
          UserId: GetLoggedInUserID(),
          IsNewEcrfA: isNewEcrfA,
          //36
          ElrexfioData: ElrexfioData,
          LinvoseltamabData: LinvoseltamabData,
          //36.1
          ElrexfioHospitalData: ElrexfioHospitalizationData,
          LinvoseltamabHospitalData: LinvoseltamabHospitalizationData,

          //37
          ELcharElrexfioModelList: Q37ElrDetail,
          ELcharLinvoseltamabModelList: Q37LinvoDetail,

          //38
          Q38ElrexfioData: q38ElrexfioData,
          Q38LinvoseltamabData: q38LinvoseltamabData,

          //38.1.A
          Q381AElrexfioData: Q381AElrexfioData,
          Q381ALinvoseltamabData: Q381ALinvoData,

          Q382AElrexfioData: Q382AElrexfioData,
          Q382ALinvoseltamabData: Q382ALinvoseltamabData,

          //39.1.A
          ElrexfioTocilizumabData: elrexfioQ391AData,
          LinvoseltamabTocilizumabData: linvoQ391AData,
        };
        if (pid > 0) {
          let response =
            await AdditionalTreatmentService.SaveELCharacteristicData(
              ELCharModel,
            );

          if (response.status !== HTTPResponse.OK) {
            if (response?.status === HTTPResponse.Unauthorized) {
              HandleSessionTimeout();
            } else throw response.error;
          } else {
            ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
            await LoadData();
          }

          ToggleLoader(false);
        }
        return true;
      } else {
        ToggleLoader(false);
        setShowTopErrMsg(true);
        return false;
      }
    } catch (error) {
      ToggleLoader(false);
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  const LoadData = async () => {
    try {
      if (pid > 0) {
        const response =
          await AdditionalTreatmentService.LoadELCharacteristicData(pid);
        if (response?.status === HTTPResponse.OK) {
          const { data } = response;
          setIsNewEcrfA(data.isNewEcrfA ?? false);
          setElrvayliDateRRMM(
            data.rrmmElrexfioDate !== null
              ? data.rrmmElrexfioDate
              : data.rrmmElrexfioDate === null && data.endofFollowUpDate != null
                ? data.endofFollowUpDate
                : "[Bispecifics/CAR-T end of follow up]",
          );

          setLinvoveyDateRRMM(
            data.rrmmLinvoseltamabDate !== null
              ? data.rrmmLinvoseltamabDate
              : data.rrmmLinvoseltamabDate === null &&
                  data.endofFollowUpDate != null
                ? data.endofFollowUpDate
                : "[Bispecifics/CAR-T end of follow up]",
          );

          setPatientDeathDate(data.patientDeathDate);
          //setPatientDeathDate(null);
          setElrNumberofAdministrator(data.elrNoOfAdministration);
          setLinvoNumberofAdministrator(data.linvoNoOfAdministration);

          setEndOfFollowUpDate(data.endofFollowUpDate);
          setIndexDateRRMM_elrHard(false);
          setIndexDateRRMM_linvoHard(false);
          setElrexfioLOTStartDate(data.elrexfioLOTStartDate ?? "");
          setLinvoseltamabLOTStartDate(data.linvoseltamabLOTStartDate ?? "");

          setBispecificQ26Data(data.bispecificQ26Data);
          setBispecificQ331AData(data.bispecificQ331AData);
          setBispecificQ31Q32Data(data.bispecificQ31Q32Data);
          setNdmmLotData(data.ndmmLotData);

          setElrNumberofAdministratorMatching(false);
          setLinvoNumberofAdministratorMatching(false);

          setIsElrLastAdminDateValid(true);
          setIsLinvoLastAdminDateValid(true);

          let cohortTreatmentModelListt = [];
          if (storedData) {
            const parsedData = JSON.parse(storedData);
            cohortTreatmentModelListt = parsedData.filter(
              (item) => item.ndmm === false && item.isEligible,
            );
          }

          let modelList = [];
          if (storedData) {
            const parseData = JSON.parse(storedData);
            modelList = parseData.filter(
              (item) => item.ndmm === true && item.isEligible,
            );
          }
          if (modelList.length > 0) {
            setNdmmAvailable(true);
          }

          if (cohortTreatmentModelListt.length > 0) {
            const isAbeOrCar = cohortTreatmentModelListt.some(
              (a) =>
                a.cohortTreatmentID === RRMMCohortTreatment.ABECMA ||
                a.cohortTreatmentID === RRMMCohortTreatment.CARVYKTI,
            );
            if (isAbeOrCar) {
              setRRMMAvailable(true);
            }
          }

          const elrCohort = cohortTreatmentModelListt.find(
            (item) => item.cohortTreatmentID === RRMMCohortTreatment.ELREXFIO,
          );
          let isTACSelected = false;

          if (elrCohort) {
            isTACSelected = true;
            setElrexvayliSelected(true);
            setElrexIndexDate(data.elrexfioIndexDate);
          }

          const linvoCohort = cohortTreatmentModelListt.find(
            (item) =>
              item.cohortTreatmentID === RRMMCohortTreatment.Linvoseltamab,
          );
          let isLINVOSelected = false;
          if (linvoCohort) {
            isLINVOSelected = true;
            setLinvoveySelected(true);

            setLinvoIndexDate(data.linvoseltamabIndexDate);
          }

          const cohortTreatmentMap = new Map();

          if (data.elrexfioData && data.elrexfioData.length > 0) {
            const elrexfioData = data.elrexfioData.map((item) => {
              const cohortTreatment =
                cohortTreatmentMap.get(item.cohorttreatmentid) || {};

              return {
                cohorttreatmentid: item.cohorttreatmentid,

                elrexlinvodosagebridgeid:
                  item.elranatamablinvoseltamabdosagebridgeid,

                dose_administration_elr_dt: item.doseAdministrationDate,
                dose_administration_elr:
                  item.doseAdministrationDateUnk === true
                    ? 99
                    : item.doseAdministrationDate
                      ? 1
                      : null,

                dosing_phase_elr: item.dosePhase,
                siteofcare_elr: item.siteOfCare,

                elr_dose_strength_rbl: item.doseStrengthmg
                  ? 1
                  : item.doseStrengthmgkg
                    ? 2
                    : item.doseStrengthmgm
                      ? 3
                      : item.doseStrengthUnk
                        ? 99
                        : null,
                elr_dose_strength_mg: item.doseStrengthmg
                  ? item.doseStrengthmg
                  : "",
                elr_dose_strength_mg_kg: item.doseStrengthmgkg
                  ? item.doseStrengthmgkg
                  : "",
                elr_dose_strength_mgm: item.doseStrengthmgm
                  ? item.doseStrengthmgm
                  : "",

                dosing_phase_oth_txt_elr: item.dosingPhaseOthTxt,

                dt_admission_elr_dt: item.inpatientAdmissionDate,

                dosing_phase_oth_txt_linvo: item.dosingPhaseOthTxt,

                dt_discharge_elr_dt: item.inpatientDischargeDate,

                Q36ElrexConditionMet:
                  (item.dosePhase === 1 ||
                    item.dosePhase === 2 ||
                    item.dosePhase === 3) &&
                  (item.siteOfCare === 1 || item.siteOfCare === 3)
                    ? true
                    : false,

                dose_administration_elrHard: false,
                dosing_phase_elrHard: false,
                dosing_phase_elrHard_othEmpty: false,
                siteofcare_elrHard: false,
                elr_dose_strength_mg_kgHard: false,
                dt_admission_elrHard: false,
                dt_discharge_elrHard: false,
                elr_dose_strength_mg_kgRange: false,

                dose_administration_elrHard_dt: false,
                Invalid_dose_administration_elr_dt: false,
                dt_admission_elrHard_dt: false,
                dt_discharge_elrHard_dt: false,
                dt_admission_elrHard_dt_check: false,
                dt_discharge_elrHard_dt_check: false,
                dose_administration_elr_dt_before_eof: false,
                // dt_elr_greater_prevCheck: false,
                dt_elr_date_out_of_bound: false,
              };
            });
            setElrexvayliDetails(elrexfioData);
            setDt_elr_2L_3L_date_conditions(false);
          } else {
            const cohortTreatmentid = isTACSelected
              ? RRMMCohortTreatment.ELREXFIO //GetLocalStorageData("elrexvayliID")
              : 0;

            // Update ElrexvayliRow with cohorttreatmentid only
            ElrexvayliRow.cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            ElrexvayliRow.elranatamablinvoseltamabdosagebridgeid =
              ElrexvayliRow.elranatamablinvoseltamabdosagebridgeid || 0;
            ElrexvayliRow.dose_administration_elr =
              ElrexvayliRow.dose_administration_elr || null;
            ElrexvayliRow.dosing_phase_elr =
              ElrexvayliRow.dosing_phase_elr || null;
            ElrexvayliRow.siteofcare_elr = ElrexvayliRow.siteofcare_elr || null;

            ElrexvayliRow.elr_dose_strength_mg_kg =
              ElrexvayliRow.elr_dose_strength_mg_kg || null;
            ElrexvayliRow.elr_dose_strength_mg =
              ElrexvayliRow.elr_dose_strength_mg || null;
            ElrexvayliRow.elr_dose_strength_mgm =
              ElrexvayliRow.elr_dose_strength_mgm || null;
            // ElrexvayliRow.dt_discharge_elr =
            //   ElrexvayliRow.dt_discharge_elr || null;
            ElrexvayliRow.dose_administration_elr_dt =
              ElrexvayliRow.dose_administration_elr_dt || "";
            ElrexvayliRow.dt_admission_elr_dt =
              ElrexvayliRow.dt_admission_elr_dt || "";
            ElrexvayliRow.dt_discharge_elr_dt =
              ElrexvayliRow.dt_discharge_elr_dt || "";

            ElrexvayliRow.dose_administration_elrHard =
              ElrexvayliRow.dose_administration_elrHard || false;
            ElrexvayliRow.dosing_phase_elrHard =
              ElrexvayliRow.dosing_phase_elrHard || false;
            ElrexvayliRow.siteofcare_elrHard =
              ElrexvayliRow.siteofcare_elrHard || false;
            ElrexvayliRow.dt_admission_elrHard =
              ElrexvayliRow.dt_admission_elrHard || false;
            ElrexvayliRow.dt_discharge_elrHard =
              ElrexvayliRow.dt_discharge_elrHard || false;

            ElrexvayliRow.dosing_phase_elrHard_othEmpty = false;
            ElrexvayliRow.elr_dose_strength_mg_kgHard = false;
            ElrexvayliRow.elr_dose_strength_mg_kgRange = false;
          }

          //36.1 elrex start
          if (
            data.elrexfioHospitalData &&
            data.elrexfioHospitalData.length > 0
          ) {
            const elrHospData = data.elrexfioHospitalData.map((item) => {
              return {
                ...HospitalizationRow,
                elrexlinvohospitalizationbridgeid:
                  item.teclistamatalquetamabhospitalizationbridgeid,
                cohorttreatmentid: item.cohorttreatmentid,
                elrexlinvodosagebridgeid:
                  item.teclistamatalquetamabdosagebridgeid,
                //B
                dt_admission: item.hospitalizationAdmissionDateUnk
                  ? 99
                  : item.noHospitalizationDosage
                    ? 2
                    : item.hospitalizationAdmissionDate
                      ? 1
                      : null,
                dt_admission_dt: item.hospitalizationAdmissionDate,
                //C
                dt_discharge: item.hospitalizationDischargeUnk
                  ? 99
                  : item.patientStillHospitalized
                    ? 2
                    : item.hospitalizationDischargeDate
                      ? 1
                      : null,
                dt_discharge_dt: item.hospitalizationDischargeDate,
                //D
                hospReason1: item.hospitalizationReasonAdministration,
                hospReason2: item.hospitalizationReasonMonitorAe,
                hospReason3: item.hospitalizationReasonCrs,
                hospReason4: item.hospitalizationReasonIcans,
                hospReason5: item.hospitalizationReasonOtherae,
                hospReason6: item.hospitalizationReasonOtnernonae,
                hosp_reason_oth_txt: item.hospitalizationReasonOthernonaeTxt,
                hospReasonUnk: item.hospitalizationReasonUnknown,
              };
            });

            setElrHospDetails(elrHospData);
          } else {
            const cohorttreatmentid = isTACSelected
              ? RRMMCohortTreatment.ELREXFIO //GetLocalStorageData("elrexvayliID")
              : 0;

            setElrHospDetails([
              {
                ...HospitalizationRow,
                cohorttreatmentid,
              },
            ]);
          }
          //end

          if (data.linvoseltamabData && data.linvoseltamabData.length > 0) {
            const linvoseltamabData = data.linvoseltamabData.map((item) => {
              const cohortTreatment =
                cohortTreatmentMap.get(item.cohorttreatmentid) || {};

              return {
                cohorttreatmentid: item.cohorttreatmentid,

                elrexlinvodosagebridgeid:
                  item.elranatamablinvoseltamabdosagebridgeid,

                dose_administration_linvo_dt: item.doseAdministrationDate,
                dose_administration_linvo:
                  item.doseAdministrationDateUnk === true
                    ? 99
                    : item.doseAdministrationDate
                      ? 1
                      : null,

                dosing_phase_linvo: item.dosePhase,
                siteofcare_linvo: item.siteOfCare,
                dosing_phase_oth_txt_linvo: item.dosingPhaseOthTxt,
                linvo_dose_strength_rbl: item.doseStrengthmg
                  ? 1
                  : item.doseStrengthmgkg
                    ? 2
                    : item.doseStrengthmgm
                      ? 3
                      : item.doseStrengthUnk
                        ? 99
                        : null,
                linvo_dose_strength_mg: item.doseStrengthmg
                  ? item.doseStrengthmg
                  : "",
                linvo_dose_strength_mg_kg: item.doseStrengthmgkg
                  ? item.doseStrengthmgkg
                  : "",
                linvo_dose_strength_mgm: item.doseStrengthmgm
                  ? item.doseStrengthmgm
                  : "",

                dt_admission_linvo_dt: item.inpatientAdmissionDate,

                dt_discharge_linvo_dt: item.inpatientDischargeDate,

                dose_administration_linvoHard: false,
                Invalid_dose_administration_linvo_dt: false,
                dosing_phase_linvoHard: false,
                siteofcare_linvoHard: false,
                dt_admission_linvoHard: false,
                dt_discharge_linvoHard: false,
                dosing_phase_linvoHard_othEmpty: false,
                linvo_dose_strength_mg_kgHard: false,
                linvo_dose_strength_mg_kgRange: false,

                dose_administration_linvoHard_dt: false,
                dt_admission_linvoHard_dt: false,
                dt_discharge_linvoHard_dt: false,

                dt_admission_linvoHard_dt_check: false,
                dt_discharge_linvoHard_dt_check: false,

                // dt_linvo_greater_prevCheck: false,
                dt_linvo_date_out_of_bound: false,
              };
            });

            setLinvoveyDetails(linvoseltamabData);
            setDt_lino_2L_3L_date_conditions(false);
          } else {
            const cohortTreatmentid = isLINVOSelected
              ? RRMMCohortTreatment.Linvoseltamab //GetLocalStorageData("linvoveyID")
              : 0;

            // Update ElrexvayliRow with cohorttreatmentid only
            LinvoveyRow.cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            LinvoveyRow.elranatamablinvoseltamabdosagebridgeid =
              LinvoveyRow.elranatamablinvoseltamabdosagebridgeid || 0;
            LinvoveyRow.dose_administration_linvo =
              LinvoveyRow.dose_administration_linvo || null;
            LinvoveyRow.dosing_phase_linvo =
              LinvoveyRow.dosing_phase_linvo || null;
            LinvoveyRow.siteofcare_linvo = LinvoveyRow.siteofcare_linvo || null;
            LinvoveyRow.dose_administration_linvo_dt =
              LinvoveyRow.dose_administration_linvo_dt || "";
            LinvoveyRow.dt_admission_linvo_dt =
              LinvoveyRow.dt_admission_linvo_dt || "";
            LinvoveyRow.dt_discharge_linvo_dt =
              LinvoveyRow.dt_discharge_linvo_dt || "";
            LinvoveyRow.dose_administration_linvoHard =
              LinvoveyRow.dose_administration_linvoHard || false;
            LinvoveyRow.dosing_phase_linvoHard =
              LinvoveyRow.dosing_phase_linvoHard || false;
            LinvoveyRow.siteofcare_linvoHard =
              LinvoveyRow.siteofcare_linvoHard || false;
            LinvoveyRow.dt_admission_linvoHard =
              LinvoveyRow.dt_admission_linvoHard || false;
            LinvoveyRow.dt_discharge_linvoHard =
              LinvoveyRow.dt_discharge_linvoHard || false;
            LinvoveyRow.Invalid_dose_administration_linvo_dt =
              LinvoveyRow.Invalid_dose_administration_linvo_dt || false;

            LinvoveyRow.dosing_phase_linvoHard_othEmpty = false;
            LinvoveyRow.linvo_dose_strength_mg_kg =
              LinvoveyRow.linvo_dose_strength_mg_kg || null;
            LinvoveyRow.linvo_dose_strength_mg =
              LinvoveyRow.linvo_dose_strength_mg || null;
            LinvoveyRow.linvo_dose_strength_mgm =
              LinvoveyRow.linvo_dose_strength_mgm || null;
            LinvoveyRow.linvo_dose_strength_mg_kgHard = false;
            LinvoveyRow.linvo_dose_strength_mg_kgRange = false;
            //  //Q38
          }
          //36.1 Linvo start
          if (
            data.linvoseltamabHospitalData &&
            data.linvoseltamabHospitalData.length > 0
          ) {
            const linvoHospData = data.linvoseltamabHospitalData.map((item) => {
              return {
                ...HospitalizationRow,
                elrexlinvohospitalizationbridgeid:
                  item.teclistamatalquetamabhospitalizationbridgeid,
                cohorttreatmentid: item.cohorttreatmentid,
                elrexlinvodosagebridgeid:
                  item.teclistamatalquetamabdosagebridgeid,
                //B
                dt_admission: item.hospitalizationAdmissionDateUnk
                  ? 99
                  : item.noHospitalizationDosage
                    ? 2
                    : item.hospitalizationAdmissionDate
                      ? 1
                      : null,
                dt_admission_dt: item.hospitalizationAdmissionDate,
                //C
                dt_discharge: item.hospitalizationDischargeUnk
                  ? 99
                  : item.patientStillHospitalized
                    ? 2
                    : item.hospitalizationDischargeDate
                      ? 1
                      : null,
                dt_discharge_dt: item.hospitalizationDischargeDate,
                //D
                hospReason1: item.hospitalizationReasonAdministration,
                hospReason2: item.hospitalizationReasonMonitorAe,
                hospReason3: item.hospitalizationReasonCrs,
                hospReason4: item.hospitalizationReasonIcans,
                hospReason5: item.hospitalizationReasonOtherae,
                hospReason6: item.hospitalizationReasonOtnernonae,
                hosp_reason_oth_txt: item.hospitalizationReasonOthernonaeTxt,
                hospReasonUnk: item.hospitalizationReasonUnknown,
              };
            });

            setLinvoHospDetails(linvoHospData);
          } else {
            const cohorttreatmentid = isLINVOSelected
              ? RRMMCohortTreatment.Linvoseltamab //GetLocalStorageData("linvoveyID")
              : 0;
            setLinvoHospDetails([
              {
                ...HospitalizationRow,
                cohorttreatmentid,
              },
            ]);
          }
          //end

          //37 LoadData -Elrexfio

          if (
            data.eLcharElrexfioModelList &&
            data.eLcharElrexfioModelList.length > 0
          ) {
            const Q37ElrexDetails = data.eLcharElrexfioModelList.map((item) => {
              const cohortTreatment =
                cohortTreatmentMap.get(item.cohorttreatmentid) || {};

              return {
                cohorttreatmentid: item.cohorttreatmentid,

                elrexlinvocharacteristicsid: item.teclistamabcharacteristicsid,

                Q37ElrexvayliRd: item.dosefrequencyreduced,

                q37_Elr_Dose_week_frquency_txt:
                  item.treatmentInitialDoseFrequencyText,
                q37_Elr_Dose_week_frquencyRd:
                  item.treatmentInitialDoseFrequency,

                q37ElrDosageRd: item.treatmentInitialDosage,
                q37ElrDosageOtherTxt: item.treatmentInitialDosageOthtext,
                q37ElrDosageRdEmpty: false,
                q37ElrDosageOtherTxtEmpty: false,

                showDateRedFreqElr:
                  item.dosefrequencyreduced === 1 ? true : false,

                Q40dosingfreqRd: item.ivigDosageFrequency,
                dosing_freq_oth_txt: item.ivigDosageFrequencyOthTxt,

                Q40IgILevelRd: item.lastIgglevel,

                Q40init_dt: item.ivigInitiationDate,
                Q40init_dt_Rd:
                  item.ivigInitiationDateUnk === true
                    ? 99
                    : item.ivigInitiationDate
                      ? 1
                      : null,
                primaryProf: item.medicationReasonPrimaryProphylactic,
                secondaryProf: item.medicationReasonSecondaryProphylactic,
                otherReson: item.medicationReasonOth,

                //39

                tocilizumab_elr: item.medicationTocilizumab,
                Granulocyte: item.medicationGcsf,
                noneoftheabove_elr: item.medicationNone === true ? 99 : null,
                SteroidsElr: item.medicationSteroids,

                //39 - 1.1
                cytokin_elr: item.dosageusageReasonProphylacticCrs,
                secondary_prophylactic_crs_elr:
                  item.dosageusageReasonSecondaryProphylacticCrs,
                crs_elr: item.dosagusageReasonTreatmentsupportiveCrs,
                neurotoxicity_elr:
                  item.dosagusageReasonProphylacticneurotoxicity,
                secondary_neurotoxicity_elr:
                  item.dosagusageReasonSecondaryProphylacticNeurotoxicity,
                tmt_neurotoxicity_elr:
                  item.dosagusageReasonTreatmentsupportiveNeurotoxicity,
                tmt_elr_unknown: item.dosagusageReasonTreatmentUnknown,
                Q39elrReasonHard: false,

                //39 - 1.3
                prophylactic_use_elr: item.gcsfUsageReasonProphylactic,
                secondary_prophylactic_use_elr:
                  item.gcsfUsageReasonSecondaryProphylactic,
                oth_use_elr: item.gcsfUsageReasonOth,
                unknown_elr: item.gcsfUsageReasonUnk === true ? 99 : null,

                // Steroids Usage Reasons 39.2
                steroid_pre_tmt_elr:
                  item.steroidUsageReasonTreatmentRecommendation,

                cytokin_elr_steroids: item.steroidsUsageReasonProphylacticCrs,
                secondary_prophylactic_elr_steroids:
                  item.steroidsUsageReasonSecondaryProphylacticCrs,
                crs_elr_steroids:
                  item.steroidsUsageReasonTreatmentsupportiveCrs,
                neurotoxicity_elr_steroids:
                  item.steroidsUsageReasonProphylacticneurotoxicity,
                secondary_neurotoxicity_elr_steroids:
                  item.steroidsUsageReasonSecondaryProphylacticNeurologic,
                tmt_neurotoxicity_elr_steroids:
                  item.steroidsUsageReasonTreatmentsupportiveNeurotoxicity,
                tmt_steroids_elr_unknown: item.steroidUsageReasonUnknown,

                betamethasone_elr: item.steroidNameBetamethasone,
                betamethasone_elrNum: item.steroidDoseBetamethasone,

                dexamethasone_elr: item.steroidNameDexamethasone,
                dexamethasone_elrNum: item.steroidDoseDexamethasone,

                hydrocortisone_elr: item.steroidNameHydrocortisone,
                hydrocortisone_elrNum: item.steroidDoseHydrocortisone,

                methylprednisolone: item.steroidNameMethylprednisolone,
                methylprednisoloneNum: item.steroidDoseMethylprednisolone,

                prednisolone_elr: item.steroidNamePrednisolone,
                prednisolone_elrNum: item.steroidDosePrednisolone,

                prednisone_elr: item.steroidNamePrednisone,
                prednisone_elrNum: item.steroidDosePrednisone,

                triamcinolone_elr: item.steroidNameTriamcinolone,
                triamcinolone_elrNum: item.steroidDoseTriamcinolone,

                dose_name_elr_unknown: item.steroidDoseNameUnknown,

                name_dose_steroidsHardEmpty: false,

                steroids_elr_txtEmpty: false,
                Q39ElrEmptyHard: false,

                q37ElrexvayliEmpty: false,
                Q40DosingFreqEmptyHard: false,
                Q40DosingFreqTxtEmptyHard: false,
                Q40IgGEmptyHard: false,
                Q40Init_dtHard: false,
                InvalidQ40init_dt: false,
                init_dt_before_eof: false,
                Q40Init_RdHard: false,
                Q40ReasonEmptyHard: false,
                q37_Elr_Dose_week_frquency_txt_Empty: false,
                q37_Elr_Dose_week_freq_range: false,
                q37_Elr_Dose_week_frquencyRd_Empty: false,
                q37SubsequentDoseConflict: false,
                Q39elrGranduloEmptyHard: false,

                Q39elrSteroidsEmptyHard: false,
              };
            });

            setQ37ElrexDetails(Q37ElrexDetails);
          }

          //37 LoadData -Linvoseltamab

          if (
            data.eLcharLinvoseltamabModelList &&
            data.eLcharLinvoseltamabModelList.length > 0
          ) {
            const Q37LinvoDetails = data.eLcharLinvoseltamabModelList.map(
              (item) => {
                return {
                  cohorttreatmentid: item.cohorttreatmentid,
                  elrexlinvocharacteristicsid:
                    item.teclistamabcharacteristicsid,

                  Q37LinvoveyRd: item.dosefrequencyreduced,

                  showDateRedFreqLinvo:
                    item.dosefrequencyreduced === 1 ? true : false,

                  //37 Linvoseltamab
                  q37_Linvo_Dose_week_frquency_txt:
                    item.treatmentInitialDoseFrequencyText,
                  q37_Linvo_Dose_week_frquencyRd:
                    item.treatmentInitialDoseFrequency,
                  q37_Linvo_Dosage_Rd: item.treatmentInitialDosage,
                  q37_Linvo_Dosage_OtherTxt: item.treatmentInitialDosageOthtext,

                  //39 Linvoseltamab data

                  // Medications
                  tocilizumab_linvo: item.medicationTocilizumab,
                  Steroids: item.medicationSteroids,
                  granulocyte_linvo: item.medicationGcsf ?? false,
                  noneoftheabove_linvo:
                    item.medicationNone === true ? 99 : null,

                  // Dosage Usage Reasons -- 39.1
                  cytokin_linvo: item.dosageusageReasonProphylacticCrs,
                  secondary_prophylactic_crs_linvo:
                    item.dosageusageReasonSecondaryProphylacticCrs,
                  crs_linvo: item.dosagusageReasonTreatmentsupportiveCrs,
                  neurotoxicity_linvo:
                    item.dosagusageReasonProphylacticneurotoxicity,
                  secondary_neurotoxicity_linvo:
                    item.dosagusageReasonSecondaryProphylacticNeurotoxicity,
                  tmt_neurotoxicity_linvo:
                    item.dosagusageReasonTreatmentsupportiveNeurotoxicity,
                  tmt_linvoseltamab_unknown:
                    item.dosagusageReasonTreatmentUnknown,

                  //39 - 1.3
                  prophylactic_use_linvo: item.gcsfUsageReasonProphylactic,
                  secondary_prophylactic_use_linvo:
                    item.gcsfUsageReasonSecondaryProphylactic,
                  oth_use_linvo: item.gcsfUsageReasonOth,
                  unknown_linvo: item.gcsfUsageReasonUnk === true ? 99 : null,

                  // Steroids Usage Reasons 39.2
                  cytokin_linvo_steroids:
                    item.steroidsUsageReasonProphylacticCrs,
                  secondary_prophylactic_linvo_steroids:
                    item.steroidsUsageReasonSecondaryProphylacticCrs,
                  crs_linvo_steroids:
                    item.steroidsUsageReasonTreatmentsupportiveCrs,
                  neurotoxicity_linvo_steroids:
                    item.steroidsUsageReasonProphylacticneurotoxicity,
                  secondary_neurotoxicity_linvo_steroids:
                    item.steroidsUsageReasonSecondaryProphylacticNeurologic,
                  tmt_neurotoxicity_linvo_steroids:
                    item.steroidsUsageReasonTreatmentsupportiveNeurotoxicity,
                  tmt_linvo_unknown: item.steroidUsageReasonUnknown,
                  steroid_pre_tmt_linvo:
                    item.steroidUsageReasonTreatmentRecommendation,

                  betamethasone_linvo: item.steroidNameBetamethasone,
                  betamethasone_linvoNum: item.steroidDoseBetamethasone,

                  dexamethasone_linvo: item.steroidNameDexamethasone,
                  dexamethasone_linvoNum: item.steroidDoseDexamethasone,

                  hydrocortisone_linvo: item.steroidNameHydrocortisone,
                  hydrocortisone_linvoNum: item.steroidDoseHydrocortisone,

                  methylprednisolone_linvo: item.steroidNameMethylprednisolone,
                  methylprednisolone_linvoNum:
                    item.steroidDoseMethylprednisolone,

                  prednisolone_linvo: item.steroidNamePrednisolone,
                  prednisolone_linvoNum: item.steroidDosePrednisolone,

                  prednisone_linvo: item.steroidNamePrednisone,
                  prednisone_linvoNum: item.steroidDosePrednisone,

                  triamcinolone_linvo: item.steroidNameTriamcinolone,
                  triamcinolone_linvoNum: item.steroidDoseTriamcinolone,

                  dose_name_linvo_unknown: item.steroidDoseNameUnknown,

                  name_dose_steroids_linvoHardEmpty: false,
                  steroids_linvo_txtEmpty: false,

                  q37LinvoveyEmpty: false,
                  Q39LinvoEmptyHard: false,
                  Q39linvoReasonHard: false,
                  Q39linvoSteroidsEmptyHard: false,
                  q37_Linvo_Dose_week_frquencyRd_Empty: false,
                  q37_Linvo_Dose_week_frquency_txt_Empty: false,
                  q37_Linvo_Dose_week_freq_range: false,
                  q37LinvoSubsequentDoseConflict: false,

                  q37_Linvo_Dosage_Rd_Empty: false,
                  q37_Linvo_Dosage_OtherTxt_Empty: false,
                  Q39linvoGranduloEmptyHard: false,

                  //Q40
                  q40DosingFreqRd_linvo: item.ivigDosageFrequency,
                  dosing_Freq_Oth_Txt_linvo: item.ivigDosageFrequencyOthTxt,
                  q40IgILevelRd_linvo: item.lastIgglevel,
                  q40Init_Dt_linvo: item.ivigInitiationDate,
                  q40Init_Dt_Rd_linvo:
                    item.ivigInitiationDateUnk === true
                      ? 99
                      : item.ivigInitiationDate
                        ? 1
                        : null,
                  primaryProf_linvo: item.medicationReasonPrimaryProphylactic,
                  secondaryProf_linvo:
                    item.medicationReasonSecondaryProphylactic,
                  otherReson_linvo: item.medicationReasonOth,
                  Q40LinvoDosingFreqEmptyHard: false,
                  Q40LinvoDosingFreqTxtEmptyHard: false,
                  Q40LinvoIgGEmptyHard: false,
                  Q40LinvoInit_dtHard: false,
                  invalidQ40Init_dt_linvo: false,
                  init_dt_before_eof_linvo: false,
                  Q40LinvoInit_RdHard: false,
                  Q40LinvoReasonEmptyHard: false,
                };
              },
            );

            setQ37LinvoDetails(Q37LinvoDetails);
          }

          // Q38
          // Process LinvoseltamabData
          if (
            data.q38LinvoseltamabData &&
            data.q38LinvoseltamabData.length > 0
          ) {
            const Q38LinvoDetails = data.q38LinvoseltamabData.map((item) => {
              const cohortTreatment =
                cohortTreatmentMap.get(item.cohorttreatmentid) || {};

              return {
                cohorttreatmentid: item.cohorttreatmentid,

                elrexlinvodosefrequencybridgeid:
                  item.teclistamatalquetamabdosefrequencybridgeid,

                Q38LinvoveyRd: item.dosefreqReductionDate
                  ? 1
                  : item.dosefreqReductionDateUnk === true
                    ? 99
                    : null,
                dt_dosefreq_linvo_dt: item.dosefreqReductionDate,

                Q38LinvoEmptyHard: false,
                Q38LinvoDateEmpty: false,
                Q38LinvoDateInvalid: false,
                InvalidQ38Linvoveydate: false,
                q38_Linvo_Dose_week_frquencyRd_Empty: false,
                q38_Linvo_Dose_week_frquency_txt_Empty: false,
                q38LinvoDoseFrequencyConflict: false,

                q38_Linvo_Dosage_Rd_Empty: false,
                q38_Linvo_Dosage_OtherTxt_Empty: false,

                q38_Linvo_Dose_week_frquency_txt:
                  item.treatmentInitialDoseFrequencyText,

                q38_Linvo_Dose_week_frquencyRd:
                  item.treatmentInitialDoseFrequency,

                q38_Linvo_Dosage_OtherTxt: item.treatmentInitialDosageOthtext,
                q38_Linvo_Dosage_Rd: item.treatmentInitialDosage,
              };
            });

            setQ38LinvoDetails(Q38LinvoDetails);
          } else {
            const cohortTreatmentid = isLINVOSelected
              ? RRMMCohortTreatment.Linvoseltamab //GetLocalStorageData("linvoveyID")
              : 0;

            // Update ElrexvayliRow with cohorttreatmentid only
            Q38LinvoRow.cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            Q38LinvoRow.elrexlinvodosefrequencybridgeid =
              Q38LinvoRow.teclistamatalquetamabdosefrequencybridgeid || 0;

            Q38LinvoRow.Q38LinvoveyRd = Q38LinvoRow.Q38LinvoveyRd || null;
            Q38LinvoRow.dt_dosefreq_linvo_dt =
              Q38LinvoRow.dt_dosefreq_linvo_dt || "";
          }

          //38
          // Process Elrexfio Data
          if (data.q38ElrexfioData && data.q38ElrexfioData.length > 0) {
            const Q38ElrexDetails = data.q38ElrexfioData.map((item) => {
              const cohortTreatment =
                cohortTreatmentMap.get(item.cohorttreatmentid) || {};

              return {
                cohorttreatmentid: item.cohorttreatmentid,

                elrexlinvodosagebridgeid:
                  item.teclistamatalquetamabdosefrequencybridgeid,

                Q38ElrexvayliRd: item.dosefreqReductionDate
                  ? 1
                  : item.dosefreqReductionDateUnk === true
                    ? 99
                    : null,
                dt_dosefreq_elr_dt: item.dosefreqReductionDate,

                Q38ElrexEmptyHard: false,
                Q38DateEmpty: false,
                Q38ElrexDateInvalid: false,
                Invalid_dt_dosefreq_elr_dt: false,

                q38_Elr_Dose_week_frquencyRd_Empty: false,
                q38_Elr_Dose_week_frquency_txt_Empty: false,
                q38ElrDoseFrequencyConflict: false,

                q38_Elr_Dose_week_frquency_txt:
                  item.treatmentInitialDoseFrequencyText,
                q38_Elr_Dose_week_frquencyRd:
                  item.treatmentInitialDoseFrequency,
              };
            });

            setQ38ElrexDetails(Q38ElrexDetails);
          } else {
            const cohortTreatmentid = isTACSelected
              ? RRMMCohortTreatment.ELREXFIO //GetLocalStorageData("elrexvayliID")
              : 0;

            // Update ElrexvayliRow with cohorttreatmentid only
            Q38ElrexRow.cohorttreatmentid = cohortTreatmentid || 0;

            // Retain the remaining fields as is
            Q38ElrexRow.elrexlinvodosefrequencybridgeid =
              Q38ElrexRow.teclistamatalquetamabdosefrequencybridgeid || 0;

            Q38ElrexRow.Q38ElrexvayliRd = Q38ElrexRow.Q38ElrexvayliRd || null;
            Q38ElrexRow.dt_dosefreq_elr_dt =
              Q38ElrexRow.dt_dosefreq_elr_dt || "";
          }

          // Q38.1.A ELREXFIO - Load data
          if (data.q381AElrexfioData && data.q381AElrexfioData.length > 0) {
            const mappedElrex381A = data.q381AElrexfioData.map((item) => {
              return {
                teclistamatalquetamabdosefrequencybridgeid:
                  item.teclistamatalquetamabdosefrequencyinfobridgeid,
                cohorttreatmentid: item.cohorttreatmentid,

                // Column B
                changeType: item.changeType,
                changeTypeDoseFrequency: item.changeTypeDoseFrequency,
                changeTypeDoseStrength: item.changeTypeDoseStrength,

                reasonUnknown: item.bispecifictreatmentdiscontinuationreasonUnk,

                // ✅ Column C - Direct from backend (singular)
                selectedReasons:
                  item.reasonList
                    ?.filter((r) => r.isSelected)
                    .map((r) => r.bispecifictreatmentdiscontinuationreasonid) ||
                  [],

                selectedAEReasons:
                  item.reasonList
                    ?.find(
                      (r) => r.bispecifictreatmentdiscontinuationreasonid === 2,
                    )
                    ?.aeSubReasons?.filter((ae) => ae.isSelected)
                    .map(
                      (ae) => ae.bispecifictreatmentdiscontinuationreasonaeid,
                    ) || [],
                neurologicAEReasonList: item?.neurologicAEReasonList ?? [],

                reasonOtherText: item.reasonOtherText || "",
                // reasonUnknown:
                //   item.reasonList?.some(
                //     (r) =>
                //       r.bispecifictreatmentdiscontinuationreasonid === 99 &&
                //       r.isSelected
                //   ) || false,

                reasonList: item.reasonList || [],

                // ✅ Column D - Pattern BEFORE (split single unit field)
                patterBeforeChangeDoseFrequency:
                  item.patternBeforeChangeDoseFrequency,

                // For frequency: split based on radio selection
                patterBeforeChangeDoseFrequencyTimesPerWeek:
                  item.patternBeforeChangeDoseFrequency === 1
                    ? item.patternBeforeChangeDoseFrequencyWeek?.toString() ||
                      ""
                    : "",
                patterBeforeChangeDoseFrequencyWeek:
                  item.patternBeforeChangeDoseFrequency === 2
                    ? item.patternBeforeChangeDoseFrequencyWeek?.toString() ||
                      ""
                    : "",

                // For strength: split single unit based on radio selection
                patterBeforeChangeDoseStrength:
                  item.patternBeforeChangeDoseStrength,
                patterBeforeChangeDoseStrengthMg:
                  item.patternBeforeChangeDoseStrength === 1
                    ? item.patternBeforeChangeDoseStrengthUnit?.toString() || ""
                    : "",
                patterBeforeChangeDoseStrengthMgKg:
                  item.patternBeforeChangeDoseStrength === 2
                    ? item.patternBeforeChangeDoseStrengthUnit?.toString() || ""
                    : "",
                patterBeforeChangeDoseStrengthMgM2:
                  item.patternBeforeChangeDoseStrength === 3
                    ? item.patternBeforeChangeDoseStrengthUnit?.toString() || ""
                    : "",

                // ✅ Column E - Pattern AFTER (split single unit field)
                patterAfterChangeDoseFrequency:
                  item.patternAfterChangeDoseFrequency,

                // For frequency: split based on radio selection
                patterAfterChangeDoseFrequencyTimesPerWeek:
                  item.patternAfterChangeDoseFrequency === 1
                    ? item.patternAfterChangeDoseFrequencyWeek?.toString() || ""
                    : "",
                patterAfterChangeDoseFrequencyWeek:
                  item.patternAfterChangeDoseFrequency === 2
                    ? item.patternAfterChangeDoseFrequencyWeek?.toString() || ""
                    : "",

                // For strength: split single unit based on radio selection
                patterAfterChangeDoseStrength:
                  item.patternAfterChangeDoseStrength,
                patterAfterChangeDoseStrengthMg:
                  item.patternAfterChangeDoseStrength === 1
                    ? item.patternAfterChangeDoseStrengthUnit?.toString() || ""
                    : "",
                patterAfterChangeDoseStrengthMgKg:
                  item.patternAfterChangeDoseStrength === 2
                    ? item.patternAfterChangeDoseStrengthUnit?.toString() || ""
                    : "",
                patterAfterChangeDoseStrengthMgM2:
                  item.patternAfterChangeDoseStrength === 3
                    ? item.patternAfterChangeDoseStrengthUnit?.toString() || ""
                    : "",

                // Column F
                dateChangeRd:
                  item.dateChangeUnk === true ? 99 : item.dateChange ? 1 : null,
                dateChange: item.dateChange || "",

                // Validation flags
                changeTypeEmpty: false,
                changeTypeDoseFrequencyEmpty: false,
                changeTypeDoseStrengthEmpty: false,
                reasonEmpty: false,
                deathDtWarning: false,
                reasonOtherTextEmpty: false,
                patternBeforeFrequencyEmpty: false,
                patternBeforeFrequencyRangeInvalid: false,
                patternBeforeStrengthEmpty: false,
                patternBeforeFrequencyRangeInvalid: false,
                patternAfterFrequencyEmpty: false,
                patternAfterFrequencyRangeInvalid: false,
                patternAfterStrengthEmpty: false,
                patternAfterStrengthRangeInvalid: false,
                dateChangeRdEmpty: false,
                dateChangeEmpty: false,
                invalidDateChange: false,
                dateChangeOutOfBound: false,
                dateChangeBeforeEOF: false,
                frequencyIncreaseConflict: false,
                frequencyDecreaseConflict: false,
                strengthIncreaseConflict: false,
                strengthDecreaseConflict: false,
                patternBeforeUnknownWarning:
                  item.patternBeforeChangeDoseStrength === 99 ||
                  item.patternBeforeChangeDoseFrequency === 99,
                patternAfterUnknownWarning:
                  item.patternAfterChangeDoseStrength === 99 ||
                  item.patternAfterChangeDoseFrequency === 99,
                aeSubReasonEmpty: false,
                neuroReasonEmpty: false,
                neuroOtherTextEmpty: false,
              };
            });

            setQ381AElrexDetails(mappedElrex381A);
          } else {
            const staticReasonList =
              data.q381AElrexfioData?.[0]?.reasonList || [];
            // ✅ For new row, fetch template reasonList from backend
            setQ381AElrexDetails([
              {
                ...Q381AElrexRow,
                cohorttreatmentid: isElrexvayliSelected
                  ? RRMMCohortTreatment.ELREXFIO
                  : 0,
                reasonList: staticReasonList,
              },
            ]);
          }

          // Q38.1.A LINVOSELTAMAB - Load data
          if (
            data.q381ALinvoseltamabData &&
            data.q381ALinvoseltamabData.length > 0
          ) {
            const mappedLinvo381A = data.q381ALinvoseltamabData.map((item) => {
              return {
                teclistamatalquetamabdosefrequencybridgeid:
                  item.teclistamatalquetamabdosefrequencyinfobridgeid,
                cohorttreatmentid: item.cohorttreatmentid,

                // Column B
                changeType: item.changeType,
                changeTypeDoseFrequency: item.changeTypeDoseFrequency,
                changeTypeDoseStrength: item.changeTypeDoseStrength,
                reasonUnknown: item.bispecifictreatmentdiscontinuationreasonUnk,

                // ✅ Column C - Direct from backend (singular)
                selectedReasons:
                  item.reasonList
                    ?.filter((r) => r.isSelected)
                    .map((r) => r.bispecifictreatmentdiscontinuationreasonid) ||
                  [],

                selectedAEReasons:
                  item.reasonList
                    ?.find(
                      (r) => r.bispecifictreatmentdiscontinuationreasonid === 2,
                    )
                    ?.aeSubReasons?.filter((ae) => ae.isSelected)
                    .map(
                      (ae) => ae.bispecifictreatmentdiscontinuationreasonaeid,
                    ) || [],
                neurologicAEReasonList: item?.neurologicAEReasonList ?? [],

                reasonOtherText: item.reasonOtherText || "",

                reasonList: item.reasonList || [],

                // ✅ Column D - Pattern BEFORE (split single unit field)
                patterBeforeChangeDoseFrequency:
                  item.patternBeforeChangeDoseFrequency,

                patterBeforeChangeDoseFrequencyTimesPerWeek:
                  item.patternBeforeChangeDoseFrequency === 1
                    ? item.patternBeforeChangeDoseFrequencyWeek?.toString() ||
                      ""
                    : "",
                patterBeforeChangeDoseFrequencyWeek:
                  item.patternBeforeChangeDoseFrequency === 2
                    ? item.patternBeforeChangeDoseFrequencyWeek?.toString() ||
                      ""
                    : "",

                patterBeforeChangeDoseStrength:
                  item.patternBeforeChangeDoseStrength,
                patterBeforeChangeDoseStrengthMg:
                  item.patternBeforeChangeDoseStrength === 1
                    ? item.patternBeforeChangeDoseStrengthUnit?.toString() || ""
                    : "",
                patterBeforeChangeDoseStrengthMgKg:
                  item.patternBeforeChangeDoseStrength === 2
                    ? item.patternBeforeChangeDoseStrengthUnit?.toString() || ""
                    : "",
                patterBeforeChangeDoseStrengthMgM2:
                  item.patternBeforeChangeDoseStrength === 3
                    ? item.patternBeforeChangeDoseStrengthUnit?.toString() || ""
                    : "",

                // ✅ Column E - Pattern AFTER (split single unit field)
                patterAfterChangeDoseFrequency:
                  item.patternAfterChangeDoseFrequency,

                patterAfterChangeDoseFrequencyTimesPerWeek:
                  item.patternAfterChangeDoseFrequency === 1
                    ? item.patternAfterChangeDoseFrequencyWeek?.toString() || ""
                    : "",
                patterAfterChangeDoseFrequencyWeek:
                  item.patternAfterChangeDoseFrequency === 2
                    ? item.patternAfterChangeDoseFrequencyWeek?.toString() || ""
                    : "",

                patterAfterChangeDoseStrength:
                  item.patternAfterChangeDoseStrength,
                patterAfterChangeDoseStrengthMg:
                  item.patternAfterChangeDoseStrength === 1
                    ? item.patternAfterChangeDoseStrengthUnit?.toString() || ""
                    : "",
                patterAfterChangeDoseStrengthMgKg:
                  item.patternAfterChangeDoseStrength === 2
                    ? item.patternAfterChangeDoseStrengthUnit?.toString() || ""
                    : "",
                patterAfterChangeDoseStrengthMgM2:
                  item.patternAfterChangeDoseStrength === 3
                    ? item.patternAfterChangeDoseStrengthUnit?.toString() || ""
                    : "",

                // Column F
                dateChangeRd:
                  item.dateChangeUnk === true ? 99 : item.dateChange ? 1 : null,
                dateChange: item.dateChange || "",

                // Validation flags (all false initially)
                changeTypeEmpty: false,
                changeTypeDoseFrequencyEmpty: false,
                changeTypeDoseStrengthEmpty: false,
                reasonEmpty: false,
                deathDtWarning: false,
                reasonOtherTextEmpty: false,
                patternBeforeFrequencyEmpty: false,
                patternBeforeFrequencyRangeInvalid: false,
                patternBeforeStrengthEmpty: false,
                patternBeforeFrequencyRangeInvalid: false,
                patternAfterFrequencyEmpty: false,
                patternAfterFrequencyRangeInvalid: false,
                patternAfterStrengthEmpty: false,
                patternAfterStrengthRangeInvalid: false,
                dateChangeRdEmpty: false,
                dateChangeEmpty: false,
                invalidDateChange: false,
                dateChangeOutOfBound: false,
                dateChangeBeforeEOF: false,
                frequencyIncreaseConflict: false,
                frequencyDecreaseConflict: false,
                strengthIncreaseConflict: false,
                strengthDecreaseConflict: false,
                patternBeforeUnknownWarning:
                  item.patternBeforeChangeDoseStrength === 99 ||
                  item.patternBeforeChangeDoseFrequency === 99,
                patternAfterUnknownWarning:
                  item.patternAfterChangeDoseStrength === 99 ||
                  item.patternAfterChangeDoseFrequency === 99,
                aeSubReasonEmpty: false,
                neuroReasonEmpty: false,
                neuroOtherTextEmpty: false,
              };
            });

            setQ381ALinvoDetails(mappedLinvo381A);
          } else {
            const staticReasonList =
              data.q381ALinvoseltamabData?.[0]?.reasonList || [];

            // For new row, fetch template reasonList from backend
            setQ381ALinvoDetails([
              {
                ...Q381ALinvoRow,
                cohorttreatmentid: isLinvoveySelected
                  ? RRMMCohortTreatment.Linvoseltamab
                  : 0,
                reasonList: staticReasonList,
              },
            ]);
          }

          //           // Q38.2.A ELREXFIO - Load data
          if (data.q382AElrexfioData && data.q382AElrexfioData.length > 0) {
            const mappedElrex382A = data.q382AElrexfioData.map((item) => {
              return {
                teclistamatalquetamabdosefrequencyinfobridgeid:
                  item.teclistamatalquetamabdosedelaybridgeid,
                cohorttreatmentid: item.cohorttreatmentid,

                changeType: item.interruptType,

                // ✅ Add reasonList here
                reasonList: item.reasonList || [],

                selectedReasons:
                  item.reasonList
                    ?.filter((r) => r.isSelected)
                    .map((r) => r.bispecifictreatmentdiscontinuationreasonid) ||
                  [],
                selectedAEReasons:
                  item.reasonList
                    ?.find(
                      (r) => r.bispecifictreatmentdiscontinuationreasonid === 2,
                    )
                    ?.aeSubReasons?.filter((ae) => ae.isSelected)
                    .map(
                      (ae) => ae.bispecifictreatmentdiscontinuationreasonaeid,
                    ) || [],
                neurologicAEReasonList: item?.neurologicAEReasonList ?? [],
                reasonOtherText: item.reasonOtherText || "",
                reasonUnknown: item.bispecifictreatmentdiscontinuationreasonUnk,

                startDateChangeRd: item.interruptStartDateUnk
                  ? 99
                  : item.interruptStartDate
                    ? 1
                    : null,
                startDateChange: item.interruptStartDate || "",

                endDateChangeRd:
                  item.interruptEndOngoingUnk === 99
                    ? 99
                    : item.interruptEndOngoingUnk === 1
                      ? 1
                      : item.interruptEndDate
                        ? 2
                        : null,
                endDateChange: item.interruptEndDate || "",

                // All validation flags false
                changeTypeEmpty: false,
                reasonEmpty: false,
                deathDtWarning: false,
                reasonOtherTextEmpty: false,
                aeSubReasonEmpty: false,
                neuroReasonEmpty: false,
                neuroOtherTextEmpty: false,
                startDateChangeRdEmpty: false,
                startDateChangeEmpty: false,
                invalidStartDateChange: false,
                startDateChangeOutOfBound: false,
                endDateChangeRdEmpty: false,
                endDateChangeEmpty: false,
                invalidEndDateChange: false,
                endDateChangeOutOfBound: false,
                interruptionStartDateUnknownWarning: item.interruptStartDateUnk,
                interruptionEndDateUnknownWarning:
                  item.interruptEndOngoingUnk === 99,
              };
            });

            setQ382AElrexDetails(mappedElrex382A);
          } else {
            const staticReasonList =
              data.q382AElrexfioData?.[0]?.reasonList || [];
            setQ382AElrexDetails([
              {
                ...Q382AElrexRow,
                cohorttreatmentid: isElrexvayliSelected
                  ? RRMMCohortTreatment.ELREXFIO
                  : 0,
                reasonList: staticReasonList,
              },
            ]);
          }

          // Q38.2.A LINVOSELTAMAB - Load data
          if (
            data.q382ALinvoseltamabData &&
            data.q382ALinvoseltamabData.length > 0
          ) {
            const mappedLinvo382A = data.q382ALinvoseltamabData.map((item) => {
              return {
                teclistamatalquetamabdosefrequencyinfobridgeid:
                  item.teclistamatalquetamabdosedelaybridgeid,
                cohorttreatmentid: item.cohorttreatmentid,

                // Column B
                changeType: item.interruptType,

                // Column C - Reasons
                selectedReasons:
                  item.reasonList
                    ?.filter((r) => r.isSelected)
                    .map((r) => r.bispecifictreatmentdiscontinuationreasonid) ||
                  [],
                selectedAEReasons:
                  item.reasonList
                    ?.find(
                      (r) => r.bispecifictreatmentdiscontinuationreasonid === 2,
                    )
                    ?.aeSubReasons?.filter((ae) => ae.isSelected)
                    .map(
                      (ae) => ae.bispecifictreatmentdiscontinuationreasonaeid,
                    ) || [],
                neurologicAEReasonList: item?.neurologicAEReasonList ?? [],
                reasonOtherText: item.reasonOtherText || "",
                reasonUnknown: item.bispecifictreatmentdiscontinuationreasonUnk,
                reasonList: item.reasonList || [],

                // Column D - Start date
                startDateChangeRd: item.interruptStartDateUnk
                  ? 99
                  : item.interruptStartDate
                    ? 1
                    : null,
                startDateChange: item.interruptStartDate || "",

                // Column E - End date
                endDateChangeRd:
                  item.interruptEndOngoingUnk === 99
                    ? 99
                    : item.interruptEndOngoingUnk === 1
                      ? 1
                      : item.interruptEndDate
                        ? 2
                        : null,
                endDateChange: item.interruptEndDate || "",

                // Validation flags
                changeTypeEmpty: false,
                reasonEmpty: false,
                deathDtWarning: false,
                reasonOtherTextEmpty: false,
                aeSubReasonEmpty: false,
                neuroReasonEmpty: false,
                neuroOtherTextEmpty: false,
                startDateChangeRdEmpty: false,
                startDateChangeEmpty: false,
                invalidStartDateChange: false,
                startDateChangeOutOfBound: false,
                endDateChangeRdEmpty: false,
                endDateChangeEmpty: false,
                invalidEndDateChange: false,
                endDateChangeOutOfBound: false,
                interruptionStartDateUnknownWarning: item.interruptStartDateUnk,
                interruptionEndDateUnknownWarning:
                  item.interruptEndOngoingUnk === 99,
              };
            });

            setQ382ALinvoDetails(mappedLinvo382A);
          } else {
            const staticReasonList =
              data.q382ALinvoseltamabData?.[0]?.reasonList;
            setQ382ALinvoDetails([
              {
                ...Q382ALinvoRow,
                cohorttreatmentid: isLinvoveySelected
                  ? RRMMCohortTreatment.Linvoseltamab
                  : 0,
                reasonList: staticReasonList,
              },
            ]);
          }

          //Q39.1.A
          // Elrex
          const elrSource = data?.elrexfioTocilizumabData ?? [];

          const elrTocilData =
            elrSource.length > 0
              ? elrSource.map((item) => ({
                  ...q391AElrRow,
                  tocilizumabmedicationid: item.tocilizumabmedicationid,
                  cohorttreatmentid: item.cohorttreatmentid,
                  patientid: item.patientid,

                  primaryProphylacticCrs_elr: item.primaryProphylacticCrs,
                  secondaryProphylacticCrs_elr: item.secondaryProphylacticCrs,
                  supportiveCareCrs_elr: item.supportiveCareCrs,
                  primaryProphylacticNeurologic_elr:
                    item.primaryProphylacticNeurologic,
                  secondaryProphylacticNeurologic_elr:
                    item.secondaryProphylacticNeurologic,
                  supportiveCareNeurologic_elr: item.supportiveCareNeurologic,
                  medicationReasonUnk_elr: item.medicationReasonUnk,
                  q39ElrReasonEmpty: false,

                  // 39.1.A
                  administrationDate_elr: item.tocilizumabAdministrationDate,
                  administrationDateRD_elr:
                    item.tocilizumabAdministrationDateUnk
                      ? 99
                      : item.tocilizumabAdministrationDate
                        ? 1
                        : null,

                  q39ElrInvalidAdministrationDate: false,
                  q39ElrAdministrationDateEmpty: false,
                  q39ElrAdministrationRDEmpty: false,
                }))
              : [
                  {
                    ...q391AElrRow,
                    patientid: data?.patientid,
                  },
                ];

          setQ391AElrTocilzumabList(elrTocilData);
          setQ391AElrAdministrationDateOutOfRange(false);

          // Linvo
          const linvoSource = data?.linvoseltamabTocilizumabData ?? [];

          const linvoTocilData =
            linvoSource.length > 0
              ? linvoSource.map((item) => ({
                  ...q391ALinvoRow,
                  tocilizumabmedicationid: item.tocilizumabmedicationid,
                  cohorttreatmentid: item.cohorttreatmentid,
                  patientid: item.patientid,

                  primaryProphylacticCrs_linvo: item.primaryProphylacticCrs,
                  secondaryProphylacticCrs_linvo: item.secondaryProphylacticCrs,
                  supportiveCareCrs_linvo: item.supportiveCareCrs,
                  primaryProphylacticNeurologic_linvo:
                    item.primaryProphylacticNeurologic,
                  secondaryProphylacticNeurologic_linvo:
                    item.secondaryProphylacticNeurologic,
                  supportiveCareNeurologic_linvo: item.supportiveCareNeurologic,

                  medicationReasonUnk_linvo: item.medicationReasonUnk,
                  q39LinvoReasonEmpty: false,

                  // 39.1.A
                  administrationDate_linvo: item.tocilizumabAdministrationDate,
                  administrationDateRD_linvo:
                    item.tocilizumabAdministrationDateUnk
                      ? 99
                      : item.tocilizumabAdministrationDate
                        ? 1
                        : null,

                  q39LinvoInvalidAdministrationDate: false,
                  q39LinvoAdministrationDateEmpty: false,
                  q39LinvoAdministrationRDEmpty: false,
                }))
              : [
                  {
                    ...q391ALinvoRow,
                    patientid: data?.patientid,
                  },
                ];
          setQ391ALinvoAdministrationDateOutOfRange(false);
          setQ391ALinvoTocilzumabList(linvoTocilData);
        } else if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  };

  useEffect(() => {
    async function FetchData() {
      if (!isNaN(pid) && Number(pid) !== 0) {
        ToggleLoader(true);
        await LoadData();
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  const HandleRepeaterFieldChange = (e) => {
    const { name, id, value } = e.target;
    const value_int = Number(value);
    const index = Number(id);

    switch (name) {
      // Elrexfio

      case "dose_administration_elr" + id: {
        let updatedArray = [...elrexvayliDetails];

        updatedArray[id].dose_administration_elr = value_int;
        updatedArray[id].dose_administration_elr_dt = "";

        updatedArray[id].dose_administration_elrHard = false;

        updatedArray[id].dose_administration_elrHard_dt = false;
        updatedArray[id].Invalid_dose_administration_elr_dt = false;
        updatedArray[id].dose_administration_elr_dt_before_eof = false;
        // updatedArray[id].dt_elr_greater_prevCheck = false;
        updatedArray[id].dt_elr_date_out_of_bound = false;
        // if(updatedArray[id].dose_administration_elr===99){
        // }
        setIndexDateRRMM_elrHard(false);
        setElrexvayliDetails(updatedArray);
        setDt_elr_2L_3L_date_conditions(false);
        setIsElrLastAdminDateValid(true);
        break;
      }

      case "dosing_phase_elr" + id: {
        let updatedArray = [...elrexvayliDetails];

        updatedArray[id].dosing_phase_elr = value_int;

        updatedArray[id].dosing_phase_elrHard = false;
        updatedArray[id].dosing_phase_oth_txt_elr = "";
        updatedArray[id].dosing_phase_elrHard_othEmpty = false;

        if (
          (value_int === 1 || value_int === 2 || value_int === 3) &&
          (updatedArray[id].siteofcare_elr === 1 ||
            updatedArray[id].siteofcare_elr === 3)
        ) {
          updatedArray[id].Q36ElrexConditionMet = true;
        } else {
          updatedArray[id].Q36ElrexConditionMet = false;
        }

        let updatedArrayQ37 = [...Q37ElrexDetails];
        if (elrexvayliDetails.some((item) => item.dosing_phase_elr != 4)) {
          updatedArrayQ37[0].q37_Elr_Dose_week_frquencyRd = null;
          updatedArrayQ37[0].q37_Elr_Dose_week_frquency_txt = "";
          updatedArrayQ37[0].q37_Elr_Dose_week_frquencyRd_Empty = false;
          updatedArrayQ37[0].q37_Elr_Dose_week_frquency_txt_Empty = false;
          updatedArrayQ37[0].q37_Elr_Dose_week_freq_range = false;
        }
        setQ37ElrexDetails(updatedArrayQ37);
        setElrexvayliDetails(updatedArray);

        const duplicates = CheckDuplicatePhasesRealtime(
          updatedArray,
          "elrexfio",
        );
        setElrexfioDuplicatePhaseWarning(
          duplicates.length > 0 ? duplicates : null,
        );

        const missingStepUp = CheckMissingStepUpDosesRealtime(
          updatedArray,
          "elrexfio",
        );
        setElrexfioMissingStepUpWarning(missingStepUp);

        break;
      }

      case "dosing_phase_oth_txt_elr" + id: {
        let updatedArray = [...elrexvayliDetails];

        updatedArray[id].dosing_phase_oth_txt_elr = value;
        updatedArray[id].dosing_phase_elr = 5;

        updatedArray[id].dosing_phase_elrHard = false;
        updatedArray[id].dosing_phase_elrHard_othEmpty = false;

        setElrexvayliDetails(updatedArray);
        break;
      }

      case "elr_dose_strength_mg_kg" + id: {
        let updatedArray = [...elrexvayliDetails];

        updatedArray[id].elr_dose_strength_mg = "";
        updatedArray[id].elr_dose_strength_mg_kg = value;
        updatedArray[id].elr_dose_strength_mgm = "";
        updatedArray[id].elr_dose_strength_rbl = 2;
        updatedArray[id].elr_dose_strength_mg_kgHard = false;
        updatedArray[id].elr_dose_strength_mg_kgRange = false;

        setElrexvayliDetails(updatedArray);
        break;
      }
      case "elr_dose_strength_mg" + id: {
        let updatedArray = [...elrexvayliDetails];
        updatedArray[id].elr_dose_strength_mg = value;
        updatedArray[id].elr_dose_strength_mg_kg = "";
        updatedArray[id].elr_dose_strength_mgm = "";
        updatedArray[id].elr_dose_strength_rbl = 1;
        updatedArray[id].elr_dose_strength_mg_kgHard = false;
        updatedArray[id].elr_dose_strength_mg_kgRange = false;
        setElrexvayliDetails(updatedArray);
        break;
      }
      case "elr_dose_strength_mgm" + id: {
        let updatedArray = [...elrexvayliDetails];
        updatedArray[id].elr_dose_strength_mg = "";
        updatedArray[id].elr_dose_strength_mg_kg = "";
        updatedArray[id].elr_dose_strength_mgm = value;
        updatedArray[id].elr_dose_strength_rbl = 3;
        updatedArray[id].elr_dose_strength_mg_kgHard = false;
        updatedArray[id].elr_dose_strength_mg_kgRange = false;
        setElrexvayliDetails(updatedArray);
        break;
      }
      case "elr_dose_strength_rbl" + id: {
        let updatedArray = [...elrexvayliDetails];
        updatedArray[id].elr_dose_strength_rbl = Number(value);
        updatedArray[id].elr_dose_strength_mg = "";
        updatedArray[id].elr_dose_strength_mg_kg = "";
        updatedArray[id].elr_dose_strength_mgm = "";
        updatedArray[id].elr_dose_strength_mg_kgHard = false;
        updatedArray[id].elr_dose_strength_mg_kgRange = false;
        setElrexvayliDetails(updatedArray);
        break;
      }

      case "siteofcare_elr" + id: {
        let updatedArray = [...elrexvayliDetails];

        updatedArray[id].siteofcare_elr = value_int;

        updatedArray[id].siteofcare_elrHard = false;

        if (value_int === 2) {
          updatedArray[id].dt_admission_elr_dt = null;
          updatedArray[id].dt_discharge_elr_dt = null;

          updatedArray[id].dt_discharge_elrHard = false;
          updatedArray[id].dt_discharge_elrHard_dt = false;
          updatedArray[id].dt_discharge_elrHard_dt_check = false;
          updatedArray[id].dt_admission_elrHard = false;
          updatedArray[id].dt_admission_elrHard_dt = false;
          updatedArray[id].dt_admission_elrHard_dt_check = false;
        }

        setElrexvayliDetails(updatedArray);
        break;
      }

      //36.1 start
      //B
      case "dt_admission_elr" + id: {
        let updatedArray = [...elrHospDetails];

        updatedArray[id].dt_admission = value_int;
        updatedArray[id].dt_admission_dt = "";

        updatedArray[id].dt_admission_Hard = false;
        updatedArray[id].dt_admission_Hard_dt = false;
        updatedArray[id].Invalid_admission_Hard_dt = false;
        updatedArray[id].dt_admission_before_eof = false;
        updatedArray[id].dt_admission_out_of_bound = false;

        //Delete rows if "Patient had no hospilinvoizations during the step-up dosing phase" is selected
        //and Reset columns C n D of current row
        if (value_int === 2) {
          updatedArray[id].dt_discharge = null;
          updatedArray[id].dt_discharge_dt = "";
          updatedArray[id].dt_discharge_Hard = false;
          updatedArray[id].dt_discharge_Hard_dt = false;
          updatedArray[id].dt_discharge_Hard_dt_check = false;
          updatedArray[id].dt_discharge_out_of_bound = false;
          updatedArray[id].Invalid_dt_discharge_Hard = false;
          updatedArray[id].dt_discharge_before_eof = false;
          updatedArray[id].dateRangeThirty = false;

          updatedArray[id].hospReason1 = false;
          updatedArray[id].hospReason2 = false;
          updatedArray[id].hospReason3 = false;
          updatedArray[id].hospReason4 = false;
          updatedArray[id].hospReason5 = false;
          updatedArray[id].hospReason6 = false;
          updatedArray[id].hosp_reason_oth_txt = "";
          updatedArray[id].hospReasonUnk = false;
          updatedArray[id].hospReasonEmptyHard = false;
          updatedArray[id].hospReasonTxtEmpty = false;

          const deleteStartIndex = Number(id) + 1;
          if (deleteStartIndex >= 0 && deleteStartIndex < updatedArray.length) {
            updatedArray.splice(
              deleteStartIndex,
              updatedArray.length - deleteStartIndex,
            );
          }
        }
        setElrHospDetails(updatedArray);
        setElrHospDateChainInvalid(false);
        break;
      }
      //C
      case "dt_discharge_elr" + id: {
        let updatedArray = [...elrHospDetails];

        updatedArray[id].dt_discharge = value_int;
        updatedArray[id].dt_discharge_dt = "";
        updatedArray[id].Invalid_dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_before_eof = false;
        updatedArray[id].dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_Hard_dt = false;
        updatedArray[id].dt_discharge_Hard_dt_check = false;
        updatedArray[id].dt_discharge_out_of_bound = false;
        updatedArray[id].dateRangeThirty = false;

        setElrHospDetails(updatedArray);
        setElrHospDateChainInvalid(false);
        break;
      }
      //D
      case "hospReason1_elr" + id:
      case "hospReason2_elr" + id:
      case "hospReason3_elr" + id:
      case "hospReason4_elr" + id:
      case "hospReason5_elr" + id: {
        let updatedArray = [...elrHospDetails];

        const ctrlId = name.split("_")[0];

        updatedArray[id][ctrlId] = !updatedArray[id][ctrlId];

        updatedArray[id].hospReasonUnk = false;

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setElrHospDetails(updatedArray);
        break;
      }
      case "hospReason6_elr" + id: {
        let updatedArray = [...elrHospDetails];

        updatedArray[id].hospReason6 = !updatedArray[id].hospReason6;
        updatedArray[id].hosp_reason_oth_txt = "";
        updatedArray[id].hospReasonUnk = false;

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setElrHospDetails(updatedArray);
        break;
      }
      case "hosp_reason_oth_txt_elr" + id: {
        let updatedArray = [...elrHospDetails];

        updatedArray[id].hosp_reason_oth_txt = value;
        updatedArray[id].hospReason6 = true;
        updatedArray[id].hospReasonUnk = false;

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setElrHospDetails(updatedArray);
        break;
      }
      case "hospReasonUnk_elr" + id: {
        let updatedArray = [...elrHospDetails];

        updatedArray[id].hospReasonUnk = true;
        updatedArray[id].hospReason1 = false;
        updatedArray[id].hospReason2 = false;
        updatedArray[id].hospReason3 = false;
        updatedArray[id].hospReason4 = false;
        updatedArray[id].hospReason5 = false;
        updatedArray[id].hospReason6 = false;
        updatedArray[id].hosp_reason_oth_txt = "";

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setElrHospDetails(updatedArray);
        break;
      }

      case "q37ElrDosageRd" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].q37ElrDosageRd = value_int;
        updatedArray[id].q37ElrDosageRdEmpty = false;

        // Clear other text if not "Other" option
        if (value_int !== 2) {
          updatedArray[id].q37ElrDosageOtherTxt = "";
          updatedArray[id].q37ElrDosageOtherTxtEmpty = false;
        }

        setQ37ElrexDetails(updatedArray);
        break;
      }

      //  ELREXFIO Dosage Other Text
      case "q37ElrDosageOtherTxt" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].q37ElrDosageOtherTxt = value;
        updatedArray[id].q37ElrDosageRd = 2;

        updatedArray[id].q37ElrDosageOtherTxtEmpty = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }
      //end

      //LINVOSELTAMAB
      case "dose_administration_linvo" + id: {
        let updatedArray = [...linvoveyDetails];

        updatedArray[id].dose_administration_linvo = value_int;
        updatedArray[id].dose_administration_linvo_dt = "";

        updatedArray[id].dose_administration_linvoHard = false;
        updatedArray[id].Invalid_dose_administration_linvo_dt = false;

        updatedArray[id].dose_administration_linvoHard_dt = false;

        updatedArray[id].dt_linvo_date_out_of_bound = false;

        setIndexDateRRMM_linvoHard(false);
        setLinvoveyDetails(updatedArray);
        setDt_lino_2L_3L_date_conditions(false);
        setIsLinvoLastAdminDateValid(true);
        break;
      }

      case "dosing_phase_linvo" + id: {
        let updatedArray = [...linvoveyDetails];

        updatedArray[id].dosing_phase_linvo = value_int;
        updatedArray[id].dosing_phase_linvoHard_othEmpty = false;

        updatedArray[id].dosing_phase_linvoHard = false;
        updatedArray[id].dosing_phase_oth_txt_linvo = "";

        let updatedArrayQ37 = [...Q37LinvoDetails];
        if (linvoveyDetails.some((item) => item.dosing_phase_linvo != 5)) {
          updatedArrayQ37[0].q37_Linvo_Dose_week_frquencyRd = null;
          updatedArrayQ37[0].q37_Linvo_Dose_week_frquency_txt = "";
          updatedArrayQ37[0].q37_Linvo_Dose_week_frquencyRd_Empty = false;
          updatedArrayQ37[0].q37_Linvo_Dose_week_frquency_txt_Empty = false;
          updatedArrayQ37[0].q37_Linvo_Dose_week_freq_range = false;
        }

        setQ37LinvoDetails(updatedArrayQ37);
        setLinvoveyDetails(updatedArray);

        const duplicatesLinvo = CheckDuplicatePhasesRealtime(
          updatedArray,
          "linvo",
        );
        setLinvoDuplicatePhaseWarning(
          duplicatesLinvo.length > 0 ? duplicatesLinvo : null,
        );

        const missingStepUpLinvo = CheckMissingStepUpDosesRealtime(
          updatedArray,
          "linvo",
        );
        setLinvoMissingStepUpWarning(missingStepUpLinvo);
        break;
      }

      case "dosing_phase_oth_txt_linvo" + id: {
        let updatedArray = [...linvoveyDetails];

        updatedArray[id].dosing_phase_oth_txt_linvo = value;
        updatedArray[id].dosing_phase_linvo = 6;
        updatedArray[id].dosing_phase_linvoHard = false;
        updatedArray[id].dosing_phase_linvoHard_othEmpty = false;

        setLinvoveyDetails(updatedArray);
        break;
      }

      case "linvo_dose_strength_mg_kg" + id: {
        let updatedArray = [...linvoveyDetails];

        updatedArray[id].linvo_dose_strength_mg = "";
        updatedArray[id].linvo_dose_strength_mg_kg = value;
        updatedArray[id].linvo_dose_strength_mgm = "";
        updatedArray[id].linvo_dose_strength_rbl = 2;
        updatedArray[id].linvo_dose_strength_mg_kgHard = false;
        updatedArray[id].linvo_dose_strength_mg_kgRange = false;

        setLinvoveyDetails(updatedArray);
        break;
      }
      case "linvo_dose_strength_mg" + id: {
        let updatedArray = [...linvoveyDetails];
        updatedArray[id].linvo_dose_strength_mg = value;
        updatedArray[id].linvo_dose_strength_mg_kg = "";
        updatedArray[id].linvo_dose_strength_mgm = "";
        updatedArray[id].linvo_dose_strength_rbl = 1;
        updatedArray[id].linvo_dose_strength_mg_kgHard = false;
        updatedArray[id].linvo_dose_strength_mg_kgRange = false;
        setLinvoveyDetails(updatedArray);
        break;
      }
      case "linvo_dose_strength_mgm" + id: {
        let updatedArray = [...linvoveyDetails];
        updatedArray[id].linvo_dose_strength_mg = "";
        updatedArray[id].linvo_dose_strength_mg_kg = "";
        updatedArray[id].linvo_dose_strength_mgm = value;
        updatedArray[id].linvo_dose_strength_rbl = 3;
        updatedArray[id].linvo_dose_strength_mg_kgHard = false;
        updatedArray[id].linvo_dose_strength_mg_kgRange = false;
        setLinvoveyDetails(updatedArray);
        break;
      }
      case "linvo_dose_strength_rbl" + id: {
        let updatedArray = [...linvoveyDetails];
        updatedArray[id].linvo_dose_strength_rbl = Number(value);
        updatedArray[id].linvo_dose_strength_mg = "";
        updatedArray[id].linvo_dose_strength_mg_kg = "";
        updatedArray[id].linvo_dose_strength_mgm = "";
        updatedArray[id].linvo_dose_strength_mg_kgHard = false;
        updatedArray[id].linvo_dose_strength_mg_kgRange = false;
        setLinvoveyDetails(updatedArray);
        break;
      }

      case "siteofcare_linvo" + id: {
        let updatedArray = [...linvoveyDetails];

        updatedArray[id].siteofcare_linvo = value_int;

        updatedArray[id].siteofcare_linvoHard = false;

        if (value_int === 2) {
          updatedArray[id].dt_admission_linvo_dt = null;
          updatedArray[id].dt_discharge_linvo_dt = null;

          updatedArray[id].dt_discharge_linvoHard = false;
          updatedArray[id].dt_discharge_linvoHard_dt = false;
          updatedArray[id].dt_discharge_linvoHard_dt_check = false;
          updatedArray[id].dt_admission_linvoHard = false;
          updatedArray[id].dt_admission_linvoHard_dt = false;
          updatedArray[id].dt_admission_linvoHard_dt_check = false;
        }

        setLinvoveyDetails(updatedArray);
        break;
      }

      //36.1 start
      //B
      case "dt_admission_linvo" + id: {
        let updatedArray = [...linvoHospDetails];

        updatedArray[id].dt_admission = value_int;
        updatedArray[id].dt_admission_dt = "";

        updatedArray[id].dt_admission_Hard = false;
        updatedArray[id].Invalid_admission_Hard_dt = false;
        updatedArray[id].dt_admission_before_eof = false;
        updatedArray[id].dt_admission_Hard_dt = false;
        // updatedArray[id].dt_admission_Hard_dt_check = false;
        updatedArray[id].dt_admission_out_of_bound = false;

        //Delete rows if "Patient had no hospilinvoizations during the step-up dosing phase" is selected
        //and Reset columns C n D of current row
        if (value_int === 2) {
          updatedArray[id].dt_discharge = null;
          updatedArray[id].dt_discharge_dt = "";
          updatedArray[id].dt_discharge_Hard = false;
          updatedArray[id].dt_discharge_Hard_dt = false;
          updatedArray[id].dt_discharge_Hard_dt_check = false;
          updatedArray[id].dt_discharge_out_of_bound = false;
          updatedArray[id].Invalid_dt_discharge_Hard = false;
          updatedArray[id].dt_discharge_before_eof = false;
          updatedArray[id].dateRangeThirty = false;

          updatedArray[id].hospReason1 = false;
          updatedArray[id].hospReason2 = false;
          updatedArray[id].hospReason3 = false;
          updatedArray[id].hospReason4 = false;
          updatedArray[id].hospReason5 = false;
          updatedArray[id].hospReason6 = false;
          updatedArray[id].hosp_reason_oth_txt = "";
          updatedArray[id].hospReasonUnk = false;
          updatedArray[id].hospReasonEmptyHard = false;
          updatedArray[id].hospReasonTxtEmpty = false;

          const deleteStartIndex = Number(id) + 1;
          if (deleteStartIndex >= 0 && deleteStartIndex < updatedArray.length) {
            updatedArray.splice(
              deleteStartIndex,
              updatedArray.length - deleteStartIndex,
            );
          }
        }
        setLinvoHospDetails(updatedArray);
        setLinvoHospDateChainInvalid(false);
        break;
      }
      //C
      case "dt_discharge_linvo" + id: {
        let updatedArray = [...linvoHospDetails];

        updatedArray[id].dt_discharge = value_int;
        updatedArray[id].dt_discharge_dt = "";

        updatedArray[id].dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_Hard_dt = false;
        updatedArray[id].dt_discharge_Hard_dt_check = false;
        updatedArray[id].dt_discharge_out_of_bound = false;
        updatedArray[id].Invalid_dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_before_eof = false;
        updatedArray[id].dateRangeThirty = false;

        setLinvoHospDetails(updatedArray);
        setLinvoHospDateChainInvalid(false);

        break;
      }
      case "hospReason1_linvo" + id:
      case "hospReason2_linvo" + id:
      case "hospReason3_linvo" + id:
      case "hospReason4_linvo" + id:
      case "hospReason5_linvo" + id: {
        let updatedArray = [...linvoHospDetails];

        const ctrlId = name.split("_")[0];

        updatedArray[id][ctrlId] = !updatedArray[id][ctrlId];
        updatedArray[id].hospReasonUnk = false;

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setLinvoHospDetails(updatedArray);
        break;
      }
      case "hospReason6_linvo" + id: {
        let updatedArray = [...linvoHospDetails];

        updatedArray[id].hospReason6 = !updatedArray[id].hospReason6;
        updatedArray[id].hosp_reason_oth_txt = "";
        updatedArray[id].hospReasonUnk = false;

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setLinvoHospDetails(updatedArray);
        break;
      }
      case "hosp_reason_oth_txt_linvo" + id: {
        let updatedArray = [...linvoHospDetails];

        updatedArray[id].hosp_reason_oth_txt = value;
        updatedArray[id].hospReason6 = true;
        updatedArray[id].hospReasonUnk = false;

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setLinvoHospDetails(updatedArray);
        break;
      }
      case "hospReasonUnk_linvo" + id: {
        let updatedArray = [...linvoHospDetails];

        updatedArray[id].hospReasonUnk = true;
        updatedArray[id].hospReason1 = false;
        updatedArray[id].hospReason2 = false;
        updatedArray[id].hospReason3 = false;
        updatedArray[id].hospReason4 = false;
        updatedArray[id].hospReason5 = false;
        updatedArray[id].hospReason6 = false;
        updatedArray[id].hosp_reason_oth_txt = "";

        updatedArray[id].hospReasonEmptyHard = false;
        updatedArray[id].hospReasonTxtEmpty = false;
        setLinvoHospDetails(updatedArray);
        break;
      }
      //end
      //Q38 Elr radio
      case "Q38ElrexvayliRd" + id: {
        let updatedArray = [...Q38ElrexDetails];

        updatedArray[id].Q38ElrexvayliRd = value_int;
        updatedArray[id].dt_dosefreq_elr_dt = "";

        updatedArray[id].Q38ElrexEmptyHard = false;
        updatedArray[id].Invalid_dt_dosefreq_elr_dt = false;

        updatedArray[id].Q38DateEmpty = false;
        updatedArray[id].Q38ElrexDateInvalid = false;
        setQ38ElrexDetails(updatedArray);
        break;
      }

      //Q38Linvoseltamab
      case "Q38LinvoveyRd" + id: {
        let updatedArray = [...Q38LinvoDetails];

        updatedArray[id].Q38LinvoveyRd = value_int;
        updatedArray[id].dt_dosefreq_linvo_dt = "";

        // updatedArray[id].dt_discharge_linvoHard = false;
        updatedArray[id].Q38LinvoEmptyHard = false;
        updatedArray[id].Q38LinvoDateEmpty = false;
        updatedArray[id].Q38LinvoDateInvalid = false;
        updatedArray[id].InvalidQ38Linvoveydate = false;
        setQ38LinvoDetails(updatedArray);
        break;
      }

      //Q38 Elr for frequency dosage
      case "q38_Elr_Dose_week_frquencyRd" + id: {
        let updatedArray = [...Q38ElrexDetails];

        updatedArray[id].q38_Elr_Dose_week_frquencyRd = Number(value);
        updatedArray[id].q38_Elr_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q38_Elr_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q38_Elr_Dose_week_frquency_txt = "";
        updatedArray[id].q38ElrDoseFrequencyConflict = false;
        setQ38ElrexDetails(updatedArray);
        break;
      }

      case "q38_Elr_Dose_week_frquency_txt" + id: {
        let updatedArray = [...Q38ElrexDetails];

        const reqValue = value;
        updatedArray[id].q38_Elr_Dose_week_frquency_txt = reqValue;
        updatedArray[id].q38_Elr_Dose_week_frquencyRd = 1;
        updatedArray[id].q38_Elr_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q38_Elr_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q38ElrDoseFrequencyConflict = false;

        setQ38ElrexDetails(updatedArray);
        break;
      }

      case "q38_Linvo_Dose_week_frquencyRd" + id: {
        let updatedArray = [...Q38LinvoDetails];

        updatedArray[id].q38_Linvo_Dose_week_frquencyRd = Number(value);
        updatedArray[id].q38_Linvo_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q38_Linvo_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q38_Linvo_Dose_week_frquency_txt = "";
        updatedArray[id].q38LinvoDoseFrequencyConflict = false;
        setQ38LinvoDetails(updatedArray);
        break;
      }

      case "q38_Linvo_Dose_week_frquency_txt" + id: {
        let updatedArray = [...Q38LinvoDetails];

        const reqValue = value;
        updatedArray[id].q38_Linvo_Dose_week_frquency_txt = reqValue;
        updatedArray[id].q38_Linvo_Dose_week_frquencyRd = 1;
        updatedArray[id].q38_Linvo_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q38_Linvo_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q38LinvoDoseFrequencyConflict = false;

        setQ38LinvoDetails(updatedArray);
        break;
      }

      case "q38_Linvo_Dosage_Rd" + id: {
        let updatedArray = [...Q38LinvoDetails];

        updatedArray[id].q38_Linvo_Dosage_Rd = Number(value);
        updatedArray[id].q38_Linvo_Dosage_OtherTxt = "";
        updatedArray[id].q38_Linvo_Dosage_Rd_Empty = false;
        updatedArray[id].q38_Linvo_Dosage_OtherTxt_Empty = false;

        setQ38LinvoDetails(updatedArray);
        break;
      }

      case "q38_Linvo_Dosage_OtherTxt" + id: {
        let updatedArray = [...Q38LinvoDetails];

        const reqValue = value;
        updatedArray[id].q38_Linvo_Dosage_Rd = 3;
        updatedArray[id].q38_Linvo_Dosage_OtherTxt = reqValue;
        updatedArray[id].q38_Linvo_Dosage_Rd_Empty = false;
        updatedArray[id].q38_Linvo_Dosage_OtherTxt_Empty = false;

        setQ38LinvoDetails(updatedArray);
        break;
      }

      // ========================================
      // Q38.1.A ELREXFIO HANDLERS
      // ========================================

      // Column B: Type of change (Main Radio)
      case "changeTypeElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].changeType = Number(value);
        updatedArray[id].changeTypeEmpty = false;

        // Reset sub-radio fields
        updatedArray[id].changeTypeDoseFrequency = null;
        updatedArray[id].changeTypeDoseStrength = null;
        updatedArray[id].changeTypeDoseFrequencyEmpty = false;
        updatedArray[id].changeTypeDoseStrengthEmpty = false;

        // Reset conflict flags
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        updatedArray[id].patternAfterUnknownWarning = false;

        if (
          updatedArray[id].reasonList &&
          Array.isArray(updatedArray[id].reasonList)
        ) {
          updatedArray[id].reasonList = updatedArray[id].reasonList.map(
            (reason) => ({
              ...reason,
              isSelected: false,
              reasonText: "",
              aeSubReasons:
                reason.aeSubReasons?.map((ae) => ({
                  ...ae,
                  isSelected: false,
                })) || [],
            }),
          );
        }

        // Reset columns C-F if radio change selected

        // Column C
        updatedArray[id].selectedReasons = [];
        updatedArray[id].selectedAEReasons = [];
        updatedArray[id].reasonOtherText = "";
        updatedArray[id].reasonEmpty = false;
        updatedArray[id].deathDtWarning = false;
        updatedArray[id].reasonOtherTextEmpty = false;

        updatedArray[id].neurologicAEReasonList = resetNeurologicReasons(
          updatedArray[id].neurologicAEReasonList,
        );

        updatedArray[id].aeSubReasonEmpty = false;
        updatedArray[id].neuroReasonEmpty = false;
        updatedArray[id].neuroOtherTextEmpty = false;

        // Column D
        updatedArray[id].patterBeforeChangeDoseFrequency = null;
        updatedArray[id].patterBeforeChangeDoseFrequencyWeek = "";
        updatedArray[id].patterBeforeChangeDoseStrength = null;

        updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;

        // Column E
        updatedArray[id].patterAfterChangeDoseFrequency = null;
        updatedArray[id].patterAfterChangeDoseFrequencyWeek = "";
        updatedArray[id].patterAfterChangeDoseStrength = null;

        updatedArray[id].patterAfterChangeDoseStrengthMg = ""; // For radio value 1
        updatedArray[id].patterAfterChangeDoseStrengthMgKg = ""; // For radio value 2
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = ""; // For radio value 3
        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].patternAfterStrengthRangeInvalid = false;

        // Column F
        updatedArray[id].dateChangeRd = null;
        updatedArray[id].dateChange = "";
        updatedArray[id].dateChangeRdEmpty = false;
        updatedArray[id].dateChangeEmpty = false;
        updatedArray[id].invalidDateChange = false;
        updatedArray[id].dateChangeOutOfBound = false;
        updatedArray[id].dateChangeBeforeEOF = false;

        if (Number(id) === 0 && (Number(value) === 1 || Number(value) === 99)) {
          updatedArray = [updatedArray[0]];
        }

        setQ381AElrexDetails(updatedArray);
        break;
      }

      // Column B: Frequency sub-radio (Increase/Decrease)
      case "changeTypeDoseFrequencyElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].changeTypeDoseFrequency = Number(value);
        updatedArray[id].changeTypeDoseFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // Column B: Strength sub-radio (Increase/Decrease)
      case "changeTypeDoseStrengthElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].changeTypeDoseStrength = Number(value);
        updatedArray[id].changeTypeDoseStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // ✅ CORRECTED - Column C Reason Checkboxes Handler
      case "selectedReasonsElr":
        {
          let updatedArray = [...Q381AElrexDetails];
          const reasonId = Number(value);

          // Update reasonList - toggle isSelected
          updatedArray[id].reasonList = updatedArray[id].reasonList.map(
            (reason) => {
              if (
                reason.bispecifictreatmentdiscontinuationreasonid === reasonId
              ) {
                return {
                  ...reason,
                  isSelected: !reason.isSelected,
                };
              }
              return reason;
            },
          );

          // ✅ SYNC to selectedReasons array
          if (updatedArray[id].selectedReasons.includes(reasonId)) {
            updatedArray[id].selectedReasons = updatedArray[
              id
            ].selectedReasons.filter((r) => r !== reasonId);
          } else {
            updatedArray[id].selectedReasons.push(reasonId);
          }

          updatedArray[id].reasonEmpty = false;
          updatedArray[id].deathDtWarning = false;

          // Clear Other text if unchecking Other option (ID=14)
          if (
            reasonId === 14 &&
            !updatedArray[id].selectedReasons.includes(14)
          ) {
            updatedArray[id].reasonOtherText = "";
            updatedArray[id].reasonOtherTextEmpty = false;
          }

          setQ381AElrexDetails(updatedArray);
        }
        break;

      // ✅ CORRECTED - Column C AE Reason Checkboxes Handler
      case "selectedAEReasonsElr":
        {
          let updatedArray = [...Q381AElrexDetails];
          const aeReasonId = Number(value);
          const parentReasonId = 2; // Adverse event parent ID

          // Update reasonList - find parent reason and toggle AE sub-reason
          updatedArray[id].reasonList = updatedArray[id].reasonList.map(
            (reason) => {
              if (
                reason.bispecifictreatmentdiscontinuationreasonid ===
                parentReasonId
              ) {
                return {
                  ...reason,
                  aeSubReasons: reason.aeSubReasons?.map((ae) => {
                    if (
                      ae.bispecifictreatmentdiscontinuationreasonaeid ===
                      aeReasonId
                    ) {
                      return {
                        ...ae,
                        isSelected: !ae.isSelected,
                      };
                    }
                    return ae;
                  }),
                };
              }
              return reason;
            },
          );

          // ✅ SYNC to selectedAEReasons array
          if (updatedArray[id].selectedAEReasons.includes(aeReasonId)) {
            updatedArray[id].selectedAEReasons = updatedArray[
              id
            ].selectedAEReasons.filter((r) => r !== aeReasonId);
          } else {
            updatedArray[id].selectedAEReasons.push(aeReasonId);
          }

          setQ381AElrexDetails(updatedArray);
        }
        break;

      // ✅ CORRECTED - Column C Reason Other Text Handler
      case "reasonOtherTextElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].reasonOtherText = value;
        updatedArray[id].reasonOtherTextEmpty = false;

        // Auto-check "Other" option (ID14) if text is entered
        if (value && !updatedArray[id].selectedReasons.includes(14)) {
          updatedArray[id].selectedReasons.push(14);

          // Also update reasonList
          updatedArray[id].reasonList = updatedArray[id].reasonList.map(
            (reason) => {
              if (reason.bispecifictreatmentdiscontinuationreasonid === 14) {
                return { ...reason, isSelected: true, reasonText: value };
              }
              return reason;
            },
          );
        }

        // ✅ ADD THIS: Uncheck "Unknown" when typing in Other text
        if (value) {
          updatedArray[id].reasonUnknown = false;
        }

        setQ381AElrexDetails(updatedArray);
        break;
      }
      // ✅ NEW: Column C - Reason Unknown Radio (ELREXFIO)
      case "reasonUnknownElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        const isChecked = value === "true" || value === true;

        updatedArray[id].reasonUnknown = isChecked;

        if (isChecked) {
          //  Clear ALL checkboxes when Unknown is selected
          updatedArray[id].reasonList = updatedArray[id].reasonList.map(
            (reason) => ({
              ...reason,
              isSelected: false,
              reasonText: "",
              // Also clear nested AE sub-reasons
              aeSubReasons: reason.aeSubReasons?.map((ae) => ({
                ...ae,
                isSelected: false,
              })),
            }),
          );

          //  Clear selected arrays
          updatedArray[id].selectedReasons = [];
          updatedArray[id].selectedAEReasons = [];
          updatedArray[id].reasonOtherText = "";
          updatedArray[id].neurologicAEReasonList = resetNeurologicReasons(
            updatedArray[id].neurologicAEReasonList,
          );

          updatedArray[id].aeSubReasonEmpty = false;
          updatedArray[id].neuroReasonEmpty = false;
          updatedArray[id].neuroOtherTextEmpty = false;

          //  Clear "Other" text
          const otherReason = updatedArray[id].reasonList.find(
            (r) => r.bispecifictreatmentdiscontinuationreasonid === 14,
          );
          if (otherReason) {
            otherReason.reasonOtherText = null;
          }
        }

        updatedArray[id].reasonEmpty = false;
        updatedArray[id].deathDtWarning = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }
      // ✅ Column D: Pattern BEFORE - Frequency Radio
      case "patterBeforeChangeDoseFrequencyElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        const int_value = Number(value);

        updatedArray[id].patterBeforeChangeDoseFrequency = int_value;

        // ✅ Clear BOTH frequency text fields when radio changes manually
        updatedArray[id].patterBeforeChangeDoseFrequencyTimesPerWeek = "";
        updatedArray[id].patterBeforeChangeDoseFrequencyWeek = "";

        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = int_value === 99;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // ✅ Column D: Pattern BEFORE - Times per week input (NEW)
      case "patterBeforeChangeDoseFrequencyTimesPerWeekElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].patterBeforeChangeDoseFrequencyTimesPerWeek = value;

        // ✅ Auto-select radio option 1 when user types
        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseFrequency = 1;
          updatedArray[id].patterBeforeChangeDoseFrequencyWeek = ""; // Clear other field
        }

        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // ✅ Column D: Pattern BEFORE - Every X weeks input
      case "patterBeforeChangeDoseFrequencyWeekElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].patterBeforeChangeDoseFrequencyWeek = value;

        // ✅ Auto-select radio option 2 when user types
        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseFrequency = 2;
          updatedArray[id].patterBeforeChangeDoseFrequencyTimesPerWeek = ""; // Clear other field
        }

        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // Column D: Pattern BEFORE - Strength Type (Radio)
      case "patterBeforeChangeDoseStrengthElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        const int_value = Number(value);

        updatedArray[id].patterBeforeChangeDoseStrength = int_value;

        // ✅ Clear ALL text fields when radio changes
        updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";

        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeStre = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = int_value === 99;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // ✅ Column D: Pattern BEFORE - mg text input
      case "patterBeforeChangeDoseStrengthMgElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].patterBeforeChangeDoseStrengthMg = value;

        // ✅ Auto-select radio and clear others
        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 1;
          updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        }

        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // ✅ Column D: Pattern BEFORE - mg/kg text input
      case "patterBeforeChangeDoseStrengthMgKgElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 2;
          updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        }

        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // ✅ Column D: Pattern BEFORE - mg/m² text input
      case "patterBeforeChangeDoseStrengthMgM2Elr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 3;
          updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        }

        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - Frequency Radio
      case "patterAfterChangeDoseFrequencyElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        const int_value = Number(value);

        updatedArray[id].patterAfterChangeDoseFrequency = int_value;

        // ✅ Clear BOTH frequency text fields
        updatedArray[id].patterAfterChangeDoseFrequencyTimesPerWeek = "";
        updatedArray[id].patterAfterChangeDoseFrequencyWeek = "";

        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = int_value === 99;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - Times per week input (NEW)
      case "patterAfterChangeDoseFrequencyTimesPerWeekElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].patterAfterChangeDoseFrequencyTimesPerWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseFrequency = 1;
          updatedArray[id].patterAfterChangeDoseFrequencyWeek = "";
        }

        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - Every X weeks input
      case "patterAfterChangeDoseFrequencyWeekElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].patterAfterChangeDoseFrequencyWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseFrequency = 2;
          updatedArray[id].patterAfterChangeDoseFrequencyTimesPerWeek = "";
        }

        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // Column E: Pattern AFTER - Strength Type (Radio)
      case "patterAfterChangeDoseStrengthElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        const int_value = Number(value);

        updatedArray[id].patterAfterChangeDoseStrength = int_value;

        // ✅ Clear ALL text fields when radio changes
        updatedArray[id].patterAfterChangeDoseStrengthMg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";

        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = int_value === 99;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - mg text input
      case "patterAfterChangeDoseStrengthMgElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].patterAfterChangeDoseStrengthMg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 1;
          updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";
        }

        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - mg/kg text input
      case "patterAfterChangeDoseStrengthMgKgElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].patterAfterChangeDoseStrengthMgKg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 2;
          updatedArray[id].patterAfterChangeDoseStrengthMg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";
        }

        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - mg/m² text input
      case "patterAfterChangeDoseStrengthMgM2Elr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 3;
          updatedArray[id].patterAfterChangeDoseStrengthMg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        }

        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // Column F: Date Radio (Date provided / Unknown)
      case "dateChangeRdElr" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].dateChangeRd = Number(value);
        updatedArray[id].dateChangeRdEmpty = false;
        updatedArray[id].dateChangeEmpty = false;
        updatedArray[id].invalidDateChange = false;
        updatedArray[id].dateChangeOutOfBound = false;
        updatedArray[id].dateChangeBeforeEOF = false;

        if (Number(value) === 99) {
          updatedArray[id].dateChange = "";
        }

        setQ381AElrexDetails(updatedArray);
        break;
      }

      // ============================================
      // Q38.1.A LINVOSELTAMAB HANDLERS
      // ============================================

      // Column B: Type of change (Main Radio)
      case "changeTypeLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].changeType = Number(value);
        updatedArray[id].changeTypeEmpty = false;

        // Reset sub-radio fields
        updatedArray[id].changeTypeDoseFrequency = null;
        updatedArray[id].changeTypeDoseStrength = null;
        updatedArray[id].changeTypeDoseFrequencyEmpty = false;
        updatedArray[id].changeTypeDoseStrengthEmpty = false;

        // Reset conflict flags
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        updatedArray[id].patternAfterUnknownWarning = false;

        if (
          updatedArray[id].reasonList &&
          Array.isArray(updatedArray[id].reasonList)
        ) {
          updatedArray[id].reasonList = updatedArray[id].reasonList.map(
            (reason) => ({
              ...reason,
              isSelected: false,
              reasonText: "",
              aeSubReasons:
                reason.aeSubReasons?.map((ae) => ({
                  ...ae,
                  isSelected: false,
                })) || [],
            }),
          );
        }

        // Reset columns C-F if "No changes" or "Unknown" selected
        //  if (Number(value) === 1 || Number(value) === 99) {
        // Column C
        updatedArray[id].selectedReasons = [];
        updatedArray[id].selectedAEReasons = [];
        updatedArray[id].reasonOtherText = "";
        updatedArray[id].reasonEmpty = false;
        updatedArray[id].deathDtWarning = false;
        updatedArray[id].reasonOtherTextEmpty = false;
        updatedArray[id].neurologicAEReasonList = resetNeurologicReasons(
          updatedArray[id].neurologicAEReasonList,
        );

        updatedArray[id].aeSubReasonEmpty = false;
        updatedArray[id].neuroReasonEmpty = false;
        updatedArray[id].neuroOtherTextEmpty = false;
        // Column D
        updatedArray[id].patterBeforeChangeDoseFrequency = null;
        updatedArray[id].patterBeforeChangeDoseFrequencyTimesPerWeek = "";
        updatedArray[id].patterBeforeChangeDoseFrequencyWeek = "";
        updatedArray[id].patterBeforeChangeDoseStrength = null;
        updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;

        // Column E
        updatedArray[id].patterAfterChangeDoseFrequency = null;
        updatedArray[id].patterAfterChangeDoseFrequencyTimesPerWeek = "";
        updatedArray[id].patterAfterChangeDoseFrequencyWeek = "";
        updatedArray[id].patterAfterChangeDoseStrength = null;
        updatedArray[id].patterAfterChangeDoseStrengthMg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";
        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].patternAfterStrengthRangeInvalid = false;

        // Column F
        updatedArray[id].dateChangeRd = null;
        updatedArray[id].dateChange = "";
        updatedArray[id].dateChangeRdEmpty = false;
        updatedArray[id].dateChangeEmpty = false;
        updatedArray[id].invalidDateChange = false;
        updatedArray[id].dateChangeOutOfBound = false;
        updatedArray[id].dateChangeBeforeEOF = false;

        if (Number(id) === 0 && (Number(value) === 1 || Number(value) === 99)) {
          updatedArray = [updatedArray[0]]; // Keep only row 0
        }
        //  }

        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // Column B: Frequency sub-radio (Increase/Decrease)
      case "changeTypeDoseFrequencyLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].changeTypeDoseFrequency = Number(value);
        updatedArray[id].changeTypeDoseFrequencyEmpty = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // Column B: Strength sub-radio (Increase/Decrease)
      case "changeTypeDoseStrengthLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].changeTypeDoseStrength = Number(value);
        updatedArray[id].changeTypeDoseStrengthEmpty = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // ✅ CORRECTED - Linvoseltamab Reason Checkboxes
      case "selectedReasonsLinvo":
        {
          let updatedArray = [...Q381ALinvoDetails];
          const reasonId = Number(value);

          // Update reasonList
          updatedArray[id].reasonList = updatedArray[id].reasonList.map(
            (reason) => {
              if (
                reason.bispecifictreatmentdiscontinuationreasonid === reasonId
              ) {
                return {
                  ...reason,
                  isSelected: !reason.isSelected,
                };
              }
              return reason;
            },
          );

          // ✅ SYNC to selectedReasons array
          if (updatedArray[id].selectedReasons.includes(reasonId)) {
            updatedArray[id].selectedReasons = updatedArray[
              id
            ].selectedReasons.filter((r) => r !== reasonId);
          } else {
            updatedArray[id].selectedReasons.push(reasonId);
          }

          updatedArray[id].reasonEmpty = false;
          updatedArray[id].deathDtWarning = false;

          if (
            reasonId === 14 &&
            !updatedArray[id].selectedReasons.includes(14)
          ) {
            updatedArray[id].reasonOtherText = "";
            updatedArray[id].reasonOtherTextEmpty = false;
          }

          setQ381ALinvoDetails(updatedArray);
        }
        break;

      //  NEW: Column C - Reason Unknown Radio (LINVOSELTAMAB)
      case "reasonUnknownLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        const isChecked = value === "true" || value === true;

        updatedArray[id].reasonUnknown = isChecked;
        updatedArray[id].reasonOtherText = "";
        if (isChecked) {
          //  Clear ALL checkboxes when Unknown is selected
          updatedArray[id].reasonList = updatedArray[id].reasonList.map(
            (reason) => ({
              ...reason,
              isSelected: false,
              reasonText: "",
              // Also clear nested AE sub-reasons
              aeSubReasons: reason.aeSubReasons?.map((ae) => ({
                ...ae,
                isSelected: false,
              })),
            }),
          );

          //  Clear selected arrays
          updatedArray[id].selectedReasons = [];
          updatedArray[id].selectedAEReasons = [];
          updatedArray[id].neurologicAEReasonList = resetNeurologicReasons(
            updatedArray[id].neurologicAEReasonList,
          );

          updatedArray[id].aeSubReasonEmpty = false;
          updatedArray[id].neuroReasonEmpty = false;
          updatedArray[id].neuroOtherTextEmpty = false;
          //  Clear "Other" text
          const otherReason = updatedArray[id].reasonList.find(
            (r) => r.bispecifictreatmentdiscontinuationreasonid === 14,
          );
          if (otherReason) {
            otherReason.reasonOtherText = null;
          }
        }

        updatedArray[id].reasonEmpty = false;
        updatedArray[id].deathDtWarning = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }
      // ✅ Column D: Pattern BEFORE - Frequency Radio
      case "patterBeforeChangeDoseFrequencyLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        const int_value = Number(value);
        updatedArray[id].patterBeforeChangeDoseFrequency = int_value;

        // ✅ Clear BOTH frequency text fields when radio changes manually
        updatedArray[id].patterBeforeChangeDoseFrequencyWeek = "";
        updatedArray[id].patterBeforeChangeDoseFrequencyTimesPerWeek = "";

        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = int_value === 99;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // ✅ Column D: Pattern BEFORE - Times per week input (NEW)
      case "patterBeforeChangeDoseFrequencyTimesPerWeekLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].patterBeforeChangeDoseFrequencyTimesPerWeek = value;

        // ✅ Auto-select radio option 1 when user types
        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseFrequency = 1;
          updatedArray[id].patterBeforeChangeDoseFrequencyWeek = ""; // Clear other field
        }

        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // ✅ Column D: Pattern BEFORE - Every X weeks input
      case "patterBeforeChangeDoseFrequencyWeekLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].patterBeforeChangeDoseFrequencyWeek = value;

        // ✅ Auto-select radio option 2 when user types
        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseFrequency = 2;
          updatedArray[id].patterBeforeChangeDoseFrequencyTimesPerWeek = ""; // Clear other field
        }

        updatedArray[id].patternBeforeFrequencyEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // Column D: Pattern BEFORE - Strength Type (Radio)
      case "patterBeforeChangeDoseStrengthLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        const int_value = Number(value);
        updatedArray[id].patterBeforeChangeDoseStrength = int_value;

        // ✅ Clear ALL text fields
        updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";

        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternBeforeUnknownWarning = int_value === 99;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // ✅ Column D: Pattern BEFORE - mg text input
      case "patterBeforeChangeDoseStrengthMgLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].patterBeforeChangeDoseStrengthMg = value;

        // ✅ Auto-select radio and clear others
        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 1;
          updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        }

        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // ✅ Column D: Pattern BEFORE - mg/kg text input
      case "patterBeforeChangeDoseStrengthMgKgLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].patterBeforeChangeDoseStrengthMgKg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 2;
          updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = "";
        }

        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // ✅ Column D: Pattern BEFORE - mg/m² text input
      case "patterBeforeChangeDoseStrengthMgM2Linvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].patterBeforeChangeDoseStrengthMgM2 = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterBeforeChangeDoseStrength = 3;
          updatedArray[id].patterBeforeChangeDoseStrengthMg = "";
          updatedArray[id].patterBeforeChangeDoseStrengthMgKg = "";
        }

        updatedArray[id].patternBeforeStrengthEmpty = false;
        updatedArray[id].patternBeforeFrequencyRangeInvalid = false;
        updatedArray[id].patternBeforeUnknownWarning = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - Frequency Radio
      case "patterAfterChangeDoseFrequencyLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        const int_value = Number(value);
        updatedArray[id].patterAfterChangeDoseFrequency = int_value;

        // ✅ Clear BOTH frequency text fields
        updatedArray[id].patterAfterChangeDoseFrequencyTimesPerWeek = "";
        updatedArray[id].patterAfterChangeDoseFrequencyWeek = "";

        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = int_value === 99;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - Times per week input (NEW)
      case "patterAfterChangeDoseFrequencyTimesPerWeekLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].patterAfterChangeDoseFrequencyTimesPerWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseFrequency = 1;
          updatedArray[id].patterAfterChangeDoseFrequencyWeek = "";
        }

        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - Every X weeks input
      case "patterAfterChangeDoseFrequencyWeekLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].patterAfterChangeDoseFrequencyWeek = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseFrequency = 2;
          updatedArray[id].patterAfterChangeDoseFrequencyTimesPerWeek = "";
        }

        updatedArray[id].patternAfterFrequencyEmpty = false;
        updatedArray[id].patternAfterFrequencyRangeInvalid = false;
        updatedArray[id].frequencyIncreaseConflict = false;
        updatedArray[id].frequencyDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // Column E: Pattern AFTER - Strength Type (Radio)
      case "patterAfterChangeDoseStrengthLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        const int_value = Number(value);
        updatedArray[id].patterAfterChangeDoseStrength = int_value;

        // ✅ Clear ALL text fields
        updatedArray[id].patterAfterChangeDoseStrengthMg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";

        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        updatedArray[id].patternAfterUnknownWarning = int_value === 99;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - mg text input
      case "patterAfterChangeDoseStrengthMgLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].patterAfterChangeDoseStrengthMg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 1;
          updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";
        }

        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - mg/kg text input
      case "patterAfterChangeDoseStrengthMgKgLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].patterAfterChangeDoseStrengthMgKg = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 2;
          updatedArray[id].patterAfterChangeDoseStrengthMg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgM2 = "";
        }

        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // ✅ Column E: Pattern AFTER - mg/m² text input
      case "patterAfterChangeDoseStrengthMgM2Linvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].patterAfterChangeDoseStrengthMgM2 = value;

        if (value && value.trim() !== "") {
          updatedArray[id].patterAfterChangeDoseStrength = 3;
          updatedArray[id].patterAfterChangeDoseStrengthMg = "";
          updatedArray[id].patterAfterChangeDoseStrengthMgKg = "";
        }

        updatedArray[id].patternAfterStrengthEmpty = false;
        updatedArray[id].patternAfterUnknownWarning = false;
        updatedArray[id].patternAfterStrengthRangeInvalid = false;
        updatedArray[id].strengthIncreaseConflict = false;
        updatedArray[id].strengthDecreaseConflict = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // Column F: Date Radio (Date provided / Unknown)
      case "dateChangeRdLinvo" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].dateChangeRd = Number(value);
        updatedArray[id].dateChangeRdEmpty = false;
        updatedArray[id].dateChangeEmpty = false;
        updatedArray[id].invalidDateChange = false;
        updatedArray[id].dateChangeOutOfBound = false;
        updatedArray[id].dateChangeBeforeEOF = false;

        if (Number(value) === 99) {
          updatedArray[id].dateChange = "";
        }

        setQ381ALinvoDetails(updatedArray);
        break;
      }

      //39.1.A
      case "primaryProphylacticCrs_elr" + id: {
        let updatedArray = [...q391AElrTocilzumabList];
        updatedArray[id].primaryProphylacticCrs_elr =
          !updatedArray[id].primaryProphylacticCrs_elr;

        updatedArray[id].medicationReasonUnk_elr = false;

        updatedArray[id].q39ElrReasonEmpty = false;
        setQ391AElrTocilzumabList(updatedArray);
        break;
      }

      case "secondaryProphylacticCrs_elr" + id: {
        let updatedArray = [...q391AElrTocilzumabList];
        updatedArray[id].secondaryProphylacticCrs_elr =
          !updatedArray[id].secondaryProphylacticCrs_elr;
        updatedArray[id].medicationReasonUnk_elr = false;
        updatedArray[id].q39ElrReasonEmpty = false;
        setQ391AElrTocilzumabList(updatedArray);
        break;
      }

      case "supportiveCareCrs_elr" + id: {
        let updatedArray = [...q391AElrTocilzumabList];
        updatedArray[id].supportiveCareCrs_elr =
          !updatedArray[id].supportiveCareCrs_elr;
        updatedArray[id].q39ElrReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_elr = false;

        setQ391AElrTocilzumabList(updatedArray);
        break;
      }

      case "primaryProphylacticNeurologic_elr" + id: {
        let updatedArray = [...q391AElrTocilzumabList];
        updatedArray[id].primaryProphylacticNeurologic_elr =
          !updatedArray[id].primaryProphylacticNeurologic_elr;
        updatedArray[id].q39ElrReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_elr = false;

        setQ391AElrTocilzumabList(updatedArray);
        break;
      }

      case "secondaryProphylacticNeurologic_elr" + id: {
        let updatedArray = [...q391AElrTocilzumabList];
        updatedArray[id].secondaryProphylacticNeurologic_elr =
          !updatedArray[id].secondaryProphylacticNeurologic_elr;
        updatedArray[id].q39ElrReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_elr = false;
        setQ391AElrTocilzumabList(updatedArray);
        break;
      }

      case "supportiveCareNeurologic_elr" + id: {
        let updatedArray = [...q391AElrTocilzumabList];
        updatedArray[id].supportiveCareNeurologic_elr =
          !updatedArray[id].supportiveCareNeurologic_elr;
        updatedArray[id].q39ElrReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_elr = false;
        setQ391AElrTocilzumabList(updatedArray);
        break;
      }

      case "medicationReasonUnk_elr" + id: {
        let updatedArray = [...q391AElrTocilzumabList];
        updatedArray[id].medicationReasonUnk_elr =
          !updatedArray[id].medicationReasonUnk_elr;
        updatedArray[id].q39ElrReasonEmpty = false;

        updatedArray[id].supportiveCareCrs_elr = false;
        updatedArray[id].primaryProphylacticCrs_elr = false;
        updatedArray[id].secondaryProphylacticNeurologic_elr = false;
        updatedArray[id].secondaryProphylacticCrs_elr = false;
        updatedArray[id].supportiveCareNeurologic_elr = false;
        updatedArray[id].primaryProphylacticNeurologic_elr = false;
        setQ391AElrTocilzumabList(updatedArray);
        break;
      }

      //39.1.A -- linvo

      case "primaryProphylacticCrs_linvo" + id: {
        let updatedArray = [...q391ALinvoTocilzumabList];
        updatedArray[id].primaryProphylacticCrs_linvo =
          !updatedArray[id].primaryProphylacticCrs_linvo;

        updatedArray[id].q39LinvoReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_linvo = false;

        setQ391ALinvoTocilzumabList(updatedArray);
        break;
      }

      case "secondaryProphylacticCrs_linvo" + id: {
        let updatedArray = [...q391ALinvoTocilzumabList];
        updatedArray[id].secondaryProphylacticCrs_linvo =
          !updatedArray[id].secondaryProphylacticCrs_linvo;

        updatedArray[id].q39LinvoReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_linvo = false;

        setQ391ALinvoTocilzumabList(updatedArray);
        break;
      }

      case "supportiveCareCrs_linvo" + id: {
        let updatedArray = [...q391ALinvoTocilzumabList];
        updatedArray[id].supportiveCareCrs_linvo =
          !updatedArray[id].supportiveCareCrs_linvo;

        updatedArray[id].medicationReasonUnk_linvo = false;

        updatedArray[id].q39LinvoReasonEmpty = false;
        setQ391ALinvoTocilzumabList(updatedArray);
        break;
      }

      case "primaryProphylacticNeurologic_linvo" + id: {
        let updatedArray = [...q391ALinvoTocilzumabList];
        updatedArray[id].primaryProphylacticNeurologic_linvo =
          !updatedArray[id].primaryProphylacticNeurologic_linvo;
        updatedArray[id].q39LinvoReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_linvo = false;

        setQ391ALinvoTocilzumabList(updatedArray);
        break;
      }

      case "secondaryProphylacticNeurologic_linvo" + id: {
        let updatedArray = [...q391ALinvoTocilzumabList];
        updatedArray[id].secondaryProphylacticNeurologic_linvo =
          !updatedArray[id].secondaryProphylacticNeurologic_linvo;
        updatedArray[id].q39LinvoReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_linvo = false;

        setQ391ALinvoTocilzumabList(updatedArray);
        break;
      }

      case "supportiveCareNeurologic_linvo" + id: {
        let updatedArray = [...q391ALinvoTocilzumabList];
        updatedArray[id].supportiveCareNeurologic_linvo =
          !updatedArray[id].supportiveCareNeurologic_linvo;
        updatedArray[id].q39LinvoReasonEmpty = false;
        updatedArray[id].medicationReasonUnk_linvo = false;
        setQ391ALinvoTocilzumabList(updatedArray);
        break;
      }

      case "medicationReasonUnk_linvo" + id: {
        let updatedArray = [...q391ALinvoTocilzumabList];
        updatedArray[id].medicationReasonUnk_linvo =
          !updatedArray[id].medicationReasonUnk_linvo;
        updatedArray[id].q39LinvoReasonEmpty = false;

        updatedArray[id].supportiveCareNeurologic_linvo = false;
        updatedArray[id].primaryProphylacticCrs_linvo = false;
        updatedArray[id].secondaryProphylacticCrs_linvo = false;
        updatedArray[id].secondaryProphylacticNeurologic_linvo = false;

        updatedArray[id].primaryProphylacticNeurologic_linvo = false;
        updatedArray[id].supportiveCareCrs_linvo = false;
        setQ391ALinvoTocilzumabList(updatedArray);
        break;
      }

      case "administrationDateRD_elr" + id: {
        let updatedArray = [...q391AElrTocilzumabList];

        updatedArray[id].administrationDateRD_elr = value_int;
        updatedArray[id].administrationDate_elr = "";

        updatedArray[id].q39ElrAdministrationDateEmpty = false;
        updatedArray[id].q39ElrAdministrationRDEmpty = false;
        updatedArray[id].q39ElrInvalidAdministrationDate = false;
        setQ391AElrAdministrationDateOutOfRange(false);

        setQ391AElrTocilzumabList(updatedArray);
        break;
      }

      case "administrationDateRD_linvo" + id: {
        let updatedArray = [...q391ALinvoTocilzumabList];

        updatedArray[id].administrationDateRD_linvo = value_int;
        updatedArray[id].administrationDate_linvo = "";

        updatedArray[id].q39LinvoInvalidAdministrationDate = false;
        updatedArray[id].q39LinvoAdministrationDateEmpty = false;
        updatedArray[id].q39LinvoAdministrationRDEmpty = false;
        setQ391ALinvoAdministrationDateOutOfRange(false);
        setQ391ALinvoTocilzumabList(updatedArray);
        break;
      }

      default:
        break;
    }

    //
    let newCountElr = null;
    elrexvayliDetails.filter((item) => {
      if (
        item.dosing_phase_elr === 1 ||
        item.dosing_phase_elr === 2 ||
        item.dosing_phase_elr === 3
      ) {
        newCountElr = 1;
      }

      if (newCountElr > 0) {
        setQ39ElrexConditionMet(true);
      } else {
        setQ39ElrexConditionMet(false);
      }
    });

    //Linvoseltamab
    let newCountLinvo = null;
    linvoveyDetails.filter((item) => {
      if (
        item.dosing_phase_linvo === 1 ||
        item.dosing_phase_linvo === 2 ||
        item.dosing_phase_linvo === 3 ||
        item.dosing_phase_linvo === 4
      ) {
        newCountLinvo = 1;
      }

      if (newCountLinvo > 0) {
        setQ39LinvoConditionMet(true);
      } else {
        setQ39LinvoConditionMet(false);
      }
    });
  };

  const HandleRepeaterDateChange = (name, date) => {
    const lastIndex = name.lastIndexOf("-");
    const id = name.slice(lastIndex + 1);

    switch (name) {
      //ELREXFIO
      case "dose_administration_elr_dt-" + id: {
        let updatedArray = [...elrexvayliDetails];

        updatedArray[id].dose_administration_elr_dt = date;
        updatedArray[id].dose_administration_elr = 1;
        updatedArray[id].dose_administration_elrHard = false;

        updatedArray[id].dose_administration_elrHard_dt = false;
        updatedArray[id].Invalid_dose_administration_elr_dt = false;
        updatedArray[id].dose_administration_elr_dt_before_eof = false;
        // updatedArray[id].dt_elr_greater_prevCheck = false;
        updatedArray[id].dt_elr_date_out_of_bound = false;
        setIndexDateRRMM_elrHard(false);
        setIsElrLastAdminDateValid(true);
        setElrexDuplicateDates(false);
        setElrexvayliDetails(updatedArray);
        setDt_elr_2L_3L_date_conditions(false);
        break;
      }

      //36.1 start
      //B
      case "dt_admission_dt_elr-" + id: {
        let updatedArray = [...elrHospDetails];
        updatedArray[id].dt_admission_dt = date;
        updatedArray[id].dt_admission = 1;
        updatedArray[id].dt_admission_Hard = false;
        updatedArray[id].dt_admission_Hard_dt = false;
        updatedArray[id].Invalid_admission_Hard_dt = false;
        updatedArray[id].dt_admission_before_eof = false;
        updatedArray[id].dt_admission_out_of_bound = false;

        const check = IsDateLessThanThirtyDays(
          updatedArray[id].dt_admission_dt,
          updatedArray[id].dt_discharge_dt,
        );
        if (!check) {
          updatedArray[id].dateRangeThirty = true;
        } else {
          updatedArray[id].dateRangeThirty = false;
        }
        setElrHospDetails(updatedArray);
        setElrHospDateChainInvalid(false);
        break;
      }
      //C
      case "dt_discharge_dt_elr-" + id: {
        let updatedArray = [...elrHospDetails];
        updatedArray[id].dt_discharge_dt = date;
        updatedArray[id].dt_discharge = 1;
        updatedArray[id].dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_Hard_dt = false;
        updatedArray[id].dt_discharge_Hard_dt_check = false;
        updatedArray[id].dt_discharge_out_of_bound = false;
        updatedArray[id].Invalid_dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_before_eof = false;

        const check = IsDateLessThanThirtyDays(
          updatedArray[id].dt_admission_dt,
          updatedArray[id].dt_discharge_dt,
        );
        if (!check) {
          updatedArray[id].dateRangeThirty = true;
        } else {
          updatedArray[id].dateRangeThirty = false;
        }
        setElrHospDetails(updatedArray);
        setElrHospDateChainInvalid(false);
        break;
      }
      //end
      //LINVOSELTAMAB
      case "dose_administration_linvo_dt-" + id: {
        let updatedArray = [...linvoveyDetails];

        updatedArray[id].dose_administration_linvo_dt = date;
        updatedArray[id].dose_administration_linvo = 1;
        updatedArray[id].dose_administration_linvoHard = false;
        updatedArray[id].Invalid_dose_administration_linvo_dt = false;
        // updatedArray[id].dt_admission_linvoHard_dt = false;
        // updatedArray[id].dt_admission_linvoHard_dt_check = false;

        // updatedArray[id].dt_linvo_greater_prevCheck = false;
        updatedArray[id].dt_linvo_date_out_of_bound = false;

        updatedArray[id].dt_admission_linvoHard_dt = false;
        setIndexDateRRMM_linvoHard(false);
        setIsLinvoLastAdminDateValid(true);
        setLinvoDuplicateDates(false);
        setLinvoveyDetails(updatedArray);
        setDt_lino_2L_3L_date_conditions(false);
        break;
      }

      //36.1 start
      //B
      case "dt_admission_dt_linvo-" + id: {
        let updatedArray = [...linvoHospDetails];

        updatedArray[id].dt_admission_dt = date;
        updatedArray[id].dt_admission = 1;
        updatedArray[id].dt_admission_Hard = false;
        updatedArray[id].Invalid_admission_Hard_dt = false;
        updatedArray[id].dt_admission_before_eof = false;
        updatedArray[id].dt_admission_Hard_dt = false;
        // updatedArray[id].dt_admission_Hard_dt_check = false;
        updatedArray[id].dt_admission_out_of_bound = false;

        const check = IsDateLessThanThirtyDays(
          updatedArray[id].dt_admission_dt,
          updatedArray[id].dt_discharge_dt,
        );
        if (!check) {
          updatedArray[id].dateRangeThirty = true;
        } else {
          updatedArray[id].dateRangeThirty = false;
        }
        setLinvoHospDetails(updatedArray);
        setLinvoHospDateChainInvalid(false);

        break;
      }
      //C
      case "dt_discharge_dt_linvo-" + id: {
        let updatedArray = [...linvoHospDetails];

        updatedArray[id].dt_discharge_dt = date;
        updatedArray[id].dt_discharge = 1;

        updatedArray[id].dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_Hard_dt = false;
        updatedArray[id].dt_discharge_Hard_dt_check = false;
        updatedArray[id].dt_discharge_out_of_bound = false;
        updatedArray[id].Invalid_dt_discharge_Hard = false;
        updatedArray[id].dt_discharge_before_eof = false;

        const check = IsDateLessThanThirtyDays(
          updatedArray[id].dt_admission_dt,
          updatedArray[id].dt_discharge_dt,
        );
        if (!check) {
          updatedArray[id].dateRangeThirty = true;
        } else {
          updatedArray[id].dateRangeThirty = false;
        }
        setLinvoHospDetails(updatedArray);
        setLinvoHospDateChainInvalid(false);

        break;
      }
      //end

      //Q38 Elr date change
      case "dt_dosefreq_elr_dt-" + id: {
        let updatedArray = [...Q38ElrexDetails];

        updatedArray[id].dt_dosefreq_elr_dt = date;
        updatedArray[id].Q38ElrexvayliRd = 1;

        updatedArray[id].Q38ElrexEmptyHard = false;
        updatedArray[id].Invalid_dt_dosefreq_elr_dt = false;
        updatedArray[id].Q38DateEmpty = false;
        updatedArray[id].Q38ElrexDateInvalid = false;
        setQ38ElrexDetails(updatedArray);
        break;
      }

      //Q38 Linvoseltamab date change
      case "dt_dosefreq_linvo_dt-" + id: {
        let updatedArray = [...Q38LinvoDetails];

        updatedArray[id].dt_dosefreq_linvo_dt = date;
        updatedArray[id].Q38LinvoveyRd = 1;
        //  updatedArray[id].dt_discharge_linvoHard = false;
        updatedArray[id].Q38LinvoEmptyHard = false;
        updatedArray[id].Q38LinvoDateEmpty = false;
        updatedArray[id].Q38LinvoDateInvalid = false;
        updatedArray[id].InvalidQ38Linvoveydate = false;
        setQ38LinvoDetails(updatedArray);
        break;
      }

      //40
      case "Q40init_dt-" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].Q40init_dt = date;
        updatedArray[id].Q40init_dt_Rd = 1;
        updatedArray[id].InvalidQ40init_dt = false;
        updatedArray[id].Q40Init_dtHard = false;
        updatedArray[id].Q40Init_RdHard = false;
        updatedArray[id].init_dt_before_eof = false;

        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "q40Init_Dt_linvo-" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].q40Init_Dt_linvo = date;
        updatedArray[id].q40Init_Dt_Rd_linvo = 1;
        updatedArray[id].invalidQ40Init_dt_linvo = false;
        updatedArray[id].Q40LinvoInit_dtHard = false;
        updatedArray[id].Q40LinvoInit_RdHard = false;
        updatedArray[id].init_dt_before_eof_linvo = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }
      //Q39.1.A
      case "administrationDate_elr-" + id: {
        let updatedArray = [...q391AElrTocilzumabList];

        updatedArray[id].administrationDate_elr = date;
        updatedArray[id].administrationDateRD_elr = 1;
        updatedArray[id].q39ElrInvalidAdministrationDate = false;
        updatedArray[id].q39ElrAdministrationDateEmpty = false;
        updatedArray[id].q39ElrAdministrationRDEmpty = false;
        setQ391AElrAdministrationDateOutOfRange(false);

        setQ391AElrTocilzumabList(updatedArray);
        break;
      }

      case "administrationDate_linvo-" + id: {
        let updatedArray = [...q391ALinvoTocilzumabList];

        updatedArray[id].administrationDate_linvo = date;
        updatedArray[id].administrationDateRD_linvo = 1;
        updatedArray[id].q39LinvoInvalidAdministrationDate = false;
        updatedArray[id].q39LinvoAdministrationDateEmpty = false;
        updatedArray[id].q39LinvoAdministrationRDEmpty = false;

        setQ391ALinvoAdministrationDateOutOfRange(false);
        setQ391ALinvoTocilzumabList(updatedArray);
        break;
      }

      // Q38.1.A ELREXFIO - Date of change
      case "dateChangeElr-" + id: {
        let updatedArray = [...Q381AElrexDetails];
        updatedArray[id].dateChange = date;
        updatedArray[id].dateChangeRd = 1;
        updatedArray[id].dateChangeRdEmpty = false;
        updatedArray[id].dateChangeEmpty = false;
        updatedArray[id].invalidDateChange = false;
        updatedArray[id].dateChangeOutOfBound = false;
        updatedArray[id].dateChangeBeforeEOF = false;
        setQ381AElrexDetails(updatedArray);
        break;
      }

      // Q38.1.A LINVOSELTAMAB - Date of change
      case "dateChangeLinvo-" + id: {
        let updatedArray = [...Q381ALinvoDetails];
        updatedArray[id].dateChange = date;
        updatedArray[id].dateChangeRd = 1;
        updatedArray[id].dateChangeRdEmpty = false;
        updatedArray[id].dateChangeEmpty = false;
        updatedArray[id].invalidDateChange = false;
        updatedArray[id].dateChangeOutOfBound = false;
        updatedArray[id].dateChangeBeforeEOF = false;
        setQ381ALinvoDetails(updatedArray);
        break;
      }

      // Q38.2.A ELREXFIO - Start date
      case `startDateChangeElr-${id}`: {
        let updatedArrayElr382Start = [...Q382AElrexDetails];
        updatedArrayElr382Start[id].startDateChange = date;
        updatedArrayElr382Start[id].startDateChangeRd = 1;
        updatedArrayElr382Start[id].startDateChangeRdEmpty = false;
        updatedArrayElr382Start[id].startDateChangeEmpty = false;
        updatedArrayElr382Start[id].invalidStartDateChange = false;
        updatedArrayElr382Start[id].startDateChangeOutOfBound = false;
        updatedArrayElr382Start[id].interruptionStartDateUnknownWarning = false;

        setQ382AElrexDetails(updatedArrayElr382Start);
        break;
      }
      // Q38.2.A ELREXFIO - End date
      case `endDateChangeElr-${id}`: {
        let updatedArrayElr382End = [...Q382AElrexDetails];
        updatedArrayElr382End[id].endDateChange = date;
        updatedArrayElr382End[id].endDateChangeRd = 2;
        updatedArrayElr382End[id].endDateChangeRdEmpty = false;
        updatedArrayElr382End[id].endDateChangeEmpty = false;
        updatedArrayElr382End[id].invalidEndDateChange = false;
        updatedArrayElr382End[id].endDateChangeOutOfBound = false;
        updatedArrayElr382End[id].interruptionEndDateUnknownWarning = false;

        setQ382AElrexDetails(updatedArrayElr382End);
        break;
      }
      // Q38.2.A LINVOSELTAMAB - Start date
      case `startDateChangeLinvo-${id}`: {
        let updatedArrayLinvo382Start = [...Q382ALinvoDetails];
        updatedArrayLinvo382Start[id].startDateChange = date;
        updatedArrayLinvo382Start[id].startDateChangeRd = 1; //
        updatedArrayLinvo382Start[id].startDateChangeRdEmpty = false;
        updatedArrayLinvo382Start[id].startDateChangeEmpty = false;
        updatedArrayLinvo382Start[id].invalidStartDateChange = false;
        updatedArrayLinvo382Start[id].startDateChangeOutOfBound = false;
        updatedArrayLinvo382Start[id].interruptionStartDateUnknownWarning =
          false;

        setQ382ALinvoDetails(updatedArrayLinvo382Start);
        break;
      }
      // Q38.2.A LINVOSELTAMAB - End date
      case `endDateChangeLinvo-${id}`: {
        let updatedArrayLinvo382End = [...Q382ALinvoDetails];
        updatedArrayLinvo382End[id].endDateChange = date;
        updatedArrayLinvo382End[id].endDateChangeRd = 2;
        updatedArrayLinvo382End[id].endDateChangeRdEmpty = false;
        updatedArrayLinvo382End[id].endDateChangeEmpty = false;
        updatedArrayLinvo382End[id].invalidEndDateChange = false;
        updatedArrayLinvo382End[id].endDateChangeOutOfBound = false;
        updatedArrayLinvo382End[id].interruptionEndDateUnknownWarning = false;

        setQ382ALinvoDetails(updatedArrayLinvo382End);
        break;
      }

      default:
        break;
    }
  };

  const HandleQ381ARepeaterFieldChange = (
    e,
    agentName,
    reasonName,
    parentIdx,
    itemIdx = null,
    aeIdx = null,
  ) => {
    const { name, value, type } = e.target;
    let updatedArray = [...Q381AElrexDetails];

    // Handle primary reason checkbox toggle
    if (name.startsWith("reasonElr") && itemIdx !== null) {
      const reasonId =
        updatedArray[parentIdx].reasonList[itemIdx]
          .bispecifictreatmentdiscontinuationreasonid;

      // Toggle isSelected
      updatedArray[parentIdx].reasonList[itemIdx].isSelected =
        !updatedArray[parentIdx].reasonList[itemIdx].isSelected;

      //  ADD THIS: SYNC to selectedReasons array
      if (updatedArray[parentIdx].reasonList[itemIdx].isSelected) {
        // Add to selectedReasons if not already there
        if (!updatedArray[parentIdx].selectedReasons.includes(reasonId)) {
          updatedArray[parentIdx].selectedReasons.push(reasonId);
        }
      } else {
        // Remove from selectedReasons
        updatedArray[parentIdx].selectedReasons = updatedArray[
          parentIdx
        ].selectedReasons.filter((r) => r !== reasonId);
      }

      updatedArray[parentIdx].reasonEmpty = false;
      updatedArray[parentIdx].reasonOtherTextEmpty = false;
      updatedArray[parentIdx].deathDtWarning = false;

      if (updatedArray[parentIdx].reasonList[itemIdx].isSelected) {
        updatedArray[parentIdx].reasonUnknown = false;
      }

      // Clear AE sub-reasons when Adverse Event is unchecked
      const reasonItem = updatedArray[parentIdx].reasonList[itemIdx];

      if (reasonId === 2) {
        // Clear AE sub-reasons
        reasonItem.aeSubReasons?.forEach((ae) => {
          ae.isSelected = false;
        });
        // Clear neurologic reasons
        reasonItem.neurologicAEReasonList = resetNeurologicReasons(
          reasonItem.neurologicAEReasonList,
        );

        //  ADD THIS: Clear selectedAEReasons array
        updatedArray[parentIdx].selectedAEReasons = [];
        updatedArray[parentIdx].aeSubReasonEmpty = false;

        // Clear neuro validations
        updatedArray[parentIdx].neuroReasonEmpty = false;
        updatedArray[parentIdx].neuroOtherTextEmpty = false;
      }

      // Clear "Other" text when unchecked
      if (
        updatedArray[parentIdx].reasonList[itemIdx].reasonName?.includes(
          "Other",
        ) &&
        !updatedArray[parentIdx].reasonList[itemIdx].isSelected
      ) {
        updatedArray[parentIdx].reasonList[itemIdx].reasonText = "";
        //  ADD THIS: Clear reasonOtherText
        updatedArray[parentIdx].reasonOtherText = "";
      }
    }

    // Handle AE sub-reason toggle
    else if (
      (name.startsWith("aeReasonElr") || name.startsWith("aeUnknownElr")) &&
      itemIdx !== null &&
      aeIdx !== null
    ) {
      const aeSubReasons =
        updatedArray[parentIdx].reasonList[itemIdx].aeSubReasons;
      const clickedAE = aeSubReasons[aeIdx];
      const aeReasonId = clickedAE.bispecifictreatmentdiscontinuationreasonaeid;
      const isClickedUnknown = clickedAE.reasonName
        .toLowerCase()
        .includes("unknown");

      if (type === "radio" && isClickedUnknown) {
        // Radio clicked - AE type unknown selected
        aeSubReasons.forEach((ae, idx) => {
          ae.isSelected = idx === aeIdx;
        });
        // ✅ ADD THIS: Clear selectedAEReasons and add only unknown
        updatedArray[parentIdx].selectedAEReasons = [aeReasonId];

        // Clear neurologic reasons
        updatedArray[parentIdx].reasonList[itemIdx].neurologicAEReasonList =
          resetNeurologicReasons(
            updatedArray[parentIdx].reasonList[itemIdx].neurologicAEReasonList,
          );

        // Clear neuro validations
        updatedArray[parentIdx].neuroReasonEmpty = false;
        updatedArray[parentIdx].neuroOtherTextEmpty = false;
      } else if (type === "checkbox") {
        // Checkbox clicked - Regular AE selected
        const newCheckedState = !aeSubReasons[aeIdx].isSelected;
        aeSubReasons[aeIdx].isSelected = newCheckedState;

        // ✅ ADD THIS: SYNC to selectedAEReasons array
        if (newCheckedState) {
          if (!updatedArray[parentIdx].selectedAEReasons.includes(aeReasonId)) {
            updatedArray[parentIdx].selectedAEReasons.push(aeReasonId);
          }
          // Uncheck AE type unknown
          aeSubReasons.forEach((ae) => {
            if (ae.reasonName.toLowerCase().includes("unknown")) {
              ae.isSelected = false;
              // Remove unknown from selectedAEReasons
              updatedArray[parentIdx].selectedAEReasons = updatedArray[
                parentIdx
              ].selectedAEReasons.filter(
                (id) => id !== ae.bispecifictreatmentdiscontinuationreasonaeid,
              );
            }
          });
        } else {
          // Remove from selectedAEReasons
          updatedArray[parentIdx].selectedAEReasons = updatedArray[
            parentIdx
          ].selectedAEReasons.filter((id) => id !== aeReasonId);
        }
        const isNeuroSelected =
          clickedAE?.reasonName === DiscontinuationReason.NeurologicalEvent;

        if (isNeuroSelected) {
          updatedArray[parentIdx].neurologicAEReasonList =
            resetNeurologicReasons(
              updatedArray[parentIdx].neurologicAEReasonList,
            );
          updatedArray[parentIdx].neuroReasonEmpty = false;
          updatedArray[parentIdx].neuroOtherTextEmpty = false;
        }
      }

      // Keep parent "Adverse Event" checked
      updatedArray[parentIdx].reasonList[itemIdx].isSelected = true;
      // ✅ ADD THIS: Ensure parent reason ID (2) is in selectedReasons
      if (!updatedArray[parentIdx].selectedReasons.includes(2)) {
        updatedArray[parentIdx].selectedReasons.push(2);
      }
      updatedArray[parentIdx].reasonEmpty = false;
      updatedArray[parentIdx].deathDtWarning = false;
      updatedArray[parentIdx].aeSubReasonEmpty = false;
    }

    // Handle "Other" reason text
    else if (name.startsWith("reasonTextElr") && itemIdx !== null) {
      const newText = value.length <= 300 ? value : value.substring(0, 300);
      updatedArray[parentIdx].reasonList[itemIdx].reasonText = newText;
      updatedArray[parentIdx].reasonList[itemIdx].isSelected = true;

      // ✅ ADD THIS: Sync to reasonOtherText and selectedReasons
      updatedArray[parentIdx].reasonOtherText = newText;
      const otherReasonId =
        updatedArray[parentIdx].reasonList[itemIdx]
          .bispecifictreatmentdiscontinuationreasonid;
      if (!updatedArray[parentIdx].selectedReasons.includes(otherReasonId)) {
        updatedArray[parentIdx].selectedReasons.push(otherReasonId);
      }

      updatedArray[parentIdx].reasonOtherTextEmpty = false;
      updatedArray[parentIdx].reasonEmpty = false;
      updatedArray[parentIdx].deathDtWarning = false;
    }

    setQ381AElrexDetails(updatedArray);
  };

  const HandleQ381ALinvoRepeaterFieldChange = (
    e,
    agentName,
    reasonName,
    parentIdx,
    itemIdx = null,
    aeIdx = null,
  ) => {
    const { name, value, type } = e.target;
    let updatedArray = [...Q381ALinvoDetails];

    // ✅ Handle primary reason checkbox toggle
    if (name.startsWith("reasonLinvo_") && itemIdx !== null) {
      const reasonId =
        updatedArray[parentIdx].reasonList[itemIdx]
          .bispecifictreatmentdiscontinuationreasonid;

      // Toggle isSelected
      updatedArray[parentIdx].reasonList[itemIdx].isSelected =
        !updatedArray[parentIdx].reasonList[itemIdx].isSelected;

      // ✅ SYNC to selectedReasons array
      if (updatedArray[parentIdx].reasonList[itemIdx].isSelected) {
        // Add to selectedReasons if not already there
        if (!updatedArray[parentIdx].selectedReasons.includes(reasonId)) {
          updatedArray[parentIdx].selectedReasons.push(reasonId);
        }
      } else {
        // Remove from selectedReasons
        updatedArray[parentIdx].selectedReasons = updatedArray[
          parentIdx
        ].selectedReasons.filter((r) => r !== reasonId);
      }

      updatedArray[parentIdx].reasonEmpty = false;
      updatedArray[parentIdx].deathDtWarning = false;
      updatedArray[parentIdx].reasonOtherTextEmpty = false;

      if (updatedArray[parentIdx].reasonList[itemIdx].isSelected) {
        updatedArray[parentIdx].reasonUnknown = false;
      }

      // Clear AE sub-reasons when Adverse Event is unchecked
      const reasonItem = updatedArray[parentIdx].reasonList[itemIdx];

      if (reasonId === 2) {
        updatedArray[parentIdx].reasonList[itemIdx].aeSubReasons?.forEach(
          (ae) => {
            ae.isSelected = false;
          },
        );
        // ✅ Clear selectedAEReasons array
        updatedArray[parentIdx].selectedAEReasons = [];
        updatedArray[parentIdx].aeSubReasonEmpty = false;
        // Clear neurologic reasons
        reasonItem.neurologicAEReasonList = resetNeurologicReasons(
          reasonItem.neurologicAEReasonList,
        );
        updatedArray[parentIdx].neuroReasonEmpty = false;
        updatedArray[parentIdx].neuroOtherTextEmpty = false;
      }

      // Clear "Other" text when unchecked
      if (
        updatedArray[parentIdx].reasonList[itemIdx].reasonName?.includes(
          "Other",
        ) &&
        !updatedArray[parentIdx].reasonList[itemIdx].isSelected
      ) {
        updatedArray[parentIdx].reasonList[itemIdx].reasonText = "";
        // ✅ Clear reasonOtherText
        updatedArray[parentIdx].reasonOtherText = "";
      }
    }

    // ✅ Handle AE sub-reason toggle (checkbox OR radio for "unknown")
    else if (
      (name.startsWith("aeReasonLinvo_") ||
        name.startsWith("aeUnknownLinvo_")) &&
      itemIdx !== null &&
      aeIdx !== null
    ) {
      const aeSubReasons =
        updatedArray[parentIdx].reasonList[itemIdx].aeSubReasons;
      const clickedAE = aeSubReasons[aeIdx];
      const aeReasonId = clickedAE.bispecifictreatmentdiscontinuationreasonaeid;
      const clickedAEName =
        clickedAE.reasonName ||
        clickedAE.bispecifictreatmentdiscontinuationreasonae ||
        "";
      const isClickedUnknown = clickedAEName.toLowerCase().includes("unknown");

      if (type === "radio" && isClickedUnknown) {
        // ✅ Radio clicked - "AE type unknown" selected
        // Uncheck ALL other AE checkboxes, only select "unknown"
        aeSubReasons.forEach((ae, idx) => {
          ae.isSelected = idx === aeIdx;
        });
        // ✅ Clear selectedAEReasons and add only unknown
        updatedArray[parentIdx].selectedAEReasons = [aeReasonId];
        // Clear neurologic reasons
        updatedArray[parentIdx].reasonList[itemIdx].neurologicAEReasonList =
          resetNeurologicReasons(
            updatedArray[parentIdx].reasonList[itemIdx].neurologicAEReasonList,
          );

        // Clear neuro validations
        updatedArray[parentIdx].neuroReasonEmpty = false;
        updatedArray[parentIdx].neuroOtherTextEmpty = false;
      } else if (type === "checkbox") {
        // ✅ Checkbox clicked - Regular AE selected
        const newCheckedState = !aeSubReasons[aeIdx].isSelected;
        aeSubReasons[aeIdx].isSelected = newCheckedState;

        // ✅ SYNC to selectedAEReasons array
        if (newCheckedState) {
          if (!updatedArray[parentIdx].selectedAEReasons.includes(aeReasonId)) {
            updatedArray[parentIdx].selectedAEReasons.push(aeReasonId);
          }
          // If any checkbox is now checked, uncheck "AE type unknown"
          aeSubReasons.forEach((ae) => {
            const aeName =
              ae.reasonName ||
              ae.bispecifictreatmentdiscontinuationreasonae ||
              "";
            if (aeName.toLowerCase().includes("unknown")) {
              ae.isSelected = false;
              // ✅ Remove unknown from selectedAEReasons
              updatedArray[parentIdx].selectedAEReasons = updatedArray[
                parentIdx
              ].selectedAEReasons.filter(
                (id) => id !== ae.bispecifictreatmentdiscontinuationreasonaeid,
              );
            }
          });
        } else {
          // ✅ Remove from selectedAEReasons
          updatedArray[parentIdx].selectedAEReasons = updatedArray[
            parentIdx
          ].selectedAEReasons.filter((id) => id !== aeReasonId);
        }
        const isNeuroSelected =
          clickedAE?.reasonName === DiscontinuationReason.NeurologicalEvent;

        if (isNeuroSelected) {
          updatedArray[parentIdx].neurologicAEReasonList =
            resetNeurologicReasons(
              updatedArray[parentIdx].neurologicAEReasonList,
            );
          updatedArray[parentIdx].neuroReasonEmpty = false;
          updatedArray[parentIdx].neuroOtherTextEmpty = false;
        }
      }

      // Keep parent "Adverse Event" checked
      updatedArray[parentIdx].reasonList[itemIdx].isSelected = true;
      // ✅ Ensure parent reason ID (2) is in selectedReasons
      if (!updatedArray[parentIdx].selectedReasons.includes(2)) {
        updatedArray[parentIdx].selectedReasons.push(2);
      }
      updatedArray[parentIdx].reasonEmpty = false;
      updatedArray[parentIdx].aeSubReasonEmpty = false;
      updatedArray[parentIdx].deathDtWarning = false;
    }

    // ✅ Handle "Other" reason text
    else if (name.startsWith("reasonTextLinvo_") && itemIdx !== null) {
      const newText = value.length <= 300 ? value : value.substring(0, 300);
      updatedArray[parentIdx].reasonList[itemIdx].reasonText = newText;
      updatedArray[parentIdx].reasonList[itemIdx].isSelected = true;

      // ✅ SYNC to reasonOtherText and selectedReasons
      updatedArray[parentIdx].reasonOtherText = newText;
      const otherReasonId =
        updatedArray[parentIdx].reasonList[itemIdx]
          .bispecifictreatmentdiscontinuationreasonid;
      if (!updatedArray[parentIdx].selectedReasons.includes(otherReasonId)) {
        updatedArray[parentIdx].selectedReasons.push(otherReasonId);
      }

      updatedArray[parentIdx].reasonOtherTextEmpty = false;
      updatedArray[parentIdx].reasonEmpty = false;
      updatedArray[parentIdx].deathDtWarning = false;
    }

    setQ381ALinvoDetails(updatedArray);
  };

  const HandleQ382ARepeaterChange = (
    e,
    agentName,
    reasonName,
    parentIdx,
    itemIdx = null,
    aeIdx = null,
  ) => {
    const { name, value, type, checked } = e.target;

    // Select the appropriate state array based on agentName
    let updatedArray =
      agentName === "Elrexfio" || agentName === "Elrex"
        ? [...Q382AElrexDetails]
        : [...Q382ALinvoDetails];

    // Handle primary reason checkbox toggle
    if (
      name.startsWith(
        `reason${
          agentName === "Elrexfio" || agentName === "Elrex" ? "Elr" : "Linvo"
        }`,
      ) &&
      itemIdx !== null
    ) {
      const reasonId =
        updatedArray[parentIdx].reasonList[itemIdx]
          .bispecifictreatmentdiscontinuationreasonid;

      // Toggle isSelected
      updatedArray[parentIdx].reasonList[itemIdx].isSelected =
        !updatedArray[parentIdx].reasonList[itemIdx].isSelected;

      // SYNC to selectedReasons array
      if (updatedArray[parentIdx].reasonList[itemIdx].isSelected) {
        if (!updatedArray[parentIdx].selectedReasons.includes(reasonId)) {
          updatedArray[parentIdx].selectedReasons.push(reasonId);
        }
      } else {
        updatedArray[parentIdx].selectedReasons = updatedArray[
          parentIdx
        ].selectedReasons.filter((r) => r !== reasonId);
      }

      // Clear validation flags
      updatedArray[parentIdx].reasonEmpty = false;
      updatedArray[parentIdx].reasonOtherTextEmpty = false;
      updatedArray[parentIdx].deathDtWarning = false;

      // Clear reasonUnknown if selecting something
      if (updatedArray[parentIdx].reasonList[itemIdx].isSelected) {
        updatedArray[parentIdx].reasonUnknown = false;
      }

      // Clear AE sub-reasons when Adverse Event is unchecked
      const reasonItem = updatedArray[parentIdx].reasonList[itemIdx];

      if (reasonId === 2) {
        updatedArray[parentIdx].reasonList[itemIdx].aeSubReasons?.forEach(
          (ae) => {
            ae.isSelected = false;
          },
        );
        updatedArray[parentIdx].selectedAEReasons = [];
        // Clear neurologic reasons
        reasonItem.neurologicAEReasonList = resetNeurologicReasons(
          reasonItem.neurologicAEReasonList,
        );
        updatedArray[parentIdx].aeSubReasonEmpty = false;
        updatedArray[parentIdx].neuroReasonEmpty = false;
        updatedArray[parentIdx].neuroOtherTextEmpty = false;
      }

      // Clear Other text when unchecked
      if (
        updatedArray[parentIdx].reasonList[itemIdx].reasonName?.includes(
          "Other",
        ) &&
        !updatedArray[parentIdx].reasonList[itemIdx].isSelected
      ) {
        updatedArray[parentIdx].reasonList[itemIdx].reasonText = "";
        updatedArray[parentIdx].reasonOtherText = "";
      }
    }

    // Handle AE sub-reason toggle (checkbox OR radio for unknown)
    else if (
      (name.startsWith(
        `aeReason${
          agentName === "Elrexfio" || agentName === "Elrex" ? "Elr" : "Linvo"
        }`,
      ) ||
        name.startsWith(
          `aeUnknown${
            agentName === "Elrexfio" || agentName === "Elrex" ? "Elr" : "Linvo"
          }`,
        )) &&
      itemIdx !== null &&
      aeIdx !== null
    ) {
      const aeSubReasons =
        updatedArray[parentIdx].reasonList[itemIdx].aeSubReasons;
      const clickedAE = aeSubReasons[aeIdx];
      const aeReasonId = clickedAE.bispecifictreatmentdiscontinuationreasonaeid;
      const clickedAEName =
        clickedAE.reasonName ||
        clickedAE.bispecifictreatmentdiscontinuationreasonae;
      const isClickedUnknown = clickedAEName.toLowerCase().includes("unknown");

      if (type === "radio" && isClickedUnknown) {
        // Radio clicked - "AE type unknown" selected
        // Uncheck ALL other AE checkboxes, only select unknown
        aeSubReasons.forEach((ae, idx) => {
          ae.isSelected = idx === aeIdx;
        });
        // Clear selectedAEReasons and add only unknown
        updatedArray[parentIdx].selectedAEReasons = [aeReasonId];
        // Clear neurologic reasons
        updatedArray[parentIdx].reasonList[itemIdx].neurologicAEReasonList =
          resetNeurologicReasons(
            updatedArray[parentIdx].reasonList[itemIdx].neurologicAEReasonList,
          );

        // Clear neuro validations
        updatedArray[parentIdx].neuroReasonEmpty = false;
        updatedArray[parentIdx].neuroOtherTextEmpty = false;
      } else if (type === "checkbox") {
        // Checkbox clicked - Regular AE selected
        const newCheckedState = !aeSubReasons[aeIdx].isSelected;
        aeSubReasons[aeIdx].isSelected = newCheckedState;

        // SYNC to selectedAEReasons array
        if (newCheckedState) {
          if (!updatedArray[parentIdx].selectedAEReasons.includes(aeReasonId)) {
            updatedArray[parentIdx].selectedAEReasons.push(aeReasonId);
          }
        } else {
          updatedArray[parentIdx].selectedAEReasons = updatedArray[
            parentIdx
          ].selectedAEReasons.filter((r) => r !== aeReasonId);
        }

        // If any regular AE checkbox is selected, uncheck the "Unknown" radio
        const unknownAE = aeSubReasons.find((ae) =>
          (ae.reasonName || ae.bispecifictreatmentdiscontinuationreasonae)
            .toLowerCase()
            .includes("unknown"),
        );
        if (unknownAE && newCheckedState) {
          unknownAE.isSelected = false;
          // Remove unknown from selectedAEReasons
          updatedArray[parentIdx].selectedAEReasons = updatedArray[
            parentIdx
          ].selectedAEReasons.filter(
            (r) => r !== unknownAE.bispecifictreatmentdiscontinuationreasonaeid,
          );
        }
        const isNeuroSelected =
          clickedAE?.reasonName === DiscontinuationReason.NeurologicalEvent;

        if (isNeuroSelected) {
          updatedArray[parentIdx].neurologicAEReasonList =
            resetNeurologicReasons(
              updatedArray[parentIdx].neurologicAEReasonList,
            );
          updatedArray[parentIdx].neuroReasonEmpty = false;
          updatedArray[parentIdx].neuroOtherTextEmpty = false;
        }
      }

      updatedArray[parentIdx].aeSubReasonEmpty = false;

      // Ensure parent "Adverse Event" (ID=2) is selected if newSelectedAEReasons.length > 0
      if (
        updatedArray[parentIdx].selectedAEReasons.length > 0 &&
        !updatedArray[parentIdx].selectedReasons.includes(2)
      ) {
        updatedArray[parentIdx].selectedReasons.push(2);
      }

      updatedArray[parentIdx].reasonEmpty =
        updatedArray[parentIdx].selectedReasons.length === 0;
      updatedArray[parentIdx].deathDtWarning = false;
    }

    // Column C - Other reason text
    if (name.startsWith("reasonText") || name.includes("reasonOtherText")) {
      const otherReasonId = 14; // "Other" reason ID
      updatedArray[parentIdx].reasonOtherText = value.substring(0, 300);

      const otherReasonIndex = updatedArray[parentIdx].reasonList?.findIndex(
        (r) => r.bispecifictreatmentdiscontinuationreasonid === otherReasonId,
      );

      if (otherReasonIndex !== -1 && otherReasonIndex !== undefined) {
        updatedArray[parentIdx].reasonList[otherReasonIndex].isSelected = true;
        updatedArray[parentIdx].reasonList[otherReasonIndex].reasonText =
          value.substring(0, 300);
      }

      // Ensure "Other" reason is selected
      if (!updatedArray[parentIdx].selectedReasons.includes(otherReasonId)) {
        updatedArray[parentIdx].selectedReasons.push(otherReasonId);
      }

      updatedArray[parentIdx].reasonOtherTextEmpty = false;
      updatedArray[parentIdx].reasonEmpty = false;
      updatedArray[parentIdx].deathDtWarning = false;
    }

    // Set the updated array (Elrexfio or Linvo)
    if (agentName === "Elrexfio" || agentName === "Elrex") {
      setQ382AElrexDetails(updatedArray);
    } else {
      setQ382ALinvoDetails(updatedArray);
    }
  };

  const HandleQ382RepeaterFieldChange = (e, agentName, rowIndex) => {
    const { name, value, type, checked } = e.target;
    const index = Number(rowIndex);
    const valueInt = Number(value);

    let updatedArray =
      agentName === "Elrexfio"
        ? [...Q382AElrexDetails]
        : [...Q382ALinvoDetails];

    // ========================================
    // COLUMN B - TYPE OF CHANGE RADIO BUTTONS
    // ========================================

    // ✅ Q38.2.A ELREXFIO - Column B Type of change radio
    if (name === `changeTypeElr382A${index}`) {
      updatedArray[index].changeType = valueInt;
      updatedArray[index].changeTypeEmpty = false;

      // Reset columns C-E if "No changes" (1) or "Unknown" (99) selected
      //  if (valueInt === 1 || valueInt === 99) {
      // Column C - Reasons
      updatedArray[index].selectedReasons = [];
      updatedArray[index].selectedAEReasons = [];
      updatedArray[index].reasonOtherText = "";
      updatedArray[index].reasonEmpty = false;
      updatedArray[index].deathDtWarning = false;
      updatedArray[index].reasonOtherTextEmpty = false;
      updatedArray[index].aeSubReasonEmpty = false;
      updatedArray[index].neuroReasonEmpty = false;
      updatedArray[index].neuroOtherTextEmpty = false;
      updatedArray[index].reasonUnknown = false;
      updatedArray[index].neurologicAEReasonList = resetNeurologicReasons(
        updatedArray[index].neurologicAEReasonList,
      );

      if (Number(index) === 0 && (valueInt === 1 || valueInt === 99)) {
        updatedArray = [updatedArray[0]]; // Keep only row 0
      }

      // Reset reasonList
      if (
        updatedArray[index].reasonList &&
        Array.isArray(updatedArray[index].reasonList)
      ) {
        updatedArray[index].reasonList = updatedArray[index].reasonList.map(
          (reason) => ({
            ...reason,
            isSelected: false,
            reasonText: "",
            aeSubReasons: reason.aeSubReasons?.map((ae) => ({
              ...ae,
              isSelected: false,
            })),
          }),
        );
      }

      // Column D - Start date
      updatedArray[index].startDateChangeRd = null;
      updatedArray[index].startDateChange = "";
      updatedArray[index].startDateChangeRdEmpty = false;
      updatedArray[index].startDateChangeEmpty = false;
      updatedArray[index].invalidStartDateChange = false;
      updatedArray[index].startDateChangeOutOfBound = false;

      // Column E - End date
      updatedArray[index].endDateChangeRd = null;
      updatedArray[index].endDateChange = "";
      updatedArray[index].endDateChangeRdEmpty = false;
      updatedArray[index].endDateChangeEmpty = false;
      updatedArray[index].invalidEndDateChange = false;
      updatedArray[index].endDateChangeOutOfBound = false;
      updatedArray[index].endDateChangeBeforeEOF = false;
      updatedArray[index].dateRangeConflict = false;
      // }

      // Clear pattern unknown warning
      updatedArray[index].patternAfterUnknownWarning = false;
      updatedArray[index].patternBeforeUnknownWarning = false;

      updatedArray[index].interruptionStartDateUnknownWarning = false;
      updatedArray[index].interruptionEndDateUnknownWarning = false;
    }

    // ✅ Q38.2.A LINVOSELTAMAB - Column B Type of change radio
    if (name === `changeTypeLinvo382A${index}`) {
      updatedArray[index].changeType = valueInt;
      updatedArray[index].changeTypeEmpty = false;

      // Reset columns C-E if "No changes" (1) or "Unknown" (99) selected
      //  if (valueInt === 1 || valueInt === 99) {
      // Column C - Reasons
      updatedArray[index].selectedReasons = [];
      updatedArray[index].selectedAEReasons = [];
      updatedArray[index].reasonOtherText = "";
      updatedArray[index].reasonEmpty = false;
      updatedArray[index].deathDtWarning = false;
      updatedArray[index].reasonOtherTextEmpty = false;
      updatedArray[index].aeSubReasonEmpty = false;
      updatedArray[index].neuroReasonEmpty = false;
      updatedArray[index].neuroOtherTextEmpty = false;
      updatedArray[index].reasonUnknown = false;
      updatedArray[index].neurologicAEReasonList = resetNeurologicReasons(
        updatedArray[index].neurologicAEReasonList,
      );

      if (Number(index) === 0 && (valueInt === 1 || valueInt === 99)) {
        updatedArray = [updatedArray[0]]; // Keep only row 0
      }

      // Reset reasonList
      if (
        updatedArray[index].reasonList &&
        Array.isArray(updatedArray[index].reasonList)
      ) {
        updatedArray[index].reasonList = updatedArray[index].reasonList.map(
          (reason) => ({
            ...reason,
            isSelected: false,
            reasonText: "",
            aeSubReasons: reason.aeSubReasons?.map((ae) => ({
              ...ae,
              isSelected: false,
            })),
          }),
        );
      }

      // Column D - Start date
      updatedArray[index].startDateChangeRd = null;
      updatedArray[index].startDateChange = "";
      updatedArray[index].startDateChangeRdEmpty = false;
      updatedArray[index].startDateChangeEmpty = false;
      updatedArray[index].invalidStartDateChange = false;
      updatedArray[index].startDateChangeOutOfBound = false;
      updatedArray[index].startDateChangeBeforeEOF = false;

      // Column E - End date
      updatedArray[index].endDateChangeRd = null;
      updatedArray[index].endDateChange = "";
      updatedArray[index].endDateChangeRdEmpty = false;
      updatedArray[index].endDateChangeEmpty = false;
      updatedArray[index].invalidEndDateChange = false;
      updatedArray[index].endDateChangeOutOfBound = false;
      updatedArray[index].endDateChangeBeforeEOF = false;
      updatedArray[index].dateRangeConflict = false;
      //   }

      // Clear pattern unknown warning
      updatedArray[index].patternAfterUnknownWarning = false;
      updatedArray[index].patternBeforeUnknownWarning = false;

      updatedArray[index].interruptionStartDateUnknownWarning = false;
      updatedArray[index].interruptionEndDateUnknownWarning = false;
    }

    // ========================================
    // COLUMN C - REASONS FOR CHANGE
    // ========================================

    // ✅ Column C - Reason "Unknown" radio (ELREXFIO)
    if (name === `reasonUnknownElr382A${index}`) {
      updatedArray[index].reasonUnknown = !updatedArray[index].reasonUnknown;

      if (updatedArray[index].reasonUnknown) {
        // Clear all other reasons
        updatedArray[index].selectedReasons = [];
        updatedArray[index].selectedAEReasons = [];
        updatedArray[index].reasonOtherText = "";

        // Uncheck all reasonList items
        if (
          updatedArray[index].reasonList &&
          Array.isArray(updatedArray[index].reasonList)
        ) {
          updatedArray[index].reasonList = updatedArray[index].reasonList.map(
            (reason) => ({
              ...reason,
              isSelected: false,
              reasonText: "",
              aeSubReasons: reason.aeSubReasons?.map((ae) => ({
                ...ae,
                isSelected: false,
              })),
            }),
          );
        }
      }
      updatedArray[index].neurologicAEReasonList = resetNeurologicReasons(
        updatedArray[index].neurologicAEReasonList,
      );

      updatedArray[index].reasonEmpty = false;
      updatedArray[index].deathDtWarning = false;
      updatedArray[index].reasonOtherTextEmpty = false;
      updatedArray[index].aeSubReasonEmpty = false;
      updatedArray[index].neuroReasonEmpty = false;
      updatedArray[index].neuroOtherTextEmpty = false;
    }

    // ✅ Column C - Reason "Unknown" radio (LINVOSELTAMAB)
    if (name === `reasonUnknownLinvo382A${index}`) {
      updatedArray[index].reasonUnknown = !updatedArray[index].reasonUnknown;

      if (updatedArray[index].reasonUnknown) {
        // Clear all other reasons
        updatedArray[index].selectedReasons = [];
        updatedArray[index].selectedAEReasons = [];
        updatedArray[index].reasonOtherText = "";

        // Uncheck all reasonList items
        if (
          updatedArray[index].reasonList &&
          Array.isArray(updatedArray[index].reasonList)
        ) {
          updatedArray[index].reasonList = updatedArray[index].reasonList.map(
            (reason) => ({
              ...reason,
              isSelected: false,
              reasonText: "",
              aeSubReasons: reason.aeSubReasons?.map((ae) => ({
                ...ae,
                isSelected: false,
              })),
            }),
          );
        }
      }
      updatedArray[index].neurologicAEReasonList = resetNeurologicReasons(
        updatedArray[index].neurologicAEReasonList,
      );
      updatedArray[index].reasonEmpty = false;
      updatedArray[index].deathDtWarning = false;
      updatedArray[index].reasonOtherTextEmpty = false;
      updatedArray[index].aeSubReasonEmpty = false;
      updatedArray[index].neuroReasonEmpty = false;
      updatedArray[index].neuroOtherTextEmpty = false;
    }

    // ========================================
    // COLUMN D - START DATE RADIO BUTTONS
    // ========================================

    // ✅ Column D - Start date radio buttons (ELREXFIO)
    if (name === `startDateChangeRdElr${index}`) {
      updatedArray[index].startDateChangeRd = valueInt;
      updatedArray[index].startDateChangeRdEmpty = false;
      updatedArray[index].interruptionStartDateUnknownWarning = valueInt === 99;
      // Clear date if "Unknown" (99) selected
      if (valueInt === 99) {
        updatedArray[index].startDateChange = "";
        updatedArray[index].startDateChangeEmpty = false;
        updatedArray[index].invalidStartDateChange = false;
        updatedArray[index].startDateChangeOutOfBound = false;
        updatedArray[index].startDateChangeBeforeEOF = false;
      }
    }

    // ✅ Column D - Start date radio buttons (LINVOSELTAMAB)
    if (name === `startDateChangeRdLinvo${index}`) {
      updatedArray[index].startDateChangeRd = valueInt;
      updatedArray[index].startDateChangeRdEmpty = false;
      updatedArray[index].interruptionStartDateUnknownWarning = valueInt === 99;

      // Clear date if "Unknown" (99) selected
      if (valueInt === 99) {
        updatedArray[index].startDateChange = "";
        updatedArray[index].startDateChangeEmpty = false;
        updatedArray[index].invalidStartDateChange = false;
        updatedArray[index].startDateChangeOutOfBound = false;
        updatedArray[index].startDateChangeBeforeEOF = false;
      }
    }

    // ========================================
    // COLUMN E - END DATE RADIO BUTTONS
    // ========================================

    // ✅ Column E - End date radio buttons (ELREXFIO)
    if (name === `endDateChangeRdElr${index}`) {
      updatedArray[index].endDateChangeRd = valueInt;
      updatedArray[index].endDateChangeRdEmpty = false;
      updatedArray[index].interruptionEndDateUnknownWarning = valueInt === 99;

      // Clear date if "Ongoing" (1) or "Unknown" (99) selected
      if (valueInt === 1 || valueInt === 99) {
        updatedArray[index].endDateChange = "";
        updatedArray[index].endDateChangeEmpty = false;
        updatedArray[index].invalidEndDateChange = false;
        updatedArray[index].endDateChangeOutOfBound = false;
        updatedArray[index].endDateChangeBeforeEOF = false;
        updatedArray[index].dateRangeConflict = false;
      }
    }

    // ✅ Column E - End date radio buttons (LINVOSELTAMAB)
    if (name === `endDateChangeRdLinvo${index}`) {
      updatedArray[index].endDateChangeRd = valueInt;
      updatedArray[index].endDateChangeRdEmpty = false;
      updatedArray[index].interruptionEndDateUnknownWarning = valueInt === 99;
      // Clear date if "Ongoing" (1) or "Unknown" (99) selected
      if (valueInt === 1 || valueInt === 99) {
        updatedArray[index].endDateChange = "";
        updatedArray[index].endDateChangeEmpty = false;
        updatedArray[index].invalidEndDateChange = false;
        updatedArray[index].endDateChangeOutOfBound = false;
        updatedArray[index].endDateChangeBeforeEOF = false;
        updatedArray[index].dateRangeConflict = false;
      }
    }

    // ========================================
    // UPDATE STATE BASED ON AGENT NAME
    // ========================================

    if (agentName === "Elrexfio") {
      setQ382AElrexDetails(updatedArray);
    } else {
      setQ382ALinvoDetails(updatedArray);
    }
  };

  const HandleNeuroRepeaterFieldChange = (
    e,
    questionKey,
    cohortId,
    aeNeuroId,
    rowIndex,
  ) => {
    if (isNaN(rowIndex)) return;
    const resolver = stateResolver[questionKey]?.[cohortId];
    if (!resolver) return;

    const [detailsArray, setState] = resolver;

    const { type, checked, value, tagName } = e.target;

    const updatedArray = [...detailsArray];
    const row = { ...updatedArray[rowIndex] };

    row.neurologicAEReasonList =
      row.neurologicAEReasonList?.map((item, index) => {
        if (index !== aeNeuroId) return item;

        // Checkbox change
        if (type === "checkbox") {
          return {
            ...item,
            isSelected: checked,
            reasonText: checked ? item.reasonText : "",
          };
        }

        // Textarea change
        if (tagName === "TEXTAREA") {
          return {
            ...item,
            isSelected: true,
            reasonText: value,
          };
        }

        return item;
      }) ?? [];

    row.aeSubReasonEmpty = false;
    row.neuroReasonEmpty = false;
    row.neuroOtherTextEmpty = false;

    updatedArray[rowIndex] = row;
    setState(updatedArray);
  };

  const AddQ382AElrexRow = () => {
    setQ382AElrexDetails((prev) => {
      // Get template reasonList from first row if exists
      const templateReasonList =
        prev.length > 0 && prev[0].reasonList?.length > 0
          ? prev[0].reasonList.map((reason) => ({
              ...reason,
              isSelected: false,
              reasonText: "",
              aeSubReasons: reason.aeSubReasons?.map((ae) => ({
                ...ae,
                isSelected: false,
              })),
            }))
          : [];

      return [
        ...prev,
        {
          ...Q382AElrexRow,
          cohorttreatmentid: isElrexvayliSelected
            ? RRMMCohortTreatment.ELREXFIO
            : 0,
          reasonList: templateReasonList,
          neurologicAEReasonList:
            prev.length > 0 && prev[0].neurologicAEReasonList
              ? resetNeurologicReasons(prev[0].neurologicAEReasonList)
              : [],
        },
      ];
    });
  };

  const AddQ382ALinvoRow = () => {
    setQ382ALinvoDetails((prev) => {
      // Get template reasonList from first row if exists
      const templateReasonList =
        prev.length > 0 && prev[0].reasonList?.length > 0
          ? prev[0].reasonList.map((reason) => ({
              ...reason,
              isSelected: false,
              reasonText: "",
              aeSubReasons: reason.aeSubReasons?.map((ae) => ({
                ...ae,
                isSelected: false,
              })),
            }))
          : [];

      return [
        ...prev,
        {
          ...Q382ALinvoRow,
          cohorttreatmentid: isLinvoveySelected
            ? RRMMCohortTreatment.Linvoseltamab
            : 0,
          reasonList: templateReasonList,
          neurologicAEReasonList:
            prev.length > 0 && prev[0].neurologicAEReasonList
              ? resetNeurologicReasons(prev[0].neurologicAEReasonList)
              : [],
        },
      ];
    });
  };

  // Delete ELREXFIO Row
  const DeleteQ382AElrexRow = (id) => {
    const newArray = [...Q382AElrexDetails];
    newArray.splice(id, 1);
    setQ382AElrexDetails(newArray);
  };

  // Delete LINVOSELTAMAB Row
  const DeleteQ382ALinvoRow = (id) => {
    const newArray = [...Q382ALinvoDetails];
    newArray.splice(id, 1);
    setQ382ALinvoDetails(newArray);
  };

  function isValidNumber(value) {
    // Convert value to a number
    const number = parseFloat(value);

    // Regular expression to match numbers with up to two decimal places
    const decimalRegex = /^\d{1,2}(\.\d{1,2})?$|^50(\.0{1,2})?$/;

    // Validate that the number is within the range and matches the decimal format
    return (
      !isNaN(number) && number >= 0 && number <= 50 && decimalRegex.test(value)
    );
  }

  const HandleFieldChange = (e) => {
    const { name, id, value, checked } = e.target;

    switch (name) {
      case "Q37ElrexvayliRd" + id: {
        let updatedArray = [...Q37ElrexDetails];
        // let updatedElrArray = [...Q38ElrexDetails]

        updatedArray[id].Q37ElrexvayliRd = Number(value);
        updatedArray[id].q37ElrexvayliEmpty = false;

        updatedArray[id].showDateRedFreqElr =
          Number(value) === 1 ? true : false;

        // setQ38ElrexDetails(updatedElrArray);

        setQ38ElrexDetails([
          {
            ...Q38ElrexRow,
          },
        ]);
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "Q37LinvoveyRd" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].Q37LinvoveyRd = Number(value);
        updatedArray[id].q37LinvoveyEmpty = false;

        updatedArray[id].showDateRedFreqLinvo =
          Number(value) === 1 ? true : false;
        //  updatedArray[id].dose_administration_elrHard = false;

        setQ38LinvoDetails([
          {
            ...Q38LinvoRow,
          },
        ]);

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "q37_Elr_Dose_week_frquencyRd" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].q37_Elr_Dose_week_frquencyRd = Number(value);
        updatedArray[id].q37_Elr_Dose_week_frquency_txt = "";
        updatedArray[id].q37_Elr_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q37_Elr_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q37_Elr_Dose_week_freq_range = false;
        updatedArray[id].q37SubsequentDoseConflict = false;

        if (Number(value) === 1) {
          updatedArray[id].Q37ElrexvayliRd = null;
          updatedArray[id].q37ElrexvayliEmpty = false;
          updatedArray[id].showDateRedFreqElr = false;

          updatedArray[id].q37ElrDosageRd = null;
          updatedArray[id].q37ElrDosageOtherTxt = "";
          updatedArray[id].q37ElrDosageRdEmpty = false;
          updatedArray[id].q37ElrDosageOtherTxtEmpty = false;
          setQ38ElrexDetails([
            {
              ...Q38ElrexRow,
            },
          ]);
        }
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "q37_Elr_Dose_week_frquency_txt" + id: {
        let updatedArray = [...Q37ElrexDetails];

        const reqValue = value;
        updatedArray[id].q37_Elr_Dose_week_frquency_txt = reqValue;
        updatedArray[id].q37_Elr_Dose_week_frquencyRd = 2;
        updatedArray[id].q37_Elr_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q37_Elr_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q37_Elr_Dose_week_freq_range = false;
        updatedArray[id].q37SubsequentDoseConflict = false;

        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "q37_Linvo_Dose_week_frquencyRd" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].q37_Linvo_Dose_week_frquencyRd = Number(value);
        updatedArray[id].q37_Linvo_Dose_week_frquency_txt = "";
        updatedArray[id].q37_Linvo_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q37_Linvo_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q37_Linvo_Dose_week_freq_range = false;
        updatedArray[id].q37LinvoSubsequentDoseConflict = false;

        if (Number(value) === 1) {
          updatedArray[id].Q37LinvoveyRd = null;
          updatedArray[id].q37LinvoveyEmpty = false;
          updatedArray[id].showDateRedFreqLinvo = false;
          setQ38LinvoDetails([
            {
              ...Q38LinvoRow,
            },
          ]);
        }

        if (Number(value) == 1) {
          updatedArray[id].q37_Linvo_Dosage_Rd = null;
          updatedArray[id].q37_Linvo_Dosage_OtherTxt = "";
          updatedArray[id].q37_Linvo_Dosage_Rd_Empty = false;
          updatedArray[id].q37_Linvo_Dosage_OtherTxt_Empty = false;
        }
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "q37_Linvo_Dose_week_frquency_txt" + id: {
        let updatedArray = [...Q37LinvoDetails];

        const reqValue = value;

        updatedArray[id].q37_Linvo_Dose_week_frquency_txt = reqValue;
        updatedArray[id].q37_Linvo_Dose_week_frquencyRd = 2;
        updatedArray[id].q37_Linvo_Dose_week_frquencyRd_Empty = false;
        updatedArray[id].q37_Linvo_Dose_week_frquency_txt_Empty = false;
        updatedArray[id].q37_Linvo_Dose_week_freq_range = false;
        updatedArray[id].q37LinvoSubsequentDoseConflict = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "q37_Linvo_Dosage_Rd" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].q37_Linvo_Dosage_Rd = Number(value);
        updatedArray[id].q37_Linvo_Dosage_OtherTxt = "";
        updatedArray[id].q37_Linvo_Dosage_Rd_Empty = false;
        updatedArray[id].q37_Linvo_Dosage_OtherTxt_Empty = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "q37_Linvo_Dosage_OtherTxt" + id: {
        let updatedArray = [...Q37LinvoDetails];

        const reqValue = value;
        updatedArray[id].q37_Linvo_Dosage_Rd = 2;
        updatedArray[id].q37_Linvo_Dosage_OtherTxt = reqValue;
        updatedArray[id].q37_Linvo_Dosage_Rd_Empty = false;
        updatedArray[id].q37_Linvo_Dosage_OtherTxt_Empty = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      //40

      case "Q40dosingfreqRd" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].Q40dosingfreqRd = Number(value);
        updatedArray[id].dosing_freq_oth_txt = "";

        updatedArray[id].Q40DosingFreqEmptyHard = false;
        updatedArray[id].Q40DosingFreqTxtEmptyHard = false;
        //Reset col C,D,E if 1
        if (Number(value) === 1) {
          updatedArray[id].Q40IgILevelRd = null;
          updatedArray[id].Q40IgGEmptyHard = false;

          updatedArray[id].Q40init_dt_Rd = null;
          updatedArray[id].Q40Init_RdHard = false;
          updatedArray[id].Q40init_dt = "";
          updatedArray[id].Q40Init_dtHard = false;
          updatedArray[id].InvalidQ40init_dt = false;
          updatedArray[id].init_dt_before_eof = false;

          updatedArray[id].primaryProf = false;
          updatedArray[id].secondaryProf = false;
          updatedArray[id].otherReson = false;
          updatedArray[id].Q40ReasonEmptyHard = false;
        }
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "Q40IgILevelRd" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].Q40IgILevelRd = Number(value);

        updatedArray[id].Q40IgGEmptyHard = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "Q40init_dt_Rd" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].Q40init_dt_Rd = Number(value);

        updatedArray[id].Q40Init_RdHard = false;
        updatedArray[id].Q40Init_dtHard = false;
        updatedArray[id].InvalidQ40init_dt = false;
        updatedArray[id].init_dt_before_eof = false;
        updatedArray[id].Q40init_dt = "";
        setQ37ElrexDetails(updatedArray);
        break;
      }

      //39Elr

      case "tocilizumab_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].noneoftheabove_elr = null;
        updatedArray[id].tocilizumab_elr = !updatedArray[id].tocilizumab_elr;

        updatedArray[id].Q39elrReasonHard = false;
        updatedArray[id].crs_elr = false;
        updatedArray[id].neurotoxicity_elr = false;
        updatedArray[id].tmt_neurotoxicity_elr = false;
        updatedArray[id].tmt_elr_unknown = false;
        updatedArray[id].cytokin_elr = false;
        updatedArray[id].secondary_prophylactic_crs_elr = false;
        updatedArray[id].secondary_neurotoxicity_elr = false;
        updatedArray[id].Q39ElrEmptyHard = false;

        //39.1.A
        if (q391AElrRow) {
          setQ391AElrTocilzumabList([{ ...q391AElrRow, patientid: pid }]);
        }

        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "Granulocyte" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].noneoftheabove_elr = null;
        updatedArray[id].Granulocyte = !updatedArray[id].Granulocyte;

        updatedArray[id].Q39ElrEmptyHard = false;
        updatedArray[id].prophylactic_use_elr = false;
        updatedArray[id].secondary_prophylactic_use_elr = false;
        updatedArray[id].oth_use_elr = false;
        updatedArray[id].unknown_elr = null;

        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "SteroidsElr" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].SteroidsElr = !updatedArray[id].SteroidsElr;
        updatedArray[id].noneoftheabove_elr = null;

        updatedArray[id].steroid_pre_tmt_elr = false;
        updatedArray[id].cytokin_elr_steroids = false;
        updatedArray[id].secondary_prophylactic_elr_steroids = false;
        updatedArray[id].secondary_neurotoxicity_elr_steroids = false;
        updatedArray[id].crs_elr_steroids = false;
        updatedArray[id].neurotoxicity_elr_steroids = false;
        updatedArray[id].tmt_neurotoxicity_elr_steroids = false;
        updatedArray[id].tmt_steroids_elr_unknown = false;

        updatedArray[id].Q39elrSteroidsEmptyHard = false;
        updatedArray[id].Q39ElrEmptyHard = false;

        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].betamethasone_elr = false;
        updatedArray[id].betamethasone_elrNum = "";

        updatedArray[id].dexamethasone_elr = false;
        updatedArray[id].dexamethasone_elrNum = "";

        updatedArray[id].hydrocortisone_elr = false;
        updatedArray[id].hydrocortisone_elrNum = "";

        updatedArray[id].methylprednisolone = false;
        updatedArray[id].methylprednisoloneNum = "";

        updatedArray[id].prednisolone_elr = false;
        updatedArray[id].prednisolone_elrNum = "";

        updatedArray[id].prednisone_elr = false;
        updatedArray[id].prednisone_elrNum = "";

        updatedArray[id].triamcinolone_elr = false;
        updatedArray[id].triamcinolone_elrNum = "";

        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "noneoftheabove_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].noneoftheabove_elr = Number(value);
        updatedArray[id].tocilizumab_elr = false;
        updatedArray[id].Granulocyte = false;

        updatedArray[id].Q39elrReasonHard = false;
        updatedArray[id].Q39elrGranduloEmptyHard = false;
        updatedArray[id].Q39ElrEmptyHard = false;
        updatedArray[id].SteroidsElr = false;

        //39.1.A
        if (q391AElrRow) {
          setQ391AElrTocilzumabList([{ ...q391AElrRow, patientid: pid }]);
        }

        setQ37ElrexDetails(updatedArray);
        break;
      }

      //39Linvoseltamab

      case "tocilizumab_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].tocilizumab_linvo =
          !updatedArray[id].tocilizumab_linvo;
        updatedArray[id].noneoftheabove_linvo = null;
        updatedArray[id].cytokin_linvo = false;
        updatedArray[id].secondary_prophylactic_crs_linvo = false;
        updatedArray[id].crs_linvo = false;
        updatedArray[id].neurotoxicity_linvo = false;
        updatedArray[id].secondary_neurotoxicity_linvo = false;
        updatedArray[id].tmt_neurotoxicity_linvo = false;
        updatedArray[id].tmt_linvoseltamab_unknown = false;

        updatedArray[id].Q39LinvoEmptyHard = false;

        updatedArray[id].Q39linvoReasonHard = false;

        //39.1.A
        if (q391ALinvoRow) {
          setQ391ALinvoTocilzumabList([{ ...q391ALinvoRow, patientid: pid }]);
        }

        setQ37LinvoDetails(updatedArray);
        break;
      }
      case "granulocyte_linvo" + id: {
        const updatedArray = [...Q37LinvoDetails];

        updatedArray[id] = {
          ...updatedArray[id],
          noneoftheabove_linvo: false,
          granulocyte_linvo: !Boolean(updatedArray[id].granulocyte_linvo),
          Q39LinvoEmptyHard: false,
          prophylactic_use_linvo: false,
          secondary_prophylactic_use_linvo: false,
          oth_use_linvo: false,
          unknown_linvo: null,
        };

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "Steroids" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].Steroids = !updatedArray[id].Steroids;
        updatedArray[id].noneoftheabove_linvo = null;

        updatedArray[id].cytokin_linvo_steroids = false;
        updatedArray[id].secondary_prophylactic_linvo_steroids = false;
        updatedArray[id].secondary_neurotoxicity_linvo_steroids = false;

        updatedArray[id].crs_linvo_steroids = false;
        updatedArray[id].neurotoxicity_linvo_steroids = false;
        updatedArray[id].tmt_neurotoxicity_linvo_steroids = false;
        updatedArray[id].tmt_linvo_unknown = false;
        updatedArray[id].steroid_pre_tmt_linvo = false;

        updatedArray[id].dose_name_linvo_unknown = false;
        updatedArray[id].betamethasone_linvo = false;
        updatedArray[id].betamethasone_linvoNum = "";

        updatedArray[id].dexamethasone_linvo = false;
        updatedArray[id].dexamethasone_linvoNum = "";

        updatedArray[id].hydrocortisone_linvo = false;
        updatedArray[id].hydrocortisone_linvoNum = "";

        updatedArray[id].methylprednisolone_linvo = false;
        updatedArray[id].methylprednisolone_linvoNum = "";

        updatedArray[id].prednisolone_linvo = false;
        updatedArray[id].prednisolone_linvoNum = "";

        updatedArray[id].prednisone_linvo = false;
        updatedArray[id].prednisone_linvoNum = "";

        updatedArray[id].triamcinolone_linvo = false;
        updatedArray[id].triamcinolone_linvoNum = "";

        updatedArray[id].Q39linvoSteroidsEmptyHard = false;
        updatedArray[id].Q39LinvoEmptyHard = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "noneoftheabove_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].Steroids = false;
        updatedArray[id].tocilizumab_linvo = false;
        updatedArray[id].noneoftheabove_linvo = Number(value);
        updatedArray[id].Q39LinvoEmptyHard = false;

        updatedArray[id].Q39linvoReasonHard = false;

        updatedArray[id].Q39linvoSteroidsEmptyHard = false;
        updatedArray[id].Q39linvoGranduloEmptyHard = false;
        updatedArray[id].granulocyte_linvo = null;

        //39.1.A
        if (q391ALinvoRow) {
          setQ391ALinvoTocilzumabList([{ ...q391ALinvoRow, patientid: pid }]);
        }

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "dosing_freq_oth_txt" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].Q40dosingfreqRd = 5;
        updatedArray[id].dosing_freq_oth_txt = value;

        updatedArray[id].Q40DosingFreqEmptyHard = false;
        updatedArray[id].Q40DosingFreqTxtEmptyHard = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      //checkbox - primary prof
      case "primaryProf" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].primaryProf = !updatedArray[id].primaryProf;

        updatedArray[id].Q40ReasonEmptyHard = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "secondaryProf" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].secondaryProf = !updatedArray[id].secondaryProf;
        updatedArray[id].Q40ReasonEmptyHard = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "otherReson" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].otherReson = !updatedArray[id].otherReson;
        updatedArray[id].Q40ReasonEmptyHard = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      //40 - Linvo

      case "q40DosingFreqRd_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].q40DosingFreqRd_linvo = Number(value);
        updatedArray[id].dosing_Freq_Oth_Txt_linvo = "";

        updatedArray[id].Q40LinvoDosingFreqEmptyHard = false;
        updatedArray[id].Q40LinvoDosingFreqTxtEmptyHard = false;
        if (Number(value) === 1) {
          updatedArray[id].q40IgILevelRd_linvo = null;
          updatedArray[id].Q40LinvoIgGEmptyHard = false;

          updatedArray[id].q40Init_Dt_Rd_linvo = null;
          updatedArray[id].Q40LinvoInit_RdHard = false;
          updatedArray[id].q40Init_Dt_linvo = "";
          updatedArray[id].Q40LinvoInit_dtHard = false;
          updatedArray[id].invalidQ40Init_dt_linvo = false;
          updatedArray[id].init_dt_before_eof_linvo = false;

          updatedArray[id].primaryProf_linvo = false;
          updatedArray[id].secondaryProf_linvo = false;
          updatedArray[id].otherReson_linvo = false;
          updatedArray[id].Q40LinvoReasonEmptyHard = false;
        }
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "q40IgILevelRd_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].q40IgILevelRd_linvo = Number(value);
        updatedArray[id].Q40LinvoIgGEmptyHard = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "q40Init_Dt_Rd_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].q40Init_Dt_Rd_linvo = Number(value);
        updatedArray[id].Q40LinvoInit_RdHard = false;
        updatedArray[id].Q40LinvoInit_dtHard = false;
        updatedArray[id].invalidQ40Init_dt_linvo = false;
        updatedArray[id].init_dt_before_eof_linvo = false;
        updatedArray[id].q40Init_Dt_linvo = "";
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "dosing_Freq_Oth_Txt_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].q40DosingFreqRd_linvo = 5;
        updatedArray[id].dosing_Freq_Oth_Txt_linvo = value;

        updatedArray[id].Q40LinvoDosingFreqEmptyHard = false;
        updatedArray[id].Q40LinvoDosingFreqTxtEmptyHard = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "primaryProf_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].primaryProf_linvo =
          !updatedArray[id].primaryProf_linvo;

        updatedArray[id].Q40LinvoReasonEmptyHard = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "secondaryProf_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].secondaryProf_linvo =
          !updatedArray[id].secondaryProf_linvo;
        updatedArray[id].Q40LinvoReasonEmptyHard = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "otherReson_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].otherReson_linvo = !updatedArray[id].otherReson_linvo;
        updatedArray[id].Q40LinvoReasonEmptyHard = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      //39- 1.1
      case "cytokin_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].cytokin_elr = !updatedArray[id].cytokin_elr;

        updatedArray[id].tmt_elr_unknown = false;

        updatedArray[id].Q39elrReasonHard = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "secondary_prophylactic_crs_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].secondary_prophylactic_crs_elr =
          !updatedArray[id].secondary_prophylactic_crs_elr;
        updatedArray[id].tmt_elr_unknown = false;
        updatedArray[id].Q39elrReasonHard = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "crs_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].crs_elr = !updatedArray[id].crs_elr;
        updatedArray[id].Q39elrReasonHard = false;
        updatedArray[id].tmt_elr_unknown = false;

        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "neurotoxicity_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].neurotoxicity_elr =
          !updatedArray[id].neurotoxicity_elr;
        updatedArray[id].Q39elrReasonHard = false;
        updatedArray[id].tmt_elr_unknown = false;

        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "secondary_neurotoxicity_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].secondary_neurotoxicity_elr =
          !updatedArray[id].secondary_neurotoxicity_elr;
        updatedArray[id].Q39elrReasonHard = false;
        updatedArray[id].tmt_elr_unknown = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "tmt_neurotoxicity_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].tmt_neurotoxicity_elr =
          !updatedArray[id].tmt_neurotoxicity_elr;
        updatedArray[id].Q39elrReasonHard = false;
        updatedArray[id].tmt_elr_unknown = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "tmt_elr_unknown" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].tmt_elr_unknown = !updatedArray[id].tmt_elr_unknown;
        updatedArray[id].Q39elrReasonHard = false;

        updatedArray[id].crs_elr = false;
        updatedArray[id].cytokin_elr = false;
        updatedArray[id].secondary_neurotoxicity_elr = false;
        updatedArray[id].secondary_prophylactic_crs_elr = false;
        updatedArray[id].tmt_neurotoxicity_elr = false;
        updatedArray[id].neurotoxicity_elr = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      //39.3

      case "prophylactic_use_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].prophylactic_use_elr =
          !updatedArray[id].prophylactic_use_elr;

        updatedArray[id].Q39elrGranduloEmptyHard = false;
        updatedArray[id].unknown_elr = null;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "secondary_prophylactic_use_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].secondary_prophylactic_use_elr =
          !updatedArray[id].secondary_prophylactic_use_elr;

        updatedArray[id].Q39elrGranduloEmptyHard = false;
        updatedArray[id].unknown_elr = null;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "oth_use_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].oth_use_elr = !updatedArray[id].oth_use_elr;

        updatedArray[id].Q39elrGranduloEmptyHard = false;
        updatedArray[id].unknown_elr = null;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "unknown_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].unknown_elr = Number(value);
        updatedArray[id].oth_use_elr = false;
        updatedArray[id].prophylactic_use_elr = false;
        updatedArray[id].secondary_prophylactic_use_elr = false;
        updatedArray[id].Q39elrGranduloEmptyHard = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      //39.1

      case "cytokin_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].cytokin_linvo = !updatedArray[id].cytokin_linvo;

        updatedArray[id].Q39linvoReasonHard = false;
        updatedArray[id].tmt_linvoseltamab_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "secondary_prophylactic_crs_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].secondary_prophylactic_crs_linvo =
          !updatedArray[id].secondary_prophylactic_crs_linvo;

        updatedArray[id].Q39linvoReasonHard = false;
        updatedArray[id].tmt_linvoseltamab_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "crs_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].crs_linvo = !updatedArray[id].crs_linvo;

        updatedArray[id].tmt_linvoseltamab_unknown = false;

        updatedArray[id].Q39linvoReasonHard = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "neurotoxicity_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].neurotoxicity_linvo =
          !updatedArray[id].neurotoxicity_linvo;
        updatedArray[id].Q39linvoReasonHard = false;
        updatedArray[id].tmt_linvoseltamab_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "secondary_neurotoxicity_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].secondary_neurotoxicity_linvo =
          !updatedArray[id].secondary_neurotoxicity_linvo;
        updatedArray[id].Q39linvoReasonHard = false;
        updatedArray[id].tmt_linvoseltamab_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "tmt_neurotoxicity_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].tmt_neurotoxicity_linvo =
          !updatedArray[id].tmt_neurotoxicity_linvo;
        updatedArray[id].Q39linvoReasonHard = false;
        updatedArray[id].tmt_linvoseltamab_unknown = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "tmt_linvoseltamab_unknown" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].tmt_linvoseltamab_unknown =
          !updatedArray[id].tmt_linvoseltamab_unknown;
        updatedArray[id].Q39linvoReasonHard = false;

        updatedArray[id].tmt_neurotoxicity_linvo = false;
        updatedArray[id].cytokin_linvo = false;
        updatedArray[id].secondary_prophylactic_crs_linvo = false;
        updatedArray[id].secondary_neurotoxicity_linvo = false;

        updatedArray[id].neurotoxicity_linvo = false;
        updatedArray[id].crs_linvo = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      //Q39.3
      case "prophylactic_use_linvo" + id: {
        const updatedArray = [...Q37LinvoDetails];

        updatedArray[id] = {
          ...updatedArray[id],
          prophylactic_use_linvo: !Boolean(
            updatedArray[id].prophylactic_use_linvo,
          ),
          Q39linvoGranduloEmptyHard: false,
          unknown_linvo: null,
        };

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "secondary_prophylactic_use_linvo" + id: {
        const updatedArray = [...Q37LinvoDetails];

        updatedArray[id] = {
          ...updatedArray[id],
          secondary_prophylactic_use_linvo: !Boolean(
            updatedArray[id].secondary_prophylactic_use_linvo,
          ),
          Q39linvoGranduloEmptyHard: false,
          unknown_linvo: null,
        };

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "oth_use_linvo" + id: {
        const updatedArray = [...Q37LinvoDetails];

        updatedArray[id] = {
          ...updatedArray[id],
          oth_use_linvo: !Boolean(updatedArray[id].oth_use_linvo),
          Q39linvoGranduloEmptyHard: false,
          unknown_linvo: null,
        };

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "unknown_linvo" + id: {
        const updatedArray = [...Q37LinvoDetails];

        updatedArray[id] = {
          ...updatedArray[id],
          unknown_linvo: Number(value),
          oth_use_linvo: false,
          prophylactic_use_linvo: false,
          secondary_prophylactic_use_linvo: false,
          Q39linvoGranduloEmptyHard: false,
        };

        setQ37LinvoDetails(updatedArray);
        break;
      }

      //39.2 Linvoseltamab
      case "cytokin_linvo_steroids" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].cytokin_linvo_steroids =
          !updatedArray[id].cytokin_linvo_steroids;

        updatedArray[id].Q39linvoSteroidsEmptyHard = false;
        updatedArray[id].tmt_linvo_unknown = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "secondary_prophylactic_linvo_steroids" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].secondary_prophylactic_linvo_steroids =
          !updatedArray[id].secondary_prophylactic_linvo_steroids;

        updatedArray[id].Q39linvoSteroidsEmptyHard = false;
        updatedArray[id].tmt_linvo_unknown = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "crs_linvo_steroids" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].crs_linvo_steroids =
          !updatedArray[id].crs_linvo_steroids;
        updatedArray[id].Q39linvoSteroidsEmptyHard = false;
        updatedArray[id].tmt_linvo_unknown = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "neurotoxicity_linvo_steroids" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].neurotoxicity_linvo_steroids =
          !updatedArray[id].neurotoxicity_linvo_steroids;
        updatedArray[id].Q39linvoSteroidsEmptyHard = false;
        updatedArray[id].tmt_linvo_unknown = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "secondary_neurotoxicity_linvo_steroids" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].secondary_neurotoxicity_linvo_steroids =
          !updatedArray[id].secondary_neurotoxicity_linvo_steroids;
        updatedArray[id].Q39linvoSteroidsEmptyHard = false;
        updatedArray[id].tmt_linvo_unknown = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "tmt_neurotoxicity_linvo_steroids" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].tmt_neurotoxicity_linvo_steroids =
          !updatedArray[id].tmt_neurotoxicity_linvo_steroids;
        updatedArray[id].Q39linvoSteroidsEmptyHard = false;
        updatedArray[id].tmt_linvo_unknown = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "tmt_linvo_unknown" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].tmt_linvo_unknown =
          !updatedArray[id].tmt_linvo_unknown;

        updatedArray[id].cytokin_linvo_steroids = false;
        updatedArray[id].secondary_prophylactic_linvo_steroids = false;
        updatedArray[id].secondary_neurotoxicity_linvo_steroids = false;

        updatedArray[id].crs_linvo_steroids = false;

        updatedArray[id].neurotoxicity_linvo_steroids = false;

        updatedArray[id].tmt_neurotoxicity_linvo_steroids = false;
        updatedArray[id].steroid_pre_tmt_linvo = false;

        updatedArray[id].Q39linvoSteroidsEmptyHard = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "steroid_pre_tmt_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].steroid_pre_tmt_linvo =
          !updatedArray[id].steroid_pre_tmt_linvo;

        updatedArray[id].Q39linvoSteroidsEmptyHard = false;
        updatedArray[id].tmt_linvo_unknown = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "betamethasone_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].betamethasone_linvo =
          !updatedArray[id].betamethasone_linvo;

        updatedArray[id].betamethasone_linvoNum = "";
        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].dose_name_linvo_unknown = false;

        updatedArray[id].steroids_linvo_txtEmpty = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "betamethasone_linvoNum" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].betamethasone_linvoNum = value;

        updatedArray[id].betamethasone_linvo = true;

        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].steroids_linvo_txtEmpty = false;
        updatedArray[id].dose_name_linvo_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "dexamethasone_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].dexamethasone_linvo =
          !updatedArray[id].dexamethasone_linvo;

        updatedArray[id].dexamethasone_linvoNum = "";
        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].steroids_linvo_txtEmpty = false;

        updatedArray[id].dose_name_linvo_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "dexamethasone_linvoNum" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].dexamethasone_linvoNum = value;

        updatedArray[id].dexamethasone_linvo = true;

        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].steroids_linvo_txtEmpty = false;
        updatedArray[id].dose_name_linvo_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "hydrocortisone_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].hydrocortisone_linvo =
          !updatedArray[id].hydrocortisone_linvo;

        updatedArray[id].hydrocortisone_linvoNum = "";

        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].steroids_linvo_txtEmpty = false;
        updatedArray[id].dose_name_linvo_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "hydrocortisone_linvoNum" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].hydrocortisone_linvoNum = value;

        updatedArray[id].hydrocortisone_linvo = true;

        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].steroids_linvo_txtEmpty = false;
        updatedArray[id].dose_name_linvo_unknown = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      //

      case "methylprednisolone_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].methylprednisolone_linvo =
          !updatedArray[id].methylprednisolone_linvo;

        updatedArray[id].methylprednisolone_linvoNum = "";

        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].steroids_linvo_txtEmpty = false;
        updatedArray[id].dose_name_linvo_unknown = false;
        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "methylprednisolone_linvoNum" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].methylprednisolone_linvoNum = value;

        updatedArray[id].methylprednisolone_linvo = true;

        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].steroids_linvo_txtEmpty = false;
        updatedArray[id].dose_name_linvo_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "prednisolone_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].prednisolone_linvo =
          !updatedArray[id].prednisolone_linvo;

        updatedArray[id].prednisolone_linvoNum = "";

        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].steroids_linvo_txtEmpty = false;
        updatedArray[id].dose_name_linvo_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "prednisolone_linvoNum" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].prednisolone_linvoNum = value;

        updatedArray[id].prednisolone_linvo = true;

        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].steroids_linvo_txtEmpty = false;
        updatedArray[id].dose_name_linvo_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "prednisone_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].prednisone_linvo = !updatedArray[id].prednisone_linvo;

        updatedArray[id].prednisone_linvoNum = "";

        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].steroids_linvo_txtEmpty = false;
        updatedArray[id].dose_name_linvo_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "prednisone_linvoNum" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].prednisone_linvoNum = value;

        updatedArray[id].prednisone_linvo = true;

        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].steroids_linvo_txtEmpty = false;
        updatedArray[id].dose_name_linvo_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "triamcinolone_linvo" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].triamcinolone_linvo =
          !updatedArray[id].triamcinolone_linvo;

        updatedArray[id].triamcinolone_linvoNum = "";

        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].steroids_linvo_txtEmpty = false;
        updatedArray[id].dose_name_linvo_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "triamcinolone_linvoNum" + id: {
        let updatedArray = [...Q37LinvoDetails];

        updatedArray[id].triamcinolone_linvoNum = value;

        updatedArray[id].triamcinolone_linvo = true;

        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;
        updatedArray[id].steroids_linvo_txtEmpty = false;
        updatedArray[id].dose_name_linvo_unknown = false;

        setQ37LinvoDetails(updatedArray);
        break;
      }

      case "dose_name_linvo_unknown" + id: {
        let updatedArray = [...Q37LinvoDetails];
        updatedArray[id].dose_name_linvo_unknown =
          !updatedArray[id].dose_name_linvo_unknown;

        updatedArray[id].name_dose_steroids_linvoHardEmpty = false;

        updatedArray[id].steroids_linvo_txtEmpty = false;

        updatedArray[id].betamethasone_linvo = false;
        updatedArray[id].betamethasone_linvoNum = "";

        updatedArray[id].dexamethasone_linvo = false;
        updatedArray[id].dexamethasone_linvoNum = "";

        updatedArray[id].hydrocortisone_linvo = false;
        updatedArray[id].hydrocortisone_linvoNum = "";

        updatedArray[id].methylprednisolone_linvo = false;
        updatedArray[id].methylprednisolone_linvoNum = "";

        updatedArray[id].prednisolone_linvo = false;
        updatedArray[id].prednisolone_linvoNum = "";

        updatedArray[id].prednisone_linvo = false;
        updatedArray[id].prednisone_linvoNum = "";

        updatedArray[id].triamcinolone_linvo = false;
        updatedArray[id].triamcinolone_linvoNum = "";

        setQ37LinvoDetails(updatedArray);
        break;
      }

      // New phase
      case "steroid_pre_tmt_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].steroid_pre_tmt_elr =
          !updatedArray[id].steroid_pre_tmt_elr;

        updatedArray[id].Q39elrSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_elr_unknown = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      //New elr column handlechange

      case "betamethasone_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].betamethasone_elr =
          !updatedArray[id].betamethasone_elr;

        updatedArray[id].betamethasone_elrNum = "";
        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].betamethasone_elr_txtEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "betamethasone_elrNum" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].betamethasone_elrNum = value;

        updatedArray[id].betamethasone_elr = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].betamethasone_elr_txtEmpty = false;

        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "dexamethasone_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].dexamethasone_elr =
          !updatedArray[id].dexamethasone_elr;

        updatedArray[id].dexamethasone_elrNum = "";
        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].dexamethasone_elr_txtEmpty = false;

        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "dexamethasone_elrNum" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].dexamethasone_elrNum = value;

        updatedArray[id].dexamethasone_elr = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].dexamethasone_elr_txtEmpty = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "hydrocortisone_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].hydrocortisone_elr =
          !updatedArray[id].hydrocortisone_elr;

        updatedArray[id].hydrocortisone_elrNum = "";

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].hydrocortisone_elr_txtEmpty = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "hydrocortisone_elrNum" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].hydrocortisone_elrNum = value;

        updatedArray[id].hydrocortisone_elr = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].hydrocortisone_elr_txtEmpty = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      //

      case "methylprednisolone" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].methylprednisolone =
          !updatedArray[id].methylprednisolone;

        updatedArray[id].methylprednisoloneNum = "";

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].methylprednisolone_txtEmpty = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "methylprednisoloneNum" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].methylprednisoloneNum = value;

        updatedArray[id].methylprednisolone = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].methylprednisolone_txtEmpty = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "prednisolone_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].prednisolone_elr = !updatedArray[id].prednisolone_elr;

        updatedArray[id].prednisolone_elrNum = "";

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].prednisolone_elr_txtEmpty = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "prednisolone_elrNum" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].prednisolone_elrNum = value;

        updatedArray[id].prednisolone_elr = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].prednisolone_elr_txtEmpty = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "prednisone_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].prednisone_elr = !updatedArray[id].prednisone_elr;

        updatedArray[id].prednisone_elrNum = "";

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].prednisone_elr_txtEmpty = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "prednisone_elrNum" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].prednisone_elrNum = value;

        updatedArray[id].prednisone_elr = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].prednisone_elr_txtEmpty = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "triamcinolone_elr" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].triamcinolone_elr =
          !updatedArray[id].triamcinolone_elr;

        updatedArray[id].triamcinolone_elrNum = "";

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].triamcinolone_elr_txtEmpty = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "triamcinolone_elrNum" + id: {
        let updatedArray = [...Q37ElrexDetails];

        updatedArray[id].triamcinolone_elrNum = value;

        updatedArray[id].triamcinolone_elr = true;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].dose_name_elr_unknown = false;
        updatedArray[id].triamcinolone_elr_txtEmpty = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "dose_name_elr_unknown" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].dose_name_elr_unknown =
          !updatedArray[id].dose_name_elr_unknown;

        updatedArray[id].name_dose_steroidsHardEmpty = false;
        updatedArray[id].steroids_elr_txtEmpty = false;
        updatedArray[id].betamethasone_elr_txtEmpty = false;
        updatedArray[id].dexamethasone_elr_txtEmpty = false;
        updatedArray[id].hydrocortisone_elr_txtEmpty = false;
        updatedArray[id].methylprednisolone_txtEmpty = false;
        updatedArray[id].prednisolone_elr_txtEmpty = false;
        updatedArray[id].prednisone_elr_txtEmpty = false;
        updatedArray[id].triamcinolone_elr_txtEmpty = false;

        updatedArray[id].betamethasone_elr = false;
        updatedArray[id].betamethasone_elrNum = "";

        updatedArray[id].dexamethasone_elr = false;
        updatedArray[id].dexamethasone_elrNum = "";

        updatedArray[id].hydrocortisone_elr = false;
        updatedArray[id].hydrocortisone_elrNum = "";

        updatedArray[id].methylprednisolone = false;
        updatedArray[id].methylprednisoloneNum = "";

        updatedArray[id].prednisolone_elr = false;
        updatedArray[id].prednisolone_elrNum = "";

        updatedArray[id].prednisone_elr = false;
        updatedArray[id].prednisone_elrNum = "";

        updatedArray[id].triamcinolone_elr = false;
        updatedArray[id].triamcinolone_elrNum = "";

        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "cytokin_elr_steroids" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].cytokin_elr_steroids =
          !updatedArray[id].cytokin_elr_steroids;

        updatedArray[id].Q39elrSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_elr_unknown = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "secondary_prophylactic_elr_steroids" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].secondary_prophylactic_elr_steroids =
          !updatedArray[id].secondary_prophylactic_elr_steroids;

        updatedArray[id].Q39elrSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_elr_unknown = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "crs_elr_steroids" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].crs_elr_steroids = !updatedArray[id].crs_elr_steroids;
        updatedArray[id].Q39elrSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_elr_unknown = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "neurotoxicity_elr_steroids" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].neurotoxicity_elr_steroids =
          !updatedArray[id].neurotoxicity_elr_steroids;
        updatedArray[id].Q39elrSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_elr_unknown = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "secondary_neurotoxicity_elr_steroids" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].secondary_neurotoxicity_elr_steroids =
          !updatedArray[id].secondary_neurotoxicity_elr_steroids;
        updatedArray[id].Q39elrSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_elr_unknown = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "tmt_neurotoxicity_elr_steroids" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].tmt_neurotoxicity_elr_steroids =
          !updatedArray[id].tmt_neurotoxicity_elr_steroids;
        updatedArray[id].Q39elrSteroidsEmptyHard = false;
        updatedArray[id].tmt_steroids_elr_unknown = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      case "tmt_steroids_elr_unknown" + id: {
        let updatedArray = [...Q37ElrexDetails];
        updatedArray[id].tmt_steroids_elr_unknown =
          !updatedArray[id].tmt_steroids_elr_unknown;

        updatedArray[id].cytokin_elr_steroids = false;
        updatedArray[id].secondary_neurotoxicity_elr_steroids = false;
        updatedArray[id].secondary_prophylactic_elr_steroids = false;

        updatedArray[id].steroid_pre_tmt_elr = false;
        updatedArray[id].crs_elr_steroids = false;

        updatedArray[id].neurotoxicity_elr_steroids = false;

        updatedArray[id].tmt_neurotoxicity_elr_steroids = false;

        updatedArray[id].Q39elrSteroidsEmptyHard = false;
        setQ37ElrexDetails(updatedArray);
        break;
      }

      default:
        break;
    }
  };

  const ValidateForm = () => {
    let isValid = true;

    let count = 0;
    let count_linvo = 0;
    if (
      isElrexvayliSelected &&
      elrexvayliDetails &&
      elrexvayliDetails.length > 0
    ) {
      if (
        elrexvayliDetails.length != elrNumberofAdministrator &&
        elrNumberofAdministrator != 0
      ) {
        setElrNumberofAdministratorMatching(true);
      } else {
        setElrNumberofAdministratorMatching(false);
      }
    }
    if (bispecificQ26Data?.length > 0) {
      const isLinvoValid = ValidateQ26LastAdministrationMatch({
        isSelected: isLinvoveySelected,
        details: linvoveyDetails,
        cohortId: RRMMCohortTreatment.Linvoseltamab,
        dateField: "dose_administration_linvo_dt",
        q26Data: bispecificQ26Data,
      });

      setIsLinvoLastAdminDateValid(isLinvoValid);

      const isElrValid = ValidateQ26LastAdministrationMatch({
        isSelected: isElrexvayliSelected,
        details: elrexvayliDetails,
        cohortId: RRMMCohortTreatment.ELREXFIO,
        dateField: "dose_administration_elr_dt",
        q26Data: bispecificQ26Data,
      });

      setIsElrLastAdminDateValid(isElrValid);

      if (!isLinvoValid || !isElrValid) isValid = false;
    }

    if (isLinvoveySelected && linvoveyDetails && linvoveyDetails.length > 0) {
      if (
        linvoveyDetails.length != linvoNumberofAdministrator &&
        linvoNumberofAdministrator != 0
      ) {
        setLinvoNumberofAdministratorMatching(true);
      } else {
        setLinvoNumberofAdministratorMatching(false);
      }
    }

    //36 Elrexfio
    if (
      isElrexvayliSelected &&
      elrexvayliDetails &&
      elrexvayliDetails.length > 0
    ) {
      const updatedArray = elrexvayliDetails.map((item, index) => {
        let dose_administration_elrHard = false;
        if (item.dose_administration_elr == null) {
          dose_administration_elrHard = true;
        }

        let dose_administration_elrHard_dt = false;
        let dt_elr_date_out_of_bound = false;
        let Invalid_dose_administration_elr_dt = false;
        let dose_administration_elr_dt_before_eof = false;
        if (item.dose_administration_elr === 1) {
          if (item.dose_administration_elr_dt === "") {
            dose_administration_elrHard_dt = true;
          } else if (item.dose_administration_elr_dt === "Invalid Date") {
            Invalid_dose_administration_elr_dt = true;
          } else if (
            item.dose_administration_elr_dt !== "Invalid Date" &&
            !DateInRange(
              item.dose_administration_elr_dt,
              dayjs("01-01-1920"),
              dayjs(),
            )
          ) {
            Invalid_dose_administration_elr_dt = true;
          } else {
            if (
              (elrexIndexDate !== "" &&
                IsDateAfter(elrexIndexDate, item.dose_administration_elr_dt)) ||
              (elrvayliDateRRMM !== "" &&
                IsDateAfter(item.dose_administration_elr_dt, elrvayliDateRRMM)) // ||
            ) {
              dt_elr_date_out_of_bound = true;
            } else {
              if (
                endOfFollowUpDate !== null &&
                endOfFollowUpDate !== "" &&
                endOfFollowUpDate !== "Invalid Date"
              ) {
                const EOFDateAfter = IsDateAfter(
                  item.dose_administration_elr_dt,
                  endOfFollowUpDate,
                );
                if (EOFDateAfter) {
                  dose_administration_elr_dt_before_eof = true;
                }
              }
            }
          }
        }

        // Q36: ELREXFIO Duplicate Date Check
        if (isElrexvayliSelected && elrexvayliDetails.length > 0) {
          let hasDuplicateElr = false;

          const updatedElrDetails = elrexvayliDetails.map((item, index) => {
            let duplicateDateCheck = false;

            if (item.dose_administration_elr_dt) {
              const duplicateCount = elrexvayliDetails.filter(
                (detail, idx) =>
                  idx !== index &&
                  detail.dose_administration_elr_dt ===
                    item.dose_administration_elr_dt,
              ).length;

              if (duplicateCount > 0) {
                duplicateDateCheck = true;
                hasDuplicateElr = true;
              }
            }

            return { ...item, duplicateDateCheck };
          });

          if (hasDuplicateElr) {
            setElrexvayliDetails(updatedElrDetails);
            setElrexDuplicateDates(true);
            isValid = false;
          } else {
            setElrexDuplicateDates(false);
          }
        }

        let dosing_phase_elrHard = false;
        if (item.dosing_phase_elr == null) {
          dosing_phase_elrHard = true;
        }

        let siteofcare_elrHard = false;
        if (item.siteofcare_elr == null) {
          siteofcare_elrHard = true;
        }

        let dosing_phase_elrHard_othEmpty = false;
        if (
          item.dosing_phase_elr === 5 &&
          item.dosing_phase_oth_txt_elr == ""
        ) {
          dosing_phase_elrHard_othEmpty = true;
        }

        let elr_dose_strength_mg_kgHard = false;
        if (
          item.elr_dose_strength_rbl == null ||
          (item.elr_dose_strength_mg === "" &&
            item.elr_dose_strength_mg_kg === "" &&
            item.elr_dose_strength_mgm === "" &&
            item.elr_dose_strength_rbl !== 99)
        ) {
          elr_dose_strength_mg_kgHard = true;
        }

        let elr_dose_strength_mg_kgRange = false;
        if (
          !elr_dose_strength_mg_kgHard &&
          item.elr_dose_strength_rbl !== 99 &&
          ((item.elr_dose_strength_mg_kg != "" &&
            !isValidNumberRange(item.elr_dose_strength_mg_kg)) ||
            (item.elr_dose_strength_mg != "" &&
              !isValidNumberRange(item.elr_dose_strength_mg)) ||
            (item.elr_dose_strength_mgm != "" &&
              !isValidNumberRange(item.elr_dose_strength_mgm)))
        ) {
          elr_dose_strength_mg_kgRange = true;
        }

        if (!isStringEmpty(item.dose_administration_elr_dt) && elrexIndexDate) {
          if (elrexIndexDate === item.dose_administration_elr_dt) {
            count++;
          }
        } else if (
          isStringEmpty(item.dose_administration_elr) ||
          item.dose_administration_elr === 99
        ) {
          count++;
        }

        if (
          dose_administration_elrHard ||
          dose_administration_elrHard_dt ||
          dosing_phase_elrHard ||
          siteofcare_elrHard ||
          dosing_phase_elrHard_othEmpty ||
          elr_dose_strength_mg_kgHard ||
          elr_dose_strength_mg_kgRange ||
          dt_elr_date_out_of_bound ||
          Invalid_dose_administration_elr_dt ||
          dose_administration_elr_dt_before_eof
        ) {
          isValid = false;
        }

        return {
          ...item,
          dose_administration_elrHard,
          dose_administration_elrHard_dt,
          Invalid_dose_administration_elr_dt,
          dose_administration_elr_dt_before_eof,
          dosing_phase_elrHard,
          siteofcare_elrHard,
          dosing_phase_elrHard_othEmpty,
          elr_dose_strength_mg_kgHard,
          elr_dose_strength_mg_kgRange,
          dt_elr_date_out_of_bound,
        };
      });

      if (count === 0) {
        setIndexDateRRMM_elrHard(true);
        isValid = false;
      } else {
        setIndexDateRRMM_elrHard(false);
      }
      setElrexvayliDetails(updatedArray);

      const isDateValid = ValidateForDateCondition(elrexvayliDetails);
      if (!isDateValid) {
        setDt_elr_2L_3L_date_conditions(true);
        isValid = false;
      }
    }

    //36.1 Elrexfio
    if (isElrexvayliSelected && elrHospDetails && elrHospDetails.length > 0) {
      const updatedArray = elrHospDetails.map((item, index) => {
        let dt_admission_Hard = false;
        let dt_admission_Hard_dt = false;
        let Invalid_admission_Hard_dt = false;
        let Invalid_dt_discharge_Hard = false;
        let dt_admission_before_eof = false;
        // let dt_admission_Hard_dt_check = false;
        let dt_admission_out_of_bound = false;

        let dt_discharge_Hard = false;
        let dt_discharge_Hard_dt = false;
        let dt_discharge_Hard_dt_check = false;
        let dt_discharge_out_of_bound = false;
        let dt_discharge_before_eof = false;

        let hospReasonEmptyHard = false;
        let hospReasonTxtEmpty = false;

        dt_admission_Hard = item.dt_admission == null;

        if (item.dt_admission === 1) {
          if (item.dt_admission_dt === "") {
            dt_admission_Hard_dt = true;
          } else if (item.dt_admission_dt === "Invalid Date") {
            Invalid_admission_Hard_dt = true;
          } else if (
            item.dt_admission_dt !== "Invalid Date" &&
            !DateInRange(item.dt_admission_dt, dayjs("01-01-1920"), dayjs())
          ) {
            Invalid_admission_Hard_dt = true;
          } else {
            if (
              (elrexIndexDate !== "" &&
                IsDateAfter(elrexIndexDate, item.dt_admission_dt)) ||
              (elrvayliDateRRMM !== "" &&
                IsDateAfter(item.dt_admission_dt, elrvayliDateRRMM))
            ) {
              dt_admission_out_of_bound = true;
            } else {
              if (
                endOfFollowUpDate !== null &&
                endOfFollowUpDate !== "" &&
                endOfFollowUpDate !== "Invalid Date"
              ) {
                const EOFDateAfter = IsDateAfter(
                  item.dt_admission_dt,
                  endOfFollowUpDate,
                );
                if (EOFDateAfter) {
                  dt_admission_before_eof = true;
                }
              }
            }
          }
        }

        if (item.dt_admission != null && item.dt_admission !== 2) {
          dt_discharge_Hard = item.dt_discharge == null;

          if (item.dt_discharge === 1) {
            if (item.dt_discharge_dt === "") {
              dt_discharge_Hard_dt = true;
            } else if (item.dt_discharge_dt === "Invalid Date") {
              Invalid_dt_discharge_Hard = true;
            } else if (
              item.dt_discharge_dt !== "Invalid Date" &&
              !DateInRange(item.dt_discharge_dt, dayjs("01-01-1920"), dayjs())
            ) {
              Invalid_dt_discharge_Hard = true;
            } else {
              if (
                (elrexIndexDate !== "" &&
                  IsDateAfter(elrexIndexDate, item.dt_discharge_dt)) ||
                (elrvayliDateRRMM !== "" &&
                  IsDateAfter(item.dt_discharge_dt, elrvayliDateRRMM))
              ) {
                dt_discharge_out_of_bound = true;
              } else {
                if (
                  endOfFollowUpDate !== null &&
                  endOfFollowUpDate !== "" &&
                  endOfFollowUpDate !== "Invalid Date"
                ) {
                  const EOFDateAfter = IsDateAfter(
                    item.dt_discharge_dt,
                    endOfFollowUpDate,
                  );
                  if (EOFDateAfter) {
                    dt_discharge_before_eof = true;
                  }
                }
              }
            }
          }
          if (
            item.dt_admission_dt &&
            DateInRange(item.dt_discharge_dt, dayjs("01-01-1920"), dayjs()) &&
            IsDateAfter(item.dt_admission_dt, item.dt_discharge_dt) // item.dt_admission_dt > item.dt_discharge_dt
          ) {
            dt_discharge_Hard_dt_check = true;
          }
          hospReasonEmptyHard =
            !item.hospReason1 &&
            !item.hospReason2 &&
            !item.hospReason3 &&
            !item.hospReason4 &&
            !item.hospReason5 &&
            !item.hospReason6 &&
            !item.hospReasonUnk;
          hospReasonTxtEmpty =
            item.hospReason6 && isStringEmpty(item.hosp_reason_oth_txt);
        }

        if (
          dt_admission_Hard ||
          dt_admission_Hard_dt ||
          dt_admission_out_of_bound ||
          dt_discharge_Hard ||
          dt_discharge_Hard_dt ||
          dt_discharge_Hard_dt_check ||
          dt_discharge_out_of_bound ||
          hospReasonEmptyHard ||
          hospReasonTxtEmpty ||
          Invalid_admission_Hard_dt ||
          Invalid_dt_discharge_Hard ||
          dt_admission_before_eof ||
          dt_discharge_before_eof
        ) {
          isValid = false;
        }

        return {
          ...item,
          dt_admission_Hard,
          dt_admission_Hard_dt,
          dt_admission_out_of_bound,
          dt_discharge_Hard,
          dt_discharge_Hard_dt,
          dt_discharge_Hard_dt_check,
          dt_discharge_out_of_bound,
          hospReasonEmptyHard,
          hospReasonTxtEmpty,
          Invalid_admission_Hard_dt,
          Invalid_dt_discharge_Hard,
          dt_admission_before_eof,
          dt_discharge_before_eof,
        };
      });

      const elrHospChainValid = ValidateQ361HospitalizationChain(
        updatedArray,
        RRMMCohortTreatment.ELREXFIO,
      );

      setElrHospDateChainInvalid(!elrHospChainValid);
      setElrHospDetails(updatedArray);
    }
    //end
    //36 Linvoseltamab
    if (isLinvoveySelected && linvoveyDetails && linvoveyDetails.length > 0) {
      //

      const updatedArray = linvoveyDetails.map((item, index) => {
        let dose_administration_linvoHard = false;
        if (item.dose_administration_linvo == null) {
          dose_administration_linvoHard = true;
        }

        let Invalid_dose_administration_linvo_dt = false;

        let dose_administration_linvoHard_dt = false;
        let dt_linvo_date_out_of_bound = false;
        if (item.dose_administration_linvo === 1) {
          if (item.dose_administration_linvo_dt === "") {
            dose_administration_linvoHard_dt = true;
          } else if (item.dose_administration_linvo_dt === "Invalid Date") {
            Invalid_dose_administration_linvo_dt = true;
          } else if (
            item.dose_administration_linvo_dt !== "Invalid Date" &&
            !DateInRange(
              item.dose_administration_linvo_dt,
              dayjs("01-01-1920"),
              dayjs(),
            )
          ) {
            Invalid_dose_administration_linvo_dt = true;
          } else {
            if (
              (linvoIndexDate !== "" &&
                IsDateAfter(
                  linvoIndexDate,
                  item.dose_administration_linvo_dt,
                )) ||
              (linvoveyDateRRMM !== "" &&
                IsDateAfter(
                  item.dose_administration_linvo_dt,
                  linvoveyDateRRMM,
                )) // ||
            ) {
              dt_linvo_date_out_of_bound = true;
            }
          }
        }

        // Q36: ELREXFIO Duplicate Date Check
        if (isLinvoveySelected && linvoveyDetails.length > 0) {
          let hasDuplicateLin = false;

          const updatedElrDetails = linvoveyDetails.map((item, index) => {
            let duplicateDateCheck = false;

            if (item.dose_administration_linvo_dt) {
              const duplicateCount = linvoveyDetails.filter(
                (detail, idx) =>
                  idx !== index &&
                  detail.dose_administration_linvo_dt ===
                    item.dose_administration_linvo_dt,
              ).length;

              if (duplicateCount > 0) {
                duplicateDateCheck = true;
                hasDuplicateLin = true;
              }
            }

            return { ...item, duplicateDateCheck };
          });

          if (hasDuplicateLin) {
            setLinvoveyDetails(updatedElrDetails);
            setLinvoDuplicateDates(true);
            isValid = false;
          } else {
            setLinvoDuplicateDates(false);
          }
        }

        let dosing_phase_linvoHard = false;
        if (item.dosing_phase_linvo == null) {
          dosing_phase_linvoHard = true;
        }

        let siteofcare_linvoHard = false;
        if (item.siteofcare_linvo == null) {
          siteofcare_linvoHard = true;
        }

        let dosing_phase_linvoHard_othEmpty = false;
        if (
          item.dosing_phase_linvo === 6 &&
          item.dosing_phase_oth_txt_linvo == ""
        ) {
          dosing_phase_linvoHard_othEmpty = true;
        }

        let linvo_dose_strength_mg_kgHard = false;
        if (
          item.linvo_dose_strength_rbl === null ||
          (item.linvo_dose_strength_mg === "" &&
            item.linvo_dose_strength_mg_kg === "" &&
            item.linvo_dose_strength_mgm === "" &&
            item.linvo_dose_strength_rbl !== 99)
        ) {
          linvo_dose_strength_mg_kgHard = true;
        }

        let linvo_dose_strength_mg_kgRange = false;
        if (
          !linvo_dose_strength_mg_kgHard &&
          item.linvo_dose_strength_rbl !== 99 &&
          ((item.linvo_dose_strength_mg_kg != "" &&
            !isValidNumberRange(item.linvo_dose_strength_mg_kg)) ||
            (item.linvo_dose_strength_mg != "" &&
              !isValidNumberRange(item.linvo_dose_strength_mg)) ||
            (item.linvo_dose_strength_mgm != "" &&
              !isValidNumberRange(item.linvo_dose_strength_mgm)))
        ) {
          linvo_dose_strength_mg_kgRange = true;
        }

        if (
          !isStringEmpty(item.dose_administration_linvo_dt) &&
          linvoIndexDate
        ) {
          if (linvoIndexDate === item.dose_administration_linvo_dt) {
            count_linvo++;
          }
        } else if (
          isStringEmpty(item.dose_administration_linvo) ||
          item.dose_administration_linvo === 99
        ) {
          count_linvo++;
        }

        if (
          dose_administration_linvoHard ||
          dose_administration_linvoHard_dt ||
          dosing_phase_linvoHard ||
          siteofcare_linvoHard ||
          dosing_phase_linvoHard_othEmpty ||
          linvo_dose_strength_mg_kgHard ||
          linvo_dose_strength_mg_kgRange ||
          dt_linvo_date_out_of_bound ||
          Invalid_dose_administration_linvo_dt
        ) {
          isValid = false;
        }

        return {
          ...item,
          dose_administration_linvoHard,
          dose_administration_linvoHard_dt,
          dosing_phase_linvoHard,
          siteofcare_linvoHard,
          dosing_phase_linvoHard_othEmpty,
          linvo_dose_strength_mg_kgHard,
          linvo_dose_strength_mg_kgRange,
          dt_linvo_date_out_of_bound,
          Invalid_dose_administration_linvo_dt,
        };
      });

      if (count_linvo === 0) {
        setIndexDateRRMM_linvoHard(true);
        isValid = false;
      } else {
        setIndexDateRRMM_linvoHard(false);
      }
      setLinvoveyDetails(updatedArray);

      const isDateValid = ValidateForDateCondition(linvoveyDetails);
      if (!isDateValid) {
        setDt_lino_2L_3L_date_conditions(true);
        isValid = false;
      }
    }

    //36.1 Linvoseltamab
    if (isLinvoveySelected && linvoHospDetails && linvoHospDetails.length > 0) {
      const updatedArray = linvoHospDetails.map((item, index) => {
        let dt_admission_Hard = false;
        let dt_admission_Hard_dt = false;

        let dt_discharge_Hard = false;
        let dt_discharge_Hard_dt = false;
        let dt_discharge_Hard_dt_check = false;
        let dt_discharge_out_of_bound = false;
        let dt_admission_out_of_bound = false;
        let Invalid_admission_Hard_dt = false;
        let dt_admission_before_eof = false;
        let dt_discharge_before_eof = false;
        let hospReasonEmptyHard = false;
        let hospReasonTxtEmpty = false;

        dt_admission_Hard = item.dt_admission == null;
        if (item.dt_admission === 1) {
          if (item.dt_admission_dt === "") {
            dt_admission_Hard_dt = true;
          } else if (item.dt_admission_dt === "Invalid Date") {
            Invalid_admission_Hard_dt = true;
          } else if (
            item.dt_admission_dt !== "Invalid Date" &&
            !DateInRange(item.dt_admission_dt, dayjs("01-01-1920"), dayjs())
          ) {
            Invalid_admission_Hard_dt = true;
          } else {
            if (
              (linvoIndexDate !== "" &&
                IsDateAfter(linvoIndexDate, item.dt_admission_dt)) ||
              (linvoveyDateRRMM !== "" &&
                IsDateAfter(item.dt_admission_dt, linvoveyDateRRMM))
            ) {
              dt_admission_out_of_bound = true;
            } else {
              if (
                endOfFollowUpDate !== null &&
                endOfFollowUpDate !== "" &&
                endOfFollowUpDate !== "Invalid Date"
              ) {
                const EOFDateAfter = IsDateAfter(
                  item.dt_admission_dt,
                  endOfFollowUpDate,
                );
                if (EOFDateAfter) {
                  dt_admission_before_eof = true;
                }
              }
            }
          }
        }

        let Invalid_dt_discharge_Hard = false;
        if (item.dt_admission != null && item.dt_admission !== 2) {
          dt_discharge_Hard = item.dt_discharge == null;

          if (item.dt_discharge === 1) {
            if (item.dt_discharge_dt === "") {
              dt_discharge_Hard_dt = true;
            } else if (item.dt_discharge_dt === "Invalid Date") {
              Invalid_dt_discharge_Hard = true;
            } else if (
              item.dt_discharge_dt !== "Invalid Date" &&
              !DateInRange(item.dt_discharge_dt, dayjs("01-01-1920"), dayjs())
            ) {
              Invalid_dt_discharge_Hard = true;
            } else {
              if (
                (linvoIndexDate !== "" &&
                  IsDateAfter(linvoIndexDate, item.dt_discharge_dt)) ||
                (linvoveyDateRRMM !== "" &&
                  IsDateAfter(item.dt_discharge_dt, linvoveyDateRRMM))
              ) {
                dt_discharge_out_of_bound = true;
              } else {
                if (
                  endOfFollowUpDate !== null &&
                  endOfFollowUpDate !== "" &&
                  endOfFollowUpDate !== "Invalid Date"
                ) {
                  const EOFDateAfter = IsDateAfter(
                    item.dt_discharge_dt,
                    endOfFollowUpDate,
                  );
                  if (EOFDateAfter) {
                    dt_discharge_before_eof = true;
                  }
                }
              }
            }
          }

          if (
            item.dt_admission_dt &&
            item.dt_discharge_dt &&
            DateInRange(item.dt_discharge_dt, dayjs("01-01-1920"), dayjs()) &&
            IsDateAfter(item.dt_admission_dt, item.dt_discharge_dt) //item.dt_admission_dt > item.dt_discharge_dt
          ) {
            dt_discharge_Hard_dt_check = true;
          }
          hospReasonEmptyHard =
            !item.hospReason1 &&
            !item.hospReason2 &&
            !item.hospReason3 &&
            !item.hospReason4 &&
            !item.hospReason5 &&
            !item.hospReason6 &&
            !item.hospReasonUnk;
          hospReasonTxtEmpty =
            item.hospReason6 && isStringEmpty(item.hosp_reason_oth_txt);
        }

        if (
          dt_admission_Hard ||
          dt_admission_Hard_dt ||
          dt_admission_out_of_bound ||
          dt_discharge_Hard ||
          dt_discharge_Hard_dt ||
          dt_discharge_Hard_dt_check ||
          dt_discharge_out_of_bound ||
          hospReasonEmptyHard ||
          hospReasonTxtEmpty ||
          Invalid_admission_Hard_dt ||
          Invalid_dt_discharge_Hard ||
          dt_admission_before_eof ||
          dt_discharge_before_eof
        ) {
          isValid = false;
        }

        return {
          ...item,
          dt_admission_Hard,
          dt_admission_Hard_dt,
          dt_admission_out_of_bound,
          dt_discharge_Hard,
          dt_discharge_Hard_dt,
          dt_discharge_Hard_dt_check,
          dt_discharge_out_of_bound,
          hospReasonEmptyHard,
          hospReasonTxtEmpty,
          Invalid_admission_Hard_dt,
          Invalid_dt_discharge_Hard,
          dt_admission_before_eof,
          dt_discharge_before_eof,
        };
      });

      const linvoHospChainValid = ValidateQ361HospitalizationChain(
        updatedArray,
        RRMMCohortTreatment.Linvoseltamab,
      );

      setLinvoHospDateChainInvalid(!linvoHospChainValid);

      if (!linvoHospChainValid) {
        isValid = false;
      }

      setLinvoHospDetails(updatedArray);
    }
    //end

    if (
      isElrexvayliSelected &&
      elrexvayliDetails &&
      elrexvayliDetails.length > 0
    ) {
      // Check if any dose has Inpatient site of care (siteofcareelr === 1) in step-up phases
      const hasInpatientDoses = elrexvayliDetails.some(
        (item) =>
          item.siteofcare_elr === 1 &&
          (item.dosing_phase_elr === 1 ||
            item.dosing_phase_elr === 2 ||
            item.dosing_phase_elr === 3),
      );

      // Check if hospitalizations exist (excluding "no hospitalizations" entries)
      const hasHospitalizations = elrHospDetails.some(
        (item) => item.dt_admission !== 2 && item.dt_admission !== null,
      );

      if (hasInpatientDoses && !hasHospitalizations) {
        setElrInpatientHospMissing(true);
        isValid = false;
      } else {
        setElrInpatientHospMissing(false);
      }
    }

    // Same validation for Linvoseltamab
    if (isLinvoveySelected && linvoveyDetails && linvoveyDetails.length > 0) {
      const hasInpatientDoses = linvoveyDetails.some(
        (item) =>
          item.siteofcare_linvo === 1 &&
          (item.dosing_phase_linvo === 1 ||
            item.dosing_phase_linvo === 2 ||
            item.dosing_phase_linvo === 3 ||
            item.dosing_phase_linvo === 4),
      );

      const hasHospitalizations = linvoHospDetails.some(
        (item) => item.dt_admission !== 2 && item.dt_admission !== null,
      );

      if (hasInpatientDoses && !hasHospitalizations) {
        setLinvoInpatientHospMissing(true);
        isValid = false;
      } else {
        setLinvoInpatientHospMissing(false);
      }
    }

    if (isElrexvayliSelected && Q37ElrexDetails && Q37ElrexDetails.length > 0) {
      const updatedArray = Q37ElrexDetails.map((item) => {
        let Q40DosingFreqEmptyHard = false;

        let Q40IgGEmptyHard = false;
        let Q40ReasonEmptyHard = false;
        let Q40Init_RdHard = false;
        let Q40Init_dtHard = false;
        let InvalidQ40init_dt = false;
        let init_dt_before_eof = false;

        let Q40DosingFreqTxtEmptyHard = false;

        if (item.Q40dosingfreqRd == null) {
          Q40DosingFreqEmptyHard = true;
        }

        if (item.Q40dosingfreqRd === 5 && item.dosing_freq_oth_txt === "") {
          Q40DosingFreqTxtEmptyHard = true;
        }

        if (item.Q40dosingfreqRd !== 1) {
          if (item.Q40IgILevelRd === null) {
            Q40IgGEmptyHard = true;
          }

          if (
            item.primaryProf === false &&
            item.secondaryProf === false &&
            item.otherReson === false
          ) {
            Q40ReasonEmptyHard = true;
          }

          if (item.Q40init_dt_Rd === null) {
            Q40Init_RdHard = true;
          }

          if (item.Q40init_dt_Rd === 1 && item.Q40init_dt === "") {
            Q40Init_dtHard = true;
          }

          if (item.Q40init_dt_Rd === 1 && item.Q40init_dt === "Invalid Date") {
            InvalidQ40init_dt = true;
          }

          if (
            item.Q40init_dt_Rd === 1 &&
            item.Q40init_dt !== "Invalid Date" &&
            !DateInRange(item.Q40init_dt, dayjs("01-01-1920"), dayjs())
          ) {
            InvalidQ40init_dt = true;
          } else {
            const isDateValid = ValidateIndexDAndLOTDateChain(
              item.Q40init_dt,
              RRMMCohortTreatment.ELREXFIO,
            );

            if (!isDateValid) {
              init_dt_before_eof = true;
            }
          }
        }

        //37Elr
        let q37ElrexvayliEmpty = false;
        if (
          isNewEcrfA === false &&
          item.q37_Elr_Dose_week_frquencyRd !== 1 &&
          item.Q37ElrexvayliRd === null
        ) {
          q37ElrexvayliEmpty = true;
        }

        let q37_Elr_Dose_week_frquencyRd_Empty = false;
        if (isNewEcrfA === false && item.q37_Elr_Dose_week_frquencyRd == null) {
          q37_Elr_Dose_week_frquencyRd_Empty = true;
        }

        let q37_Elr_Dose_week_frquency_txt_Empty = false;
        let q37_Elr_Dose_week_freq_range = false;
        if (
          isNewEcrfA === false &&
          item.q37_Elr_Dose_week_frquencyRd === 2 &&
          (item.q37_Elr_Dose_week_frquency_txt === "" ||
            item.q37_Elr_Dose_week_frquency_txt === null)
        ) {
          q37_Elr_Dose_week_frquency_txt_Empty = true;
        }

        //invalid Number
        if (
          isNewEcrfA === false &&
          item.q37_Elr_Dose_week_frquencyRd == 2 &&
          (item.q37_Elr_Dose_week_frquency_txt !== "" ||
            item.q37_Elr_Dose_week_frquency_txt !== null)
        ) {
          const checkValue = isValidNumber(item.q37_Elr_Dose_week_frquency_txt);
          if (
            item.q37_Elr_Dose_week_frquency_txt &&
            item.q37_Elr_Dose_week_frquencyRd_Empty == false &&
            !checkValue
          ) {
            q37_Elr_Dose_week_freq_range = true;
          }
        }

        let q37SubsequentDoseConflict = false;
        // Check if any dose in Q36 has "Subsequent treatment doses" (dosingphaseelr === 4)
        const hasSubsequentDoses = elrexvayliDetails.some(
          (item) => item.dosing_phase_elr === 4,
        );

        // Check if Q37 answer is "Patient has not completed the step-up dosing phase" (q37ElrDoseweekfrquencyRd === 1)
        const q37NotCompleted = item.q37_Elr_Dose_week_frquencyRd === 1;

        if (hasSubsequentDoses && q37NotCompleted && isNewEcrfA === false) {
          isValid = false;
          q37SubsequentDoseConflict = true;
        }

        let q37ElrDosageRdEmpty = false;
        if (
          isNewEcrfA === false &&
          item.q37_Elr_Dose_week_frquencyRd !== 1 &&
          item.q37ElrDosageRd == null
        ) {
          q37ElrDosageRdEmpty = true;
        }

        let q37ElrDosageOtherTxtEmpty = false;
        if (
          isNewEcrfA === false &&
          item.q37_Elr_Dose_week_frquencyRd !== 1 &&
          item.q37ElrDosageRd === 2 &&
          (!item.q37ElrDosageOtherTxt || item.q37ElrDosageOtherTxt == null)
        ) {
          q37ElrDosageOtherTxtEmpty = true;
        }

        let Q39ElrEmptyHard = false;
        let Q39elrReasonHard = false;
        let Q39elrGranduloEmptyHard = false;
        let Q39elrSteroidsEmptyHard = false;

        let name_dose_steroidsHardEmpty = false;
        let steroids_elr_txtEmpty = false;

        if (
          item.tocilizumab_elr === false &&
          item.Granulocyte === false &&
          item.SteroidsElr === false &&
          item.noneoftheabove_elr !== 99
        ) {
          Q39ElrEmptyHard = true;
        }

        if (item.tocilizumab_elr === true && !isNewEcrfA) {
          if (
            item.cytokin_elr === false &&
            item.secondary_prophylactic_crs_elr === false &&
            item.crs_elr === false &&
            item.neurotoxicity_elr === false &&
            item.tmt_neurotoxicity_elr === false &&
            item.secondary_neurotoxicity_elr === false &&
            item.tmt_elr_unknown === false
          ) {
            Q39elrReasonHard = true;
          }
        }

        if (item.Granulocyte === true) {
          if (
            item.prophylactic_use_elr === false &&
            item.secondary_prophylactic_use_elr === false &&
            item.oth_use_elr === false &&
            item.unknown_elr === null
          ) {
            Q39elrGranduloEmptyHard = true;
          }
        }

        if (item.SteroidsElr === true) {
          if (
            item.cytokin_elr_steroids === false &&
            item.secondary_prophylactic_elr_steroids === false &&
            item.crs_elr_steroids === false &&
            item.neurotoxicity_elr_steroids === false &&
            item.secondary_neurotoxicity_elr_steroids === false &&
            item.tmt_neurotoxicity_elr_steroids === false &&
            item.tmt_steroids_elr_unknown === false &&
            item.steroid_pre_tmt_elr === false
          ) {
            Q39elrSteroidsEmptyHard = true;
          }

          if (
            item.betamethasone_elr === false &&
            item.dexamethasone_elr === false &&
            item.hydrocortisone_elr === false &&
            item.methylprednisolone === false &&
            item.prednisolone_elr === false &&
            item.prednisone_elr === false &&
            item.triamcinolone_elr === false &&
            item.dose_name_elr_unknown === false
          ) {
            name_dose_steroidsHardEmpty = true;
          }

          if (
            (item.betamethasone_elr === true &&
              (!item.betamethasone_elrNum === "" ||
                item.betamethasone_elrNum === "")) ||
            (item.dexamethasone_elr === true &&
              (!item.dexamethasone_elrNum === "" ||
                item.dexamethasone_elrNum === "")) ||
            (item.hydrocortisone_elr === true &&
              (!item.hydrocortisone_elrNum ||
                item.hydrocortisone_elrNum === "")) ||
            (item.methylprednisolone === true &&
              (!item.methylprednisoloneNum ||
                item.methylprednisoloneNum === "")) ||
            (item.prednisolone_elr === true &&
              (!item.prednisolone_elrNum || item.prednisolone_elrNum === "")) ||
            (item.prednisone_elr === true &&
              (!item.prednisone_elrNum || item.prednisone_elrNum === "")) ||
            (item.triamcinolone_elr === true &&
              (!item.triamcinolone_elrNum || item.triamcinolone_elrNum === ""))
          ) {
            steroids_elr_txtEmpty = true;
          }
        }

        //39.1.A Elrexfio
        if (
          isNewEcrfA &&
          item.tocilizumab_elr === true &&
          q391AElrTocilzumabList?.length > 0
        ) {
          let elrIsValid = true;

          const updatedArray = q391AElrTocilzumabList.map((elrRow) => {
            const hasAnyReason =
              elrRow.primaryProphylacticCrs_elr === true ||
              elrRow.secondaryProphylacticCrs_elr === true ||
              elrRow.supportiveCareCrs_elr === true ||
              elrRow.primaryProphylacticNeurologic_elr === true ||
              elrRow.secondaryProphylacticNeurologic_elr === true ||
              elrRow.supportiveCareNeurologic_elr === true ||
              elrRow.medicationReasonUnk_elr === true;

            const q39ElrReasonEmpty = !hasAnyReason;

            const q39ElrAdministrationRDEmpty =
              !elrRow.administrationDateRD_elr;

            let q39ElrAdministrationDateEmpty = false;
            let q39ElrInvalidAdministrationDate = false;

            if (elrRow.administrationDateRD_elr === 1) {
              if (!elrRow.administrationDate_elr) {
                q39ElrAdministrationDateEmpty = true;
              } else if (
                elrRow.administrationDate_elr === "Invalid Date" ||
                !DateInRange(
                  elrRow.administrationDate_elr,
                  dayjs("01-01-1920"),
                  dayjs(),
                )
              ) {
                q39ElrInvalidAdministrationDate = true;
              } else {
              }
            }

            // ---- Aggregate validity ----
            if (
              q39ElrReasonEmpty ||
              q39ElrAdministrationRDEmpty ||
              q39ElrAdministrationDateEmpty ||
              q39ElrInvalidAdministrationDate
            ) {
              elrIsValid = false;
            }

            return {
              ...elrRow,
              q39ElrReasonEmpty,
              q39ElrAdministrationRDEmpty,
              q39ElrAdministrationDateEmpty,
              q39ElrInvalidAdministrationDate,
            };
          });

          let elrDateIsValid = true;
          const adminDates = q391AElrTocilzumabList
            .filter(
              (row) =>
                row.administrationDateRD_elr === 1 &&
                row.administrationDate_elr &&
                IsValidDateValue(row.administrationDate_elr),
            )
            .map((row) => row.administrationDate_elr);
          const earliestAdminDate =
            adminDates.length > 0
              ? adminDates.reduce((min, d) => (IsLessOrEqual(d, min) ? d : min))
              : null;

          const latestAdminDate =
            adminDates.length > 0
              ? adminDates.reduce((max, d) => (IsLessOrEqual(max, d) ? d : max))
              : null;

          // initiation date ≤ earliest admin date
          if (
            earliestAdminDate &&
            IsValidDateValue(earliestAdminDate) &&
            !IsLessOrEqual(elrexIndexDate, earliestAdminDate)
          ) {
            elrDateIsValid = false;
          }

          // latest admin date ≤ subsequent LOT (if exists)
          if (
            latestAdminDate &&
            IsValidDateValue(latestAdminDate) &&
            elrexfioLOTStartDate &&
            IsValidDateValue(elrexfioLOTStartDate) &&
            !IsLessOrEqual(latestAdminDate, elrexfioLOTStartDate)
          ) {
            elrDateIsValid = false;
          }

          // latest admin date ≤ end of follow-up
          if (
            latestAdminDate &&
            endOfFollowUpDate &&
            IsValidDateValue(endOfFollowUpDate) &&
            !IsLessOrEqual(latestAdminDate, endOfFollowUpDate)
          ) {
            elrDateIsValid = false;
          }

          setQ391AElrAdministrationDateOutOfRange(!elrDateIsValid);

          isValid = elrIsValid && elrDateIsValid;
          setQ391AElrTocilzumabList(updatedArray);
        }

        if (
          Q40DosingFreqEmptyHard ||
          Q40DosingFreqTxtEmptyHard ||
          Q40IgGEmptyHard ||
          Q40ReasonEmptyHard ||
          Q40Init_RdHard ||
          Q40Init_dtHard ||
          q37ElrexvayliEmpty ||
          Q39ElrEmptyHard ||
          Q39elrReasonHard ||
          Q39elrGranduloEmptyHard ||
          Q39elrSteroidsEmptyHard ||
          name_dose_steroidsHardEmpty ||
          steroids_elr_txtEmpty ||
          q37_Elr_Dose_week_frquencyRd_Empty ||
          q37_Elr_Dose_week_frquency_txt_Empty ||
          q37_Elr_Dose_week_freq_range ||
          q37SubsequentDoseConflict ||
          q37ElrDosageRdEmpty ||
          q37ElrDosageOtherTxtEmpty ||
          InvalidQ40init_dt ||
          init_dt_before_eof
        ) {
          isValid = false;
        }
        return {
          ...item,
          Q40DosingFreqEmptyHard,
          Q40DosingFreqTxtEmptyHard,
          Q40IgGEmptyHard,
          Q40ReasonEmptyHard,
          Q40Init_RdHard,
          Q40Init_dtHard,
          q37ElrexvayliEmpty,
          Q39ElrEmptyHard,
          Q39elrReasonHard,
          Q39elrGranduloEmptyHard,
          Q39elrSteroidsEmptyHard,
          name_dose_steroidsHardEmpty,

          steroids_elr_txtEmpty,
          q37_Elr_Dose_week_frquencyRd_Empty,
          q37_Elr_Dose_week_frquency_txt_Empty,
          q37_Elr_Dose_week_freq_range,
          q37SubsequentDoseConflict,
          q37ElrDosageRdEmpty,
          q37ElrDosageOtherTxtEmpty,
          InvalidQ40init_dt,
          init_dt_before_eof,
        };
      });
      setQ37ElrexDetails(updatedArray);
    }

    //37linvo
    if (isLinvoveySelected) {
      if (Q37LinvoDetails && Q37LinvoDetails.length > 0) {
        const updatedArray = Q37LinvoDetails.map((item) => {
          //Q40
          let Q40LinvoDosingFreqEmptyHard = false;
          let Q40LinvoDosingFreqTxtEmptyHard = false;

          let Q40LinvoIgGEmptyHard = false;
          let Q40LinvoReasonEmptyHard = false;
          let Q40LinvoInit_RdHard = false;
          let Q40LinvoInit_dtHard = false;
          let invalidQ40Init_dt_linvo = false;
          let init_dt_before_eof_linvo = false;

          if (item.q40DosingFreqRd_linvo == null) {
            Q40LinvoDosingFreqEmptyHard = true;
          }

          if (
            item.q40DosingFreqRd_linvo === 5 &&
            item.dosing_Freq_Oth_Txt_linvo === ""
          ) {
            Q40LinvoDosingFreqTxtEmptyHard = true;
          }

          if (item.q40DosingFreqRd_linvo !== 1) {
            if (item.q40IgILevelRd_linvo === null) {
              Q40LinvoIgGEmptyHard = true;
            }

            if (
              item.primaryProf_linvo !== true &&
              item.secondaryProf_linvo !== true &&
              item.otherReson_linvo !== true
            ) {
              Q40LinvoReasonEmptyHard = true;
            }

            if (item.q40Init_Dt_Rd_linvo === null) {
              Q40LinvoInit_RdHard = true;
            }

            if (
              item.q40Init_Dt_Rd_linvo === 1 &&
              item.q40Init_Dt_linvo === ""
            ) {
              Q40LinvoInit_dtHard = true;
            }

            if (
              item.q40Init_Dt_Rd_linvo === 1 &&
              item.q40Init_Dt_linvo === "Invalid Date"
            ) {
              invalidQ40Init_dt_linvo = true;
            }

            if (
              item.q40Init_Dt_Rd_linvo === 1 &&
              item.q40Init_Dt_linvo !== "Invalid Date" &&
              item.q40Init_Dt_linvo &&
              !DateInRange(item.q40Init_Dt_linvo, dayjs("01-01-1920"), dayjs())
            ) {
              invalidQ40Init_dt_linvo = true;
            } else {
              const isDateValid = ValidateIndexDAndLOTDateChain(
                item.q40Init_Dt_linvo,
                RRMMCohortTreatment.Linvoseltamab,
              );

              if (!isDateValid) {
                init_dt_before_eof_linvo = true;
              }
            }
          }

          let Q39LinvoEmptyHard = false;

          let Q39linvoSteroidsEmptyHard = false;
          let name_dose_steroids_linvoHardEmpty = false;
          let steroids_linvo_txtEmpty = false;

          let Q39linvoReasonHard = false;

          let q37LinvoveyEmpty = false;
          let Q39linvoGranduloEmptyHard = false;
          if (
            isNewEcrfA === false &&
            item.q37_Linvo_Dose_week_frquencyRd !== 1 &&
            item.Q37LinvoveyRd === null
          ) {
            q37LinvoveyEmpty = true;
          }

          if (q37LinvoveyEmpty) {
            isValid = false;
          }

          let q37_Linvo_Dose_week_frquencyRd_Empty = false;
          if (
            isNewEcrfA === false &&
            item.q37_Linvo_Dose_week_frquencyRd == null
          ) {
            q37_Linvo_Dose_week_frquencyRd_Empty = true;
          }

          let q37_Linvo_Dose_week_frquency_txt_Empty = false;
          let q37_Linvo_Dose_week_freq_range = false;
          if (
            isNewEcrfA === false &&
            item.q37_Linvo_Dose_week_frquencyRd == 2 &&
            (item.q37_Linvo_Dose_week_frquency_txt === "" ||
              item.q37_Linvo_Dose_week_frquency_txt === null)
          ) {
            q37_Linvo_Dose_week_frquency_txt_Empty = true;
          }

          if (
            isNewEcrfA === false &&
            item.q37_Linvo_Dose_week_frquencyRd == 2 &&
            (item.q37_Linvo_Dose_week_frquency_txt !== "" ||
              item.q37_Linvo_Dose_week_frquency_txt !== null)
          ) {
            const checkValue = isValidNumber(
              item.q37_Linvo_Dose_week_frquency_txt,
            );
            if (
              isNewEcrfA === false &&
              item.q37_Linvo_Dose_week_frquency_txt &&
              item.q37_Linvo_Dose_week_frquencyRd_Empty == false &&
              !checkValue
            ) {
              q37_Linvo_Dose_week_freq_range = true;
            }
          }

          let q37LinvoSubsequentDoseConflict = false;
          // Check if any dose in Q36 has "Subsequent treatment doses" (dosingphaselinvo === 5)
          const hasSubsequentDosesLinvo = linvoveyDetails.some(
            (item) => item.dosing_phase_linvo === 5,
          );

          // Check if Q37 answer is "Patient has not completed the step-up dosing phase"
          const q37LinvoNotCompleted =
            item.q37_Linvo_Dose_week_frquencyRd === 1;

          if (
            hasSubsequentDosesLinvo &&
            q37LinvoNotCompleted &&
            isNewEcrfA === false
          ) {
            isValid = false;
            q37LinvoSubsequentDoseConflict = true;
          }

          let q37_Linvo_Dosage_Rd_Empty = false;
          if (
            isNewEcrfA === false &&
            item.q37_Linvo_Dose_week_frquencyRd != 1 &&
            item.q37_Linvo_Dosage_Rd == null
          ) {
            q37_Linvo_Dosage_Rd_Empty = true;
          }

          let q37_Linvo_Dosage_OtherTxt_Empty = false;
          if (
            isNewEcrfA === false &&
            item.q37_Linvo_Dosage_Rd == 2 &&
            (item.q37_Linvo_Dosage_OtherTxt == "" ||
              item.q37_Linvo_Dosage_OtherTxt == null)
          ) {
            q37_Linvo_Dosage_OtherTxt_Empty = true;
          }

          //39linvo
          if (
            item.tocilizumab_linvo === false &&
            item.granulocyte_linvo === false &&
            item.Steroids === false &&
            item.noneoftheabove_linvo !== 99
          ) {
            Q39LinvoEmptyHard = true;
          }

          if (item.tocilizumab_linvo === true && !isNewEcrfA) {
            if (
              item.cytokin_linvo === false &&
              item.secondary_prophylactic_crs_linvo === false &&
              item.crs_linvo === false &&
              item.neurotoxicity_linvo === false &&
              item.secondary_neurotoxicity_linvo === false &&
              item.tmt_neurotoxicity_linvo === false &&
              item.tmt_linvoseltamab_unknown === false
            ) {
              Q39linvoReasonHard = true;
            }
          }

          if (item.granulocyte_linvo === true) {
            if (
              item.prophylactic_use_linvo === false &&
              item.secondary_prophylactic_use_linvo === false &&
              item.oth_use_linvo === false &&
              item.unknown_linvo === null
            ) {
              Q39linvoGranduloEmptyHard = true;
            }
          }

          if (item.Steroids === true) {
            if (
              item.cytokin_linvo_steroids === false &&
              item.secondary_prophylactic_linvo_steroids === false &&
              item.crs_linvo_steroids === false &&
              item.neurotoxicity_linvo_steroids === false &&
              item.secondary_neurotoxicity_linvo_steroids === false &&
              item.tmt_neurotoxicity_linvo_steroids === false &&
              item.tmt_linvo_unknown === false &&
              item.steroid_pre_tmt_linvo === false
            ) {
              Q39linvoSteroidsEmptyHard = true;
            }

            if (
              item.betamethasone_linvo === false &&
              item.dexamethasone_linvo === false &&
              item.hydrocortisone_linvo === false &&
              item.methylprednisolone_linvo === false &&
              item.prednisolone_linvo === false &&
              item.prednisone_linvo === false &&
              item.triamcinolone_linvo === false &&
              item.dose_name_linvo_unknown === false
            ) {
              name_dose_steroids_linvoHardEmpty = true;
            }

            if (
              (item.betamethasone_linvo === true &&
                (!item.betamethasone_linvoNum ||
                  item.betamethasone_linvoNum === "")) ||
              (item.dexamethasone_linvo === true &&
                (!item.dexamethasone_linvoNum ||
                  item.dexamethasone_linvoNum === "")) ||
              (item.hydrocortisone_linvo === true &&
                (!item.hydrocortisone_linvoNum ||
                  item.hydrocortisone_linvoNum === "")) ||
              (item.methylprednisolone_linvo === true &&
                (!item.methylprednisolone_linvoNum ||
                  item.methylprednisolone_linvoNum === "")) ||
              (item.prednisolone_linvo === true &&
                (!item.prednisolone_linvoNum ||
                  item.prednisolone_linvoNum === "")) ||
              (item.prednisone_linvo === true &&
                (!item.prednisone_linvoNum ||
                  item.prednisone_linvoNum === "")) ||
              (item.triamcinolone_linvo === true &&
                (!item.triamcinolone_linvoNum ||
                  item.triamcinolone_linvoNum === ""))
            ) {
              steroids_linvo_txtEmpty = true;
            }
          }

          //39.1.A Linvo
          if (
            isNewEcrfA &&
            item.tocilizumab_linvo === true &&
            q391ALinvoTocilzumabList?.length > 0
          ) {
            let linvoIsValid = true;

            const updatedArray = q391ALinvoTocilzumabList.map((linvoRow) => {
              const hasAnyReason =
                linvoRow.primaryProphylacticCrs_linvo === true ||
                linvoRow.secondaryProphylacticCrs_linvo === true ||
                linvoRow.supportiveCareCrs_linvo === true ||
                linvoRow.primaryProphylacticNeurologic_linvo === true ||
                linvoRow.secondaryProphylacticNeurologic_linvo === true ||
                linvoRow.supportiveCareNeurologic_linvo === true ||
                linvoRow.medicationReasonUnk_linvo === true;

              const q39LinvoReasonEmpty = !hasAnyReason;

              const q39LinvoAdministrationRDEmpty =
                !linvoRow.administrationDateRD_linvo;

              let q39LinvoAdministrationDateEmpty = false;
              let q39LinvoInvalidAdministrationDate = false;

              if (linvoRow.administrationDateRD_linvo === 1) {
                if (!linvoRow.administrationDate_linvo) {
                  q39LinvoAdministrationDateEmpty = true;
                } else if (
                  linvoRow.administrationDate_linvo === "Invalid Date" ||
                  !DateInRange(
                    linvoRow.administrationDate_linvo,
                    dayjs("01-01-1920"),
                    dayjs(),
                  )
                ) {
                  q39LinvoInvalidAdministrationDate = true;
                }
              }

              // ---- Aggregate validity ----
              if (
                q39LinvoReasonEmpty ||
                q39LinvoAdministrationRDEmpty ||
                q39LinvoAdministrationDateEmpty ||
                q39LinvoInvalidAdministrationDate
              ) {
                linvoIsValid = false;
              }

              return {
                ...linvoRow,
                q39LinvoReasonEmpty,
                q39LinvoAdministrationRDEmpty,
                q39LinvoAdministrationDateEmpty,
                q39LinvoInvalidAdministrationDate,
              };
            });

            let linvoDateIsValid = true;
            const adminDates = q391ALinvoTocilzumabList
              .filter(
                (row) =>
                  row.administrationDateRD_linvo === 1 &&
                  row.administrationDate_linvo &&
                  IsValidDateValue(row.administrationDate_linvo),
              )
              .map((row) => row.administrationDate_linvo);
            const earliestAdminDate =
              adminDates.length > 0
                ? adminDates.reduce((min, d) =>
                    IsLessOrEqual(d, min) ? d : min,
                  )
                : null;

            const latestAdminDate =
              adminDates.length > 0
                ? adminDates.reduce((max, d) =>
                    IsLessOrEqual(max, d) ? d : max,
                  )
                : null;

            // initiation date ≤ earliest admin date
            if (
              earliestAdminDate &&
              IsValidDateValue(earliestAdminDate) &&
              !IsLessOrEqual(linvoIndexDate, earliestAdminDate)
            ) {
              linvoDateIsValid = false;
            }

            // latest admin date ≤ subsequent LOT (if exists)
            if (
              latestAdminDate &&
              linvoseltamabLOTStartDate &&
              IsValidDateValue(linvoseltamabLOTStartDate) &&
              !IsLessOrEqual(latestAdminDate, linvoseltamabLOTStartDate)
            ) {
              linvoDateIsValid = false;
            }

            // latest admin date ≤ end of follow-up
            if (
              latestAdminDate &&
              endOfFollowUpDate &&
              IsValidDateValue(endOfFollowUpDate) &&
              !IsLessOrEqual(latestAdminDate, endOfFollowUpDate)
            ) {
              linvoDateIsValid = false;
            }

            setQ391ALinvoAdministrationDateOutOfRange(!linvoDateIsValid);

            isValid = linvoIsValid && linvoDateIsValid;

            setQ391ALinvoTocilzumabList(updatedArray);
          }

          if (
            Q39LinvoEmptyHard ||
            Q39linvoReasonHard ||
            Q39linvoSteroidsEmptyHard ||
            name_dose_steroids_linvoHardEmpty ||
            steroids_linvo_txtEmpty ||
            q37LinvoveyEmpty ||
            q37_Linvo_Dose_week_frquencyRd_Empty ||
            q37_Linvo_Dose_week_frquency_txt_Empty ||
            q37_Linvo_Dose_week_freq_range ||
            q37LinvoSubsequentDoseConflict ||
            q37_Linvo_Dosage_Rd_Empty ||
            q37_Linvo_Dosage_OtherTxt_Empty ||
            Q39linvoGranduloEmptyHard ||
            Q40LinvoDosingFreqEmptyHard ||
            Q40LinvoDosingFreqTxtEmptyHard ||
            Q40LinvoIgGEmptyHard ||
            Q40LinvoReasonEmptyHard ||
            Q40LinvoInit_RdHard ||
            Q40LinvoInit_dtHard ||
            invalidQ40Init_dt_linvo ||
            init_dt_before_eof_linvo
          ) {
            isValid = false;
          }

          return {
            ...item,
            Q39LinvoEmptyHard,
            Q39linvoReasonHard,
            Q39linvoSteroidsEmptyHard,
            name_dose_steroids_linvoHardEmpty,
            steroids_linvo_txtEmpty,
            q37LinvoveyEmpty,
            q37_Linvo_Dosage_OtherTxt_Empty,
            q37LinvoSubsequentDoseConflict,
            q37_Linvo_Dosage_Rd_Empty,
            q37_Linvo_Dose_week_frquency_txt_Empty,
            q37_Linvo_Dose_week_freq_range,

            q37_Linvo_Dose_week_frquencyRd_Empty,
            Q39linvoGranduloEmptyHard,
            Q40LinvoDosingFreqEmptyHard,
            Q40LinvoDosingFreqTxtEmptyHard,
            Q40LinvoIgGEmptyHard,
            Q40LinvoReasonEmptyHard,
            Q40LinvoInit_RdHard,
            Q40LinvoInit_dtHard,
            invalidQ40Init_dt_linvo,
            init_dt_before_eof_linvo,
          };
        });
        setQ37LinvoDetails(updatedArray);
      }
    }

    //38elr

    if (
      isElrexvayliSelected &&
      Q37ElrexDetails[0].Q37ElrexvayliRd === 1 &&
      Q38ElrexDetails &&
      Q38ElrexDetails.length > 0
    ) {
      const updatedArray = Q38ElrexDetails.map((item, index) => {
        let Q38ElrexEmptyHard = false;
        if (isNewEcrfA == false && item.Q38ElrexvayliRd === null) {
          Q38ElrexEmptyHard = true;
        }

        let Q38DateEmpty = false;
        if (
          isNewEcrfA == false &&
          item.Q38ElrexvayliRd === 1 &&
          item.dt_dosefreq_elr_dt === ""
        ) {
          Q38DateEmpty = true;
        }

        let Invalid_dt_dosefreq_elr_dt = false;
        if (
          isNewEcrfA == false &&
          item.Q38ElrexvayliRd === 1 &&
          item.dt_dosefreq_elr_dt &&
          item.dt_dosefreq_elr_dt === "Invalid Date"
        ) {
          Invalid_dt_dosefreq_elr_dt = true;
        }

        if (
          item.Q38ElrexvayliRd === 1 &&
          item.dt_dosefreq_elr_dt != "Invalid Date" &&
          item.dt_dosefreq_elr_dt &&
          !DateInRange(item.dt_dosefreq_elr_dt, dayjs("01-01-1920"), dayjs())
        ) {
          Invalid_dt_dosefreq_elr_dt = true;
        }

        const q36DoseAdminDates = elrexvayliDetails
          .filter(
            (row) =>
              row.dose_administration_elr === 1 &&
              IsValidDateValue(row.dose_administration_elr_dt),
          )
          .map((row) => row.dose_administration_elr_dt);

        const latestQ36DoseDate =
          q36DoseAdminDates.length > 0
            ? q36DoseAdminDates.reduce((max, d) =>
                IsLessOrEqual(max, d) ? d : max,
              )
            : null;

        let Q38ElrexDateInvalid = false;
        if (
          isNewEcrfA === false &&
          item.Q38ElrexvayliRd === 1 &&
          item.dt_dosefreq_elr_dt !== "" &&
          DateInRange(item.dt_dosefreq_elr_dt, dayjs("01-01-1920"), dayjs())
        ) {
          // Rule 1: Index Date ≤ Q38 Date
          if (elrexIndexDate !== "" && IsValidDateValue(elrexIndexDate)) {
            if (!IsLessOrEqual(elrexIndexDate, item.dt_dosefreq_elr_dt)) {
              Q38ElrexDateInvalid = true;
            }
          }

          // Rule 2: Latest Q36 Date ≤ Q38 Date
          if (
            latestQ36DoseDate &&
            !IsLessOrEqual(latestQ36DoseDate, item.dt_dosefreq_elr_dt)
          ) {
            Q38ElrexDateInvalid = true;
          }

          // Rule 3: Q38 Date ≤ LOT Start Date
          if (
            elrexfioLOTStartDate !== "" &&
            IsValidDateValue(elrexfioLOTStartDate)
          ) {
            if (!IsLessOrEqual(item.dt_dosefreq_elr_dt, elrexfioLOTStartDate)) {
              Q38ElrexDateInvalid = true;
            }
          }

          // Rule 4: LOT Start Date ≤ End of Follow-up (or Q38 ≤ EOF if no LOT)
          if (endOfFollowUpDate !== "" && IsValidDateValue(endOfFollowUpDate)) {
            if (
              elrexfioLOTStartDate !== "" &&
              IsValidDateValue(elrexfioLOTStartDate)
            ) {
              if (!IsLessOrEqual(elrexfioLOTStartDate, endOfFollowUpDate)) {
                Q38ElrexDateInvalid = true;
              }
            } else {
              // No LOT, so check Q38 ≤ EOF directly
              if (!IsLessOrEqual(item.dt_dosefreq_elr_dt, endOfFollowUpDate)) {
                Q38ElrexDateInvalid = true;
              }
            }
          }
        }

        //Q38Elr New Column Validation

        let q38ElrexfioEmpty = false;
        if (item.Q38ElrexvayliRd === null) {
          q38ElrexfioEmpty = true;
        }

        let q38_Elr_Dose_week_frquencyRd_Empty = false;
        if (isNewEcrfA == false && item.q38_Elr_Dose_week_frquencyRd == null) {
          q38_Elr_Dose_week_frquencyRd_Empty = true;
        }

        let q38_Elr_Dose_week_frquency_txt_Empty = false;
        if (
          isNewEcrfA == false &&
          item.q38_Elr_Dose_week_frquencyRd == 1 &&
          (item.q38_Elr_Dose_week_frquency_txt === "" ||
            item.q38_Elr_Dose_week_frquency_txt === null)
        ) {
          q38_Elr_Dose_week_frquency_txt_Empty = true;
        }

        //invalid Number
        if (
          item.q38_Elr_Dose_week_frquencyRd == 1 &&
          (item.q38_Elr_Dose_week_frquency_txt !== "" ||
            item.q38_Elr_Dose_week_frquency_txt !== null)
        ) {
          const checkValue = isValidNumber(item.q38_Elr_Dose_week_frquency_txt);
          if (item.q38_Elr_Dose_week_frquencyRd_Empty == false && !checkValue) {
            q38_Elr_Dose_week_frquency_txt_Empty = true;
          }
        }
        let q38ElrDoseFrequencyConflict = false;

        if (Q37ElrexDetails.length > 0) {
          const q37Frequency = Q37ElrexDetails[0].q37_Elr_Dose_week_frquencyRd;
          const q38Frequency = item.q38_Elr_Dose_week_frquencyRd;

          // Check if both are using custom frequency
          if (q37Frequency === 2 && q38Frequency === 1) {
            const q37FreqValue = parseFloat(
              Q37ElrexDetails[0].q37_Elr_Dose_week_frquency_txt,
            );
            const q38FreqValue = parseFloat(
              item.q38_Elr_Dose_week_frquency_txt,
            );

            // Q38 should be LESS than Q37 (reduction means lower frequency)
            if (
              !isNaN(q37FreqValue) &&
              !isNaN(q38FreqValue) &&
              q37FreqValue > q38FreqValue
            ) {
              q38ElrDoseFrequencyConflict = true;
              isValid = false;
            }
          }
        }

        if (
          Q38ElrexEmptyHard ||
          Q38DateEmpty ||
          Q38ElrexDateInvalid ||
          q38ElrexfioEmpty ||
          q38_Elr_Dose_week_frquencyRd_Empty ||
          q38_Elr_Dose_week_frquency_txt_Empty ||
          Invalid_dt_dosefreq_elr_dt ||
          q38ElrDoseFrequencyConflict
        ) {
          isValid = false;
        }

        return {
          ...item,

          Q38ElrexEmptyHard,
          Q38DateEmpty,
          Q38ElrexDateInvalid,
          q38ElrexfioEmpty,
          q38_Elr_Dose_week_frquencyRd_Empty,
          q38_Elr_Dose_week_frquency_txt_Empty,
          Invalid_dt_dosefreq_elr_dt,
          q38ElrDoseFrequencyConflict,
        };
      });

      setQ38ElrexDetails(updatedArray);
    }

    //38 linvo
    if (
      isLinvoveySelected &&
      Q37LinvoDetails[0].Q37LinvoveyRd === 1 &&
      Q38LinvoDetails &&
      Q38LinvoDetails.length > 0
    ) {
      const updatedArray = Q38LinvoDetails.map((item, index) => {
        let Q38LinvoEmptyHard = false;
        if (isNewEcrfA == false && item.Q38LinvoveyRd === null) {
          Q38LinvoEmptyHard = true;
        }

        let Q38LinvoDateEmpty = false;
        if (
          isNewEcrfA == false &&
          item.Q38LinvoveyRd === 1 &&
          item.dt_dosefreq_linvo_dt === ""
        ) {
          Q38LinvoDateEmpty = true;
        }

        let InvalidQ38Linvoveydate = false;

        if (
          item.Q38LinvoveyRd === 1 &&
          item.dt_dosefreq_linvo_dt &&
          item.dt_dosefreq_linvo_dt === "Invalid Date"
        ) {
          InvalidQ38Linvoveydate = true;
        }

        if (
          isNewEcrfA == false &&
          item.Q38LinvoveyRd === 1 &&
          item.dt_dosefreq_linvo_dt &&
          item.dt_dosefreq_linvo_dt != "Invalid Date" &&
          !DateInRange(item.dt_dosefreq_linvo_dt, dayjs("01-01-1920"), dayjs())
        ) {
          InvalidQ38Linvoveydate = true;
        }

        const q36DoseAdminDates = linvoveyDetails
          .filter(
            (row) =>
              row.dose_administration_linvo === 1 &&
              IsValidDateValue(row.dose_administration_linvo_dt),
          )
          .map((row) => row.dose_administration_linvo_dt);

        const latestQ36DoseDate =
          q36DoseAdminDates.length > 0
            ? q36DoseAdminDates.reduce((max, d) =>
                IsLessOrEqual(max, d) ? d : max,
              )
            : null;

        // ✅ NEW: Complete date chain validation
        let Q38LinvoDateInvalid = false;
        if (
          isNewEcrfA === false &&
          item.Q38LinvoveyRd === 1 &&
          item.dt_dosefreq_linvo_dt !== "" &&
          DateInRange(item.dt_dosefreq_linvo_dt, dayjs("01-01-1920"), dayjs())
        ) {
          // Rule 1: Index Date ≤ Q38 Date
          if (linvoIndexDate !== "" && IsValidDateValue(linvoIndexDate)) {
            if (!IsLessOrEqual(linvoIndexDate, item.dt_dosefreq_linvo_dt)) {
              Q38LinvoDateInvalid = true;
            }
          }

          // Rule 2: Latest Q36 Date ≤ Q38 Date
          if (
            latestQ36DoseDate &&
            !IsLessOrEqual(latestQ36DoseDate, item.dt_dosefreq_linvo_dt)
          ) {
            Q38LinvoDateInvalid = true;
          }

          // Rule 3: Q38 Date ≤ LOT Start Date
          if (
            linvoseltamabLOTStartDate !== "" &&
            IsValidDateValue(linvoseltamabLOTStartDate)
          ) {
            if (
              !IsLessOrEqual(
                item.dt_dosefreq_linvo_dt,
                linvoseltamabLOTStartDate,
              )
            ) {
              Q38LinvoDateInvalid = true;
            }
          }

          // Rule 4: LOT Start Date ≤ End of Follow-up (or Q38 ≤ EOF if no LOT)
          if (endOfFollowUpDate !== "" && IsValidDateValue(endOfFollowUpDate)) {
            if (
              linvoseltamabLOTStartDate !== "" &&
              IsValidDateValue(linvoseltamabLOTStartDate)
            ) {
              if (
                !IsLessOrEqual(linvoseltamabLOTStartDate, endOfFollowUpDate)
              ) {
                Q38LinvoDateInvalid = true;
              }
            } else {
              // No LOT, so check Q38 ≤ EOF directly
              if (
                !IsLessOrEqual(item.dt_dosefreq_linvo_dt, endOfFollowUpDate)
              ) {
                Q38LinvoDateInvalid = true;
              }
            }
          }
        }

        let q38_Linvo_Dose_week_frquencyRd_Empty = false;
        if (
          isNewEcrfA == false &&
          item.q38_Linvo_Dose_week_frquencyRd == null
        ) {
          q38_Linvo_Dose_week_frquencyRd_Empty = true;
        }

        let q38_Linvo_Dose_week_frquency_txt_Empty = false;
        if (
          isNewEcrfA == false &&
          item.q38_Linvo_Dose_week_frquencyRd == 1 &&
          (item.q38_Linvo_Dose_week_frquency_txt === "" ||
            item.q38_Linvo_Dose_week_frquency_txt === null)
        ) {
          q38_Linvo_Dose_week_frquency_txt_Empty = true;
        }

        if (
          item.q38_Linvo_Dose_week_frquencyRd == 1 &&
          (item.q38_Linvo_Dose_week_frquency_txt !== "" ||
            item.q38_Linvo_Dose_week_frquency_txt !== null)
        ) {
          const checkValue = isValidNumber(
            item.q38_Linvo_Dose_week_frquency_txt,
          );
          if (
            item.q38_Linvo_Dose_week_frquencyRd_Empty == false &&
            !checkValue
          ) {
            q38_Linvo_Dose_week_frquency_txt_Empty = true;
          }
        }

        let q38_Linvo_Dosage_Rd_Empty = false;

        let q38_Linvo_Dosage_OtherTxt_Empty = false;

        let q38LinvoDoseFrequencyConflict = false;

        if (Q37LinvoDetails.length > 0) {
          const q37Frequency =
            Q37LinvoDetails[0].q37_Linvo_Dose_week_frquencyRd;
          const q38Frequency = item.q38_Linvo_Dose_week_frquencyRd;

          // Check if both are using custom frequency
          if (q37Frequency === 2 && q38Frequency === 1) {
            const q37FreqValue = parseFloat(
              Q37LinvoDetails[0].q37_Linvo_Dose_week_frquency_txt,
            );
            const q38FreqValue = parseFloat(
              item.q38_Linvo_Dose_week_frquency_txt,
            );

            // Q38 should be LESS than Q37 (reduction means lower frequency)
            if (
              !isNaN(q37FreqValue) &&
              !isNaN(q38FreqValue) &&
              q37FreqValue > q38FreqValue
            ) {
              q38LinvoDoseFrequencyConflict = true;
              isValid = false;
            }
          }
        }

        if (
          Q38LinvoEmptyHard ||
          Q38LinvoDateEmpty ||
          Q38LinvoDateInvalid ||
          q38_Linvo_Dosage_OtherTxt_Empty ||
          q38_Linvo_Dosage_Rd_Empty ||
          q38_Linvo_Dose_week_frquency_txt_Empty ||
          q38_Linvo_Dose_week_frquencyRd_Empty ||
          InvalidQ38Linvoveydate ||
          q38LinvoDoseFrequencyConflict
        ) {
          isValid = false;
        }

        return {
          ...item,

          Q38LinvoEmptyHard,
          Q38LinvoDateEmpty,
          Q38LinvoDateInvalid,
          q38_Linvo_Dosage_Rd_Empty,
          q38_Linvo_Dose_week_frquency_txt_Empty,
          q38_Linvo_Dose_week_frquencyRd_Empty,
          q38_Linvo_Dosage_OtherTxt_Empty,
          InvalidQ38Linvoveydate,
          q38LinvoDoseFrequencyConflict,
        };
      });
      setQ38LinvoDetails(updatedArray);
    }

    // ============================================
    // Q38.1.A ELREXFIO VALIDATION
    // ============================================

    if (isElrexvayliSelected && isNewEcrfA) {
      Q381AElrexDetails.forEach((row, index) => {
        let rowHasError = false;

        // ========================================
        // Column B: Type of change - HARD ERROR
        // ========================================
        if (row.changeType === null || row.changeType === undefined) {
          isValid = false;
          rowHasError = true;
          Q381AElrexDetails[index].changeTypeEmpty = true;
        }

        // If changeType is "Frequency change" (2), validate sub-radio
        if (
          row.changeType === 2 &&
          (row.changeTypeDoseFrequency === null ||
            row.changeTypeDoseFrequency === undefined)
        ) {
          isValid = false;
          rowHasError = true;
          Q381AElrexDetails[index].changeTypeDoseFrequencyEmpty = true;
        }

        // If changeType is "Strength change" (3), validate sub-radio
        if (
          row.changeType === 3 &&
          (row.changeTypeDoseStrength === null ||
            row.changeTypeDoseStrength === undefined)
        ) {
          isValid = false;
          rowHasError = true;
          Q381AElrexDetails[index].changeTypeDoseStrengthEmpty = true;
        }

        // Skip columns C-F validation if "No changes" or "Unknown"
        if (row.changeType === 1 || row.changeType === 99) {
          return; // Skip rest of validations for this row
        }

        // ========================================
        // Column C: Reasons - HARD ERROR
        // ========================================
        if (
          row.selectedReasons.length === 0 &&
          row.selectedAEReasons.length === 0 &&
          !row.reasonUnknown
        ) {
          isValid = false;
          rowHasError = true;
          Q381AElrexDetails[index].reasonEmpty = true;
        }

        if (
          row.selectedReasons.includes(1) &&
          (patientDeathDate == null || !isStringEmpty(patientDeathDate))
        ) {
          isValid = false;
          rowHasError = true;
          Q381AElrexDetails[index].deathDtWarning = true;
        }

        // If "Other" (ID=14) is selected, validate other text field
        if (
          row.selectedReasons.includes(14) &&
          isStringEmpty(row.reasonOtherText)
        ) {
          isValid = false;
          rowHasError = true;
          Q381AElrexDetails[index].reasonOtherTextEmpty = true;
        }

        // After checking if reasonEmpty
        if (row.selectedReasons.includes(2)) {
          // 2 = Adverse Event ID
          const hasAESubReasons = row.selectedAEReasons.length > 0;
          const aeReasonItem = row.reasonList?.find(
            (r) => r.bispecifictreatmentdiscontinuationreasonid === 2,
          );
          const isAEUnknownChecked =
            aeReasonItem?.aeSubReasons?.some(
              (ae) =>
                ae.bispecifictreatmentdiscontinuationreasonaeid === 99 &&
                ae.isSelected,
            ) || false;

          if (!hasAESubReasons && !isAEUnknownChecked) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].aeSubReasonEmpty = true;
          } else {
            const selectedAEs =
              aeReasonItem?.aeSubReasons?.filter((ae) => ae.isSelected) || [];
            const isNeuroSelected = selectedAEs.some(
              (ae) => ae.reasonName === DiscontinuationReason.NeurologicalEvent,
            );

            if (isNeuroSelected) {
              const selectedNeuroReasons =
                row.neurologicAEReasonList?.filter((n) => n.isSelected) || [];

              if (selectedNeuroReasons.length === 0) {
                isValid = false;
                rowHasError = true;
                Q381AElrexDetails[index].neuroReasonEmpty = true;
              }

              selectedNeuroReasons.forEach((neuro) => {
                if (
                  neuro.reasonName?.includes("Other") &&
                  (!neuro.reasonText || !neuro.reasonText.trim())
                ) {
                  isValid = false;
                  rowHasError = true;
                  Q381AElrexDetails[index].neuroOtherTextEmpty = true;
                }
              });
            }
          }
        }

        // ========================================
        // Column D: Pattern BEFORE change - HARD ERROR
        // ========================================
        // If changeType is "Frequency change" (2)
        if (row.changeType === 2) {
          // Frequency type required
          if (
            row.patterBeforeChangeDoseFrequency === null ||
            row.patterBeforeChangeDoseFrequency === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].patternBeforeFrequencyEmpty = true;
          }

          // Frequency value required if type is 1 (times/week) or 2 (every X weeks)
          if (
            (row.patterBeforeChangeDoseFrequency === 1 ||
              row.patterBeforeChangeDoseFrequency === 2) &&
            isStringEmpty(
              row.patterBeforeChangeDoseFrequency === 1
                ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
                : row.patterBeforeChangeDoseFrequencyWeek,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].patternBeforeFrequencyEmpty = true;
          }

          // Range validation: Integer, >0 and ≤10
          if (
            !isStringEmpty(
              row.patterBeforeChangeDoseFrequency === 1
                ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
                : row.patterBeforeChangeDoseFrequencyWeek,
            ) &&
            row.patterBeforeChangeDoseFrequency !== 99
          ) {
            const weekValue = Number(
              row.patterBeforeChangeDoseFrequency === 1
                ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
                : row.patterBeforeChangeDoseFrequencyWeek,
            );
            if (
              !Number.isInteger(weekValue) ||
              weekValue <= 0 ||
              weekValue > 20
            ) {
              isValid = false;
              rowHasError = true;
              Q381AElrexDetails[index].patternBeforeFrequencyRangeInvalid =
                true;
            }
          }
        }
        // If changeType is "Strength change" (3)
        if (row.changeType === 3) {
          // Strength type required
          if (
            row.patterBeforeChangeDoseStrength === null ||
            row.patterBeforeChangeDoseStrength === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].patternBeforeStrengthEmpty = true;
          }

          // Strength value required if type is 1 (mg), 2 (mg/kg), or 3 (mg/m²)
          if (
            (row.patterBeforeChangeDoseStrength === 1 ||
              row.patterBeforeChangeDoseStrength === 2 ||
              row.patterBeforeChangeDoseStrength === 3) &&
            isStringEmpty(
              row.patterBeforeChangeDoseStrength === 1
                ? row.patterBeforeChangeDoseStrengthMg
                : row.patterBeforeChangeDoseStrength === 2
                  ? row.patterBeforeChangeDoseStrengthMgKg
                  : row.patterBeforeChangeDoseStrengthMgM2,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].patternBeforeStrengthEmpty = true;
          }

          // Range validation: Decimal, >0.00 and ≤4000.00
          if (
            !isStringEmpty(
              row.patterBeforeChangeDoseStrength === 1
                ? row.patterBeforeChangeDoseStrengthMg
                : row.patterBeforeChangeDoseStrength === 2
                  ? row.patterBeforeChangeDoseStrengthMgKg
                  : row.patterBeforeChangeDoseStrengthMgM2,
            ) &&
            row.patterBeforeChangeDoseStrength !== 99
          ) {
            const strengthValue = Number(
              row.patterBeforeChangeDoseStrength == 1
                ? row.patterBeforeChangeDoseStrengthMg
                : row.patterBeforeChangeDoseStrength == 2
                  ? row.patterBeforeChangeDoseStrengthMgKg
                  : row.patterBeforeChangeDoseStrengthMgM2,
            );
            if (
              isNaN(strengthValue) ||
              strengthValue <= 0 ||
              strengthValue > 4000
            ) {
              isValid = false;
              rowHasError = true;
              Q381AElrexDetails[index].patternBeforeFrequencyRangeInvalid =
                true;
            }
          }
        }
        // ========================================
        // Column E: Pattern AFTER change - HARD ERROR
        // ========================================
        // If changeType is "Frequency change" (2)
        if (row.changeType === 2) {
          // Frequency type required
          if (
            row.patterAfterChangeDoseFrequency === null ||
            row.patterAfterChangeDoseFrequency === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].patternAfterFrequencyEmpty = true;
          }

          // Frequency value required if type is 1 or 2
          if (
            (row.patterAfterChangeDoseFrequency === 1 ||
              row.patterAfterChangeDoseFrequency === 2) &&
            isStringEmpty(
              row.patterAfterChangeDoseFrequency === 1
                ? row.patterAfterChangeDoseFrequencyTimesPerWeek
                : row.patterAfterChangeDoseFrequencyWeek,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].patternAfterFrequencyEmpty = true;
          }

          // Range validation: Integer, >0 and ≤10
          if (
            !isStringEmpty(
              row.patterAfterChangeDoseFrequency === 1
                ? row.patterAfterChangeDoseFrequencyTimesPerWeek
                : row.patterAfterChangeDoseFrequencyWeek,
            ) &&
            row.patterAfterChangeDoseFrequency !== 99
          ) {
            const weekValue = Number(
              row.patterAfterChangeDoseFrequency === 1
                ? row.patterAfterChangeDoseFrequencyTimesPerWeek
                : row.patterAfterChangeDoseFrequencyWeek,
            );
            if (
              !Number.isInteger(weekValue) ||
              weekValue <= 0 ||
              weekValue > 20
            ) {
              isValid = false;
              rowHasError = true;
              Q381AElrexDetails[index].patternAfterFrequencyRangeInvalid = true;
            }
          }
        }

        // If changeType is "Strength change" (3)
        if (row.changeType === 3) {
          // Strength type required
          if (
            row.patterAfterChangeDoseStrength === null ||
            row.patterAfterChangeDoseStrength === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].patternAfterStrengthEmpty = true;
          }

          // Strength value required if type is 1, 2, or 3
          if (
            (row.patterAfterChangeDoseStrength === 1 ||
              row.patterAfterChangeDoseStrength === 2 ||
              row.patterAfterChangeDoseStrength === 3) &&
            isStringEmpty(
              row.patterAfterChangeDoseStrength === 1
                ? row.patterAfterChangeDoseStrengthMg
                : row.patterAfterChangeDoseStrength === 2
                  ? row.patterAfterChangeDoseStrengthMgKg
                  : row.patterAfterChangeDoseStrengthMgM2,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].patternAfterStrengthEmpty = true;
          }

          // Range validation: Decimal, >0.00 and ≤4000.00
          if (
            !isStringEmpty(
              row.patterAfterChangeDoseStrength === 1
                ? row.patterAfterChangeDoseStrengthMg
                : row.patterAfterChangeDoseStrength === 2
                  ? row.patterAfterChangeDoseStrengthMgKg
                  : row.patterAfterChangeDoseStrengthMgM2,
            ) &&
            row.patterAfterChangeDoseStrength !== 99
          ) {
            const strengthValue = Number(
              row.patterAfterChangeDoseStrength === 1
                ? row.patterAfterChangeDoseStrengthMg
                : row.patterAfterChangeDoseStrength === 2
                  ? row.patterAfterChangeDoseStrengthMgKg
                  : row.patterAfterChangeDoseStrengthMgM2,
            );
            if (
              isNaN(strengthValue) ||
              strengthValue <= 0 ||
              strengthValue > 4000
            ) {
              isValid = false;
              rowHasError = true;
              Q381AElrexDetails[index].patternAfterStrengthRangeInvalid = true;
            }
          }
        }

        // ========================================
        // Conflict Validations: Before vs After
        // ========================================
        // Only validate if both BEFORE and AFTER are NOT "Unknown"
        // For FREQUENCY INCREASE
        if (
          row.changeType === 2 &&
          row.changeTypeDoseFrequency === 1 &&
          row.patterBeforeChangeDoseFrequency !== 99 &&
          row.patterAfterChangeDoseFrequency !== 99 &&
          row.patterBeforeChangeDoseFrequency ===
            row.patterAfterChangeDoseFrequency &&
          !isStringEmpty(
            row.patterBeforeChangeDoseFrequency === 1
              ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
              : row.patterBeforeChangeDoseFrequencyWeek,
          ) &&
          !isStringEmpty(
            row.patterAfterChangeDoseFrequency === 1
              ? row.patterAfterChangeDoseFrequencyTimesPerWeek
              : row.patterAfterChangeDoseFrequencyWeek,
          )
        ) {
          const isTimesPerWeek = row.patterBeforeChangeDoseFrequency === 1;

          const beforeValue = Number(
            isTimesPerWeek
              ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
              : row.patterBeforeChangeDoseFrequencyWeek,
          );

          const afterValue = Number(
            isTimesPerWeek
              ? row.patterAfterChangeDoseFrequencyTimesPerWeek
              : row.patterAfterChangeDoseFrequencyWeek,
          );

          let isConflict = false;

          if (isTimesPerWeek) {
            // Times per week → After must be greater
            if (afterValue <= beforeValue) {
              isConflict = true;
            }
          } else {
            // Once every X weeks → After must be smaller
            if (afterValue >= beforeValue) {
              isConflict = true;
            }
          }

          if (isConflict) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].frequencyIncreaseConflict = true;
          }
        }

        // For FREQUENCY DECREASE
        if (
          row.changeType === 2 &&
          row.changeTypeDoseFrequency === 2 &&
          row.patterBeforeChangeDoseFrequency !== 99 &&
          row.patterAfterChangeDoseFrequency !== 99 &&
          row.patterBeforeChangeDoseFrequency ===
            row.patterAfterChangeDoseFrequency &&
          !isStringEmpty(
            row.patterBeforeChangeDoseFrequency === 1
              ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
              : row.patterBeforeChangeDoseFrequencyWeek,
          ) &&
          !isStringEmpty(
            row.patterAfterChangeDoseFrequency === 1
              ? row.patterAfterChangeDoseFrequencyTimesPerWeek
              : row.patterAfterChangeDoseFrequencyWeek,
          )
        ) {
          const isTimesPerWeek = row.patterBeforeChangeDoseFrequency === 1;

          const beforeValue = Number(
            isTimesPerWeek
              ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
              : row.patterBeforeChangeDoseFrequencyWeek,
          );

          const afterValue = Number(
            isTimesPerWeek
              ? row.patterAfterChangeDoseFrequencyTimesPerWeek
              : row.patterAfterChangeDoseFrequencyWeek,
          );

          let isConflict = false;

          if (isTimesPerWeek) {
            // Times per week → After must be smaller
            if (afterValue >= beforeValue) {
              isConflict = true;
            }
          } else {
            // Once every X weeks → After must be larger
            if (afterValue <= beforeValue) {
              isConflict = true;
            }
          }

          if (isConflict) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].frequencyDecreaseConflict = true;
          }
        }

        // For STRENGTH INCREASE
        if (
          row.changeType === 3 &&
          row.changeTypeDoseStrength === 1 &&
          row.patterBeforeChangeDoseStrength !== 99 &&
          row.patterAfterChangeDoseStrength !== 99 &&
          row.patterBeforeChangeDoseStrength ===
            row.patterAfterChangeDoseStrength &&
          !isStringEmpty(
            row.patterBeforeChangeDoseStrength == 1
              ? row.patterBeforeChangeDoseStrengthMg
              : row.patterBeforeChangeDoseStrength == 2
                ? row.patterBeforeChangeDoseStrengthMgKg
                : row.patterBeforeChangeDoseStrengthMgM2,
          ) &&
          !isStringEmpty(
            row.patterAfterChangeDoseStrength == 1
              ? row.patterAfterChangeDoseStrengthMg
              : row.patterAfterChangeDoseStrength == 2
                ? row.patterAfterChangeDoseStrengthMgKg
                : row.patterAfterChangeDoseStrengthMgM2,
          )
        ) {
          const beforeValue = Number(
            row.patterBeforeChangeDoseStrength == 1
              ? row.patterBeforeChangeDoseStrengthMg
              : row.patterBeforeChangeDoseStrength == 2
                ? row.patterBeforeChangeDoseStrengthMgKg
                : row.patterBeforeChangeDoseStrengthMgM2,
          );
          const afterValue = Number(
            row.patterAfterChangeDoseStrength == 1
              ? row.patterAfterChangeDoseStrengthMg
              : row.patterAfterChangeDoseStrength == 2
                ? row.patterAfterChangeDoseStrengthMgKg
                : row.patterAfterChangeDoseStrengthMgM2,
          );

          // After should be > Before
          if (afterValue <= beforeValue) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].strengthIncreaseConflict = true;
          }
        }

        // For STRENGTH DECREASE
        if (
          row.changeType === 3 &&
          row.changeTypeDoseStrength === 2 &&
          row.patterBeforeChangeDoseStrength !== 99 &&
          row.patterAfterChangeDoseStrength !== 99 &&
          row.patterBeforeChangeDoseStrength ===
            row.patterAfterChangeDoseStrength &&
          !isStringEmpty(
            row.patterBeforeChangeDoseStrength == 1
              ? row.patterBeforeChangeDoseStrengthMg
              : row.patterBeforeChangeDoseStrength == 2
                ? row.patterBeforeChangeDoseStrengthMgKg
                : row.patterBeforeChangeDoseStrengthMgM2,
          ) &&
          !isStringEmpty(
            row.patterAfterChangeDoseStrength == 1
              ? row.patterAfterChangeDoseStrengthMg
              : row.patterAfterChangeDoseStrength == 2
                ? row.patterAfterChangeDoseStrengthMgKg
                : row.patterAfterChangeDoseStrengthMgM2,
          )
        ) {
          const beforeValue = Number(
            row.patterBeforeChangeDoseStrength == 1
              ? row.patterBeforeChangeDoseStrengthMg
              : row.patterBeforeChangeDoseStrength == 2
                ? row.patterBeforeChangeDoseStrengthMgKg
                : row.patterBeforeChangeDoseStrengthMgM2,
          );
          const afterValue = Number(
            row.patterAfterChangeDoseStrength == 1
              ? row.patterAfterChangeDoseStrengthMg
              : row.patterAfterChangeDoseStrength == 2
                ? row.patterAfterChangeDoseStrengthMgKg
                : row.patterAfterChangeDoseStrengthMgM2,
          );

          // After should be < Before
          if (afterValue >= beforeValue) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].strengthDecreaseConflict = true;
          }
        }

        // ========================================
        // WARNING: Both patterns "Unknown"
        // ========================================
        if (row.changeType === 2 || row.changeType === 3) {
          const beforeUnknowValue =
            row.changeType === 2
              ? row.patterBeforeChangeDoseFrequency
              : row.patterBeforeChangeDoseStrength;
          const afterUnknowValue =
            row.changeType === 2
              ? row.patterAfterChangeDoseFrequency
              : row.patterAfterChangeDoseStrength;

          Q381AElrexDetails[index].patternBeforeUnknownWarning =
            beforeUnknowValue === 99;
          Q381AElrexDetails[index].patternAfterUnknownWarning =
            afterUnknowValue === 99;
        }

        // ========================================
        // Column F: Date - HARD ERROR
        // ========================================
        if (row.dateChangeRd === null || row.dateChangeRd === undefined) {
          isValid = false;
          rowHasError = true;
          Q381AElrexDetails[index].dateChangeRdEmpty = true;
        }
        // If "Date provided" (1) is selected, validate the date

        if (row.dateChangeRd === 1) {
          if (isStringEmpty(row.dateChange)) {
            isValid = false;
            rowHasError = true;
            Q381AElrexDetails[index].dateChangeEmpty = true;
          } else {
            // Date format validation
            if (!DateInRange(row.dateChange, dayjs("01-01-1920"), dayjs())) {
              isValid = false;
              rowHasError = true;
              Q381AElrexDetails[index].invalidDateChange = true;
            } else {
              // ✅ Use the new date chain validation
              if (
                !ValidateQ381ADateChain(
                  row.dateChange,
                  RRMMCohortTreatment.Linvoseltamab,
                )
              ) {
                isValid = false;
                rowHasError = true;
                Q381AElrexDetails[index].dateChangeOutOfBound = true;
              }
            }
          }
        }
      });

      setQ381AElrexDetails([...Q381AElrexDetails]);
    }

    // ============================================
    // Q38.1.A LINVOSELTAMAB VALIDATION
    // ============================================
    if (isLinvoveySelected && isNewEcrfA) {
      Q381ALinvoDetails.forEach((row, index) => {
        let rowHasError = false;

        // ========================================
        // Column B: Type of change - HARD ERROR
        // ========================================
        if (row.changeType === null || row.changeType === undefined) {
          isValid = false;
          rowHasError = true;
          Q381ALinvoDetails[index].changeTypeEmpty = true;
        }

        if (
          row.changeType === 2 &&
          (row.changeTypeDoseFrequency === null ||
            row.changeTypeDoseFrequency === undefined)
        ) {
          isValid = false;
          rowHasError = true;
          Q381ALinvoDetails[index].changeTypeDoseFrequencyEmpty = true;
        }

        if (
          row.changeType === 3 &&
          (row.changeTypeDoseStrength === null ||
            row.changeTypeDoseStrength === undefined)
        ) {
          isValid = false;
          rowHasError = true;
          Q381ALinvoDetails[index].changeTypeDoseStrengthEmpty = true;
        }

        if (row.changeType === 1 || row.changeType === 99) {
          return;
        }

        // ========================================
        // Column C: Reasons - HARD ERROR
        // ========================================
        if (
          row.selectedReasons.length === 0 &&
          row.selectedAEReasons.length === 0 &&
          !row.reasonUnknown
        ) {
          isValid = false;
          rowHasError = true;
          Q381ALinvoDetails[index].reasonEmpty = true;
        }

        if (
          row.selectedReasons.includes(1) &&
          (patientDeathDate == null || !isStringEmpty(patientDeathDate))
        ) {
          isValid = false;
          rowHasError = true;
          Q381ALinvoDetails[index].deathDtWarning = true;
        }

        if (
          row.selectedReasons.includes(14) &&
          isStringEmpty(row.reasonOtherText)
        ) {
          isValid = false;
          rowHasError = true;
          Q381ALinvoDetails[index].reasonOtherTextEmpty = true;
        }

        // In Q38.1.A LINVOSELTAMAB validation section
        if (row.selectedReasons.includes(2)) {
          const hasAESubReasons = row.selectedAEReasons.length > 0;
          const aeReasonItem = row.reasonList?.find(
            (r) => r.bispecifictreatmentdiscontinuationreasonid === 2,
          );
          const isAEUnknownChecked =
            aeReasonItem?.aeSubReasons?.some(
              (ae) =>
                ae.bispecifictreatmentdiscontinuationreasonaeid === 99 &&
                ae.isSelected,
            ) || false;

          if (!hasAESubReasons && !isAEUnknownChecked) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].aeSubReasonEmpty = true;
          } else {
            const selectedAEs =
              aeReasonItem?.aeSubReasons?.filter((ae) => ae.isSelected) || [];
            const isNeuroSelected = selectedAEs.some(
              (ae) => ae.reasonName === DiscontinuationReason.NeurologicalEvent,
            );

            if (isNeuroSelected) {
              const selectedNeuroReasons =
                row.neurologicAEReasonList?.filter((n) => n.isSelected) || [];

              if (selectedNeuroReasons.length === 0) {
                isValid = false;
                rowHasError = true;
                Q381ALinvoDetails[index].neuroReasonEmpty = true;
              }

              selectedNeuroReasons.forEach((neuro) => {
                if (
                  neuro.reasonName?.includes("Other") &&
                  (!neuro.reasonText || !neuro.reasonText.trim())
                ) {
                  isValid = false;
                  rowHasError = true;
                  Q381ALinvoDetails[index].neuroOtherTextEmpty = true;
                }
              });
            }
          }
        }

        // ========================================
        // Column D: Pattern BEFORE change - HARD ERROR
        // ========================================
        if (row.changeType === 2) {
          if (
            row.patterBeforeChangeDoseFrequency === null ||
            row.patterBeforeChangeDoseFrequency === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].patternBeforeFrequencyEmpty = true;
          }

          if (
            (row.patterBeforeChangeDoseFrequency === 1 ||
              row.patterBeforeChangeDoseFrequency === 2) &&
            isStringEmpty(
              row.patterBeforeChangeDoseFrequency === 1
                ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
                : row.patterBeforeChangeDoseFrequencyWeek,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].patternBeforeFrequencyEmpty = true;
          }

          if (
            !isStringEmpty(
              row.patterBeforeChangeDoseFrequency === 1
                ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
                : row.patterBeforeChangeDoseFrequencyWeek,
            ) &&
            row.patterBeforeChangeDoseFrequency !== 99
          ) {
            const weekValue = Number(
              row.patterBeforeChangeDoseFrequency === 1
                ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
                : row.patterBeforeChangeDoseFrequencyWeek,
            );
            if (
              !Number.isInteger(weekValue) ||
              weekValue <= 0 ||
              weekValue > 20
            ) {
              isValid = false;
              rowHasError = true;
              Q381ALinvoDetails[index].patternBeforeFrequencyRangeInvalid =
                true;
            }
          }
        }

        if (row.changeType === 3) {
          if (
            row.patterBeforeChangeDoseStrength === null ||
            row.patterBeforeChangeDoseStrength === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].patternBeforeStrengthEmpty = true;
          }

          if (
            (row.patterBeforeChangeDoseStrength === 1 ||
              row.patterBeforeChangeDoseStrength === 2 ||
              row.patterBeforeChangeDoseStrength === 3) &&
            isStringEmpty(
              row.patterBeforeChangeDoseStrength === 1
                ? row.patterBeforeChangeDoseStrengthMg
                : row.patterBeforeChangeDoseStrength === 2
                  ? row.patterBeforeChangeDoseStrengthMgKg
                  : row.patterBeforeChangeDoseStrengthMgM2,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].patternBeforeStrengthEmpty = true;
          }

          if (
            !isStringEmpty(
              row.patterBeforeChangeDoseStrength === 1
                ? row.patterBeforeChangeDoseStrengthMg
                : row.patterBeforeChangeDoseStrength === 2
                  ? row.patterBeforeChangeDoseStrengthMgKg
                  : row.patterBeforeChangeDoseStrengthMgM2,
            ) &&
            row.patterBeforeChangeDoseStrength !== 99
          ) {
            const strengthValue = Number(
              row.patterBeforeChangeDoseStrength === 1
                ? row.patterBeforeChangeDoseStrengthMg
                : row.patterBeforeChangeDoseStrength === 2
                  ? row.patterBeforeChangeDoseStrengthMgKg
                  : row.patterBeforeChangeDoseStrengthMgM2,
            );
            if (
              isNaN(strengthValue) ||
              strengthValue <= 0 ||
              strengthValue > 4000
            ) {
              isValid = false;
              rowHasError = true;
              Q381ALinvoDetails[index].patternBeforeFrequencyRangeInvalid =
                true;
            }
          }
        }

        // ========================================
        // Column E: Pattern AFTER change - HARD ERROR
        // ========================================
        if (row.changeType === 2) {
          if (
            row.patterAfterChangeDoseFrequency === null ||
            row.patterAfterChangeDoseFrequency === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].patternAfterFrequencyEmpty = true;
          }

          if (
            (row.patterAfterChangeDoseFrequency === 1 ||
              row.patterAfterChangeDoseFrequency === 2) &&
            isStringEmpty(
              row.patterAfterChangeDoseFrequency === 1
                ? row.patterAfterChangeDoseFrequencyTimesPerWeek
                : row.patterAfterChangeDoseFrequencyWeek,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].patternAfterFrequencyEmpty = true;
          }

          if (
            !isStringEmpty(
              row.patterAfterChangeDoseFrequency === 1
                ? row.patterAfterChangeDoseFrequencyTimesPerWeek
                : row.patterAfterChangeDoseFrequencyWeek,
            ) &&
            row.patterAfterChangeDoseFrequency !== 99
          ) {
            const weekValue = Number(
              row.patterAfterChangeDoseFrequency === 1
                ? row.patterAfterChangeDoseFrequencyTimesPerWeek
                : row.patterAfterChangeDoseFrequencyWeek,
            );
            if (
              !Number.isInteger(weekValue) ||
              weekValue <= 0 ||
              weekValue > 20
            ) {
              isValid = false;
              rowHasError = true;
              Q381ALinvoDetails[index].patternAfterFrequencyRangeInvalid = true;
            }
          }
        }

        if (row.changeType === 3) {
          if (
            row.patterAfterChangeDoseStrength === null ||
            row.patterAfterChangeDoseStrength === undefined
          ) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].patternAfterStrengthEmpty = true;
          }

          if (
            (row.patterAfterChangeDoseStrength === 1 ||
              row.patterAfterChangeDoseStrength === 2 ||
              row.patterAfterChangeDoseStrength === 3) &&
            isStringEmpty(
              row.patterAfterChangeDoseStrength === 1
                ? row.patterAfterChangeDoseStrengthMg
                : row.patterAfterChangeDoseStrength === 2
                  ? row.patterAfterChangeDoseStrengthMgKg
                  : row.patterAfterChangeDoseStrengthMgM2,
            )
          ) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].patternAfterStrengthEmpty = true;
          }

          if (
            !isStringEmpty(
              row.patterAfterChangeDoseStrength === 1
                ? row.patterAfterChangeDoseStrengthMg
                : row.patterAfterChangeDoseStrength === 2
                  ? row.patterAfterChangeDoseStrengthMgKg
                  : row.patterAfterChangeDoseStrengthMgM2,
            ) &&
            row.patterAfterChangeDoseStrength !== 99
          ) {
            const strengthValue = Number(
              row.patterAfterChangeDoseStrength === 1
                ? row.patterAfterChangeDoseStrengthMg
                : row.patterAfterChangeDoseStrength === 2
                  ? row.patterAfterChangeDoseStrengthMgKg
                  : row.patterAfterChangeDoseStrengthMgM2,
            );
            if (
              isNaN(strengthValue) ||
              strengthValue <= 0 ||
              strengthValue > 4000
            ) {
              isValid = false;
              rowHasError = true;
              Q381ALinvoDetails[index].patternAfterStrengthRangeInvalid = true;
            }
          }
        }

        // ========================================
        // Conflict Validations: Before vs After
        // ========================================
        // For FREQUENCY INCREASE
        if (
          row.changeType === 2 &&
          row.changeTypeDoseFrequency === 1 &&
          row.patterBeforeChangeDoseFrequency !== 99 &&
          row.patterAfterChangeDoseFrequency !== 99 &&
          row.patterBeforeChangeDoseFrequency ===
            row.patterAfterChangeDoseFrequency &&
          !isStringEmpty(
            row.patterBeforeChangeDoseFrequency === 1
              ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
              : row.patterBeforeChangeDoseFrequencyWeek,
          ) &&
          !isStringEmpty(
            row.patterAfterChangeDoseFrequency === 1
              ? row.patterAfterChangeDoseFrequencyTimesPerWeek
              : row.patterAfterChangeDoseFrequencyWeek,
          )
        ) {
          const isTimesPerWeek = row.patterBeforeChangeDoseFrequency === 1;

          const beforeValue = Number(
            isTimesPerWeek
              ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
              : row.patterBeforeChangeDoseFrequencyWeek,
          );

          const afterValue = Number(
            isTimesPerWeek
              ? row.patterAfterChangeDoseFrequencyTimesPerWeek
              : row.patterAfterChangeDoseFrequencyWeek,
          );

          let isConflict = false;

          if (isTimesPerWeek) {
            // Times per week → After must be greater
            if (afterValue <= beforeValue) {
              isConflict = true;
            }
          } else {
            // Once every X weeks → After must be smaller
            if (afterValue >= beforeValue) {
              isConflict = true;
            }
          }

          if (isConflict) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].frequencyIncreaseConflict = true;
          }
        }

        // For FREQUENCY DECREASE
        if (
          row.changeType === 2 &&
          row.changeTypeDoseFrequency === 2 &&
          row.patterBeforeChangeDoseFrequency !== 99 &&
          row.patterAfterChangeDoseFrequency !== 99 &&
          row.patterBeforeChangeDoseFrequency ===
            row.patterAfterChangeDoseFrequency &&
          !isStringEmpty(
            row.patterBeforeChangeDoseFrequency === 1
              ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
              : row.patterBeforeChangeDoseFrequencyWeek,
          ) &&
          !isStringEmpty(
            row.patterAfterChangeDoseFrequency === 1
              ? row.patterAfterChangeDoseFrequencyTimesPerWeek
              : row.patterAfterChangeDoseFrequencyWeek,
          )
        ) {
          const isTimesPerWeek = row.patterBeforeChangeDoseFrequency === 1;

          const beforeValue = Number(
            isTimesPerWeek
              ? row.patterBeforeChangeDoseFrequencyTimesPerWeek
              : row.patterBeforeChangeDoseFrequencyWeek,
          );

          const afterValue = Number(
            isTimesPerWeek
              ? row.patterAfterChangeDoseFrequencyTimesPerWeek
              : row.patterAfterChangeDoseFrequencyWeek,
          );

          let isConflict = false;

          if (isTimesPerWeek) {
            // Times per week → After must be smaller
            if (afterValue >= beforeValue) {
              isConflict = true;
            }
          } else {
            // Once every X weeks → After must be larger
            if (afterValue <= beforeValue) {
              isConflict = true;
            }
          }

          if (isConflict) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].frequencyDecreaseConflict = true;
          }
        }

        if (
          row.changeType === 3 &&
          row.changeTypeDoseStrength === 1 &&
          row.patterBeforeChangeDoseStrength !== 99 &&
          row.patterAfterChangeDoseStrength !== 99 &&
          row.patterBeforeChangeDoseStrength ===
            row.patterAfterChangeDoseStrength &&
          !isStringEmpty(
            row.patterBeforeChangeDoseStrength == 1
              ? row.patterBeforeChangeDoseStrengthMg
              : row.patterBeforeChangeDoseStrength == 2
                ? row.patterBeforeChangeDoseStrengthMgKg
                : row.patterBeforeChangeDoseStrengthMgM2,
          ) &&
          !isStringEmpty(
            row.patterAfterChangeDoseStrength == 1
              ? row.patterAfterChangeDoseStrengthMg
              : row.patterAfterChangeDoseStrength == 2
                ? row.patterAfterChangeDoseStrengthMgKg
                : row.patterAfterChangeDoseStrengthMgM2,
          )
        ) {
          const beforeValue = Number(
            row.patterBeforeChangeDoseStrength == 1
              ? row.patterBeforeChangeDoseStrengthMg
              : row.patterBeforeChangeDoseStrength == 2
                ? row.patterBeforeChangeDoseStrengthMgKg
                : row.patterBeforeChangeDoseStrengthMgM2,
          );
          const afterValue = Number(
            row.patterAfterChangeDoseStrength == 1
              ? row.patterAfterChangeDoseStrengthMg
              : row.patterAfterChangeDoseStrength == 2
                ? row.patterAfterChangeDoseStrengthMgKg
                : row.patterAfterChangeDoseStrengthMgM2,
          );

          if (afterValue <= beforeValue) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].strengthIncreaseConflict = true;
          }
        }

        if (
          row.changeType === 3 &&
          row.changeTypeDoseStrength === 2 &&
          row.patterBeforeChangeDoseStrength !== 99 &&
          row.patterAfterChangeDoseStrength !== 99 &&
          row.patterBeforeChangeDoseStrength ===
            row.patterAfterChangeDoseStrength &&
          !isStringEmpty(
            row.patterBeforeChangeDoseStrength == 1
              ? row.patterBeforeChangeDoseStrengthMg
              : row.patterBeforeChangeDoseStrength == 2
                ? row.patterBeforeChangeDoseStrengthMgKg
                : row.patterBeforeChangeDoseStrengthMgM2,
          ) &&
          !isStringEmpty(
            row.patterAfterChangeDoseStrength == 1
              ? row.patterAfterChangeDoseStrengthMg
              : row.patterAfterChangeDoseStrength == 2
                ? row.patterAfterChangeDoseStrengthMgKg
                : row.patterAfterChangeDoseStrengthMgM2,
          )
        ) {
          const beforeValue = Number(
            row.patterBeforeChangeDoseStrength == 1
              ? row.patterBeforeChangeDoseStrengthMg
              : row.patterBeforeChangeDoseStrength == 2
                ? row.patterBeforeChangeDoseStrengthMgKg
                : row.patterBeforeChangeDoseStrengthMgM2,
          );
          const afterValue = Number(
            row.patterAfterChangeDoseStrength == 1
              ? row.patterAfterChangeDoseStrengthMg
              : row.patterAfterChangeDoseStrength == 2
                ? row.patterAfterChangeDoseStrengthMgKg
                : row.patterAfterChangeDoseStrengthMgM2,
          );

          if (afterValue >= beforeValue) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].strengthDecreaseConflict = true;
          }
        }

        // ========================================
        // WARNING: Pattern Unknown
        // ========================================
        if (row.changeType === 2 || row.changeType === 3) {
          const beforeUnknowValue =
            row.changeType === 2
              ? row.patterBeforeChangeDoseFrequency
              : row.patterBeforeChangeDoseStrength;
          const afterUnknowValue =
            row.changeType === 2
              ? row.patterAfterChangeDoseFrequency
              : row.patterAfterChangeDoseStrength;

          Q381ALinvoDetails[index].patternBeforeUnknownWarning =
            beforeUnknowValue === 99;
          Q381ALinvoDetails[index].patternAfterUnknownWarning =
            afterUnknowValue === 99;
        }

        // ========================================
        // Column F: Date - HARD ERROR
        // ========================================
        if (row.dateChangeRd === null || row.dateChangeRd === undefined) {
          isValid = false;
          rowHasError = true;
          Q381ALinvoDetails[index].dateChangeRdEmpty = true;
        }

        if (row.dateChangeRd === 1) {
          if (isStringEmpty(row.dateChange)) {
            isValid = false;
            rowHasError = true;
            Q381ALinvoDetails[index].dateChangeEmpty = true;
          } else {
            // Date format validation
            if (
              row.dateChange &&
              !DateInRange(row.dateChange, dayjs("01-01-1920"), dayjs())
            ) {
              isValid = false;
              rowHasError = true;
              Q381ALinvoDetails[index].invalidDateChange = true;
            } else {
              // ✅ Use the new date chain validation
              if (
                !ValidateQ381ADateChain(
                  row.dateChange,
                  RRMMCohortTreatment.Linvoseltamab,
                )
              ) {
                isValid = false;
                rowHasError = true;
                Q381ALinvoDetails[index].dateChangeOutOfBound = true;
              }
            }
          }
        }
      });

      setQ381ALinvoDetails([...Q381ALinvoDetails]);
    }

    // ==================== Q38.2.A ELREXFIO VALIDATION ====================
    if (isElrexvayliSelected && isNewEcrfA) {
      Q382AElrexDetails.forEach((row, index) => {
        let rowHasError = false;

        // Column B: Type of change - HARD ERROR
        if (row.changeType === null || row.changeType === undefined) {
          isValid = false;
          rowHasError = true;
          Q382AElrexDetails[index].changeTypeEmpty = true;
        }

        // Skip columns C-E validation if "No changes" (1) or "Unknown" (99)
        if (row.changeType === 1 || row.changeType === 99) {
          return; // Skip rest of validations for this row
        }

        // Column C: Reasons - HARD ERROR
        if (row.selectedReasons.length === 0 && !row.reasonUnknown) {
          isValid = false;
          rowHasError = true;
          Q382AElrexDetails[index].reasonEmpty = true;
        }

        // Check for patient death warning
        if (row.selectedReasons.includes(1)) {
          // ID=1 is "Patient death"
          if (patientDeathDate === null || isStringEmpty(patientDeathDate)) {
            isValid = false;
            rowHasError = true;
            Q382AElrexDetails[index].deathDtWarning = true;
          }
        }

        // If "Other" (ID=14) is selected, validate other text field
        if (row.selectedReasons.includes(14)) {
          if (isStringEmpty(row.reasonOtherText)) {
            isValid = false;
            rowHasError = true;
            Q382AElrexDetails[index].reasonOtherTextEmpty = true;
          }
        }

        // If "Adverse Event" (ID=2) is selected, validate AE sub-reasons
        if (row.selectedReasons.includes(2)) {
          const hasAESubReasons = row.selectedAEReasons.length > 0;
          const aeReasonItem = row.reasonList?.find(
            (r) => r.bispecifictreatmentdiscontinuationreasonid === 2,
          );
          if (!hasAESubReasons) {
            isValid = false;
            rowHasError = true;
            Q382AElrexDetails[index].aeSubReasonEmpty = true;
          } else {
            const selectedAEs =
              aeReasonItem?.aeSubReasons?.filter((ae) => ae.isSelected) || [];
            const isNeuroSelected = selectedAEs.some(
              (ae) => ae.reasonName === DiscontinuationReason.NeurologicalEvent,
            );

            if (isNeuroSelected) {
              const selectedNeuroReasons =
                row.neurologicAEReasonList?.filter((n) => n.isSelected) || [];

              if (selectedNeuroReasons.length === 0) {
                isValid = false;
                rowHasError = true;
                Q382AElrexDetails[index].neuroReasonEmpty = true;
              }

              selectedNeuroReasons.forEach((neuro) => {
                if (
                  neuro.reasonName?.includes("Other") &&
                  (!neuro.reasonText || !neuro.reasonText.trim())
                ) {
                  isValid = false;
                  rowHasError = true;
                  Q382AElrexDetails[index].neuroOtherTextEmpty = true;
                }
              });
            }
          }
        }

        // Column D: Start date - HARD ERROR
        if (
          row.startDateChangeRd === null ||
          row.startDateChangeRd === undefined
        ) {
          isValid = false;
          rowHasError = true;
          Q382AElrexDetails[index].startDateChangeRdEmpty = true;
        }

        // If "Date provided" (1) is selected for start date
        if (row.startDateChangeRd === 1) {
          if (isStringEmpty(row.startDateChange)) {
            isValid = false;
            rowHasError = true;
            Q382AElrexDetails[index].startDateChangeEmpty = true;
          } else {
            // Date format validation
            if (
              !DateInRange(row.startDateChange, dayjs("01-01-1920"), dayjs())
            ) {
              isValid = false;
              rowHasError = true;
              Q382AElrexDetails[index].invalidStartDateChange = true;
            } else {
              // Date range validation (between Index Date and End of Follow-up)
              if (
                !ValidateQ382ADateChain(
                  row.startDateChange,
                  RRMMCohortTreatment.ELREXFIO,
                  "start",
                )
              ) {
                isValid = false;
                rowHasError = true;
                Q382AElrexDetails[index].startDateChangeOutOfBound = true;
              }
            }
          }
        }

        // Column E: End date - HARD ERROR
        if (row.endDateChangeRd === null || row.endDateChangeRd === undefined) {
          isValid = false;
          rowHasError = true;
          Q382AElrexDetails[index].endDateChangeRdEmpty = true;
        }

        // If "Date provided" (2) is selected for end date
        if (row.endDateChangeRd === 2) {
          if (isStringEmpty(row.endDateChange)) {
            isValid = false;
            rowHasError = true;
            Q382AElrexDetails[index].endDateChangeEmpty = true;
          } else {
            // Date format validation
            if (!DateInRange(row.endDateChange, dayjs("01-01-1920"), dayjs())) {
              isValid = false;
              rowHasError = true;
              Q382AElrexDetails[index].invalidEndDateChange = true;
            } else {
              // Date range validation
              if (
                !ValidateQ382ADateChain(
                  row.endDateChange,
                  RRMMCohortTreatment.ELREXFIO,
                  "end",
                )
              ) {
                isValid = false;
                rowHasError = true;
                Q382AElrexDetails[index].endDateChangeOutOfBound = true;
              }

              // End date must be >= Start date
              if (
                row.startDateChangeRd === 1 &&
                !isStringEmpty(row.startDateChange)
              ) {
                if (
                  dayjs(row.endDateChange).isBefore(dayjs(row.startDateChange))
                ) {
                  isValid = false;
                  rowHasError = true;
                  Q382AElrexDetails[index].invalidEndDateChange = true;
                }
              }
            }
          }
        }
      });

      setQ382AElrexDetails([...Q382AElrexDetails]);
    }

    // ==================== Q38.2.A LINVOSELTAMAB VALIDATION ====================
    if (isLinvoveySelected && isNewEcrfA) {
      Q382ALinvoDetails.forEach((row, index) => {
        let rowHasError = false;

        // Column B: Type of change - HARD ERROR
        if (row.changeType === null || row.changeType === undefined) {
          isValid = false;
          rowHasError = true;
          Q382ALinvoDetails[index].changeTypeEmpty = true;
        }

        // Skip columns C-E validation if "No changes" (1) or "Unknown" (99)
        if (row.changeType === 1 || row.changeType === 99) {
          return; // Skip rest of validations for this row
        }

        // Column C: Reasons - HARD ERROR
        if (row.selectedReasons.length === 0 && !row.reasonUnknown) {
          isValid = false;
          rowHasError = true;
          Q382ALinvoDetails[index].reasonEmpty = true;
        }

        // Check for patient death warning
        if (row.selectedReasons.includes(1)) {
          if (patientDeathDate === null || isStringEmpty(patientDeathDate)) {
            isValid = false;
            rowHasError = true;
            Q382ALinvoDetails[index].deathDtWarning = true;
          }
        }

        // If "Other" (ID=14) is selected, validate other text field
        if (row.selectedReasons.includes(14)) {
          if (isStringEmpty(row.reasonOtherText)) {
            isValid = false;
            rowHasError = true;
            Q382ALinvoDetails[index].reasonOtherTextEmpty = true;
          }
        }

        // If "Adverse Event" (ID=2) is selected, validate AE sub-reasons
        if (row.selectedReasons.includes(2)) {
          const hasAESubReasons = row.selectedAEReasons.length > 0;
          const aeReasonItem = row.reasonList?.find(
            (r) => r.bispecifictreatmentdiscontinuationreasonid === 2,
          );
          if (!hasAESubReasons) {
            isValid = false;
            rowHasError = true;
            Q382ALinvoDetails[index].aeSubReasonEmpty = true;
          } else {
            const selectedAEs =
              aeReasonItem?.aeSubReasons?.filter((ae) => ae.isSelected) || [];
            const isNeuroSelected = selectedAEs.some(
              (ae) => ae.reasonName === DiscontinuationReason.NeurologicalEvent,
            );

            if (isNeuroSelected) {
              const selectedNeuroReasons =
                row.neurologicAEReasonList?.filter((n) => n.isSelected) || [];

              if (selectedNeuroReasons.length === 0) {
                isValid = false;
                rowHasError = true;
                Q382ALinvoDetails[index].neuroReasonEmpty = true;
              }

              selectedNeuroReasons.forEach((neuro) => {
                if (
                  neuro.reasonName?.includes("Other") &&
                  (!neuro.reasonText || !neuro.reasonText.trim())
                ) {
                  isValid = false;
                  rowHasError = true;
                  Q382ALinvoDetails[index].neuroOtherTextEmpty = true;
                }
              });
            }
          }
        }

        // Column D: Start date - HARD ERROR
        if (
          row.startDateChangeRd === null ||
          row.startDateChangeRd === undefined
        ) {
          isValid = false;
          rowHasError = true;
          Q382ALinvoDetails[index].startDateChangeRdEmpty = true;
        }

        // If "Date provided" (1) is selected for start date
        if (row.startDateChangeRd === 1) {
          if (isStringEmpty(row.startDateChange)) {
            isValid = false;
            rowHasError = true;
            Q382ALinvoDetails[index].startDateChangeEmpty = true;
          } else {
            // Date format validation
            if (
              !DateInRange(row.startDateChange, dayjs("01-01-1920"), dayjs())
            ) {
              isValid = false;
              rowHasError = true;
              Q382ALinvoDetails[index].invalidStartDateChange = true;
            } else {
              // Date range validation
              if (
                !ValidateQ382ADateChain(
                  row.startDateChange,
                  RRMMCohortTreatment.Linvoseltamab,
                  "start",
                )
              ) {
                isValid = false;
                rowHasError = true;
                Q382ALinvoDetails[index].startDateChangeOutOfBound = true;
              }
            }
          }
        }

        // Column E: End date - HARD ERROR
        if (row.endDateChangeRd === null || row.endDateChangeRd === undefined) {
          isValid = false;
          rowHasError = true;
          Q382ALinvoDetails[index].endDateChangeRdEmpty = true;
        }

        // If "Date provided" (2) is selected for end date
        if (row.endDateChangeRd === 2) {
          if (isStringEmpty(row.endDateChange)) {
            isValid = false;
            rowHasError = true;
            Q382ALinvoDetails[index].endDateChangeEmpty = true;
          } else {
            // Date format validation
            if (!DateInRange(row.endDateChange, dayjs("01-01-1920"), dayjs())) {
              isValid = false;
              rowHasError = true;
              Q382ALinvoDetails[index].invalidEndDateChange = true;
            } else {
              // Date range validation
              if (
                !ValidateQ382ADateChain(
                  row.endDateChange,
                  RRMMCohortTreatment.Linvoseltamab,
                  "end",
                )
              ) {
                isValid = false;
                rowHasError = true;
                Q382ALinvoDetails[index].endDateChangeOutOfBound = true;
              }

              // End date must be >= Start date
              if (
                row.startDateChangeRd === 1 &&
                !isStringEmpty(row.startDateChange)
              ) {
                if (
                  dayjs(row.endDateChange).isBefore(dayjs(row.startDateChange))
                ) {
                  isValid = false;
                  rowHasError = true;
                  Q382ALinvoDetails[index].invalidEndDateChange = true;
                }
              }
            }
          }
        }
      });

      setQ382ALinvoDetails([...Q382ALinvoDetails]);
    }

    return isValid;
  };

  const ValidateForDateCondition = (Q36ListData) => {
    let isValid = true;
    let cohortId = Q36ListData[0].cohorttreatmentid;

    const bispecificQ26DataForQ36 = bispecificQ26Data;
    const bispecificQ331ADataForQ36 = bispecificQ331AData;
    const bispecificQ31Q32DataForQ36 = (bispecificQ31Q32Data ?? []).filter(
      (x) => x?.cohortTreatmentId === cohortId,
    );

    //Date 1: Fetch earliest Date from Q26 & Q26.1
    const earliestQ26Dt = bispecificQ26DataForQ36
      .filter(
        (row) =>
          row.firstAdministrationDt !== null &&
          row.firstAdministrationDt !== "",
      )
      .reduce((earliest, row) => {
        const currentDate = new Date(row.firstAdministrationDt);

        if (!earliest || currentDate < earliest) {
          return currentDate;
        }
        return earliest;
      }, null);

    const formattedEarliestQ26Dt = earliestQ26Dt
      ? earliestQ26Dt.toLocaleDateString("en-US")
      : null;

    //Date 2: Fetch Latest Date of Dose Administration
    const latestQ36Dt = Q36ListData.filter(
      (row) =>
        row.dose_administration_tech_dt !== null &&
        row.dose_administration_tech_dt !== "",
    ).reduce((latest, row) => {
      const currentDate = new Date(row.dose_administration_tech_dt);
      return !latest || currentDate > new Date(latest)
        ? currentDate.toLocaleDateString("en-US")
        : latest;
    }, null);

    const hasValue = (v) =>
      v !== null && v !== undefined && v.toString().trim() !== "";
    const safeFind = (data, predicate) =>
      (data ?? []).find((x) => x && predicate(x)) ?? null;

    //Check which lot to consider while validating based on Q26 data
    if (bispecificQ26DataForQ36.length === 1) {
      const lot = Number(bispecificQ26DataForQ36[0].lotNumber);
      let nextLotNumber = lot + 1;

      if (lot === 1) {
        const firstAdminDtLot1 =
          (bispecificQ331ADataForQ36 ?? []).find(
            (x) => x && Number(x.lotNumber) === lot,
          )?.firstAdministrationDt ?? null;

        // Latest Date of Dose Administration <= 1L of Q33.1.A <=  end of followup
        isValid = CheckDateValidationQ36(
          latestQ36Dt,
          null,
          firstAdminDtLot1,
          endOfFollowUpDate,
        );
      } else if (lot === 2) {
        //Date 3: Fetch earliest Date from Q26 & Q26.1

        //Q28 2L Discontinuation Date
        const ndmmDiscontinuationLot =
          safeFind(ndmmLotData, (x) => Number(x.lotNumber) === lot)?.endLotDt ??
          null;

        //Q33.1.A 2L Discontinuation Date
        const q331ALastAdminDtLot =
          safeFind(
            bispecificQ331ADataForQ36,
            (x) => Number(x.lotNumber) === lot,
          )?.lastAdministrationDt ?? null;

        //Q31 3L Start Date
        const q31FirstAdminDtLot =
          safeFind(
            bispecificQ31Q32DataForQ36,
            (x) => Number(x.lotNumber) === nextLotNumber,
          )?.firstAdministrationDt ?? null;

        const dateToCompare =
          ndmmDiscontinuationLot != null
            ? ndmmDiscontinuationLot
            : q331ALastAdminDtLot != null
              ? q331ALastAdminDtLot
              : q31FirstAdminDtLot != null
                ? q31FirstAdminDtLot
                : null;

        //Earliest date of 12,12.1 or 26, 26.1 <= Latest Date of Dose Administration <= 2L Q28 discontinuation date or 2L Q33.1.A discontinuation date or 3L start date in Q31 <= end of follow up
        isValid = CheckDateValidationQ36(
          formattedEarliestQ26Dt,
          latestQ36Dt,
          dateToCompare,
          endOfFollowUpDate,
        );
      }
    } else if (bispecificQ26DataForQ36.length > 1) {
      const lotNumbers = bispecificQ26DataForQ36
        .map((x) => Number(x.lotNumber))
        .filter((x) => !isNaN(x))
        .sort((a, b) => a - b);

      for (let i = 0; i < lotNumbers.length; i++) {
        let isSequential = true;
        let lot = lotNumbers[i];
        let nextLotNumber = lot + 1;

        // Check if this is the last lot
        let isLastLot = i === lotNumbers.length - 1;

        // Check if not first and not last
        let isNotFirstOrLast = i !== 0 && i !== lotNumbers.length - 1;

        if (lotNumbers[i] !== lotNumbers[i - 1] + 1) {
          isSequential = false;
        }

        if (isSequential) {
          // LOTs are sequential

          //Q28, Q29 L Discontinuation Date
          const ndmmDiscontinuationLot =
            safeFind(ndmmLotData, (x) => Number(x.lotNumber) === lot)
              ?.endLotDt ?? null;

          //Q33.1.A L Discontinuation Date
          const q331ALastAdminDtLot =
            safeFind(
              bispecificQ331ADataForQ36,
              (x) => Number(x.lotNumber) === lot,
            )?.lastAdministrationDt ?? null;

          //Q26.1 L+1 Start Date
          const q26FirstAdminDtNextLot =
            safeFind(
              bispecificQ26DataForQ36,
              (x) => Number(x.lotNumber) === nextLotNumber,
            )?.firstAdministrationDt ?? null;

          //Q32 Discontinuation Date
          const q32LastAdminDtLot =
            safeFind(
              bispecificQ31Q32DataForQ36,
              (x) => Number(x.lotNumber) === lot,
            )?.lastAdministrationDt ?? null;

          //Q31 next Lot Start Date
          const q31FirstAdminDtNextLot =
            safeFind(
              bispecificQ31Q32DataForQ36,
              (x) => Number(x.lotNumber) === nextLotNumber,
            )?.firstAdministrationDt ?? null;

          const dateToCompare = hasValue(ndmmDiscontinuationLot)
            ? ndmmDiscontinuationLot
            : hasValue(q331ALastAdminDtLot)
              ? q331ALastAdminDtLot
              : hasValue(q26FirstAdminDtNextLot)
                ? q26FirstAdminDtNextLot
                : null;
          const dateToCompareLastLot = hasValue(q32LastAdminDtLot)
            ? q32LastAdminDtLot
            : hasValue(ndmmDiscontinuationLot)
              ? ndmmDiscontinuationLot
              : hasValue(q331ALastAdminDtLot)
                ? q331ALastAdminDtLot
                : hasValue(q31FirstAdminDtNextLot)
                  ? q31FirstAdminDtNextLot
                  : null;
          const dateToCompareMidlot = hasValue(q32LastAdminDtLot)
            ? q32LastAdminDtLot
            : lot === 3 && hasValue(ndmmDiscontinuationLot)
              ? ndmmDiscontinuationLot
              : hasValue(q331ALastAdminDtLot)
                ? q331ALastAdminDtLot
                : lot === 3 && hasValue(q26FirstAdminDtNextLot)
                  ? q26FirstAdminDtNextLot
                  : hasValue(q31FirstAdminDtNextLot)
                    ? q31FirstAdminDtNextLot
                    : null;

          if (isLastLot) {
            //if this is the last lotnumber of the list
            //Earliest of Q26, Q26.1 <= Latest Date of Dose Administration <= L end Q32 OR L end Q29 OR L end Q33.1.A OR L+1 Start Q31 <= end of follow up
            isValid = CheckDateValidationQ36(
              formattedEarliestQ26Dt,
              latestQ36Dt,
              dateToCompareLastLot,
              endOfFollowUpDate,
            );
          } else if (isNotFirstOrLast) {
            //if this is not the first or last lotnumber of the list
            isValid = CheckDateValidationQ36(
              formattedEarliestQ26Dt,
              latestQ36Dt,
              dateToCompareMidlot,
              endOfFollowUpDate,
            );
          } else {
            //if this is not the last lotnumber of the list
            //Earliest of Q26, Q26.1 <= Latest Date of Dose Administration <= L end Q28 OR L end Q33.1.A OR L+1 Start Q26, Q26.1 <= end of follow up
            isValid = CheckDateValidationQ36(
              formattedEarliestQ26Dt,
              latestQ36Dt,
              dateToCompare,
              endOfFollowUpDate,
            );
          }
        } else if (!isSequential) {
          // LOTs are sequential

          //Q28, Q29 L Discontinuation Date
          const ndmmDiscontinuationLot =
            safeFind(ndmmLotData, (x) => Number(x.lotNumber) === lot)
              ?.endLotDt ?? null;

          //Q33.1.A L Discontinuation Date
          const q331ALastAdminDtLot =
            safeFind(
              bispecificQ331ADataForQ36,
              (x) => Number(x.lotNumber) === lot,
            )?.lastAdministrationDt ?? null;

          //Q31 L+1 Start Date
          const q31StartDateLot =
            safeFind(
              bispecificQ31Q32DataForQ36,
              (x) => Number(x.lotNumber) === nextLotNumber,
            )?.firstAdministrationDt ?? null;

          //Q27 L+1 Start Date
          const q27StartDateLot =
            safeFind(ndmmLotData, (x) => Number(x.lotNumber) === nextLotNumber)
              ?.startLotDt ?? null;

          //Q33.1.A L+1 Start Date
          const q331AStartAdminDtNextLot =
            safeFind(
              bispecificQ331ADataForQ36,
              (x) => Number(x.lotNumber) === nextLotNumber,
            )?.firstAdministrationDt ?? null;

          const dateToCompare = hasValue(ndmmDiscontinuationLot)
            ? ndmmDiscontinuationLot
            : hasValue(q331ALastAdminDtLot)
              ? q331ALastAdminDtLot
              : hasValue(q31StartDateLot)
                ? q31StartDateLot
                : hasValue(q27StartDateLot)
                  ? q27StartDateLot
                  : hasValue(q331AStartAdminDtNextLot)
                    ? q331AStartAdminDtNextLot
                    : null;
          const dateToCompareLastLot = hasValue(q331ALastAdminDtLot)
            ? q331ALastAdminDtLot
            : hasValue(q31StartDateLot)
              ? q31StartDateLot
              : null;
          const dateToCompareMidlot = hasValue(q331ALastAdminDtLot)
            ? q331ALastAdminDtLot
            : hasValue(q31StartDateLot)
              ? q31StartDateLot
              : hasValue(q331AStartAdminDtNextLot)
                ? q331AStartAdminDtNextLot
                : null;

          if (isLastLot) {
            //if this is the last lotnumber of the list
            //Earliest of Q26, Q26.1 <= Latest Date of Dose Administration <= L Q33.1.A DD OR L+1 Q31 SD <= end of follow up
            isValid = CheckDateValidationQ36(
              formattedEarliestQ26Dt,
              latestQ36Dt,
              dateToCompareLastLot,
              endOfFollowUpDate,
            );
          } else if (isNotFirstOrLast) {
            //if this is not the first or last lotnumber of the list
            isValid = CheckDateValidationQ36(
              formattedEarliestQ26Dt,
              latestQ36Dt,
              dateToCompareMidlot,
              endOfFollowUpDate,
            );
          } else {
            //if this is not the last lotnumber of the list
            //Earliest of Q26, Q26.1 <= Latest Date of Dose Administration <= L end Q28 DD OR L end Q33.1.A DD OR L+1 Q31 SD OR L+1 Q27 SD OR L+1 Q33.1.A SD <= end of follow up
            isValid = CheckDateValidationQ36(
              formattedEarliestQ26Dt,
              latestQ36Dt,
              dateToCompare,
              endOfFollowUpDate,
            );
          }
          if (!isValid) return isValid;
        }
      }
    }

    return isValid;
  };

  const getLatestQ36ColumnBDate = (cohortType) => {
    // ✅ Q36 Dosage data - NOT Q36.1
    const dosageDetails =
      cohortType === RRMMCohortTreatment.ELREXFIO
        ? elrexvayliDetails
        : linvoveyDetails;

    // ✅ Column [B] = doseadministrationelrdt / doseadministrationlinvodt
    const validDates = dosageDetails
      .filter((row) => {
        const dateField =
          cohortType === RRMMCohortTreatment.ELREXFIO
            ? row.dose_administration_elr_dt
            : row.dose_administration_linvo_dt;
        const radioField =
          cohortType === RRMMCohortTreatment.ELREXFIO
            ? row.dose_administration_elr
            : row.dose_administration_linvo;

        return IsValidDateValue(dateField) && radioField === 1;
      })
      .map((row) => {
        const dateField =
          cohortType === RRMMCohortTreatment.ELREXFIO
            ? row.dose_administration_elr_dt
            : row.dose_administration_linvo_dt;
        return dayjs(dateField);
      });

    if (validDates.length === 0) return null;

    // Return the latest (maximum) date as string
    return validDates
      .reduce((max, date) => (date.isAfter(max) ? date : max))
      .format("MM/DD/YYYY");
  };

  const ValidateIndexDAndLOTDateChain = (date, cohortType) => {
    const indexDate =
      cohortType === RRMMCohortTreatment.ELREXFIO
        ? elrexIndexDate
        : linvoIndexDate;
    const lotStartDate =
      cohortType === RRMMCohortTreatment.ELREXFIO
        ? elrexfioLOTStartDate
        : linvoseltamabLOTStartDate;

    const idx = IsValidDateValue(indexDate) ? indexDate : null;
    const q40Date = IsValidDateValue(date) ? date : null;
    const lot = IsValidDateValue(lotStartDate) ? lotStartDate : null;
    const eof = IsValidDateValue(endOfFollowUpDate) ? endOfFollowUpDate : null;
    // index date ≤ [D]
    if (idx && q40Date && !IsLessOrEqual(idx, q40Date)) {
      return false;
    }

    // [D] ≤ LOT (if exists)
    if (q40Date && lot && !IsLessOrEqual(q40Date, lot)) {
      return false;
    }

    // LOT ≤ EOF (if exists)
    if (lot && eof && !IsLessOrEqual(lot, eof)) {
      return false;
    }

    // [D] ≤ EOF (if LOT does not exist)
    if (q40Date && eof && !IsLessOrEqual(q40Date, eof)) {
      return false;
    }

    return true;
  };

  const ValidateQ381ADateChain = (date, cohortType) => {
    const indexDate =
      cohortType === RRMMCohortTreatment.ELREXFIO
        ? elrexIndexDate
        : linvoIndexDate;

    const latestQ36Date = getLatestQ36ColumnBDate(cohortType);

    const lotStartDate =
      cohortType === RRMMCohortTreatment.ELREXFIO
        ? elrexfioLOTStartDate
        : linvoseltamabLOTStartDate;

    const idx = IsValidDateValue(indexDate) ? indexDate : null;
    const q381ADate = IsValidDateValue(date) ? date : null;
    const q36Latest = IsValidDateValue(latestQ36Date) ? latestQ36Date : null;
    const lot = IsValidDateValue(lotStartDate) ? lotStartDate : null;
    const eof = IsValidDateValue(endOfFollowUpDate) ? endOfFollowUpDate : null;

    // Rule 1: index date ≤ [D]
    if (idx && q381ADate && !IsLessOrEqual(idx, q381ADate)) {
      return false;
    }

    // Rule 2: [D] ≤ latest Q36 [B] (if Q36 dates exist)
    if (q381ADate && q36Latest && !IsLessOrEqual(q381ADate, q36Latest)) {
      return false;
    }

    // Rule 3: latest Q36 [B] ≤ LOT (if both exist)
    if (q36Latest && lot && !IsLessOrEqual(q36Latest, lot)) {
      return false;
    }

    // Rule 4: [D] ≤ LOT (if LOT exists and no Q36 dates)
    if (q381ADate && lot && !q36Latest && !IsLessOrEqual(q381ADate, lot)) {
      return false;
    }

    // Rule 5: LOT ≤ EOF
    if (lot && eof && !IsLessOrEqual(lot, eof)) {
      return false;
    }

    // Rule 6: [D] ≤ EOF
    if (q381ADate && eof && !IsLessOrEqual(q381ADate, eof)) {
      return false;
    }

    return true;
  };

  // Q38.2.A Date validation helper -
  const ValidateQ382ADateChain = (date, cohortType, dateType) => {
    // Get Index Date
    const indexDate =
      cohortType === RRMMCohortTreatment.ELREXFIO
        ? elrexIndexDate
        : linvoIndexDate;

    // Get latest Q36 Column B date (latest dose administration date)
    const latestQ36Date = getLatestQ36ColumnBDate(cohortType);

    // Get LOT Start Date
    const lotStartDate =
      cohortType === RRMMCohortTreatment.ELREXFIO
        ? elrexfioLOTStartDate
        : linvoseltamabLOTStartDate;

    // Validate all dates
    const idx = IsValidDateValue(indexDate) ? indexDate : null;
    const q382ADate = IsValidDateValue(date) ? date : null;
    const q36Latest = IsValidDateValue(latestQ36Date) ? latestQ36Date : null;
    const lot = IsValidDateValue(lotStartDate) ? lotStartDate : null;
    const eof = IsValidDateValue(endOfFollowUpDate) ? endOfFollowUpDate : null;

    // Rule 1: Index Date ≤ Q38.2.A Date [D] or [E]
    if (idx && q382ADate && !IsLessOrEqual(idx, q382ADate)) {
      return false;
    }

    // Rule 2: Q38.2.A Date ≤ Latest Q36 [B] date (if Q36 dates exist)
    if (q382ADate && q36Latest && !IsLessOrEqual(q382ADate, q36Latest)) {
      return false;
    }

    // Rule 3: Latest Q36 [B] ≤ LOT Start Date (if both exist)
    if (q36Latest && lot && !IsLessOrEqual(q36Latest, lot)) {
      return false;
    }

    // Rule 4: Q38.2.A Date ≤ LOT Start Date (if LOT exists and no Q36 dates)
    if (q382ADate && lot && !q36Latest && !IsLessOrEqual(q382ADate, lot)) {
      return false;
    }

    // Rule 5: LOT Start Date ≤ End of Follow-up
    if (lot && eof && !IsLessOrEqual(lot, eof)) {
      return false;
    }

    // Rule 6: Q38.2.A Date ≤ End of Follow-up
    if (q382ADate && eof && !IsLessOrEqual(q382ADate, eof)) {
      return false;
    }

    return true;
  };

  // Q36.1 - Aggregate Hospitalization Date Chain Validation
  const ValidateQ361HospitalizationChain = (hospDetails, cohortType) => {
    // Get reference dates
    const indexDate =
      cohortType === RRMMCohortTreatment.ELREXFIO
        ? elrexIndexDate
        : linvoIndexDate;

    const lotStartDate =
      cohortType === RRMMCohortTreatment.ELREXFIO
        ? elrexfioLOTStartDate
        : linvoseltamabLOTStartDate;

    // Extract all valid admission dates (column B)
    const admissionDates = hospDetails
      .filter(
        (row) =>
          row.dt_admission === 1 && IsValidDateValue(row.dt_admission_dt),
      )
      .map((row) => row.dt_admission_dt);

    // Extract all valid discharge dates (column C)
    const dischargeDates = hospDetails
      .filter(
        (row) =>
          row.dt_discharge === 1 && IsValidDateValue(row.dt_discharge_dt),
      )
      .map((row) => row.dt_discharge_dt);

    // If no dates, no validation needed
    if (admissionDates.length === 0 && dischargeDates.length === 0) {
      return true;
    }

    // Find earliest admission date
    const earliestAdmission =
      admissionDates.length > 0
        ? admissionDates.reduce((min, d) => (IsLessOrEqual(d, min) ? d : min))
        : null;

    // Find latest discharge date
    const latestDischarge =
      dischargeDates.length > 0
        ? dischargeDates.reduce((max, d) => (IsLessOrEqual(max, d) ? d : max))
        : null;

    // Validate chain: Index Date ≤ Earliest Admission
    if (earliestAdmission && IsValidDateValue(indexDate)) {
      if (!IsLessOrEqual(indexDate, earliestAdmission)) {
        return false;
      }
    }

    // Validate chain: Earliest Admission ≤ Latest Discharge
    if (earliestAdmission && latestDischarge) {
      if (!IsLessOrEqual(earliestAdmission, latestDischarge)) {
        return false;
      }
    }

    // Validate chain: Latest Discharge ≤ LOT Start Date (if LOT exists)
    if (latestDischarge && IsValidDateValue(lotStartDate)) {
      if (!IsLessOrEqual(latestDischarge, lotStartDate)) {
        return false;
      }
    }

    // Validate chain: LOT Start Date ≤ End of Follow-up (if both exist)
    if (IsValidDateValue(lotStartDate) && IsValidDateValue(endOfFollowUpDate)) {
      if (!IsLessOrEqual(lotStartDate, endOfFollowUpDate)) {
        return false;
      }
    }

    // Validate chain: Latest Discharge ≤ End of Follow-up (if no LOT)
    if (latestDischarge && IsValidDateValue(endOfFollowUpDate)) {
      if (!IsLessOrEqual(latestDischarge, endOfFollowUpDate)) {
        return false;
      }
    }

    return true;
  };

  const sidebar = document.getElementById("mySidebar");
  const main = document.getElementById("main");

  const toggleNav = () => {
    if (isSideMenuActive === true) {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
      setIsSideMenuActive(false);
    } else if (isSideMenuActive === false) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
      setIsSideMenuActive(true);
    }
  };

  useEffect(() => {
    const sidebar = document.getElementById("mySidebar");
    const main = document.getElementById("main");

    if (isSideMenuActive === true) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
    } else {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
    }
  });

  const showLinvoDate = () => {
    let varLinvoIndexDate = "";
    if (linvoIndexDate === null || "") {
      varLinvoIndexDate = "[Bispecifics/CAR-T index date]";
    } else {
      varLinvoIndexDate = linvoIndexDate;
    }

    return varLinvoIndexDate;
  };

  const showElrDate = () => {
    let varElrIndexDate = "";
    if (elrexIndexDate === null || "") {
      varElrIndexDate = "[Bispecifics/CAR-T index date]";
    } else {
      varElrIndexDate = elrexIndexDate;
    }

    return varElrIndexDate;
  };

  const CheckDuplicatePhasesRealtime = (doseDetails, type) => {
    const phaseField =
      type === "elrexfio" ? "dosing_phase_elr" : "dosing_phase_linvo";

    // Elrex does NOT have step-up 3, but DOES include 1st dose
    const phasesToCheck = type === "elrexfio" ? [1, 2, 3] : [1, 2, 3];

    let duplicates = [];

    phasesToCheck.forEach((phase) => {
      const phaseCount = doseDetails.filter(
        (dose) => Number(dose[phaseField]) === phase,
      ).length;

      if (phaseCount >= 2) {
        const phaseName =
          phase === 1
            ? "Step-up dose 1"
            : phase === 2
              ? "Step-up dose 2"
              : phase === 3
                ? "Step-up dose 3"
                : "1st treatment dose";

        duplicates.push({ phase, count: phaseCount, phaseName });
      }
    });

    return duplicates;
  };

  const CheckMissingStepUpDosesRealtime = (doseDetails, type) => {
    const phaseField =
      type === "elrexfio" ? "dosing_phase_elr" : "dosing_phase_linvo";
    // Collect all valid numeric phases
    const phases = doseDetails
      .map((d) => Number(d[phaseField]))
      .filter((v) => !isNaN(v) && v > 0);

    // Check if 1st treatment dose exists
    // Elrexfio: phase 3 = 1st treatment dose
    // Linvo: phase 4 = 1st treatment dose
    const firstTreatmentPhase = type === "elrexfio" ? 3 : 4;
    const hasFirstTreatment = phases.includes(firstTreatmentPhase);

    // If no 1st treatment dose selected, no warning needed
    if (!hasFirstTreatment) {
      return false;
    }

    // Check for required step-up doses (same for both)
    const hasStepUp1 = phases.includes(1); // Step-up dose 1
    const hasStepUp2 = phases.includes(2); // Step-up dose 2

    // Warning if EITHER step-up 1 OR step-up 2 is missing
    // when 1st treatment dose is present
    return !hasStepUp1 && !hasStepUp2;
  };

  const runElrexWarnings = (doseArray) => {
    const duplicates = CheckDuplicatePhasesRealtime(doseArray, "elrexfio");
    setElrexfioDuplicatePhaseWarning(duplicates.length > 0 ? duplicates : null);

    const missingStepUp = CheckMissingStepUpDosesRealtime(
      doseArray,
      "elrexfio",
    );
    setElrexfioMissingStepUpWarning(missingStepUp);
  };

  useEffect(() => {
    if (elrexvayliDetails && elrexvayliDetails.length > 0) {
      runElrexWarnings(elrexvayliDetails);
    }
  }, [elrexvayliDetails]);

  const runLinvoWarnings = (doseArray) => {
    const duplicates = CheckDuplicatePhasesRealtime(doseArray, "linvo");
    setLinvoDuplicatePhaseWarning(duplicates.length > 0 ? duplicates : null);

    const missingStepUp = CheckMissingStepUpDosesRealtime(doseArray, "linvo");
    setLinvoMissingStepUpWarning(missingStepUp);
  };

  useEffect(() => {
    if (linvoveyDetails?.length) {
      runLinvoWarnings(linvoveyDetails);
    }
  }, [linvoveyDetails]);

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>
      <section className="main-survey-section">
        <div>
          <SideBarMenu activePageId={SideMenuItems.ELCharacteristics} />
          <div id="main" className="col-pad-left">
            <>
              <button
                className={isSideMenuActive ? "openbtn" : "openbtn active"}
                // onclick="toggleNav()"
                onClick={() => toggleNav()}
              >
                <i
                  id="arrowNavigation"
                  className="fa fa-arrow-left"
                  aria-hidden="true"
                ></i>
              </button>
            </>

            <div className="survey-section-content">
              <div className="survey-section-content-header">
                <h4>ELRANATAMAB AND LINVOSELTAMAB CHARACTERISTICS </h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}

              <div className="survey-question-section">
                <div className="survey-question-content">
                  <div className="question-answer">
                    {(isLinvoveySelected || isElrexvayliSelected) && (
                      <>
                        <div>
                          <div className="question question-weight">
                            <span>Q36.</span>

                            <span className="quest-text-pad">
                              Provide dosing information for each administration
                              of
                              <>
                                {" "}
                                {isElrexvayliSelected && isLinvoveySelected ? (
                                  <>
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      ELREXFIO<sup>TM</sup> (elranatamab-bcmm)
                                    </span>{" "}
                                    from the initiation of treatment on
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      {" "}
                                      {elrexIndexDate} until{" "}
                                      {elrvayliDateRRMM}{" "}
                                    </span>
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      and LYNOZYFIC
                                      <sup className="supscript">TM</sup>{" "}
                                      (linvoquetamab-gcpt)
                                    </span>{" "}
                                    from the initiation of treatment on
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      {" "}
                                      {linvoIndexDate} until {linvoveyDateRRMM}
                                    </span>
                                    .{" "}
                                    <b>
                                      Please add additional rows to enter the
                                      date of each dose administration.
                                    </b>
                                    <br />
                                    <br />
                                  </>
                                ) : isElrexvayliSelected ? (
                                  <>
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      ELREXFIO<sup>TM</sup> (elranatamab-bcmm)
                                    </span>{" "}
                                    from the initiation of treatment on
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      {" "}
                                      {showElrDate()} until {elrvayliDateRRMM}
                                    </span>
                                    .{" "}
                                    <b>
                                      Please add additional rows to enter the
                                      date of each dose administration.
                                    </b>
                                    <br />
                                    <br />
                                  </>
                                ) : isLinvoveySelected ? (
                                  <>
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      LYNOZYFIC
                                      <sup className="supscript">TM</sup>{" "}
                                      (linvoquetamab-gcpt)
                                    </span>{" "}
                                    from the initiation of treatment on
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                        fontWeight: "bolder",
                                      }}
                                    >
                                      {" "}
                                      {showLinvoDate()} until {linvoveyDateRRMM}
                                    </span>
                                    .{" "}
                                    <b>
                                      Please add additional rows to enter the
                                      date of each dose administration.
                                    </b>
                                    <br />
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}{" "}
                              </>
                              If the dosing phase is not documented, please
                              infer the dosing phase using the relevant dosing
                              label information provided.
                            </span>
                          </div>
                          <ErrorField
                            show={elrNumberofAdministratorMatching}
                            message={ELCharacteristics_MSGS.RRMMNotMatchingElr}
                            style={{ paddingLeft: "0px" }}
                          />

                          <ErrorField
                            show={linvoNumberofAdministratorMatching}
                            message={
                              ELCharacteristics_MSGS.RRMMNotMatchingLinvo
                            }
                            style={{ paddingLeft: "0px" }}
                          />

                          <ErrorField
                            show={indexDateRRMM_elrHard}
                            message={
                              ELCharacteristics_MSGS.indexDateRRMMNotMatchingElr
                            }
                            style={{ paddingLeft: "50px" }}
                          />

                          {isElrexvayliSelected && (
                            <>
                              <div className="dependent-section">
                                <ErrorField
                                  show={elrexDuplicateDates}
                                  message={
                                    "ELREXFIO cannot have duplicate date of dose administration."
                                  }
                                  style={{ paddingLeft: "0px" }}
                                />

                                <ErrorField
                                  show={elrexfioDuplicatePhaseWarning}
                                  message={
                                    ELCharacteristics_MSGS.IdenticalWarning
                                  }
                                  style={{ paddingLeft: "0px" }}
                                />
                                <ErrorField
                                  show={elrexfioMissingStepUpWarning}
                                  message={ELCharacteristics_MSGS.StepUpWarning}
                                  style={{ paddingLeft: "0px" }}
                                />

                                <ErrorField
                                  show={dt_elr_2L_3L_date_conditions}
                                  message={
                                    ELCharacteristics_MSGS.Q362L3LErrorMessage
                                  }
                                  style={{
                                    paddingLeft: "0px",
                                  }}
                                />

                                <ErrorField
                                  show={!isElrLastAdminDateValid}
                                  message={
                                    ELCharacteristics_MSGS.DoseMustMatchLastAdministrationDateElr
                                  }
                                  style={{
                                    paddingLeft: "0px",
                                    paddingBottom: "2px",
                                  }}
                                />

                                {elrexvayliDetails &&
                                  elrexvayliDetails.length > 0 &&
                                  elrexvayliDetails.map((data, idx) => (
                                    <div className="loop-section-ul" key={idx}>
                                      <div className="loop-head">
                                        <span
                                          className="question-weight"
                                          style={{ float: "inline-start" }}
                                        >
                                          {GetOrdinal(idx + 1)} ELREXFIO
                                          <sup>TM</sup> (elranatamab-bcmm)
                                        </span>
                                        {idx != 0 && (
                                          <div
                                            className="delete-btn-div"
                                            style={{ float: "inline-end" }}
                                          >
                                            <img
                                              width="16px"
                                              src="../Assets/images/Icon-material-delete.png"
                                              alt=""
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                DeleteElrexvayliRow(idx)
                                              }
                                            />
                                          </div>
                                        )}
                                      </div>

                                      {/* ELREXFIO® */}
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            className="date-picker-ttchar"
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Date of dose administration
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "20%",
                                                  }}
                                                >
                                                  {" "}
                                                  <span
                                                    data-tooltip-id="encounterTip"
                                                    className="modal-popup"
                                                    onClick={() =>
                                                      setShowHideHyperlinkModalQ36Tecvayli(
                                                        true,
                                                      )
                                                    }
                                                  >
                                                    Dosing phase
                                                  </span>
                                                  {showHideHyperlinkModalQ36Tecvayli && (
                                                    <InfoPopUp
                                                      description={
                                                        hyperlinkTextQ36Elrexfio
                                                      }
                                                      OkClick={() =>
                                                        setShowHideHyperlinkModalQ36Tecvayli(
                                                          false,
                                                        )
                                                      }
                                                    />
                                                  )}{" "}
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Site of care
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    minWidth: "280px",
                                                  }}
                                                >
                                                  Dose strength
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    ELREXFIO<sup>TM</sup>{" "}
                                                    (elranatamab-bcmm)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "dose_administration_elr" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.dose_administration_elr ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                          marginLeft: "-5px",
                                                        }}
                                                      >
                                                        <DatePickerComponent
                                                          ctrlId={
                                                            "dose_administration_elr_dt-" +
                                                            idx
                                                          }
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          // optionId={1}
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                          date={
                                                            data.dose_administration_elr_dt
                                                          }
                                                        />
                                                      </span>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dose_administration_elr" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            data.dose_administration_elr ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Date of dose
                                                          administration unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.dose_administration_elrHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.administrationEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.dose_administration_elrHard_dt
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.administrationEmptyDate
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.dt_elr_date_out_of_bound
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.Q36DateOutOfBound
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Invalid_dose_administration_elr_dt
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.dose_administration_elr_dt_before_eof
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.DateBeforeEOF
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_elr" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.dosing_phase_elr ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Step-up dose 1{" "}
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_elr" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.dosing_phase_elr ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Step-up dose 2
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_elr" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            data.dosing_phase_elr ===
                                                            3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          1<sup>st</sup>{" "}
                                                          treatment dose
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_elr" +
                                                            idx
                                                          }
                                                          value={4}
                                                          checked={
                                                            data.dosing_phase_elr ===
                                                            4
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Subsequent treatment
                                                          doses
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.dosing_phase_elrHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.dosingphaseEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.dosing_phase_elrHard_othEmpty
                                                      }
                                                      message={
                                                        "Please enter the text"
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "siteofcare_elr" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.siteofcare_elr ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Inpatient{" "}
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "siteofcare_elr" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.siteofcare_elr ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Outpatient
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.siteofcare_elrHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.siteofcareEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="option-fbox">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "elr_dose_strength_rbl" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.elr_dose_strength_rbl ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                      </label>
                                                      <label>
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-sm"
                                                            id={idx}
                                                            name={
                                                              "elr_dose_strength_mg" +
                                                              idx
                                                            }
                                                            value={
                                                              data.elr_dose_strength_mg
                                                            }
                                                            type="text"
                                                            onKeyDown={
                                                              AllowNumericWithDecimal
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </span>
                                                        mg
                                                      </label>
                                                    </div>
                                                    <br />
                                                    <div className="option-fbox">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "elr_dose_strength_rbl" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.elr_dose_strength_rbl ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                      </label>
                                                      <label>
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-sm"
                                                            id={idx}
                                                            name={
                                                              "elr_dose_strength_mg_kg" +
                                                              idx
                                                            }
                                                            value={
                                                              data.elr_dose_strength_mg_kg
                                                            }
                                                            type="text"
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, and delete
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }

                                                              // Prevent non-numeric characters, except '.'
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );

                                                              // Prevent multiple '.'
                                                              if (
                                                                e.key === "." &&
                                                                value.includes(
                                                                  ".",
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                            }}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </span>
                                                        mg/kg
                                                      </label>
                                                    </div>
                                                    <br />
                                                    <div className="option-fbox">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "elr_dose_strength_rbl" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            data.elr_dose_strength_rbl ===
                                                            3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                      </label>
                                                      <label>
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-sm"
                                                            id={idx}
                                                            name={
                                                              "elr_dose_strength_mgm" +
                                                              idx
                                                            }
                                                            value={
                                                              data.elr_dose_strength_mgm
                                                            }
                                                            type="text"
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, and delete
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }

                                                              // Prevent non-numeric characters, except '.'
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );

                                                              // Prevent multiple '.'
                                                              if (
                                                                e.key === "." &&
                                                                value.includes(
                                                                  ".",
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                            }}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </span>
                                                        &nbsp; mg/m<sup>2</sup>
                                                      </label>
                                                      {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                                    </div>
                                                    <div className="">
                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "elr_dose_strength_rbl" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.elr_dose_strength_rbl ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.elr_dose_strength_mg_kgHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.DecimalRange
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.elr_dose_strength_mg_kgRange
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.DecimalRange
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  ))}

                                {elrexvayliDetails &&
                                  elrexvayliDetails.length > 0 &&
                                  elrexvayliDetails.length < 550 && (
                                    <div className="sub-question-bot-sapce-ul mt-2">
                                      <div
                                        className="answer-list-text"
                                        onClick={AddElrexvayliRow}
                                      >
                                        <a>
                                          <img
                                            width="18px"
                                            src="../Assets/images/plus.png"
                                            alt=""
                                          />
                                        </a>
                                        <a className="radio-text-padding">
                                          Click here to add another dose
                                          administration of elranatamab
                                        </a>
                                      </div>
                                    </div>
                                  )}
                              </div>
                              {/* 36.1 Elrex start */}
                              <div>
                                <div className="dependent-section sub-question marginleft15">
                                  <div
                                    className="question question-weight"
                                    style={{ marginBottom: "10px" }}
                                  >
                                    <span>Q36.1.</span>
                                    <span className="quest-text-pad">
                                      Please list{" "}
                                      <u>
                                        all hospitalizations that occurred
                                        during the step-up dosing phase.
                                      </u>
                                      Please specify the date of admission, date
                                      of discharge, and reason for
                                      hospitalization.{" "}
                                    </span>
                                  </div>
                                  <ErrorField
                                    show={elrInpatientHospMissing}
                                    message={
                                      ELCharacteristics_MSGS.ELREXFIO_INPATIENT_HOSP_MISSING
                                    }
                                    style={{ paddingLeft: "0px" }}
                                  />
                                  <ErrorField
                                    show={elrHospDateChainInvalid}
                                    message={
                                      ELCharacteristics_MSGS.EarliestDateInvalid
                                    }
                                    style={{ paddingLeft: "0px" }}
                                  />

                                  {elrHospDetails &&
                                    elrHospDetails.length > 0 &&
                                    elrHospDetails.map((data, idx) => (
                                      <div
                                        className="loop-section-ul"
                                        key={idx}
                                      >
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} ELREXFIO
                                            <sup>TM</sup> (elranatamab-bcmm)
                                            Hospitalization
                                          </span>

                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  DeleteElrHospRow(idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        {/* ELREXFIO® */}
                                        <div className="question-bot-sapce">
                                          <div className="sub-question grid-overflow">
                                            <table
                                              style={{
                                                border: "1px solid black",
                                                borderCollapse: "collapse",
                                                width: "100%",
                                              }}
                                            >
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      // width: "25%"
                                                    }}
                                                  >
                                                    Treatment
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      // width: "20%"
                                                    }}
                                                  >
                                                    Date of admission
                                                  </th>
                                                  {data.dt_admission != null &&
                                                    data.dt_admission !== 2 && (
                                                      <>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            // width: "20%"
                                                          }}
                                                        >
                                                          Date of discharge
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            // width: "35%"
                                                          }}
                                                        >
                                                          Reason of
                                                          hospitalization
                                                        </th>
                                                      </>
                                                    )}
                                                </tr>
                                              </thead>

                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <span className="quest-text-pad">
                                                      ELREXFIO<sup>TM</sup>{" "}
                                                      (elranatamab-bcmm)
                                                    </span>
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "dt_admission_elr" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.dt_admission ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          <DatePickerComponent
                                                            ctrlId={
                                                              "dt_admission_dt_elr-" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            // optionId={1}
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                            date={
                                                              data.dt_admission_dt
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "dt_admission_elr" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.dt_admission ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Date of admission
                                                            unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "dt_admission_elr" +
                                                              idx
                                                            }
                                                            value={2}
                                                            checked={
                                                              data.dt_admission ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Patient had no
                                                            hospitalizations
                                                            during the step-up
                                                            dosing phase
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_Hard
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.admissionEmpty_linvo
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_Hard_dt
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.admissionEmptyDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Invalid_admission_Hard_dt
                                                        }
                                                        message={
                                                          CommonError_Msgs.InvalidDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_before_eof
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.DateBeforeEOF
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_out_of_bound
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.Q36DateOutOfBound
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  {data.dt_admission != null &&
                                                    data.dt_admission !== 2 && (
                                                      <>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={idx}
                                                                name={
                                                                  "dt_discharge_elr" +
                                                                  idx
                                                                }
                                                                value={1}
                                                                checked={
                                                                  data.dt_discharge ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                <DatePickerComponent
                                                                  ctrlId={
                                                                    "dt_discharge_dt_elr-" +
                                                                    idx
                                                                  }
                                                                  HandleDateChange={
                                                                    HandleRepeaterDateChange
                                                                  }
                                                                  // optionId={1}
                                                                  minDate={dayjs(
                                                                    "01-01-1920",
                                                                  )}
                                                                  maxDate={dayjs()}
                                                                  locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                                  date={
                                                                    data.dt_discharge_dt
                                                                  }
                                                                />
                                                              </span>
                                                            </div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="radio"
                                                                  style={{
                                                                    marginTop:
                                                                      "6px",
                                                                  }}
                                                                  id={idx}
                                                                  name={
                                                                    "dt_discharge_elr" +
                                                                    idx
                                                                  }
                                                                  value={99}
                                                                  checked={
                                                                    data.dt_discharge ===
                                                                    99
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />

                                                                <span
                                                                  className="radio-text-padding"
                                                                  style={{
                                                                    paddingLeft:
                                                                      "10px",
                                                                  }}
                                                                >
                                                                  Date of
                                                                  discharge
                                                                  unknown
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="radio"
                                                                  style={{
                                                                    marginTop:
                                                                      "6px",
                                                                  }}
                                                                  id={idx}
                                                                  name={
                                                                    "dt_discharge_elr" +
                                                                    idx
                                                                  }
                                                                  value={2}
                                                                  checked={
                                                                    data.dt_discharge ===
                                                                    2
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />

                                                                <span
                                                                  className="radio-text-padding"
                                                                  style={{
                                                                    paddingLeft:
                                                                      "10px",
                                                                  }}
                                                                >
                                                                  Patient is
                                                                  still
                                                                  hospitalized
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_Hard
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.dischargeEmpty_linvo
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_Hard_dt
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.dischargeEmptyDate
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_Hard_dt_check
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.dischargeDateCheck
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_out_of_bound
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.Q36DateOutOfBound
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.dateRangeThirty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.DateRangeThirty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.Invalid_dt_discharge_Hard
                                                              }
                                                              message={
                                                                CommonError_Msgs.InvalidDate
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_before_eof
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.DateBeforeEOF
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason1_elr" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason1
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Administration
                                                                  of elranatamab
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason2_elr" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason2
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Monitoring of
                                                                  adverse event
                                                                  (AE) as part
                                                                  of the
                                                                  treatment
                                                                  plan{" "}
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason3_elr" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason3
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Management of
                                                                  cytokine
                                                                  release
                                                                  syndrome (CRS)
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason4_elr" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason4
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Management of
                                                                  immune
                                                                  effector
                                                                  cell-associated
                                                                  neurotoxicity
                                                                  syndrome
                                                                  (ICANS)
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason5_elr" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason5
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Management of
                                                                  other AE
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason6_elr" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason6
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "4px",
                                                                    paddingRight:
                                                                      "15px",
                                                                    marginBottom:
                                                                      "0px",
                                                                    padding:
                                                                      "0",
                                                                  }}
                                                                >
                                                                  Other non-AE
                                                                  related
                                                                  reasons,
                                                                  please
                                                                  specify:
                                                                  <div
                                                                    style={{
                                                                      paddingLeft:
                                                                        "15px",
                                                                      marginBottom:
                                                                        "0px",
                                                                      padding:
                                                                        "0",
                                                                    }}
                                                                  >
                                                                    <textarea
                                                                      name={
                                                                        "hosp_reason_oth_txt_elr" +
                                                                        idx
                                                                      }
                                                                      className="input-dash"
                                                                      type="text"
                                                                      value={
                                                                        data.hosp_reason_oth_txt
                                                                      }
                                                                      onChange={
                                                                        HandleRepeaterFieldChange
                                                                      }
                                                                      maxLength={
                                                                        300
                                                                      }
                                                                      id={idx}
                                                                    />
                                                                  </div>
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="radio"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReasonUnk_elr" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReasonUnk
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Unknown
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <ErrorField
                                                              show={
                                                                data.hospReasonEmptyHard
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.Q40ReasonEmptyHard
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.hospReasonTxtEmpty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.Q36Point1ReasonTxtEmpty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                      </>
                                                    )}
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ))}

                                  {elrHospDetails &&
                                    elrHospDetails.length > 0 &&
                                    elrHospDetails.length < 550 &&
                                    elrHospDetails[elrHospDetails.length - 1]
                                      .dt_admission != null &&
                                    elrHospDetails[elrHospDetails.length - 1]
                                      .dt_admission !== 2 && (
                                      <div className="sub-question-bot-sapce-ul mt-2">
                                        <div
                                          className="answer-list-text"
                                          onClick={AddElrHospRow}
                                        >
                                          <a>
                                            <img
                                              width="18px"
                                              src="../Assets/images/plus.png"
                                              alt=""
                                            />
                                          </a>
                                          <a className="radio-text-padding">
                                            Click here to add another
                                            hospitalization of ELREXFIO
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>
                              {/* 36.1 Tecvayli end */}
                            </>
                          )}
                          {/* Table 2 Linvoseltamab */}

                          {isLinvoveySelected && (
                            <>
                              <div className="dependent-section">
                                <ErrorField
                                  show={linvoDuplicateDates}
                                  message={
                                    "LINVOSELTAMAB cannot have duplicate date of dose administration."
                                  }
                                  style={{ paddingLeft: "0px" }}
                                />

                                <ErrorField
                                  show={linvoDuplicatePhaseWarning}
                                  message={
                                    ELCharacteristics_MSGS.IdenticalWarning
                                  }
                                  style={{ paddingLeft: "0px" }}
                                />
                                <ErrorField
                                  show={linvoMissingStepUpWarning}
                                  message={ELCharacteristics_MSGS.StepUpWarning}
                                  style={{ paddingLeft: "0px" }}
                                />

                                <ErrorField
                                  show={dt_lino_2L_3L_date_conditions}
                                  message={
                                    ELCharacteristics_MSGS.Q362L3LErrorMessage
                                  }
                                  style={{
                                    paddingLeft: "0px",
                                  }}
                                />

                                <ErrorField
                                  show={indexDateRRMM_linvoHard}
                                  message={
                                    ELCharacteristics_MSGS.indexDateRRMMNotMatchingLinvo
                                  }
                                  style={{
                                    paddingLeft: "0px",
                                    paddingBottom: "2px",
                                  }}
                                />
                                <ErrorField
                                  show={!isLinvoLastAdminDateValid}
                                  message={
                                    ELCharacteristics_MSGS.DoseMustMatchLastAdministrationDateLinvo
                                  }
                                  style={{
                                    paddingLeft: "0px",
                                    paddingBottom: "2px",
                                  }}
                                />

                                {linvoveyDetails &&
                                  linvoveyDetails.length > 0 &&
                                  linvoveyDetails.map((data, idx) => (
                                    <div className="loop-section-ul" key={idx}>
                                      <div className="loop-head">
                                        <span
                                          className="question-weight"
                                          style={{ float: "inline-start" }}
                                        >
                                          {GetOrdinal(idx + 1)} LYNOZYFIC{" "}
                                          <sup className="supscript">TM</sup>{" "}
                                          (linvoquetamab-gcpt)
                                        </span>

                                        {idx != 0 && (
                                          <div
                                            className="delete-btn-div"
                                            style={{ float: "inline-end" }}
                                          >
                                            <img
                                              width="16px"
                                              src="../Assets/images/Icon-material-delete.png"
                                              alt=""
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                DeleteLinvoveyRow(idx)
                                              }
                                            />
                                          </div>
                                        )}
                                      </div>

                                      {/* ELREXFIO® */}
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Date of dose administration
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "20%",
                                                  }}
                                                >
                                                  {" "}
                                                  <span
                                                    data-tooltip-id="encounterTip"
                                                    className="modal-popup"
                                                    onClick={() =>
                                                      setShowHideHyperlinkModalQ36Linvoseltamab(
                                                        true,
                                                      )
                                                    }
                                                  >
                                                    Dosing phase
                                                  </span>
                                                  {showHideHyperlinkModalQ36Linvoseltamab && (
                                                    <InfoPopUp
                                                      description={
                                                        hyperlinkTextQ36Linvoseltamab
                                                      }
                                                      OkClick={() =>
                                                        setShowHideHyperlinkModalQ36Linvoseltamab(
                                                          false,
                                                        )
                                                      }
                                                    />
                                                  )}{" "}
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Site of care
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    minWidth: "280px",
                                                  }}
                                                >
                                                  Dose strength
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    LYNOZYFIC<sup>TM</sup>{" "}
                                                    (linvoquetamab-gcpt)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "dose_administration_linvo" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.dose_administration_linvo ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                          marginLeft: "-5px",
                                                        }}
                                                      >
                                                        <DatePickerComponent
                                                          ctrlId={
                                                            "dose_administration_linvo_dt-" +
                                                            idx
                                                          }
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          // optionId={1}
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                          date={
                                                            data.dose_administration_linvo_dt
                                                          }
                                                        />
                                                      </span>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dose_administration_linvo" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            data.dose_administration_linvo ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Date of dose
                                                          administration unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.dose_administration_linvoHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.administrationEmpty_linvo
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.dose_administration_linvoHard_dt
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.administrationEmptyDate
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.dt_linvo_date_out_of_bound
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.Q36DateOutOfBound
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Invalid_dose_administration_linvo_dt
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_linvo" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.dosing_phase_linvo ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Step-up dose 1{" "}
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_linvo" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.dosing_phase_linvo ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Step-up dose 2
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_linvo" +
                                                            idx
                                                          }
                                                          value={4}
                                                          checked={
                                                            data.dosing_phase_linvo ===
                                                            4
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          1<sup>st</sup>{" "}
                                                          treatment dose
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "dosing_phase_linvo" +
                                                            idx
                                                          }
                                                          value={5}
                                                          checked={
                                                            data.dosing_phase_linvo ===
                                                            5
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Subsequent treatment
                                                          doses
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.dosing_phase_linvoHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.dosingphaseEmpty_linvo
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.dosing_phase_linvoHard_othEmpty
                                                      }
                                                      message={
                                                        "Please enter the text"
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "siteofcare_linvo" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.siteofcare_linvo ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Inpatient{" "}
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "siteofcare_linvo" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.siteofcare_linvo ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          // className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Outpatient
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.siteofcare_linvoHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.siteofcareEmpty_linvo
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="option-fbox">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "linvo_dose_strength_rbl" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.linvo_dose_strength_rbl ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                      </label>
                                                      <label>
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-sm"
                                                            id={idx}
                                                            name={
                                                              "linvo_dose_strength_mg" +
                                                              idx
                                                            }
                                                            value={
                                                              data.linvo_dose_strength_mg
                                                            }
                                                            type="text"
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, and delete
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }

                                                              // Prevent non-numeric characters, except '.'
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );

                                                              // Prevent multiple '.'
                                                              if (
                                                                e.key === "." &&
                                                                value.includes(
                                                                  ".",
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                            }}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </span>
                                                        mg
                                                      </label>
                                                    </div>
                                                    <br />
                                                    <div className="option-fbox">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "linvo_dose_strength_rbl" +
                                                            idx
                                                          }
                                                          value={2}
                                                          checked={
                                                            data.linvo_dose_strength_rbl ===
                                                            2
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                      </label>
                                                      <label>
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-sm"
                                                            id={idx}
                                                            name={
                                                              "linvo_dose_strength_mg_kg" +
                                                              idx
                                                            }
                                                            value={
                                                              data.linvo_dose_strength_mg_kg
                                                            }
                                                            type="text"
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, and delete
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }

                                                              // Prevent non-numeric characters, except '.'
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );

                                                              // Prevent multiple '.'
                                                              if (
                                                                e.key === "." &&
                                                                value.includes(
                                                                  ".",
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                            }}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </span>
                                                        mg/kg
                                                      </label>
                                                    </div>
                                                    <br />
                                                    <div className="option-fbox">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "linvo_dose_strength_rbl" +
                                                            idx
                                                          }
                                                          value={3}
                                                          checked={
                                                            data.linvo_dose_strength_rbl ===
                                                            3
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                      </label>
                                                      <label>
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-sm"
                                                            id={idx}
                                                            name={
                                                              "linvo_dose_strength_mgm" +
                                                              idx
                                                            }
                                                            value={
                                                              data.linvo_dose_strength_mgm
                                                            }
                                                            type="text"
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, and delete
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }

                                                              // Prevent non-numeric characters, except '.'
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );

                                                              // Prevent multiple '.'
                                                              if (
                                                                e.key === "." &&
                                                                value.includes(
                                                                  ".",
                                                                )
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }

                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                            }}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                        </span>
                                                        &nbsp; mg/m<sup>2</sup>
                                                      </label>
                                                    </div>
                                                    <br />
                                                    <div className="">
                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "linvo_dose_strength_rbl" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.linvo_dose_strength_rbl ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />

                                                          <span className="radio-text-padding">
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.linvo_dose_strength_mg_kgHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.DecimalRange
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.linvo_dose_strength_mg_kgRange
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.DecimalRange
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  ))}

                                {linvoveyDetails &&
                                  linvoveyDetails.length > 0 &&
                                  linvoveyDetails.length < 550 && (
                                    <div className="sub-question-bot-sapce-ul mt-2">
                                      <div
                                        className="answer-list-text"
                                        onClick={AddLinvoveyRow}
                                      >
                                        <a>
                                          <img
                                            width="18px"
                                            src="../Assets/images/plus.png"
                                            alt=""
                                          />
                                        </a>
                                        <a className="radio-text-padding">
                                          Click here to add another dose
                                          administration of Linvoseltamab
                                        </a>
                                      </div>
                                    </div>
                                  )}
                              </div>
                              {/* 36.1 Linvoseltamab start */}
                              <div>
                                <div className="dependent-section sub-question marginleft15">
                                  <div
                                    className="question question-weight"
                                    style={{ marginBottom: "10px" }}
                                  >
                                    <span>Q36.1.</span>
                                    <span className="quest-text-pad">
                                      Please list{" "}
                                      <u>
                                        all hospitalizations that occurred
                                        during the step-up dosing phase.
                                      </u>
                                      Please specify the date of admission, date
                                      of discharge, and reason for
                                      hospitalization.{" "}
                                    </span>
                                  </div>
                                  <ErrorField
                                    show={linvoInpatientHospMissing}
                                    message={
                                      ELCharacteristics_MSGS.LINVO_INPATIENT_HOSP_MISSING
                                    }
                                    style={{ paddingLeft: "0px" }}
                                  />
                                  <ErrorField
                                    show={linvoHospDateChainInvalid}
                                    message={
                                      ELCharacteristics_MSGS.EarliestDateInvalid
                                    }
                                    style={{ paddingLeft: "0px" }}
                                  />
                                  {linvoHospDetails &&
                                    linvoHospDetails.length > 0 &&
                                    linvoHospDetails.map((data, idx) => (
                                      <div
                                        className="loop-section-ul"
                                        key={idx}
                                      >
                                        <div className="loop-head">
                                          <span
                                            className="question-weight"
                                            style={{ float: "inline-start" }}
                                          >
                                            {GetOrdinal(idx + 1)} LYNOZYFIC{" "}
                                            <sup className="supscript">TM</sup>{" "}
                                            (linvoquetamab-gcpt)
                                            Hospitalizations
                                          </span>

                                          {idx != 0 && (
                                            <div
                                              className="delete-btn-div"
                                              style={{ float: "inline-end" }}
                                            >
                                              <img
                                                width="16px"
                                                src="../Assets/images/Icon-material-delete.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  DeleteLinvoHospRow(idx)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>

                                        {/* ELREXFIO® */}
                                        <div className="question-bot-sapce">
                                          <div className="sub-question grid-overflow">
                                            <table
                                              style={{
                                                border: "1px solid black",
                                                borderCollapse: "collapse",
                                                width: "100%",
                                              }}
                                            >
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      // width: "25%"
                                                    }}
                                                  >
                                                    Treatment
                                                  </th>
                                                  <th
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                      // width: "20%"
                                                    }}
                                                  >
                                                    Date of admission
                                                  </th>
                                                  {data.dt_admission != null &&
                                                    data.dt_admission !== 2 && (
                                                      <>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            // width: "20%"
                                                          }}
                                                        >
                                                          Date of discharge
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            // width: "35%"
                                                          }}
                                                        >
                                                          Reason of
                                                          hospitalization
                                                        </th>
                                                      </>
                                                    )}
                                                </tr>
                                              </thead>

                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <span className="quest-text-pad">
                                                      LYNOZYFIC<sup>TM</sup>{" "}
                                                      (linvoquetamab-gcpt)
                                                    </span>
                                                  </td>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "dt_admission_linvo" +
                                                            idx
                                                          }
                                                          value={1}
                                                          checked={
                                                            data.dt_admission ===
                                                            1
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                            marginLeft: "-5px",
                                                          }}
                                                        >
                                                          <DatePickerComponent
                                                            ctrlId={
                                                              "dt_admission_dt_linvo-" +
                                                              idx
                                                            }
                                                            HandleDateChange={
                                                              HandleRepeaterDateChange
                                                            }
                                                            // optionId={1}
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                            date={
                                                              data.dt_admission_dt
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "dt_admission_linvo" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.dt_admission ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Date of admission
                                                            unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "dt_admission_linvo" +
                                                              idx
                                                            }
                                                            value={2}
                                                            checked={
                                                              data.dt_admission ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Patient had no
                                                            hospitalizations
                                                            during the step-up
                                                            dosing phase
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_Hard
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.admissionEmpty_linvo
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_Hard_dt
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.admissionEmptyDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.Invalid_admission_Hard_dt
                                                        }
                                                        message={
                                                          CommonError_Msgs.InvalidDate
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_before_eof
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.DateBeforeEOF
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.dt_admission_out_of_bound
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.Q36DateOutOfBound
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                  {data.dt_admission != null &&
                                                    data.dt_admission !== 2 && (
                                                      <>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={idx}
                                                                name={
                                                                  "dt_discharge_linvo" +
                                                                  idx
                                                                }
                                                                value={1}
                                                                checked={
                                                                  data.dt_discharge ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                {/* <DateControl
                                                                  ctrlId={
                                                                    "dt_discharge_dt_linvo-" +
                                                                    idx
                                                                  }
                                                                  HandleDateChange={
                                                                    HandleRepeaterDateChange
                                                                  }
                                                                  date={
                                                                    data.dt_discharge_dt
                                                                  }
                                                                /> */}

                                                                <DatePickerComponent
                                                                  ctrlId={
                                                                    "dt_discharge_dt_linvo-" +
                                                                    idx
                                                                  }
                                                                  // selectedDate={selectedDate}
                                                                  //onDateChange={(newDate) => setSelectedDate(newDate)}
                                                                  HandleDateChange={
                                                                    HandleRepeaterDateChange
                                                                  }
                                                                  // optionId={1}
                                                                  minDate={dayjs(
                                                                    "01-01-1920",
                                                                  )}
                                                                  maxDate={dayjs()}
                                                                  locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                                  date={
                                                                    data.dt_discharge_dt
                                                                  }
                                                                />
                                                              </span>
                                                            </div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="radio"
                                                                  style={{
                                                                    marginTop:
                                                                      "6px",
                                                                  }}
                                                                  id={idx}
                                                                  name={
                                                                    "dt_discharge_linvo" +
                                                                    idx
                                                                  }
                                                                  value={99}
                                                                  checked={
                                                                    data.dt_discharge ===
                                                                    99
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />

                                                                <span
                                                                  className="radio-text-padding"
                                                                  style={{
                                                                    paddingLeft:
                                                                      "10px",
                                                                  }}
                                                                >
                                                                  Date of
                                                                  discharge
                                                                  unknown
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="radio"
                                                                  style={{
                                                                    marginTop:
                                                                      "6px",
                                                                  }}
                                                                  id={idx}
                                                                  name={
                                                                    "dt_discharge_linvo" +
                                                                    idx
                                                                  }
                                                                  value={2}
                                                                  checked={
                                                                    data.dt_discharge ===
                                                                    2
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />

                                                                <span
                                                                  className="radio-text-padding"
                                                                  style={{
                                                                    paddingLeft:
                                                                      "10px",
                                                                  }}
                                                                >
                                                                  Patient is
                                                                  still
                                                                  hospitalized
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_Hard
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.dischargeEmpty_linvo
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_Hard_dt
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.dischargeEmptyDate
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_Hard_dt_check
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.dischargeDateCheck
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_out_of_bound
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.Q36DateOutOfBound
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.dateRangeThirty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.DateRangeThirty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                data.Invalid_dt_discharge_Hard
                                                              }
                                                              message={
                                                                CommonError_Msgs.InvalidDate
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.dt_discharge_before_eof
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.DateBeforeEOF
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason1_linvo" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason1
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Administration
                                                                  of
                                                                  linvoseltamab
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason2_linvo" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason2
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Monitoring of
                                                                  adverse event
                                                                  (AE) as part
                                                                  of the
                                                                  treatment
                                                                  plan{" "}
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason3_linvo" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason3
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Management of
                                                                  cytokine
                                                                  release
                                                                  syndrome (CRS)
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason4_linvo" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason4
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Management of
                                                                  immune
                                                                  effector
                                                                  cell-associated
                                                                  neurotoxicity
                                                                  syndrome
                                                                  (ICANS)
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason5_linvo" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason5
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Management of
                                                                  other AE
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="checkbox"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReason6_linvo" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReason6
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "4px",
                                                                    paddingRight:
                                                                      "15px",
                                                                    marginBottom:
                                                                      "0px",
                                                                    padding:
                                                                      "0",
                                                                  }}
                                                                >
                                                                  Other non-AE
                                                                  related
                                                                  reasons,
                                                                  please
                                                                  specify:
                                                                  <div
                                                                    style={{
                                                                      paddingLeft:
                                                                        "15px",
                                                                      marginBottom:
                                                                        "0px",
                                                                      padding:
                                                                        "0",
                                                                    }}
                                                                  >
                                                                    <textarea
                                                                      name={
                                                                        "hosp_reason_oth_txt_linvo" +
                                                                        idx
                                                                      }
                                                                      className="input-dash"
                                                                      type="text"
                                                                      value={
                                                                        data.hosp_reason_oth_txt
                                                                      }
                                                                      onChange={
                                                                        HandleRepeaterFieldChange
                                                                      }
                                                                      maxLength={
                                                                        300
                                                                      }
                                                                      id={idx}
                                                                    />
                                                                  </div>
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="long-text-option">
                                                                <input
                                                                  type="radio"
                                                                  id={idx}
                                                                  name={
                                                                    "hospReasonUnk_linvo" +
                                                                    idx
                                                                  }
                                                                  checked={
                                                                    data.hospReasonUnk
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "6px",
                                                                  }}
                                                                >
                                                                  Unknown
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <ErrorField
                                                              show={
                                                                data.hospReasonEmptyHard
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.Q40ReasonEmptyHard
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                data.hospReasonTxtEmpty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.Q36Point1ReasonTxtEmpty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                      </>
                                                    )}
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  {linvoHospDetails &&
                                    linvoHospDetails.length > 0 &&
                                    linvoHospDetails.length < 550 &&
                                    linvoHospDetails[
                                      linvoHospDetails.length - 1
                                    ].dt_admission != null &&
                                    linvoHospDetails[
                                      linvoHospDetails.length - 1
                                    ].dt_admission !== 2 && (
                                      <div className="sub-question-bot-sapce-ul mt-2">
                                        <div
                                          className="answer-list-text"
                                          onClick={AddLinvoHospRow}
                                        >
                                          <a>
                                            <img
                                              width="18px"
                                              src="../Assets/images/plus.png"
                                              alt=""
                                            />
                                          </a>
                                          <a className="radio-text-padding">
                                            Click here to add another
                                            hospitalization of Linvoseltamab
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>
                              {/* 36.1 Linvoseltamab end */}
                            </>
                          )}
                        </div>
                        {/* Q37 start --------------------------------------- */}
                        {isNewEcrfA === false && (
                          <>
                            <div>
                              <div className="question question-weight">
                                <span>Q37.</span>
                                <span className="quest-text-pad">
                                  Please indicate if any medication(s) had dose
                                  frequency reductions during treatment with{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                      fontWeight: "bolder",
                                    }}
                                  >
                                    {isElrexvayliSelected &&
                                    isLinvoveySelected ? (
                                      <>
                                        ELREXFIO<sup>TM</sup> (elranatamab-bcmm)
                                        and LYNOZYFIC
                                        <sup className="supscript">TM</sup>{" "}
                                        (linvoquetamab-gcpt).
                                      </>
                                    ) : isElrexvayliSelected ? (
                                      "ELREXFIO<sup>TM</sup> (elranatamab-bcmm)."
                                    ) : isLinvoveySelected ? (
                                      <>
                                        LYNOZYFIC
                                        <sup className="supscript">TM</sup>{" "}
                                        (linvoquetamab-gcpt).
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </span>{" "}
                                </span>
                              </div>
                              {isElrexvayliSelected &&
                                Q37ElrexDetails &&
                                Q37ElrexDetails.length > 0 && (
                                  <ErrorField
                                    show={
                                      Q37ElrexDetails[0]
                                        .q37SubsequentDoseConflict
                                    }
                                    message={
                                      ELCharacteristics_MSGS.q37SubsequentDoseConflict
                                    }
                                    style={{
                                      paddingLeft: "0px",
                                      marginBottom: "10px",
                                    }}
                                  />
                                )}

                              {isLinvoveySelected &&
                                Q37LinvoDetails &&
                                Q37LinvoDetails.length > 0 && (
                                  <ErrorField
                                    show={
                                      Q37LinvoDetails[0]
                                        ?.q37LinvoSubsequentDoseConflict
                                    }
                                    message={
                                      ELCharacteristics_MSGS.q37SubsequentDoseConflict
                                    }
                                    style={{
                                      paddingLeft: "0px",
                                      marginBottom: "10px",
                                    }}
                                  />
                                )}

                              <div className="question-bot-sapce">
                                <div className="sub-question grid-overflow">
                                  <table
                                    style={{
                                      border: "1px solid black",
                                      borderCollapse: "collapse",
                                      width: "100%",
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Treatment
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                            width: "25%",
                                          }}
                                        >
                                          Initial dosing frequency after the
                                          step-up dose is completed
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                            width: "25%",
                                          }}
                                        >
                                          Was the dosing frequency reduced for
                                          this medication at any point during
                                          the
                                          {/*                                   
                                   line of
                                  therapy */}
                                          <span
                                            data-tooltip-id="encounterTip"
                                            className="modal-popup"
                                            onClick={() =>
                                              setShowLineOfTherapyModal(true)
                                            }
                                          >
                                            {" "}
                                            {""} line of therapy
                                          </span>
                                          {showLineOfTherapyModal && (
                                            <InfoPopUp
                                              description={
                                                hyperlinkTextLineOfTherapy
                                              }
                                              OkClick={() =>
                                                setShowLineOfTherapyModal(false)
                                              }
                                            />
                                          )}{" "}
                                          ?
                                        </th>

                                        <th
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Initial dosing strength after step-up
                                          dose phase was completed
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {/* Elrex */}
                                      {isElrexvayliSelected && (
                                        <tr>
                                          {Q37ElrexDetails.length > 0 &&
                                            Q37ElrexDetails.map((data, idx) => (
                                              <React.Fragment key={idx}>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    ELREXFIO<sup>TM</sup>{" "}
                                                    (elranatamab-bcmm)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "q37_Elr_Dose_week_frquencyRd" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.q37_Elr_Dose_week_frquencyRd ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        The patient has not
                                                        completed the step-up
                                                        dosing phase
                                                      </span>
                                                    </label>
                                                  </div>

                                                  {elrexvayliDetails &&
                                                    elrexvayliDetails.length >
                                                      0 && (
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "q37_Elr_Dose_week_frquencyRd" +
                                                              idx
                                                            }
                                                            value={2}
                                                            checked={
                                                              data.q37_Elr_Dose_week_frquencyRd ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <span>
                                                              Once every &nbsp;
                                                            </span>
                                                            <span>
                                                              <input
                                                                className="input-dash-sm"
                                                                id={idx}
                                                                name={
                                                                  "q37_Elr_Dose_week_frquency_txt" +
                                                                  idx
                                                                }
                                                                value={
                                                                  data.q37_Elr_Dose_week_frquency_txt
                                                                }
                                                                type="text"
                                                                onKeyDown={(
                                                                  e,
                                                                ) => {
                                                                  // Allow backspace, arrow keys, and delete
                                                                  if (
                                                                    [
                                                                      "Backspace",
                                                                      "ArrowLeft",
                                                                      "ArrowRight",
                                                                      "Delete",
                                                                      "Tab",
                                                                    ].includes(
                                                                      e.key,
                                                                    )
                                                                  ) {
                                                                    return;
                                                                  }

                                                                  // Prevent non-numeric characters, except '.'
                                                                  if (
                                                                    !/[0-9.]/.test(
                                                                      e.key,
                                                                    )
                                                                  ) {
                                                                    e.preventDefault();
                                                                    return;
                                                                  }

                                                                  const value =
                                                                    e.target
                                                                      .value;
                                                                  const selectionStart =
                                                                    e.target
                                                                      .selectionStart;
                                                                  const newValue =
                                                                    value.slice(
                                                                      0,
                                                                      selectionStart,
                                                                    ) +
                                                                    e.key +
                                                                    value.slice(
                                                                      e.target
                                                                        .selectionEnd,
                                                                    );

                                                                  // Prevent multiple '.'
                                                                  if (
                                                                    e.key ===
                                                                      "." &&
                                                                    value.includes(
                                                                      ".",
                                                                    )
                                                                  ) {
                                                                    e.preventDefault();
                                                                    return;
                                                                  }

                                                                  // Prevent '.' as the first character
                                                                  if (
                                                                    e.key ===
                                                                      "." &&
                                                                    value === ""
                                                                  ) {
                                                                    e.preventDefault();
                                                                    return;
                                                                  }

                                                                  // Allow only one digit after decimal point
                                                                  if (
                                                                    newValue.includes(
                                                                      ".",
                                                                    ) &&
                                                                    newValue.split(
                                                                      ".",
                                                                    )[1]
                                                                      .length >
                                                                      2
                                                                  ) {
                                                                    e.preventDefault();
                                                                    return;
                                                                  }
                                                                }}
                                                                onChange={
                                                                  HandleFieldChange
                                                                }
                                                              />
                                                            </span>
                                                            week
                                                          </span>
                                                        </label>
                                                      </div>
                                                    )}
                                                  {/* new Unknown */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "q37_Elr_Dose_week_frquencyRd" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.q37_Elr_Dose_week_frquencyRd ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleFieldChange
                                                        }
                                                      />

                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.q37_Elr_Dose_week_frquencyRd_Empty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.admissionEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.q37_Elr_Dose_week_frquency_txt_Empty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.specifyDosageFrequency
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.q37_Elr_Dose_week_freq_range
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.allowedRange
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </td>

                                                {data.q37_Elr_Dose_week_frquencyRd !==
                                                1 ? (
                                                  <>
                                                    <td
                                                      style={{
                                                        border:
                                                          "1px solid black",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      <div>
                                                        <div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <label className="option-fbox">
                                                              <input
                                                                type="radio"
                                                                // id="Q37Elrexfio_select_1"

                                                                id={idx}
                                                                //name="Q37ElrexvayliRd"
                                                                name={
                                                                  "Q37ElrexvayliRd" +
                                                                  idx
                                                                }
                                                                value={1}
                                                                checked={
                                                                  data.Q37ElrexvayliRd ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleFieldChange
                                                                }
                                                              />
                                                              <span
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Yes
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                            }}
                                                          >
                                                            <label className="option-fbox">
                                                              <input
                                                                type="radio"
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                id={idx}
                                                                name={
                                                                  "Q37ElrexvayliRd" +
                                                                  idx
                                                                }
                                                                value={2}
                                                                checked={
                                                                  data.Q37ElrexvayliRd ===
                                                                  2
                                                                }
                                                                onChange={
                                                                  HandleFieldChange
                                                                }
                                                              />

                                                              <span
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                }}
                                                              >
                                                                No
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                            }}
                                                          >
                                                            <label className="option-fbox">
                                                              <input
                                                                type="radio"
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                id={idx}
                                                                name={
                                                                  "Q37ElrexvayliRd" +
                                                                  idx
                                                                }
                                                                value={99}
                                                                checked={
                                                                  data.Q37ElrexvayliRd ===
                                                                  99
                                                                }
                                                                onChange={
                                                                  HandleFieldChange
                                                                }
                                                              />

                                                              <span
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                }}
                                                              >
                                                                Unknown
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <ErrorField
                                                            show={
                                                              data.q37ElrexvayliEmpty
                                                            }
                                                            message={
                                                              ELCharacteristics_MSGS.administrationEmpty
                                                            }
                                                            style={{
                                                              paddingLeft:
                                                                "0px",
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </>
                                                ) : (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      //alignContent: "flex-start",
                                                      textAlign: "center",
                                                      padding: "8px",
                                                      //textAlign: 'start'
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        textAlign: "center",
                                                        verticalAlign: "center",
                                                      }}
                                                      className="not-applicable"
                                                    >
                                                      <b>Not applicable</b>
                                                    </span>
                                                  </td>
                                                )}

                                                {/* third column here */}
                                                {data.q37_Elr_Dose_week_frquencyRd !==
                                                1 ? (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <>
                                                      <div>
                                                        <label>
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "q37ElrDosageRd" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              data.q37ElrDosageRd ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            76 mg
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div>
                                                        <label>
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "q37ElrDosageRd" +
                                                              idx
                                                            }
                                                            value={2}
                                                            checked={
                                                              data.q37ElrDosageRd ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Other, please
                                                            specify{" "}
                                                            <textarea
                                                              className="input-dash"
                                                              style={{
                                                                marginLeft:
                                                                  "23px",
                                                              }}
                                                              id={idx}
                                                              name={
                                                                "q37ElrDosageOtherTxt" +
                                                                idx
                                                              }
                                                              value={
                                                                data.q37ElrDosageOtherTxt
                                                              }
                                                              type="text"
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              maxLength={300}
                                                            />
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div>
                                                        <label>
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "q37ElrDosageRd" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.q37ElrDosageRd ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* Error Fields */}
                                                      <ErrorField
                                                        show={
                                                          Q37ElrexDetails[idx]
                                                            .q37ElrDosageRdEmpty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.administrationEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          Q37ElrexDetails[0]
                                                            .q37ElrDosageOtherTxtEmpty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.specifyOtherText
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </>
                                                  </td>
                                                ) : (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      //alignContent: "flex-start",
                                                      textAlign: "center",
                                                      padding: "8px",
                                                      //textAlign: 'start'
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        textAlign: "center",
                                                        verticalAlign: "center",
                                                      }}
                                                      className="not-applicable"
                                                    >
                                                      <b>Not applicable</b>
                                                    </span>
                                                  </td>
                                                )}
                                              </React.Fragment>
                                            ))}
                                        </tr>
                                      )}

                                      {/* Linvoseltamab */}
                                      {isLinvoveySelected && (
                                        <tr>
                                          {Q37LinvoDetails.length > 0 &&
                                            Q37LinvoDetails.map((data, idx) => (
                                              <React.Fragment key={idx}>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    LYNOZYFIC
                                                    <sup className="supscript">
                                                      TM
                                                    </sup>{" "}
                                                    (linvoquetamab-gcpt)
                                                  </span>
                                                </td>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "q37_Linvo_Dose_week_frquencyRd" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.q37_Linvo_Dose_week_frquencyRd ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleFieldChange
                                                        }
                                                      />

                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        The patient has not
                                                        completed the step-up
                                                        dosing phase
                                                      </span>
                                                    </label>
                                                  </div>
                                                  {linvoveyDetails &&
                                                    linvoveyDetails.length >
                                                      0 && (
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "q37_Linvo_Dose_week_frquencyRd" +
                                                              idx
                                                            }
                                                            value={2}
                                                            checked={
                                                              data.q37_Linvo_Dose_week_frquencyRd ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <span>
                                                              Once every &nbsp;
                                                            </span>
                                                            <span>
                                                              <input
                                                                className="input-dash-sm"
                                                                id={idx}
                                                                name={
                                                                  "q37_Linvo_Dose_week_frquency_txt" +
                                                                  idx
                                                                }
                                                                type="text"
                                                                onChange={
                                                                  HandleFieldChange
                                                                }
                                                                value={
                                                                  data.q37_Linvo_Dose_week_frquency_txt
                                                                }
                                                                onKeyDown={(
                                                                  e,
                                                                ) => {
                                                                  // Allow backspace, arrow keys, and delete
                                                                  if (
                                                                    [
                                                                      "Backspace",
                                                                      "ArrowLeft",
                                                                      "ArrowRight",
                                                                      "Delete",
                                                                      "Tab",
                                                                    ].includes(
                                                                      e.key,
                                                                    )
                                                                  ) {
                                                                    return;
                                                                  }

                                                                  // Prevent non-numeric characters, except '.'
                                                                  if (
                                                                    !/[0-9.]/.test(
                                                                      e.key,
                                                                    )
                                                                  ) {
                                                                    e.preventDefault();
                                                                    return;
                                                                  }

                                                                  const value =
                                                                    e.target
                                                                      .value;
                                                                  const selectionStart =
                                                                    e.target
                                                                      .selectionStart;
                                                                  const newValue =
                                                                    value.slice(
                                                                      0,
                                                                      selectionStart,
                                                                    ) +
                                                                    e.key +
                                                                    value.slice(
                                                                      e.target
                                                                        .selectionEnd,
                                                                    );

                                                                  // Prevent multiple '.'
                                                                  if (
                                                                    e.key ===
                                                                      "." &&
                                                                    value.includes(
                                                                      ".",
                                                                    )
                                                                  ) {
                                                                    e.preventDefault();
                                                                    return;
                                                                  }

                                                                  // Prevent '.' as the first character
                                                                  if (
                                                                    e.key ===
                                                                      "." &&
                                                                    value === ""
                                                                  ) {
                                                                    e.preventDefault();
                                                                    return;
                                                                  }

                                                                  // Allow only one digit after decimal point
                                                                  if (
                                                                    newValue.includes(
                                                                      ".",
                                                                    ) &&
                                                                    newValue.split(
                                                                      ".",
                                                                    )[1]
                                                                      .length >
                                                                      2
                                                                  ) {
                                                                    e.preventDefault();
                                                                    return;
                                                                  }
                                                                }}
                                                              />
                                                            </span>
                                                            week
                                                          </span>
                                                        </label>
                                                      </div>
                                                    )}
                                                  {/* new Unknown */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "q37_Linvo_Dose_week_frquencyRd" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.q37_Linvo_Dose_week_frquencyRd ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleFieldChange
                                                        }
                                                      />

                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div>
                                                    <ErrorField
                                                      show={
                                                        data.q37_Linvo_Dose_week_frquencyRd_Empty
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.admissionEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.q37_Linvo_Dose_week_frquency_txt_Empty
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.specifyDosageFrequency
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.q37_Linvo_Dose_week_freq_range
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.allowedRange
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                                {data.q37_Linvo_Dose_week_frquencyRd !==
                                                1 ? (
                                                  <>
                                                    <td
                                                      style={{
                                                        border:
                                                          "1px solid black",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      <div>
                                                        <div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <label className="option-fbox">
                                                              <input
                                                                type="radio"
                                                                // id="Q37Linvoseltamab_select_1"
                                                                // name="Q37LinvoveyRd"

                                                                id={idx}
                                                                name={
                                                                  "Q37LinvoveyRd" +
                                                                  idx
                                                                }
                                                                value={1}
                                                                checked={
                                                                  data.Q37LinvoveyRd ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleFieldChange
                                                                }
                                                              />
                                                              <span
                                                                // className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                Yes
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                            }}
                                                          >
                                                            <label className="option-fbox">
                                                              <input
                                                                type="radio"
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                // id="Q37Linvoseltamab_select_0"
                                                                // name="Q37LinvoveyRd"

                                                                id={idx}
                                                                name={
                                                                  "Q37LinvoveyRd" +
                                                                  idx
                                                                }
                                                                value={2}
                                                                checked={
                                                                  data.Q37LinvoveyRd ===
                                                                  2
                                                                }
                                                                onChange={
                                                                  HandleFieldChange
                                                                }
                                                              />

                                                              <span
                                                                // className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                }}
                                                              >
                                                                No
                                                              </span>
                                                            </label>
                                                          </div>

                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                            }}
                                                          >
                                                            <label className="option-fbox">
                                                              <input
                                                                type="radio"
                                                                style={{
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                // id="Q37Elrexfio_select_0"
                                                                // name="Q37ElrexvayliRd"
                                                                id={idx}
                                                                name={
                                                                  "Q37LinvoveyRd" +
                                                                  idx
                                                                }
                                                                value={99}
                                                                checked={
                                                                  data.Q37LinvoveyRd ===
                                                                  99
                                                                }
                                                                onChange={
                                                                  HandleFieldChange
                                                                }
                                                              />

                                                              <span
                                                                // className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                }}
                                                              >
                                                                Unknown
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <ErrorField
                                                            show={
                                                              data.q37LinvoveyEmpty
                                                            }
                                                            message={
                                                              ELCharacteristics_MSGS.administrationEmpty
                                                            }
                                                            style={{
                                                              paddingLeft:
                                                                "0px",
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </td>

                                                    {/* end */}
                                                  </>
                                                ) : (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      //alignContent: "flex-start",
                                                      textAlign: "center",
                                                      padding: "8px",
                                                      //textAlign: 'start'
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      className="not-applicable"
                                                    >
                                                      <b>Not applicable</b>
                                                    </span>
                                                  </td>
                                                )}
                                                {/* third column here */}
                                                {data.q37_Linvo_Dose_week_frquencyRd !==
                                                1 ? (
                                                  <div className="option-without-input">
                                                    <div
                                                      style={{
                                                        paddingLeft: "15px",
                                                      }}
                                                    >
                                                      <div
                                                        className="option-without-input"
                                                        //style={{ display: "flex" }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "q37_Linvo_Dosage_Rd" +
                                                              idx
                                                            }
                                                            value={1}
                                                            checked={
                                                              data.q37_Linvo_Dosage_Rd ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            200 mg{" "}
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "q37_Linvo_Dosage_Rd" +
                                                              idx
                                                            }
                                                            value={2}
                                                            checked={
                                                              data.q37_Linvo_Dosage_Rd ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />

                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Other, please
                                                            specify
                                                            <span>
                                                              <textarea
                                                                className="input-dash"
                                                                id={idx}
                                                                name={
                                                                  "q37_Linvo_Dosage_OtherTxt" +
                                                                  idx
                                                                }
                                                                type="text"
                                                                onChange={
                                                                  HandleFieldChange
                                                                }
                                                                value={
                                                                  data.q37_Linvo_Dosage_OtherTxt
                                                                }
                                                              />
                                                            </span>
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "q37_Linvo_Dosage_Rd" +
                                                              idx
                                                            }
                                                            value={99}
                                                            checked={
                                                              data.q37_Linvo_Dosage_Rd ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />

                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.q37_Linvo_Dosage_Rd_Empty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.admissionEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.q37_Linvo_Dosage_OtherTxt_Empty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.specifyOtherText
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      //alignContent: "flex-start",
                                                      textAlign: "center",
                                                      padding: "8px",
                                                      //textAlign: 'start'
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      className="not-applicable"
                                                    >
                                                      <b>Not applicable</b>
                                                    </span>
                                                  </td>
                                                )}
                                              </React.Fragment>
                                            ))}
                                        </tr>
                                      )}
                                      {/* Linvoseltamab */}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {/* Q37 end---------------------------------------------------------- */}
                        {/* Q38 start */}
                        {(Q37ElrexDetails[0].Q37ElrexvayliRd === 1 ||
                          Q37LinvoDetails[0].Q37LinvoveyRd === 1) &&
                          !isNewEcrfA && (
                            <>
                              <div className="question question-weight">
                                <span>Q38.</span>
                                <span className="quest-text-pad">
                                  Please provide all dates of dose frequency
                                  reductions during treatment with{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                      fontWeight: "bolder",
                                    }}
                                  >
                                    {isElrexvayliSelected &&
                                    Q37ElrexDetails[0].Q37ElrexvayliRd === 1 &&
                                    isLinvoveySelected &&
                                    Q37LinvoDetails[0].Q37LinvoveyRd === 1 ? (
                                      <>
                                        ELREXFIO<sup>TM</sup> (elranatamab-bcmm)
                                        and LYNOZYFIC
                                        <sup className="supscript">TM</sup>{" "}
                                        (linvoquetamab-gcpt).
                                      </>
                                    ) : isElrexvayliSelected &&
                                      Q37ElrexDetails[0].Q37ElrexvayliRd ===
                                        1 ? (
                                      "ELREXFIO<sup>TM</sup> (elranatamab-bcmm)."
                                    ) : isLinvoveySelected &&
                                      Q37LinvoDetails[0].Q37LinvoveyRd === 1 ? (
                                      <>
                                        LYNOZYFIC
                                        <sup className="supscript">TM</sup>{" "}
                                        (linvoquetamab-gcpt).
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </span>{" "}
                                  <br />
                                  <span>
                                    Note that dose frequency reductions refers
                                    only to the frequency of administrations
                                    (i.e., weekly, biweekly, monthly, etc.) and
                                    note changes in dose strength.
                                  </span>
                                </span>
                              </div>
                            </>
                          )}
                        {isElrexvayliSelected &&
                          Q37ElrexDetails[0].showDateRedFreqElr &&
                          !isNewEcrfA && (
                            <div className="dependent-section">
                              {Q38ElrexDetails &&
                                Q38ElrexDetails.length > 0 &&
                                Q38ElrexDetails.map((data, idx) => (
                                  <div className="loop-section-ul" key={idx}>
                                    <div className="loop-head">
                                      <span
                                        className="question-weight"
                                        style={{ float: "inline-start" }}
                                      >
                                        {GetOrdinal(idx + 1)} Dose frequency
                                        reductions
                                      </span>
                                      {idx != 0 && (
                                        <div
                                          className="delete-btn-div"
                                          style={{ float: "inline-end" }}
                                        >
                                          <img
                                            width="16px"
                                            src="../Assets/images/Icon-material-delete.png"
                                            alt=""
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              DeleteQ38ElrexvayliRow(idx)
                                            }
                                          />
                                        </div>
                                      )}
                                    </div>

                                    {/* ELREXFIO® */}
                                    <div className="question-bot-sapce">
                                      <div className="sub-question grid-overflow">
                                        <table
                                          style={{
                                            border: "1px solid black",
                                            borderCollapse: "collapse",
                                            width: "100%",
                                          }}
                                        >
                                          <thead>
                                            <tr>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Treatment
                                              </th>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                  width: "15%",
                                                }}
                                              >
                                                Date of dose frequency reduction
                                              </th>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Dose frequency after reduction
                                              </th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                            <tr>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="quest-text-pad">
                                                  ELREXFIO<sup>TM</sup>{" "}
                                                  (elranatamab-bcmm)
                                                </span>
                                              </td>

                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div>
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "Q38ElrexvayliRd" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.Q38ElrexvayliRd ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                          marginLeft: "-5px",
                                                        }}
                                                      >
                                                        <DatePickerComponent
                                                          ctrlId={
                                                            "dt_dosefreq_elr_dt-" +
                                                            idx
                                                          }
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                          date={
                                                            data.dt_dosefreq_elr_dt
                                                          }
                                                        />
                                                      </span>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "Q38ElrexvayliRd" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            data.Q38ElrexvayliRd ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Date of dose frequency
                                                          reduction unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.Q38ElrexEmptyHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.administrationEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.Q38ElrexDateInvalid
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.Q38ElrexDateInvalid
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={data.Q38DateEmpty}
                                                      message={
                                                        ELCharacteristics_MSGS.Q38DateEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.Invalid_dt_dosefreq_elr_dt
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              </td>

                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "q38_Elr_Dose_week_frquencyRd" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.q38_Elr_Dose_week_frquencyRd ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                      }}
                                                    >
                                                      <span>
                                                        Once every &nbsp;
                                                      </span>
                                                      <span>
                                                        <input
                                                          className="input-dash-sm"
                                                          id={idx}
                                                          name={
                                                            "q38_Elr_Dose_week_frquency_txt" +
                                                            idx
                                                          }
                                                          value={
                                                            data.q38_Elr_Dose_week_frquency_txt
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={(e) => {
                                                            // Allow backspace, arrow keys, and delete
                                                            if (
                                                              [
                                                                "Backspace",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Delete",
                                                                "Tab",
                                                              ].includes(e.key)
                                                            ) {
                                                              return;
                                                            }

                                                            // Prevent non-numeric characters, except '.'
                                                            if (
                                                              !/[0-9.]/.test(
                                                                e.key,
                                                              )
                                                            ) {
                                                              e.preventDefault();
                                                              return;
                                                            }

                                                            const value =
                                                              e.target.value;
                                                            const selectionStart =
                                                              e.target
                                                                .selectionStart;
                                                            const newValue =
                                                              value.slice(
                                                                0,
                                                                selectionStart,
                                                              ) +
                                                              e.key +
                                                              value.slice(
                                                                e.target
                                                                  .selectionEnd,
                                                              );

                                                            // Prevent multiple '.'
                                                            if (
                                                              e.key === "." &&
                                                              value.includes(
                                                                ".",
                                                              )
                                                            ) {
                                                              e.preventDefault();
                                                              return;
                                                            }

                                                            // Prevent '.' as the first character
                                                            if (
                                                              e.key === "." &&
                                                              value === ""
                                                            ) {
                                                              e.preventDefault();
                                                              return;
                                                            }

                                                            // Allow only one digit after decimal point
                                                            if (
                                                              newValue.includes(
                                                                ".",
                                                              ) &&
                                                              newValue.split(
                                                                ".",
                                                              )[1].length > 2
                                                            ) {
                                                              e.preventDefault();
                                                              return;
                                                            }
                                                          }}
                                                        />
                                                      </span>
                                                      week
                                                    </span>
                                                  </label>
                                                </div>
                                                {/* new Unknown */}
                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "q38_Elr_Dose_week_frquencyRd" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.q38_Elr_Dose_week_frquencyRd ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />

                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>
                                                <ErrorField
                                                  show={
                                                    data.q38_Elr_Dose_week_frquencyRd_Empty
                                                  }
                                                  message={
                                                    ELCharacteristics_MSGS.administrationEmpty
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                                <ErrorField
                                                  show={
                                                    data.q38_Elr_Dose_week_frquency_txt_Empty
                                                  }
                                                  message={
                                                    ELCharacteristics_MSGS.specifyDosageFrequencyAndRange
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />

                                                <ErrorField
                                                  show={
                                                    data.q38ElrDoseFrequencyConflict
                                                  }
                                                  message={
                                                    ELCharacteristics_MSGS.Q38FrequencyConflict
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                ))}

                              {Q38ElrexDetails &&
                                Q38ElrexDetails.length > 0 &&
                                Q38ElrexDetails.length < 550 && (
                                  <div className="sub-question-bot-sapce-ul mt-2">
                                    <div
                                      className="answer-list-text"
                                      onClick={AddQ38ElrexvayliRow}
                                    >
                                      <a>
                                        <img
                                          width="18px"
                                          src="../Assets/images/plus.png"
                                          alt=""
                                        />
                                      </a>
                                      <a className="radio-text-padding">
                                        Click here to add another date of dose
                                        frequency reduction
                                      </a>
                                    </div>
                                  </div>
                                )}
                            </div>
                          )}
                        {/* Q38 end  */}
                        {/* Q38 Linvoseltamab */}
                        {isLinvoveySelected &&
                          Q37LinvoDetails[0].showDateRedFreqLinvo &&
                          !isNewEcrfA && (
                            <div className="dependent-section">
                              {Q38LinvoDetails &&
                                Q38LinvoDetails.length > 0 &&
                                Q38LinvoDetails.map((data, idx) => (
                                  <div className="loop-section-ul" key={idx}>
                                    <div className="loop-head">
                                      <span
                                        className="question-weight"
                                        style={{ float: "inline-start" }}
                                      >
                                        {GetOrdinal(idx + 1)} Dose frequency
                                        reductions
                                      </span>
                                      {idx != 0 && (
                                        <div
                                          className="delete-btn-div"
                                          style={{ float: "inline-end" }}
                                        >
                                          <img
                                            width="16px"
                                            src="../Assets/images/Icon-material-delete.png"
                                            alt=""
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              DeleteQ38LinvoveyRow(idx)
                                            }
                                          />
                                        </div>
                                      )}
                                    </div>

                                    {/* LINVOSELTAMAB */}
                                    <div className="question-bot-sapce">
                                      <div className="sub-question grid-overflow">
                                        <table
                                          style={{
                                            border: "1px solid black",
                                            borderCollapse: "collapse",
                                            width: "100%",
                                          }}
                                        >
                                          <thead>
                                            <tr>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Treatment
                                              </th>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                  width: "15%",
                                                }}
                                              >
                                                Date of dose frequency reduction
                                              </th>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Dose frequency after reduction
                                              </th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                            <tr>
                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <span className="quest-text-pad">
                                                  LYNOZYFIC
                                                  <sup className="supscript">
                                                    TM
                                                  </sup>{" "}
                                                  (linvoquetamab-gcpt)
                                                </span>
                                              </td>

                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div>
                                                  <div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "Q38LinvoveyRd" + idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.Q38LinvoveyRd ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                          marginLeft: "-5px",
                                                        }}
                                                      >
                                                        <DatePickerComponent
                                                          ctrlId={
                                                            "dt_dosefreq_linvo_dt-" +
                                                            idx
                                                          }
                                                          HandleDateChange={
                                                            HandleRepeaterDateChange
                                                          }
                                                          minDate={dayjs(
                                                            "01-01-1920",
                                                          )}
                                                          maxDate={dayjs()}
                                                          locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                          date={
                                                            data.dt_dosefreq_linvo_dt
                                                          }
                                                        />
                                                      </span>
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{
                                                        display: "flex",
                                                        alignItems:
                                                          "flex-start",
                                                      }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          id={idx}
                                                          name={
                                                            "Q38LinvoveyRd" +
                                                            idx
                                                          }
                                                          value={99}
                                                          checked={
                                                            data.Q38LinvoveyRd ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                        />

                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          Date of dose frequency
                                                          reduction unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.Q38LinvoEmptyHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.Q38LinvoEmptyHard
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.Q38LinvoDateEmpty
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.Q38LinvoDateEmpty
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                    <ErrorField
                                                      show={
                                                        data.Q38LinvoDateInvalid
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.Q38LinvoDateInvalid
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />

                                                    <ErrorField
                                                      show={
                                                        data.InvalidQ38Linvoveydate
                                                      }
                                                      message={
                                                        CommonError_Msgs.InvalidDate
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              </td>
                                              {/* </> */}
                                              {/* ))} */}

                                              <td
                                                style={{
                                                  border: "1px solid black",
                                                  padding: "8px",
                                                }}
                                              >
                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "q38_Linvo_Dose_week_frquencyRd" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.q38_Linvo_Dose_week_frquencyRd ===
                                                        1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <span>
                                                        Once every &nbsp;
                                                      </span>
                                                      <span>
                                                        <input
                                                          className="input-dash-sm"
                                                          id={idx}
                                                          name={
                                                            "q38_Linvo_Dose_week_frquency_txt" +
                                                            idx
                                                          }
                                                          type="text"
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          value={
                                                            data.q38_Linvo_Dose_week_frquency_txt
                                                          }
                                                          onKeyDown={(e) => {
                                                            // Allow backspace, arrow keys, and delete
                                                            if (
                                                              [
                                                                "Backspace",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Delete",
                                                                "Tab",
                                                              ].includes(e.key)
                                                            ) {
                                                              return;
                                                            }

                                                            // Prevent non-numeric characters, except '.'
                                                            if (
                                                              !/[0-9.]/.test(
                                                                e.key,
                                                              )
                                                            ) {
                                                              e.preventDefault();
                                                              return;
                                                            }

                                                            const value =
                                                              e.target.value;
                                                            const selectionStart =
                                                              e.target
                                                                .selectionStart;
                                                            const newValue =
                                                              value.slice(
                                                                0,
                                                                selectionStart,
                                                              ) +
                                                              e.key +
                                                              value.slice(
                                                                e.target
                                                                  .selectionEnd,
                                                              );

                                                            // Prevent multiple '.'
                                                            if (
                                                              e.key === "." &&
                                                              value.includes(
                                                                ".",
                                                              )
                                                            ) {
                                                              e.preventDefault();
                                                              return;
                                                            }

                                                            // Prevent '.' as the first character
                                                            if (
                                                              e.key === "." &&
                                                              value === ""
                                                            ) {
                                                              e.preventDefault();
                                                              return;
                                                            }

                                                            // Allow only one digit after decimal point
                                                            if (
                                                              newValue.includes(
                                                                ".",
                                                              ) &&
                                                              newValue.split(
                                                                ".",
                                                              )[1].length > 2
                                                            ) {
                                                              e.preventDefault();
                                                              return;
                                                            }
                                                          }}
                                                        />
                                                      </span>
                                                      week
                                                    </span>
                                                  </label>
                                                </div>
                                                {/* new Unknown */}
                                                <div
                                                  className="option-without-input"
                                                  style={{ display: "flex" }}
                                                >
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "q38_Linvo_Dose_week_frquencyRd" +
                                                        idx
                                                      }
                                                      value={99}
                                                      checked={
                                                        data.q38_Linvo_Dose_week_frquencyRd ===
                                                        99
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />

                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                      }}
                                                    >
                                                      Unknown
                                                    </span>
                                                  </label>
                                                </div>
                                                <div>
                                                  <ErrorField
                                                    show={
                                                      data.q38_Linvo_Dose_week_frquencyRd_Empty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.admissionEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.q38_Linvo_Dose_week_frquency_txt_Empty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.specifyDosageFrequencyAndRange
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.q38LinvoDoseFrequencyConflict
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.Q38FrequencyConflict
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              </td>
                                            </tr>

                                            {/* Linvoseltamab */}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                ))}

                              {Q38LinvoDetails &&
                                Q38LinvoDetails.length > 0 &&
                                Q38LinvoDetails.length < 550 && (
                                  <div className="sub-question-bot-sapce-ul mt-2">
                                    <div
                                      className="answer-list-text"
                                      onClick={AddQ38LinvoveyRow}
                                    >
                                      <a>
                                        <img
                                          width="18px"
                                          src="../Assets/images/plus.png"
                                          alt=""
                                        />
                                      </a>
                                      <a className="radio-text-padding">
                                        Click here to add another date of dose
                                        frequency reduction
                                      </a>
                                    </div>
                                  </div>
                                )}
                            </div>
                          )}
                        <br></br>
                        {/* Q38Linvoseltamab */}
                        {/* Q38.1.A start Elrex */}
                        {isElrexvayliSelected && isNewEcrfA == true && (
                          <div className="question question-weight">
                            <span>Q38.1.A</span>
                            <span className="quest-text-pad">
                              Please provide information on any{" "}
                              <i>dose frequency, or dose strength</i>, changes
                              that occurred from completion of the step-up
                              dosing phase until the end of the line of therapy
                              with{" "}
                              <span
                                style={{
                                  color: PageDesignConstants.fontColor,
                                  fontWeight: "bolder",
                                }}
                              >
                                {isElrexvayliSelected && (
                                  <>
                                    ELREXFIO<sup>TM</sup> (elranatamab-bcmm)
                                  </>
                                )}
                              </span>{" "}
                              Add additional rows for each type of change that
                              occurred.
                              <br />
                            </span>
                          </div>
                        )}
                        {/* Q38.1.A ELREXFIO */}
                        {isElrexvayliSelected && isNewEcrfA && (
                          <div className="dependent-section">
                            {Q381AElrexDetails &&
                              Q381AElrexDetails.length > 0 &&
                              Q381AElrexDetails.map((data, idx) => (
                                <div className="loop-section-ul" key={idx}>
                                  <div className="loop-head">
                                    <span
                                      className="question-weight"
                                      style={{ float: "inline-start" }}
                                    >
                                      {GetOrdinal(idx + 1)} Dose/frequency
                                      change
                                    </span>
                                    {idx !== 0 && (
                                      <div
                                        className="delete-btn-div"
                                        style={{ float: "inline-end" }}
                                      >
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            DeleteQ381AElrexRow(idx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  {/* ELREXFIO Table */}
                                  <div className="question-bot-sapce">
                                    <div className="sub-question grid-overflow">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Treatment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "150px",
                                              }}
                                            >
                                              Type of change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "280px",
                                              }}
                                            >
                                              Reason for change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Pattern <i>before</i> change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Pattern <i>after</i> change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of change
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            {/* Column A: Treatment */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span className="quest-text-pad">
                                                ELREXFIO<sup>TM</sup>{" "}
                                                (elranatamab-bcmm)
                                              </span>
                                            </td>

                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {/* Radio 1 - No changes */}

                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={`changeTypeElr${idx}`}
                                                    value="1"
                                                    checked={
                                                      Number(
                                                        data.changeType,
                                                      ) === 1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    No dose frequency or dose
                                                    strength changes occurred
                                                  </span>
                                                </label>
                                              </div>

                                              {/* Radio 2 - Frequency change */}
                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    style={{ marginTop: "6px" }}
                                                    type="radio"
                                                    id={idx}
                                                    name={`changeTypeElr${idx}`}
                                                    value="2"
                                                    checked={
                                                      Number(
                                                        data.changeType,
                                                      ) === 2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Dose frequency change
                                                  </span>
                                                </label>
                                              </div>

                                              {/* Sub-radio for Frequency Increase/Decrease */}
                                              {data.changeType === 2 && (
                                                <div
                                                  style={{
                                                    paddingLeft: "15px",
                                                  }}
                                                >
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={`changeTypeDoseFrequencyElr${idx}`}
                                                        value="1"
                                                        checked={
                                                          data.changeTypeDoseFrequency ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Frequency increase
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div className="option-without-input">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={`changeTypeDoseFrequencyElr${idx}`}
                                                        value="2"
                                                        checked={
                                                          data.changeTypeDoseFrequency ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Frequency decrease
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.changeTypeDoseFrequencyEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.ChangeTypeDoseFrequencyEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              )}

                                              {/* Radio 3 - Strength change */}
                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={`changeTypeElr${idx}`}
                                                    value="3"
                                                    checked={
                                                      Number(
                                                        data.changeType,
                                                      ) === 3
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Dose strength change
                                                  </span>
                                                </label>
                                              </div>

                                              {/* Sub-radio for Strength Increase/Decrease */}
                                              {data.changeType === 3 && (
                                                <div
                                                  style={{
                                                    paddingLeft: "15px",
                                                  }}
                                                >
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={`changeTypeDoseStrengthElr${idx}`}
                                                        value="1"
                                                        checked={
                                                          data.changeTypeDoseStrength ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Strength increase
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div className="option-without-input">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={`changeTypeDoseStrengthElr${idx}`}
                                                        value="2"
                                                        checked={
                                                          data.changeTypeDoseStrength ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Strength decrease
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.changeTypeDoseStrengthEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.ChangeTypeDoseStrengthEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              )}

                                              {/* Radio 4 - Unknown */}
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={`changeTypeElr${idx}`}
                                                    value={99}
                                                    checked={
                                                      data.changeType === 99
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Unknown if any dose changes
                                                    occurred
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={data.changeTypeEmpty}
                                                message={
                                                  ELCharacteristics_MSGS.ChangeTypeEmpty
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </td>

                                            {/* Column C: Reasons for change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  {/* Primary Reasons */}
                                                  {data.reasonList?.map(
                                                    (reason, itemidx) => (
                                                      <div
                                                        key={
                                                          reason.bispecifictreatmentdiscontinuationreasonid
                                                        }
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          flexDirection:
                                                            "column",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="checkbox"
                                                            id={`reasonElr_${idx}_${itemidx}`}
                                                            name={`reasonElr_${idx}_${itemidx}`}
                                                            idx={idx}
                                                            itemidx={itemidx}
                                                            value={
                                                              reason.bispecifictreatmentdiscontinuationreasonid
                                                            }
                                                            checked={
                                                              reason.isSelected ||
                                                              false
                                                            }
                                                            onChange={(e) =>
                                                              HandleQ381ARepeaterFieldChange(
                                                                e,
                                                                "Elrex",
                                                                reason.reasonName,
                                                                idx,
                                                                itemidx,
                                                                null,
                                                              )
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            {reason.reasonName}
                                                            {reason.superscripttext && (
                                                              <sup>
                                                                {
                                                                  reason.superscripttext
                                                                }
                                                              </sup>
                                                            )}
                                                          </span>
                                                        </label>

                                                        {/* "Other" text field - Show only if this reason contains "Other" and is selected */}
                                                        {reason.reasonName?.includes(
                                                          "Other",
                                                        ) && (
                                                          <div
                                                            style={{
                                                              paddingLeft:
                                                                "25px",
                                                              marginTop: "5px",
                                                            }}
                                                          >
                                                            <textarea
                                                              className="input-dash"
                                                              id={`reasonTextElr_${idx}_${itemidx}`}
                                                              name={`reasonTextElr_${idx}_${itemidx}`}
                                                              idx={idx}
                                                              itemidx={itemidx}
                                                              value={
                                                                Q381AElrexDetails[
                                                                  idx
                                                                ]
                                                                  ?.reasonOtherText ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                HandleQ381ARepeaterFieldChange(
                                                                  e,
                                                                  "Elrex",
                                                                  reason.reasonName,
                                                                  idx,
                                                                  itemidx,
                                                                  null,
                                                                )
                                                              }
                                                              maxLength={300}
                                                              style={{
                                                                width: "100%",
                                                                minHeight:
                                                                  "60px",
                                                                resize:
                                                                  "vertical",
                                                              }}
                                                            />
                                                            <div
                                                              style={{
                                                                fontSize:
                                                                  "11px",
                                                                color: "#666",
                                                                marginTop:
                                                                  "2px",
                                                              }}
                                                            ></div>
                                                            <ErrorField
                                                              show={
                                                                data.reasonOtherTextEmpty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.ReasonOtherTextEmpty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        )}

                                                        {/* AE Sub-reasons - Only show if this is "Adverse event" (ID=2) and it's selected */}
                                                        {reason.bispecifictreatmentdiscontinuationreasonid ===
                                                          2 &&
                                                          reason.isSelected &&
                                                          reason.aeSubReasons
                                                            ?.length > 0 && (
                                                            <div
                                                              style={{
                                                                paddingLeft:
                                                                  "25px",
                                                                marginTop:
                                                                  "5px",
                                                              }}
                                                            >
                                                              {reason.aeSubReasons.map(
                                                                (ae, aeIdx) => {
                                                                  // ✅ Check if this is "AE type unknown" - check BOTH possible property names
                                                                  const aeName =
                                                                    ae.reasonName ||
                                                                    ae.bispecifictreatmentdiscontinuationreasonae ||
                                                                    "";
                                                                  const isAEUnknown =
                                                                    aeName
                                                                      .toLowerCase()
                                                                      .includes(
                                                                        "unknown",
                                                                      );

                                                                  return (
                                                                    <div
                                                                      key={
                                                                        ae.bispecifictreatmentdiscontinuationreasonaeid
                                                                      }
                                                                      className="option-without-input"
                                                                    >
                                                                      <label className="option-fbox">
                                                                        <input
                                                                          type={
                                                                            isAEUnknown
                                                                              ? "radio"
                                                                              : "checkbox"
                                                                          } // ✅ Radio for unknown, checkbox for others
                                                                          id={`aeReasonElr_${idx}_${itemidx}_${aeIdx}`}
                                                                          name={
                                                                            isAEUnknown
                                                                              ? `aeUnknownElr_${idx}_${itemidx}`
                                                                              : `aeReasonElr_${idx}_${itemidx}_${aeIdx}`
                                                                          }
                                                                          idx={
                                                                            idx
                                                                          }
                                                                          itemidx={
                                                                            itemidx
                                                                          }
                                                                          aeidx={
                                                                            aeIdx
                                                                          }
                                                                          value={
                                                                            ae.bispecifictreatmentdiscontinuationreasonaeid
                                                                          }
                                                                          checked={
                                                                            ae.isSelected ||
                                                                            false
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            HandleQ381ARepeaterFieldChange(
                                                                              e,
                                                                              "Elrex",
                                                                              reason.reasonName,
                                                                              idx,
                                                                              itemidx,
                                                                              aeIdx,
                                                                            )
                                                                          }
                                                                        />
                                                                        <span
                                                                          style={{
                                                                            paddingLeft:
                                                                              "10px",
                                                                          }}
                                                                        >
                                                                          {
                                                                            ae.reasonName
                                                                          }{" "}
                                                                          {/* ✅ Using the correct property name from your original code */}
                                                                          {ae.superscripttext && (
                                                                            <sup>
                                                                              {
                                                                                ae.superscripttext
                                                                              }
                                                                            </sup>
                                                                          )}
                                                                        </span>
                                                                      </label>
                                                                      {ae.reasonName ===
                                                                        DiscontinuationReason.NeurologicalEvent &&
                                                                        ae.isSelected && (
                                                                          <div
                                                                            style={{
                                                                              marginLeft:
                                                                                "28px",
                                                                              marginTop:
                                                                                "8px",
                                                                            }}
                                                                          >
                                                                            {data
                                                                              .neurologicAEReasonList
                                                                              ?.length >
                                                                              0 &&
                                                                              data.neurologicAEReasonList.map(
                                                                                (
                                                                                  aeNeuro,
                                                                                  aeNeuroIdx,
                                                                                ) => {
                                                                                  return (
                                                                                    <div
                                                                                      key={
                                                                                        aeNeuroIdx
                                                                                      }
                                                                                    >
                                                                                      <label
                                                                                        className="d-flex align-items-start"
                                                                                        htmlFor={`elr_adverse_neuro_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                      >
                                                                                        <input
                                                                                          type="checkbox"
                                                                                          id={`elr_adverse_neuro_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          name={`elr_adverse_neuro_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          checked={
                                                                                            aeNeuro.isSelected
                                                                                          }
                                                                                          onChange={(
                                                                                            e,
                                                                                          ) =>
                                                                                            HandleNeuroRepeaterFieldChange(
                                                                                              e,
                                                                                              "381A",
                                                                                              RRMMCohortTreatment.ELREXFIO,
                                                                                              aeNeuroIdx,
                                                                                              idx,
                                                                                            )
                                                                                          }
                                                                                          style={{
                                                                                            marginTop:
                                                                                              "6px",
                                                                                          }}
                                                                                        />

                                                                                        <span
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                          className="radio-text-padding"
                                                                                        >
                                                                                          {
                                                                                            aeNeuro.reasonName
                                                                                          }
                                                                                        </span>
                                                                                      </label>

                                                                                      {aeNeuro.reasonName.includes(
                                                                                        "Other",
                                                                                      ) && (
                                                                                        <div>
                                                                                          <label
                                                                                            htmlFor={`elr_neuro_reasontxt_${itemidx}_${aeNeuroIdx}`}
                                                                                          >
                                                                                            <span
                                                                                              style={{
                                                                                                paddingLeft:
                                                                                                  "28px",
                                                                                              }}
                                                                                              className="radio-text-padding"
                                                                                            >
                                                                                              <textarea
                                                                                                style={{
                                                                                                  width:
                                                                                                    "264px",
                                                                                                }}
                                                                                                id={`elr_neuro_reasontxt_${itemidx}_${aeNeuroIdx}`}
                                                                                                name={`elr_neuro_reasontxt_${itemidx}_${aeNeuroIdx}`}
                                                                                                type="text"
                                                                                                value={
                                                                                                  aeNeuro.reasonText
                                                                                                }
                                                                                                onChange={(
                                                                                                  e,
                                                                                                ) =>
                                                                                                  HandleNeuroRepeaterFieldChange(
                                                                                                    e,
                                                                                                    "381A",
                                                                                                    RRMMCohortTreatment.ELREXFIO,
                                                                                                    aeNeuroIdx,
                                                                                                    idx,
                                                                                                  )
                                                                                                }
                                                                                                maxLength={
                                                                                                  300
                                                                                                }
                                                                                              />
                                                                                            </span>
                                                                                          </label>
                                                                                          <ErrorField
                                                                                            show={
                                                                                              data.neuroOtherTextEmpty
                                                                                            }
                                                                                            message={
                                                                                              ELCharacteristics_MSGS.Q38AENeurologicOther
                                                                                            }
                                                                                          />
                                                                                        </div>
                                                                                      )}
                                                                                    </div>
                                                                                  );
                                                                                },
                                                                              )}
                                                                            <ErrorField
                                                                              show={
                                                                                data.neuroReasonEmpty
                                                                              }
                                                                              message={
                                                                                ELCharacteristics_MSGS.Q38AENeurologicEmpty
                                                                              }
                                                                            />
                                                                          </div>
                                                                        )}
                                                                    </div>
                                                                  );
                                                                },
                                                              )}
                                                              <ErrorField
                                                                show={
                                                                  data.aeSubReasonEmpty
                                                                }
                                                                message={
                                                                  ELCharacteristics_MSGS.Q38AEEmpty
                                                                }
                                                                style={{
                                                                  paddingLeft:
                                                                    "0px",
                                                                }}
                                                              />
                                                            </div>
                                                          )}
                                                      </div>
                                                    ),
                                                  )}

                                                  {/* ELREXFIO - Unknown Option */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "reasonUnknownElr" +
                                                          idx
                                                        }
                                                        checked={
                                                          data.reasonUnknown ||
                                                          false
                                                        }
                                                        value={true}
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={data.reasonEmpty}
                                                    message={
                                                      ELCharacteristics_MSGS.Q38ReasonEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={data.deathDtWarning}
                                                    message={
                                                      ELCharacteristics_MSGS.deathWarningQ20
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column D - Pattern BEFORE change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType === null ||
                                              data.changeType === 99 ||
                                              data.changeType === 1 ? (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              ) : (
                                                <div>
                                                  {/* Frequency Pattern - only show if changeType is 2 (Frequency) */}
                                                  {data.changeType === 2 && (
                                                    <div>
                                                      {/* ✅ Option 1: Times per week WITH TEXT INPUT */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseFrequencyElr${idx}`}
                                                            value={1}
                                                            checked={
                                                              data.patterBeforeChangeDoseFrequency ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterBeforeChangeDoseFrequencyTimesPerWeekElr${idx}`}
                                                              value={
                                                                data.patterBeforeChangeDoseFrequencyTimesPerWeek ||
                                                                ""
                                                              }
                                                              type="text"
                                                              style={{
                                                                width: "50px",
                                                                margin: "0 5px",
                                                              }}
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={(
                                                                e,
                                                              ) => {
                                                                if (
                                                                  [
                                                                    "Backspace",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Delete",
                                                                    "Tab",
                                                                  ].includes(
                                                                    e.key,
                                                                  )
                                                                )
                                                                  return;
                                                                if (
                                                                  !/[0-9]/.test(
                                                                    e.key,
                                                                  )
                                                                )
                                                                  e.preventDefault();
                                                              }}
                                                            />
                                                            times per week
                                                          </span>
                                                        </label>
                                                      </div>
                                                      {/* Option 2: Every X weeks */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseFrequencyElr${idx}`}
                                                            value={2}
                                                            checked={
                                                              data.patterBeforeChangeDoseFrequency ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            Once every
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterBeforeChangeDoseFrequencyWeekElr${idx}`}
                                                              value={
                                                                data.patterBeforeChangeDoseFrequencyWeek ||
                                                                ""
                                                              }
                                                              type="text"
                                                              style={{
                                                                width: "50px",
                                                                margin: "0 5px",
                                                              }}
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={(
                                                                e,
                                                              ) => {
                                                                if (
                                                                  [
                                                                    "Backspace",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Delete",
                                                                    "Tab",
                                                                  ].includes(
                                                                    e.key,
                                                                  )
                                                                )
                                                                  return;
                                                                if (
                                                                  !/[0-9]/.test(
                                                                    e.key,
                                                                  )
                                                                )
                                                                  e.preventDefault();
                                                              }}
                                                            />
                                                            week(s)
                                                          </span>
                                                        </label>
                                                      </div>
                                                      {/* Unknown */}
                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseFrequencyElr${idx}`}
                                                            value={99}
                                                            checked={
                                                              data.patterBeforeChangeDoseFrequency ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.patternBeforeFrequencyEmpty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.frequencyPatternEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.patternBeforeFrequencyRangeInvalid
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.frequencyRange
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.patternBeforeUnknownWarning
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.Q381AWarningUnk
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  )}

                                                  {/* Strength Pattern - only show if changeType is 3 (Strength) */}
                                                  {data.changeType === 3 && (
                                                    <div
                                                      style={{
                                                        marginTop:
                                                          data.changeType === 2
                                                            ? "15px"
                                                            : "0",
                                                      }}
                                                    >
                                                      {/* mg option */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseStrengthElr${idx}`}
                                                            value={1}
                                                            checked={
                                                              data.patterBeforeChangeDoseStrength ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterBeforeChangeDoseStrengthMgElr${idx}`}
                                                              value={
                                                                data.patterBeforeChangeDoseStrengthMg ||
                                                                ""
                                                              }
                                                              type="text"
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={
                                                                AllowNumericWithDecimal
                                                              }
                                                            />
                                                            <span>
                                                              &nbsp;mg
                                                            </span>
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* mg/kg option */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseStrengthElr${idx}`}
                                                            value={2}
                                                            checked={
                                                              data.patterBeforeChangeDoseStrength ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterBeforeChangeDoseStrengthMgKgElr${idx}`}
                                                              value={
                                                                data.patterBeforeChangeDoseStrengthMgKg ||
                                                                ""
                                                              }
                                                              type="text"
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={
                                                                AllowNumericWithDecimal
                                                              }
                                                            />
                                                            <span>
                                                              &nbsp;mg/kg
                                                            </span>
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* mg/m² option */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseStrengthElr${idx}`}
                                                            value={3}
                                                            checked={
                                                              data.patterBeforeChangeDoseStrength ===
                                                              3
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterBeforeChangeDoseStrengthMgM2Elr${idx}`}
                                                              value={
                                                                data.patterBeforeChangeDoseStrengthMgM2 ||
                                                                ""
                                                              }
                                                              type="text"
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={
                                                                AllowNumericWithDecimal
                                                              }
                                                            />
                                                            <span>
                                                              &nbsp;mg/m²
                                                            </span>
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* Unknown option */}
                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseStrengthElr${idx}`}
                                                            value={99}
                                                            checked={
                                                              data.patterBeforeChangeDoseStrength ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.patternBeforeStrengthEmpty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.strengthPatternEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.patternBeforeFrequencyRangeInvalid
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.DecimalRange
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.patternBeforeUnknownWarning
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.Q381AWarningUnk
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  )}
                                                </div>
                                              )}
                                            </td>

                                            {/* Column E: Pattern AFTER change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType === null ||
                                              data.changeType === 99 ||
                                              data.changeType === 1 ? (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              ) : (
                                                <div>
                                                  {/* Frequency Pattern - only show if changeType is 2 (Frequency) */}
                                                  {data.changeType === 2 && (
                                                    <div>
                                                      {/* Times per week */}
                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterAfterChangeDoseFrequencyElr${idx}`}
                                                            value={1}
                                                            checked={
                                                              data.patterAfterChangeDoseFrequency ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <input
                                                            className="input-dash-sm"
                                                            id={idx}
                                                            name={`patterAfterChangeDoseFrequencyTimesPerWeekElr${idx}`}
                                                            value={
                                                              data.patterAfterChangeDoseFrequencyTimesPerWeek ||
                                                              ""
                                                            }
                                                            type="text"
                                                            style={{
                                                              width: "60px",
                                                              margin: "0 5px",
                                                            }}
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                            onKeyDown={(e) => {
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              )
                                                                return;
                                                              if (
                                                                !/[0-9]/.test(
                                                                  e.key,
                                                                )
                                                              )
                                                                e.preventDefault();
                                                            }}
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            times per week
                                                          </span>
                                                        </label>
                                                      </div>
                                                      {/* Every X weeks */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterAfterChangeDoseFrequencyElr${idx}`}
                                                            value={2}
                                                            checked={
                                                              data.patterAfterChangeDoseFrequency ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                            }}
                                                          >
                                                            Every
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterAfterChangeDoseFrequencyWeekElr${idx}`}
                                                              value={
                                                                data.patterAfterChangeDoseFrequencyWeek
                                                              }
                                                              type="text"
                                                              style={{
                                                                width: "50px",
                                                                margin: "0 5px",
                                                              }}
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={(
                                                                e,
                                                              ) => {
                                                                if (
                                                                  [
                                                                    "Backspace",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Delete",
                                                                    "Tab",
                                                                  ].includes(
                                                                    e.key,
                                                                  )
                                                                )
                                                                  return;
                                                                if (
                                                                  !/[0-9]/.test(
                                                                    e.key,
                                                                  )
                                                                )
                                                                  e.preventDefault();
                                                              }}
                                                            />
                                                            week(s)
                                                          </span>
                                                        </label>
                                                      </div>
                                                      {/* Unknown */}
                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterAfterChangeDoseFrequencyElr${idx}`}
                                                            value={99}
                                                            checked={
                                                              data.patterAfterChangeDoseFrequency ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <ErrorField
                                                        show={
                                                          data.patternAfterFrequencyEmpty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.frequencyPatternEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.patternAfterFrequencyRangeInvalid
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.frequencyRange
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.patternAfterUnknownWarning
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.Q381AWarningUnk
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  )}

                                                  {/* Strength Pattern - only show if changeType is 3 (Strength) */}
                                                  {data.changeType === 3 && (
                                                    <div
                                                      style={{
                                                        marginTop:
                                                          data.changeType === 2
                                                            ? "15px"
                                                            : "0",
                                                      }}
                                                    >
                                                      {/* ✅ Option 1: mg */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterAfterChangeDoseStrengthElr${idx}`}
                                                            value={1}
                                                            checked={
                                                              data.patterAfterChangeDoseStrength ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterAfterChangeDoseStrengthMgElr${idx}`}
                                                              value={
                                                                data.patterAfterChangeDoseStrengthMg
                                                              }
                                                              type="text"
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={
                                                                AllowNumericWithDecimal
                                                              }
                                                            />
                                                            <span>
                                                              &nbsp;mg
                                                            </span>
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* ✅ Option 2: mg/kg */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterAfterChangeDoseStrengthElr${idx}`}
                                                            value={2}
                                                            checked={
                                                              data.patterAfterChangeDoseStrength ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterAfterChangeDoseStrengthMgKgElr${idx}`}
                                                              value={
                                                                data.patterAfterChangeDoseStrengthMgKg
                                                              }
                                                              type="text"
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={
                                                                AllowNumericWithDecimal
                                                              }
                                                            />
                                                            <span>
                                                              &nbsp;mg/kg
                                                            </span>
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* ✅ Option 3: mg/m² */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterAfterChangeDoseStrengthElr${idx}`}
                                                            value={3}
                                                            checked={
                                                              data.patterAfterChangeDoseStrength ===
                                                              3
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                            }}
                                                          >
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterAfterChangeDoseStrengthMgM2Elr${idx}`}
                                                              value={
                                                                data.patterAfterChangeDoseStrengthMgM2
                                                              }
                                                              type="text"
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={
                                                                AllowNumericWithDecimal
                                                              }
                                                            />
                                                            <span>
                                                              &nbsp;mg/m²
                                                            </span>
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* Unknown option */}
                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterAfterChangeDoseStrengthElr${idx}`}
                                                            value={99}
                                                            checked={
                                                              data.patterAfterChangeDoseStrength ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.patternAfterStrengthEmpty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.strengthPatternEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.patternAfterStrengthRangeInvalid
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.DecimalRange
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.patternAfterUnknownWarning
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.Q381AWarningUnk
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  )}

                                                  {/* Conflict validation errors */}
                                                  <ErrorField
                                                    show={
                                                      data.frequencyIncreaseConflict
                                                    }
                                                    message={
                                                      data.patterBeforeChangeDoseFrequency ===
                                                      1
                                                        ? ELCharacteristics_MSGS.FrequencyIncreaseConflict
                                                        : ELCharacteristics_MSGS.FrequencyDecreaseConflict
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.frequencyDecreaseConflict
                                                    }
                                                    message={
                                                      data.patterBeforeChangeDoseFrequency ===
                                                      2
                                                        ? ELCharacteristics_MSGS.FrequencyIncreaseConflict
                                                        : ELCharacteristics_MSGS.FrequencyDecreaseConflict
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.strengthIncreaseConflict
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.StrengthIncreaseConflict
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.strengthDecreaseConflict
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.StrengthDecreaseConflict
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              )}
                                            </td>

                                            {/* Column F: Date of change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "dateChangeRdElr" + idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.dateChangeRd === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`dateChangeElr-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={data.dateChange}
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "dateChangeRdElr" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.dateChangeRd ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Date of change unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.dateChangeRdEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.General
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={data.dateChangeEmpty}
                                                    message={
                                                      ELCharacteristics_MSGS.GeneralDateEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.invalidDateChange
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.dateChangeOutOfBound
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.DateChangeOutOfBound
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ))}

                            {/* Add button */}
                            {Q381AElrexDetails &&
                              Q381AElrexDetails.length > 0 &&
                              Number(Q381AElrexDetails[0].changeType) !== 1 &&
                              Number(Q381AElrexDetails[0].changeType) !==
                                99 && (
                                <div className="sub-question-bot-sapce-ul mt-2">
                                  <div
                                    className="answer-list-text"
                                    onClick={AddQ381AElrexRow}
                                  >
                                    <a>
                                      <img
                                        width="18px"
                                        src="../Assets/images/plus.png"
                                        alt=""
                                      />
                                    </a>
                                    <a className="radio-text-padding">
                                      Click here to add another dose/frequency
                                      change
                                    </a>
                                  </div>
                                </div>
                              )}
                          </div>
                        )}
                        {/* Q38.1.A End */}
                        {isLinvoveySelected && isNewEcrfA == true && (
                          <div className="question question-weight">
                            <span>Q38.1.A</span>
                            <span className="quest-text-pad">
                              Please provide information on any{" "}
                              <i>dose frequency, or dose strength</i>, changes
                              that occurred from completion of the step-up
                              dosing phase until the end of the line of therapy
                              with{" "}
                              <span
                                style={{
                                  color: PageDesignConstants.fontColor,
                                  fontWeight: "bolder",
                                }}
                              >
                                {isLinvoveySelected && (
                                  <>
                                    LYNOZYFIC<sup>TM</sup> (linvoseltamab-gcpt)
                                  </>
                                )}
                              </span>{" "}
                              Add additional rows for each type of change that
                              occurred.
                              <br />
                            </span>
                          </div>
                        )}
                        {/* Q38.1.A LINVOSELTAMAB */}
                        {isLinvoveySelected && isNewEcrfA && (
                          <div className="dependent-section">
                            {Q381ALinvoDetails &&
                              Q381ALinvoDetails.length > 0 &&
                              Q381ALinvoDetails.map((data, idx) => (
                                <div className="loop-section-ul" key={idx}>
                                  <div className="loop-head">
                                    <span
                                      className="question-weight"
                                      style={{ float: "inline-start" }}
                                    >
                                      {GetOrdinal(idx + 1)} Dose/frequency
                                      change
                                    </span>
                                    {idx !== 0 && (
                                      <div
                                        className="delete-btn-div"
                                        style={{ float: "inline-end" }}
                                      >
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            DeleteQ381ALinvoRow(idx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  {/* LINVOSELTAMAB Table */}
                                  <div className="question-bot-sapce">
                                    <div className="sub-question grid-overflow">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "150px",
                                              }}
                                            >
                                              Treatment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "250px",
                                              }}
                                            >
                                              Type of change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "280px",
                                              }}
                                            >
                                              Reason for change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Pattern <i>before</i> change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Pattern <i>after</i> change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of change
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            {/* Column A: Treatment */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span className="quest-text-pad">
                                                LYNOZYFIC
                                                <sup className="superscript">
                                                  TM
                                                </sup>{" "}
                                                (linvoquetamab-gcpt)
                                              </span>
                                            </td>

                                            {/* Column B: Type of change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "changeTypeLinvo" + idx
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.changeType === 1
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    No dose frequency or dose
                                                    strength changes occurred
                                                  </span>
                                                </label>
                                              </div>
                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "changeTypeLinvo" + idx
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.changeType === 2
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Dose frequency change
                                                  </span>
                                                </label>
                                              </div>

                                              {/* Sub-radio for Frequency Increase/Decrease */}
                                              {data.changeType === 2 && (
                                                <div
                                                  style={{
                                                    paddingLeft: "15px",
                                                  }}
                                                >
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "changeTypeDoseFrequencyLinvo" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.changeTypeDoseFrequency ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Frequency increase
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div className="option-without-input">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "changeTypeDoseFrequencyLinvo" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.changeTypeDoseFrequency ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Frequency decrease
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.changeTypeDoseFrequencyEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.ChangeTypeDoseFrequencyEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              )}

                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "changeTypeLinvo" + idx
                                                    }
                                                    value={3}
                                                    checked={
                                                      data.changeType === 3
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Dose strength change
                                                  </span>
                                                </label>
                                              </div>

                                              {/* Sub-radio for Strength Increase/Decrease */}
                                              {data.changeType === 3 && (
                                                <div
                                                  style={{
                                                    paddingLeft: "15px",
                                                  }}
                                                >
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "changeTypeDoseStrengthLinvo" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.changeTypeDoseStrength ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Strength increase
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <div className="option-without-input">
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "changeTypeDoseStrengthLinvo" +
                                                          idx
                                                        }
                                                        value={2}
                                                        checked={
                                                          data.changeTypeDoseStrength ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Strength decrease
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.changeTypeDoseStrengthEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.ChangeTypeDoseStrengthEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              )}

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={
                                                      "changeTypeLinvo" + idx
                                                    }
                                                    value={99}
                                                    checked={
                                                      data.changeType === 99
                                                    }
                                                    onChange={
                                                      HandleRepeaterFieldChange
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Unknown if any dose changes
                                                    occurred
                                                  </span>
                                                </label>
                                              </div>
                                              <ErrorField
                                                show={data.changeTypeEmpty}
                                                message={
                                                  ELCharacteristics_MSGS.ChangeTypeEmpty
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </td>

                                            {/* Column C: Reasons for change */}
                                            {/* Q38.1.A LINVOSELTAMAB - Column C - Reasons for change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  {/* Primary Reasons */}
                                                  {data.reasonList?.map(
                                                    (reason, itemidx) => (
                                                      <div
                                                        key={
                                                          reason.bispecifictreatmentdiscontinuationreasonid
                                                        }
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          flexDirection:
                                                            "column",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="checkbox"
                                                            id={`reasonLinvo_${idx}_${itemidx}`}
                                                            name={`reasonLinvo_${idx}_${itemidx}`}
                                                            idx={idx}
                                                            itemidx={itemidx}
                                                            value={
                                                              reason.bispecifictreatmentdiscontinuationreasonid
                                                            }
                                                            checked={
                                                              reason.isSelected ||
                                                              false
                                                            }
                                                            onChange={(e) =>
                                                              HandleQ381ALinvoRepeaterFieldChange(
                                                                e,
                                                                "Linvo",
                                                                reason.reasonName,
                                                                idx,
                                                                itemidx,
                                                                null,
                                                              )
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            {reason.reasonName}
                                                            {reason.superscripttext && (
                                                              <sup>
                                                                {
                                                                  reason.superscripttext
                                                                }
                                                              </sup>
                                                            )}
                                                          </span>
                                                        </label>

                                                        {/* "Other" text field - Show only if this reason contains "Other" and is selected */}
                                                        {reason.reasonName?.includes(
                                                          "Other",
                                                        ) && (
                                                          <div
                                                            style={{
                                                              paddingLeft:
                                                                "25px",
                                                              marginTop: "5px",
                                                            }}
                                                          >
                                                            <textarea
                                                              className="input-dash"
                                                              id={`reasonTextLinvo_${idx}_${itemidx}`}
                                                              name={`reasonTextLinvo_${idx}_${itemidx}`}
                                                              idx={idx}
                                                              itemidx={itemidx}
                                                              value={
                                                                Q381ALinvoDetails[
                                                                  idx
                                                                ]
                                                                  ?.reasonOtherText ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                HandleQ381ALinvoRepeaterFieldChange(
                                                                  e,
                                                                  "Linvo",
                                                                  reason.reasonName,
                                                                  idx,
                                                                  itemidx,
                                                                  null,
                                                                )
                                                              }
                                                              maxLength={300}
                                                              style={{
                                                                width: "100%",
                                                                minHeight:
                                                                  "60px",
                                                                resize:
                                                                  "vertical",
                                                              }}
                                                            />
                                                            <div
                                                              style={{
                                                                fontSize:
                                                                  "11px",
                                                                color: "#666",
                                                                marginTop:
                                                                  "2px",
                                                              }}
                                                            ></div>
                                                            <ErrorField
                                                              show={
                                                                data.reasonOtherTextEmpty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.ReasonOtherTextEmpty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        )}

                                                        {/* AE Sub-reasons - Only show if this is "Adverse event" (ID=2) and it's selected */}
                                                        {reason.bispecifictreatmentdiscontinuationreasonid ===
                                                          2 &&
                                                          reason.isSelected &&
                                                          reason.aeSubReasons
                                                            ?.length > 0 && (
                                                            <div
                                                              style={{
                                                                paddingLeft:
                                                                  "25px",
                                                                marginTop:
                                                                  "5px",
                                                              }}
                                                            >
                                                              {reason.aeSubReasons.map(
                                                                (ae, aeIdx) => {
                                                                  const aeName =
                                                                    ae.reasonName ||
                                                                    ae.bispecifictreatmentdiscontinuationreasonae ||
                                                                    "";
                                                                  const isAEUnknown =
                                                                    aeName
                                                                      .toLowerCase()
                                                                      .includes(
                                                                        "unknown",
                                                                      );

                                                                  return (
                                                                    <div
                                                                      key={
                                                                        ae.bispecifictreatmentdiscontinuationreasonaeid
                                                                      }
                                                                      className="option-without-input"
                                                                    >
                                                                      <label className="option-fbox">
                                                                        <input
                                                                          type={
                                                                            isAEUnknown
                                                                              ? "radio"
                                                                              : "checkbox"
                                                                          }
                                                                          id={`aeReasonLinvo_${idx}_${itemidx}_${aeIdx}`}
                                                                          name={
                                                                            isAEUnknown
                                                                              ? `aeUnknownLinvo_${idx}_${itemidx}`
                                                                              : `aeReasonLinvo_${idx}_${itemidx}_${aeIdx}`
                                                                          }
                                                                          idx={
                                                                            idx
                                                                          }
                                                                          itemidx={
                                                                            itemidx
                                                                          }
                                                                          aeidx={
                                                                            aeIdx
                                                                          }
                                                                          value={
                                                                            ae.bispecifictreatmentdiscontinuationreasonaeid
                                                                          }
                                                                          checked={
                                                                            ae.isSelected ||
                                                                            false
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            HandleQ381ALinvoRepeaterFieldChange(
                                                                              e,
                                                                              "Linvo",
                                                                              reason.reasonName,
                                                                              idx,
                                                                              itemidx,
                                                                              aeIdx,
                                                                            )
                                                                          }
                                                                        />
                                                                        <span
                                                                          style={{
                                                                            paddingLeft:
                                                                              "10px",
                                                                          }}
                                                                        >
                                                                          {
                                                                            ae.reasonName
                                                                          }
                                                                          {ae.superscripttext && (
                                                                            <sup>
                                                                              {
                                                                                ae.superscripttext
                                                                              }
                                                                            </sup>
                                                                          )}
                                                                        </span>
                                                                      </label>
                                                                      {ae.reasonName ===
                                                                        DiscontinuationReason.NeurologicalEvent &&
                                                                        ae.isSelected && (
                                                                          <div
                                                                            style={{
                                                                              marginLeft:
                                                                                "28px",
                                                                              marginTop:
                                                                                "8px",
                                                                            }}
                                                                          >
                                                                            {data
                                                                              .neurologicAEReasonList
                                                                              ?.length >
                                                                              0 &&
                                                                              data.neurologicAEReasonList.map(
                                                                                (
                                                                                  aeNeuro,
                                                                                  aeNeuroIdx,
                                                                                ) => {
                                                                                  return (
                                                                                    <div
                                                                                      key={
                                                                                        aeNeuroIdx
                                                                                      }
                                                                                    >
                                                                                      <label
                                                                                        className="d-flex align-items-start"
                                                                                        htmlFor={`linvo_adverse_neuro_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                      >
                                                                                        <input
                                                                                          type="checkbox"
                                                                                          id={`linvo_adverse_neuro_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          name={`linvo_adverse_neuro_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          checked={
                                                                                            aeNeuro.isSelected
                                                                                          }
                                                                                          onChange={(
                                                                                            e,
                                                                                          ) =>
                                                                                            HandleNeuroRepeaterFieldChange(
                                                                                              e,
                                                                                              "381A",
                                                                                              RRMMCohortTreatment.Linvoseltamab,
                                                                                              aeNeuroIdx,
                                                                                              idx,
                                                                                            )
                                                                                          }
                                                                                          style={{
                                                                                            marginTop:
                                                                                              "6px",
                                                                                          }}
                                                                                        />

                                                                                        <span
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                          className="radio-text-padding"
                                                                                        >
                                                                                          {
                                                                                            aeNeuro.reasonName
                                                                                          }
                                                                                        </span>
                                                                                      </label>

                                                                                      {aeNeuro.reasonName.includes(
                                                                                        "Other",
                                                                                      ) && (
                                                                                        <div>
                                                                                          <label
                                                                                            htmlFor={`linvo_neuro_reasontxt_${itemidx}_${aeNeuroIdx}`}
                                                                                          >
                                                                                            <span
                                                                                              style={{
                                                                                                paddingLeft:
                                                                                                  "28px",
                                                                                              }}
                                                                                              className="radio-text-padding"
                                                                                            >
                                                                                              <textarea
                                                                                                style={{
                                                                                                  width:
                                                                                                    "264px",
                                                                                                }}
                                                                                                id={`linvo_neuro_reasontxt_${itemidx}_${aeNeuroIdx}`}
                                                                                                name={`linvo_neuro_reasontxt_${itemidx}_${aeNeuroIdx}`}
                                                                                                type="text"
                                                                                                value={
                                                                                                  aeNeuro.reasonText
                                                                                                }
                                                                                                onChange={(
                                                                                                  e,
                                                                                                ) =>
                                                                                                  HandleNeuroRepeaterFieldChange(
                                                                                                    e,
                                                                                                    "381A",
                                                                                                    RRMMCohortTreatment.Linvoseltamab,
                                                                                                    aeNeuroIdx,
                                                                                                    idx,
                                                                                                  )
                                                                                                }
                                                                                                maxLength={
                                                                                                  300
                                                                                                }
                                                                                              />
                                                                                            </span>
                                                                                          </label>
                                                                                          <ErrorField
                                                                                            show={
                                                                                              data.neuroOtherTextEmpty
                                                                                            }
                                                                                            message={
                                                                                              ELCharacteristics_MSGS.Q38AENeurologicOther
                                                                                            }
                                                                                          />
                                                                                        </div>
                                                                                      )}
                                                                                    </div>
                                                                                  );
                                                                                },
                                                                              )}
                                                                            <ErrorField
                                                                              show={
                                                                                data.neuroReasonEmpty
                                                                              }
                                                                              message={
                                                                                ELCharacteristics_MSGS.Q38AENeurologicEmpty
                                                                              }
                                                                            />
                                                                          </div>
                                                                        )}
                                                                    </div>
                                                                  );
                                                                },
                                                              )}
                                                              <ErrorField
                                                                show={
                                                                  data.aeSubReasonEmpty
                                                                }
                                                                message={
                                                                  ELCharacteristics_MSGS.Q38AEEmpty
                                                                }
                                                                style={{
                                                                  paddingLeft:
                                                                    "0px",
                                                                }}
                                                              />
                                                            </div>
                                                          )}
                                                      </div>
                                                    ),
                                                  )}

                                                  {/* LINVOSELTAMAB - Unknown Option */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      marginTop: "5px",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "reasonUnknownLinvo" +
                                                          idx
                                                        }
                                                        checked={
                                                          data.reasonUnknown ||
                                                          false
                                                        }
                                                        value={true}
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={data.reasonEmpty}
                                                    message={
                                                      ELCharacteristics_MSGS.Q38ReasonEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={data.deathDtWarning}
                                                    message={
                                                      ELCharacteristics_MSGS.deathWarningQ20
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column D - Pattern BEFORE change - LINVOSELTAMAB */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType === null ||
                                              data.changeType === 99 ||
                                              data.changeType === 1 ? (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              ) : (
                                                <div>
                                                  {/* Frequency Pattern */}
                                                  {data.changeType === 2 && (
                                                    <div>
                                                      {/* ✅ Option 1: Times per week WITH INPUT */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <label
                                                          className="option-fbox"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseFrequencyLinvo${idx}`}
                                                            value={1}
                                                            checked={
                                                              data.patterBeforeChangeDoseFrequency ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterBeforeChangeDoseFrequencyTimesPerWeekLinvo${idx}`}
                                                              value={
                                                                data.patterBeforeChangeDoseFrequencyTimesPerWeek ||
                                                                ""
                                                              }
                                                              type="text"
                                                              style={{
                                                                width: "60px",
                                                                margin: "0 5px",
                                                              }}
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={(
                                                                e,
                                                              ) => {
                                                                if (
                                                                  [
                                                                    "Backspace",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Delete",
                                                                    "Tab",
                                                                  ].includes(
                                                                    e.key,
                                                                  )
                                                                )
                                                                  return;
                                                                if (
                                                                  !/[0-9]/.test(
                                                                    e.key,
                                                                  )
                                                                )
                                                                  e.preventDefault();
                                                              }}
                                                            />
                                                            times per week
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* Option 2: Once every X weeks */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <label
                                                          className="option-fbox"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseFrequencyLinvo${idx}`}
                                                            value={2}
                                                            checked={
                                                              data.patterBeforeChangeDoseFrequency ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            Once every
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterBeforeChangeDoseFrequencyWeekLinvo${idx}`}
                                                              value={
                                                                data.patterBeforeChangeDoseFrequencyWeek ||
                                                                ""
                                                              }
                                                              type="text"
                                                              style={{
                                                                width: "60px",
                                                                margin: "0 5px",
                                                              }}
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={(
                                                                e,
                                                              ) => {
                                                                if (
                                                                  [
                                                                    "Backspace",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Delete",
                                                                    "Tab",
                                                                  ].includes(
                                                                    e.key,
                                                                  )
                                                                )
                                                                  return;
                                                                if (
                                                                  !/[0-9]/.test(
                                                                    e.key,
                                                                  )
                                                                )
                                                                  e.preventDefault();
                                                              }}
                                                            />
                                                            week(s)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* Unknown */}
                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseFrequencyLinvo${idx}`}
                                                            value={99}
                                                            checked={
                                                              data.patterBeforeChangeDoseFrequency ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.patternBeforeFrequencyEmpty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.frequencyPatternEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.patternBeforeFrequencyRangeInvalid
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.frequencyRange
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.patternBeforeUnknownWarning
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.Q381AWarningUnk
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  )}

                                                  {/* Strength Pattern */}
                                                  {data.changeType === 3 && (
                                                    <div
                                                      style={{
                                                        marginTop:
                                                          data.changeType === 2
                                                            ? "15px"
                                                            : "0",
                                                      }}
                                                    >
                                                      {/* ✅ mg option - SEPARATE FIELD */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <label
                                                          className="option-fbox"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseStrengthLinvo${idx}`}
                                                            value={1}
                                                            checked={
                                                              data.patterBeforeChangeDoseStrength ===
                                                              1
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterBeforeChangeDoseStrengthMgLinvo${idx}`}
                                                              value={
                                                                data.patterBeforeChangeDoseStrengthMg ||
                                                                ""
                                                              }
                                                              type="text"
                                                              style={{
                                                                width: "80px",
                                                              }}
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={
                                                                AllowNumericWithDecimal
                                                              }
                                                            />
                                                            <span>
                                                              &nbsp;mg
                                                            </span>
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* ✅ mg/kg option - SEPARATE FIELD */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <label
                                                          className="option-fbox"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseStrengthLinvo${idx}`}
                                                            value={2}
                                                            checked={
                                                              data.patterBeforeChangeDoseStrength ===
                                                              2
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterBeforeChangeDoseStrengthMgKgLinvo${idx}`}
                                                              value={
                                                                data.patterBeforeChangeDoseStrengthMgKg ||
                                                                ""
                                                              }
                                                              type="text"
                                                              style={{
                                                                width: "80px",
                                                              }}
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={
                                                                AllowNumericWithDecimal
                                                              }
                                                            />
                                                            <span>
                                                              &nbsp;mg/kg
                                                            </span>
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* ✅ mg/m² option - SEPARATE FIELD */}
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <label
                                                          className="option-fbox"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseStrengthLinvo${idx}`}
                                                            value={3}
                                                            checked={
                                                              data.patterBeforeChangeDoseStrength ===
                                                              3
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <input
                                                              className="input-dash-sm"
                                                              id={idx}
                                                              name={`patterBeforeChangeDoseStrengthMgM2Linvo${idx}`}
                                                              value={
                                                                data.patterBeforeChangeDoseStrengthMgM2 ||
                                                                ""
                                                              }
                                                              type="text"
                                                              style={{
                                                                width: "80px",
                                                              }}
                                                              onChange={
                                                                HandleRepeaterFieldChange
                                                              }
                                                              onKeyDown={
                                                                AllowNumericWithDecimal
                                                              }
                                                            />
                                                            <span>
                                                              &nbsp;mg/m²
                                                            </span>
                                                          </span>
                                                        </label>
                                                      </div>

                                                      {/* Unknown */}
                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={`patterBeforeChangeDoseStrengthLinvo${idx}`}
                                                            value={99}
                                                            checked={
                                                              data.patterBeforeChangeDoseStrength ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleRepeaterFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.patternBeforeStrengthEmpty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.strengthPatternEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.patternBeforeFrequencyRangeInvalid
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.DecimalRange
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                      <ErrorField
                                                        show={
                                                          data.patternBeforeUnknownWarning
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.Q381AWarningUnk
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  )}
                                                </div>
                                              )}
                                            </td>

                                            {/* Column E: Pattern AFTER change */}
                                            {/* Column E: Pattern AFTER change - LINVOSELTAMAB */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType === 2 ? (
                                                <div>
                                                  {/* Frequency Pattern AFTER */}

                                                  {/* ✅ Option 1: Times per week - SEPARATE FIELD */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <label
                                                      className="option-fbox"
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={`patterAfterChangeDoseFrequencyLinvo${idx}`}
                                                        value={1}
                                                        checked={
                                                          data.patterAfterChangeDoseFrequency ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-sm"
                                                          id={idx}
                                                          name={`patterAfterChangeDoseFrequencyTimesPerWeekLinvo${idx}`}
                                                          value={
                                                            data.patterAfterChangeDoseFrequencyTimesPerWeek ||
                                                            ""
                                                          }
                                                          type="text"
                                                          style={{
                                                            width: "60px",
                                                            margin: "0 5px",
                                                          }}
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={(e) => {
                                                            if (
                                                              [
                                                                "Backspace",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Delete",
                                                                "Tab",
                                                              ].includes(e.key)
                                                            )
                                                              return;
                                                            if (
                                                              !/[0-9]/.test(
                                                                e.key,
                                                              )
                                                            )
                                                              e.preventDefault();
                                                          }}
                                                        />
                                                        times per week
                                                      </span>
                                                    </label>
                                                  </div>

                                                  {/* ✅ Option 2: Once every X weeks - SEPARATE FIELD */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <label
                                                      className="option-fbox"
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={`patterAfterChangeDoseFrequencyLinvo${idx}`}
                                                        value={2}
                                                        checked={
                                                          data.patterAfterChangeDoseFrequency ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        Once every
                                                        <input
                                                          className="input-dash-sm"
                                                          id={idx}
                                                          name={`patterAfterChangeDoseFrequencyWeekLinvo${idx}`}
                                                          value={
                                                            data.patterAfterChangeDoseFrequencyWeek ||
                                                            ""
                                                          }
                                                          type="text"
                                                          style={{
                                                            width: "60px",
                                                            margin: "0 5px",
                                                          }}
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={(e) => {
                                                            if (
                                                              [
                                                                "Backspace",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Delete",
                                                                "Tab",
                                                              ].includes(e.key)
                                                            )
                                                              return;
                                                            if (
                                                              !/[0-9]/.test(
                                                                e.key,
                                                              )
                                                            )
                                                              e.preventDefault();
                                                          }}
                                                        />
                                                        week(s)
                                                      </span>
                                                    </label>
                                                  </div>

                                                  {/* Unknown */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={`patterAfterChangeDoseFrequencyLinvo${idx}`}
                                                        value={99}
                                                        checked={
                                                          data.patterAfterChangeDoseFrequency ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.patternAfterFrequencyEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.frequencyPatternEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternAfterFrequencyRangeInvalid
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.frequencyRange
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.frequencyIncreaseConflict
                                                    }
                                                    message={
                                                      data.patterBeforeChangeDoseFrequency ===
                                                      1
                                                        ? ELCharacteristics_MSGS.FrequencyIncreaseConflict
                                                        : ELCharacteristics_MSGS.FrequencyDecreaseConflict
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.frequencyDecreaseConflict
                                                    }
                                                    message={
                                                      data.patterBeforeChangeDoseFrequency ===
                                                      2
                                                        ? ELCharacteristics_MSGS.FrequencyIncreaseConflict
                                                        : ELCharacteristics_MSGS.FrequencyDecreaseConflict
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternAfterUnknownWarning
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.Q381AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : data.changeType === 3 ? (
                                                <div>
                                                  {/* Strength Pattern AFTER */}

                                                  {/* ✅ mg option - SEPARATE FIELD */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <label
                                                      className="option-fbox"
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={`patterAfterChangeDoseStrengthLinvo${idx}`}
                                                        value={1}
                                                        checked={
                                                          data.patterAfterChangeDoseStrength ===
                                                          1
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-sm"
                                                          id={idx}
                                                          name={`patterAfterChangeDoseStrengthMgLinvo${idx}`}
                                                          value={
                                                            data.patterAfterChangeDoseStrengthMg ||
                                                            ""
                                                          }
                                                          type="text"
                                                          style={{
                                                            width: "80px",
                                                          }}
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                        />
                                                        <span>&nbsp;mg</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  {/* ✅ mg/kg option - SEPARATE FIELD */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <label
                                                      className="option-fbox"
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={`patterAfterChangeDoseStrengthLinvo${idx}`}
                                                        value={2}
                                                        checked={
                                                          data.patterAfterChangeDoseStrength ===
                                                          2
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-sm"
                                                          id={idx}
                                                          name={`patterAfterChangeDoseStrengthMgKgLinvo${idx}`}
                                                          value={
                                                            data.patterAfterChangeDoseStrengthMgKg ||
                                                            ""
                                                          }
                                                          type="text"
                                                          style={{
                                                            width: "80px",
                                                          }}
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                        />
                                                        <span>&nbsp;mg/kg</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  {/* ✅ mg/m² option - SEPARATE FIELD */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <label
                                                      className="option-fbox"
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={`patterAfterChangeDoseStrengthLinvo${idx}`}
                                                        value={3}
                                                        checked={
                                                          data.patterAfterChangeDoseStrength ===
                                                          3
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <input
                                                          className="input-dash-sm"
                                                          id={idx}
                                                          name={`patterAfterChangeDoseStrengthMgM2Linvo${idx}`}
                                                          value={
                                                            data.patterAfterChangeDoseStrengthMgM2 ||
                                                            ""
                                                          }
                                                          type="text"
                                                          style={{
                                                            width: "80px",
                                                          }}
                                                          onChange={
                                                            HandleRepeaterFieldChange
                                                          }
                                                          onKeyDown={
                                                            AllowNumericWithDecimal
                                                          }
                                                        />
                                                        <span>&nbsp;mg/m²</span>
                                                      </span>
                                                    </label>
                                                  </div>

                                                  {/* Unknown */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={`patterAfterChangeDoseStrengthLinvo${idx}`}
                                                        value={99}
                                                        checked={
                                                          data.patterAfterChangeDoseStrength ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                          display: "flex",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={
                                                      data.patternAfterStrengthEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.strengthPatternEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.patternAfterStrengthRangeInvalid
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.DecimalRange
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.strengthIncreaseConflict
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.StrengthIncreaseConflict
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.strengthDecreaseConflict
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.StrengthDecreaseConflict
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.patternAfterUnknownWarning
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.Q381AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column F: Date of change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "dateChangeRdLinvo" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.dateChangeRd === 1
                                                      }
                                                      onChange={
                                                        HandleRepeaterFieldChange
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`dateChangeLinvo-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={data.dateChange}
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "dateChangeRdLinvo" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.dateChangeRd ===
                                                          99
                                                        }
                                                        onChange={
                                                          HandleRepeaterFieldChange
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Date of change unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.dateChangeRdEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.General
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={data.dateChangeEmpty}
                                                    message={
                                                      ELCharacteristics_MSGS.DateChangeEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.invalidDateChange
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.dateChangeOutOfBound
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.DateChangeOutOfBound
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ))}

                            {/* Add button */}
                            {Q381ALinvoDetails &&
                              Q381ALinvoDetails.length > 0 &&
                              Number(Q381ALinvoDetails[0].changeType) !== 1 &&
                              Number(Q381ALinvoDetails[0].changeType) !==
                                99 && (
                                <div className="sub-question-bot-sapce-ul mt-2">
                                  <div
                                    className="answer-list-text"
                                    onClick={AddQ381ALinvoRow}
                                  >
                                    <a>
                                      <img
                                        width="18px"
                                        src="../Assets/images/plus.png"
                                        alt=""
                                      />
                                    </a>
                                    <a className="radio-text-padding">
                                      Click here to add another dose/frequency
                                      change
                                    </a>
                                  </div>
                                </div>
                              )}
                          </div>
                        )}
                        {/* Q38.1.A End */}
                        <br></br> <br></br>
                        {/* Q38.2 NEw changes */}
                        {isElrexvayliSelected && isNewEcrfA == true && (
                          <div className="question question-weight">
                            <span>Q38.2.A</span>
                            <span className="quest-text-pad">
                              Please provide information on any{" "}
                              <i>dose interruptions or dose delays</i>, that
                              occurred from completion of the step-up dosing
                              phase until the end of the line of therapy with{" "}
                              <span
                                style={{
                                  color: PageDesignConstants.fontColor,
                                  fontWeight: "bolder",
                                }}
                              >
                                {isElrexvayliSelected && (
                                  <>
                                    ELREXFIO<sup>TM</sup> (elranatamab-bcmm)
                                  </>
                                )}
                              </span>{" "}
                              Add additional rows for each interruption/delay
                              that occurred.
                              <br />
                            </span>
                          </div>
                        )}
                        {/* Q38.2.A ELREXFIO */}
                        {isElrexvayliSelected && isNewEcrfA && (
                          <div className="dependent-section">
                            {Q382AElrexDetails &&
                              Q382AElrexDetails.length > 0 &&
                              Q382AElrexDetails.map((data, idx) => (
                                <div className="loop-section-ul" key={idx}>
                                  <div className="loop-head">
                                    <span
                                      className="question-weight"
                                      style={{ float: "inline-start" }}
                                    >
                                      {GetOrdinal(idx + 1)} Dose interruptions/
                                      Dose delay
                                    </span>
                                    {idx !== 0 && (
                                      <div
                                        className="delete-btn-div"
                                        style={{ float: "inline-end" }}
                                      >
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            DeleteQ382AElrexRow(idx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  {/* ELREXFIO Table */}
                                  <div className="question-bot-sapce">
                                    <div className="sub-question grid-overflow">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Treatment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Type of change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "280px",
                                              }}
                                            >
                                              Reason for change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Start of dose interruption/delay
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              End of dose interruption/delay
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            {/* Column A: Treatment */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span className="quest-text-pad">
                                                ELREXFIO<sup>TM</sup>{" "}
                                                (elranatamab-bcmm)
                                              </span>
                                            </td>

                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {/* Radio 1 - No interruption/delay */}
                                              <div className="option-without-input">
                                                <label className="d-flex align-items-start">
                                                  <input
                                                    style={{ marginTop: "6px" }}
                                                    type="radio"
                                                    id={idx}
                                                    name={`changeTypeElr382A${idx}`}
                                                    value="1"
                                                    checked={
                                                      Number(
                                                        data.changeType,
                                                      ) === 1
                                                    }
                                                    onChange={(e) =>
                                                      HandleQ382RepeaterFieldChange(
                                                        e,
                                                        "Elrexfio",
                                                        idx,
                                                      )
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    No dose interruption or
                                                    delay occurred
                                                  </span>
                                                </label>
                                              </div>

                                              {/* Radio 2 - Interruption/delay */}
                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={`changeTypeElr382A${idx}`}
                                                    value="2"
                                                    checked={
                                                      Number(
                                                        data.changeType,
                                                      ) === 2
                                                    }
                                                    onChange={(e) =>
                                                      HandleQ382RepeaterFieldChange(
                                                        e,
                                                        "Elrexfio",
                                                        idx,
                                                      )
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Dose interruption or delay
                                                  </span>
                                                </label>
                                              </div>

                                              {/* Radio 3 - Unknown */}
                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={`changeTypeElr382A${idx}`}
                                                    value="99"
                                                    checked={
                                                      Number(
                                                        data.changeType,
                                                      ) === 99
                                                    }
                                                    onChange={(e) =>
                                                      HandleQ382RepeaterFieldChange(
                                                        e,
                                                        "Elrexfio",
                                                        idx,
                                                      )
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Unknown if dose interruption
                                                    or delay occurred
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={data.changeTypeEmpty}
                                                message={
                                                  ELCharacteristics_MSGS.ChangeTypeEmpty
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </td>

                                            {/* Column C: Reasons for change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  {/* Primary Reasons */}
                                                  {data.reasonList?.map(
                                                    (reason, itemidx) => (
                                                      <div
                                                        key={
                                                          reason.bispecifictreatmentdiscontinuationreasonid
                                                        }
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          flexDirection:
                                                            "column",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="checkbox"
                                                            id={`reasonElr_${idx}_${itemidx}`}
                                                            name={`reasonElr_${idx}_${itemidx}`}
                                                            idx={idx}
                                                            itemidx={itemidx}
                                                            value={
                                                              reason.bispecifictreatmentdiscontinuationreasonid
                                                            }
                                                            checked={
                                                              reason.isSelected ||
                                                              false
                                                            }
                                                            onChange={(e) =>
                                                              HandleQ382ARepeaterChange(
                                                                e,
                                                                "Elrex",
                                                                reason.reasonName,
                                                                idx,
                                                                itemidx,
                                                                null,
                                                              )
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            {reason.reasonName}
                                                            {reason.superscripttext && (
                                                              <sup>
                                                                {
                                                                  reason.superscripttext
                                                                }
                                                              </sup>
                                                            )}
                                                          </span>
                                                        </label>

                                                        {/* "Other" text field - Show only if this reason contains "Other" and is selected */}
                                                        {reason.reasonName?.includes(
                                                          "Other",
                                                        ) && (
                                                          <div
                                                            style={{
                                                              paddingLeft:
                                                                "25px",
                                                              marginTop: "5px",
                                                            }}
                                                          >
                                                            <textarea
                                                              className="input-dash"
                                                              id={`reasonTextElr_${idx}_${itemidx}`}
                                                              name={`reasonTextElr_${idx}_${itemidx}`}
                                                              idx={idx}
                                                              itemidx={itemidx}
                                                              value={
                                                                Q382AElrexDetails[
                                                                  idx
                                                                ]
                                                                  ?.reasonOtherText ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                HandleQ382ARepeaterChange(
                                                                  e,
                                                                  "Elrex",
                                                                  reason.reasonName,
                                                                  idx,
                                                                  itemidx,
                                                                  null,
                                                                )
                                                              }
                                                              maxLength={300}
                                                              style={{
                                                                width: "100%",
                                                                minHeight:
                                                                  "60px",
                                                                resize:
                                                                  "vertical",
                                                              }}
                                                            />
                                                            <div
                                                              style={{
                                                                fontSize:
                                                                  "11px",
                                                                color: "#666",
                                                                marginTop:
                                                                  "2px",
                                                              }}
                                                            ></div>
                                                            <ErrorField
                                                              show={
                                                                data.reasonOtherTextEmpty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.ReasonOtherTextEmpty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        )}

                                                        {/* AE Sub-reasons - Only show if this is "Adverse event" (ID=2) and it's selected */}
                                                        {reason.bispecifictreatmentdiscontinuationreasonid ===
                                                          2 &&
                                                          reason.isSelected &&
                                                          reason.aeSubReasons
                                                            ?.length > 0 && (
                                                            <div
                                                              style={{
                                                                paddingLeft:
                                                                  "25px",
                                                                marginTop:
                                                                  "5px",
                                                              }}
                                                            >
                                                              {reason.aeSubReasons.map(
                                                                (ae, aeIdx) => {
                                                                  // ✅ Check if this is "AE type unknown" - check BOTH possible property names
                                                                  const aeName =
                                                                    ae.reasonName ||
                                                                    ae.bispecifictreatmentdiscontinuationreasonae ||
                                                                    "";
                                                                  const isAEUnknown =
                                                                    aeName
                                                                      .toLowerCase()
                                                                      .includes(
                                                                        "unknown",
                                                                      );

                                                                  return (
                                                                    <div
                                                                      key={
                                                                        ae.bispecifictreatmentdiscontinuationreasonaeid
                                                                      }
                                                                      className="option-without-input"
                                                                    >
                                                                      <label className="option-fbox">
                                                                        <input
                                                                          type={
                                                                            isAEUnknown
                                                                              ? "radio"
                                                                              : "checkbox"
                                                                          } // ✅ Radio for unknown, checkbox for others
                                                                          id={`aeReasonElr_${idx}_${itemidx}_${aeIdx}`}
                                                                          name={
                                                                            isAEUnknown
                                                                              ? `aeUnknownElr_${idx}_${itemidx}`
                                                                              : `aeReasonElr_${idx}_${itemidx}_${aeIdx}`
                                                                          }
                                                                          idx={
                                                                            idx
                                                                          }
                                                                          itemidx={
                                                                            itemidx
                                                                          }
                                                                          aeidx={
                                                                            aeIdx
                                                                          }
                                                                          value={
                                                                            ae.bispecifictreatmentdiscontinuationreasonaeid
                                                                          }
                                                                          checked={
                                                                            ae.isSelected ||
                                                                            false
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            HandleQ382ARepeaterChange(
                                                                              e,
                                                                              "Elrex",
                                                                              reason.reasonName,
                                                                              idx,
                                                                              itemidx,
                                                                              aeIdx,
                                                                            )
                                                                          }
                                                                        />
                                                                        <span
                                                                          style={{
                                                                            paddingLeft:
                                                                              "10px",
                                                                          }}
                                                                        >
                                                                          {
                                                                            ae.reasonName
                                                                          }{" "}
                                                                          {/* ✅ Using the correct property name from your original code */}
                                                                          {ae.superscripttext && (
                                                                            <sup>
                                                                              {
                                                                                ae.superscripttext
                                                                              }
                                                                            </sup>
                                                                          )}
                                                                        </span>
                                                                      </label>
                                                                      {ae.reasonName ===
                                                                        DiscontinuationReason.NeurologicalEvent &&
                                                                        ae.isSelected && (
                                                                          <div
                                                                            style={{
                                                                              marginLeft:
                                                                                "28px",
                                                                              marginTop:
                                                                                "8px",
                                                                            }}
                                                                          >
                                                                            {data
                                                                              .neurologicAEReasonList
                                                                              ?.length >
                                                                              0 &&
                                                                              data.neurologicAEReasonList.map(
                                                                                (
                                                                                  aeNeuro,
                                                                                  aeNeuroIdx,
                                                                                ) => {
                                                                                  return (
                                                                                    <div
                                                                                      key={
                                                                                        aeNeuroIdx
                                                                                      }
                                                                                    >
                                                                                      <label
                                                                                        className="d-flex align-items-start"
                                                                                        htmlFor={`adverse_neuro_elr_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                      >
                                                                                        <input
                                                                                          type="checkbox"
                                                                                          id={`adverse_neuro_elr_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          name={`adverse_neuro_elr_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          checked={
                                                                                            aeNeuro.isSelected
                                                                                          }
                                                                                          onChange={(
                                                                                            e,
                                                                                          ) =>
                                                                                            HandleNeuroRepeaterFieldChange(
                                                                                              e,
                                                                                              "382A",
                                                                                              RRMMCohortTreatment.ELREXFIO,
                                                                                              aeNeuroIdx,
                                                                                              idx,
                                                                                            )
                                                                                          }
                                                                                          style={{
                                                                                            marginTop:
                                                                                              "6px",
                                                                                          }}
                                                                                        />

                                                                                        <span
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                          className="radio-text-padding"
                                                                                        >
                                                                                          {
                                                                                            aeNeuro.reasonName
                                                                                          }
                                                                                        </span>
                                                                                      </label>

                                                                                      {aeNeuro.reasonName.includes(
                                                                                        "Other",
                                                                                      ) && (
                                                                                        <div>
                                                                                          <label
                                                                                            htmlFor={`neuro_reasontxt_elr_${itemidx}_${aeNeuroIdx}`}
                                                                                          >
                                                                                            <span
                                                                                              style={{
                                                                                                paddingLeft:
                                                                                                  "28px",
                                                                                              }}
                                                                                              className="radio-text-padding"
                                                                                            >
                                                                                              <textarea
                                                                                                style={{
                                                                                                  width:
                                                                                                    "264px",
                                                                                                }}
                                                                                                id={`neuro_reasontxt_elr_${itemidx}_${aeNeuroIdx}`}
                                                                                                name={`neuro_reasontxt_elr_${itemidx}_${aeNeuroIdx}`}
                                                                                                type="text"
                                                                                                value={
                                                                                                  aeNeuro.reasonText
                                                                                                }
                                                                                                onChange={(
                                                                                                  e,
                                                                                                ) =>
                                                                                                  HandleNeuroRepeaterFieldChange(
                                                                                                    e,
                                                                                                    "382A",
                                                                                                    RRMMCohortTreatment.ELREXFIO,
                                                                                                    aeNeuroIdx,
                                                                                                    idx,
                                                                                                  )
                                                                                                }
                                                                                                maxLength={
                                                                                                  300
                                                                                                }
                                                                                              />
                                                                                            </span>
                                                                                          </label>
                                                                                          <ErrorField
                                                                                            show={
                                                                                              data.neuroOtherTextEmpty
                                                                                            }
                                                                                            message={
                                                                                              ELCharacteristics_MSGS.Q38AENeurologicOther
                                                                                            }
                                                                                          />
                                                                                        </div>
                                                                                      )}
                                                                                    </div>
                                                                                  );
                                                                                },
                                                                              )}
                                                                            <ErrorField
                                                                              show={
                                                                                data.neuroReasonEmpty
                                                                              }
                                                                              message={
                                                                                ELCharacteristics_MSGS.Q38AENeurologicEmpty
                                                                              }
                                                                            />
                                                                          </div>
                                                                        )}
                                                                    </div>
                                                                  );
                                                                },
                                                              )}
                                                              <ErrorField
                                                                show={
                                                                  data.aeSubReasonEmpty
                                                                }
                                                                message={
                                                                  ELCharacteristics_MSGS.Q38AEEmpty
                                                                }
                                                                style={{
                                                                  paddingLeft:
                                                                    "0px",
                                                                }}
                                                              />
                                                            </div>
                                                          )}
                                                      </div>
                                                    ),
                                                  )}

                                                  {/* ELREXFIO - Unknown Option */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "reasonUnknownElr382A" +
                                                          idx
                                                        }
                                                        checked={
                                                          data.reasonUnknown ||
                                                          false
                                                        }
                                                        value={true}
                                                        onChange={(e) =>
                                                          HandleQ382RepeaterFieldChange(
                                                            e,
                                                            "Elrexfio",
                                                            idx,
                                                          )
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={data.reasonEmpty}
                                                    message={
                                                      ELCharacteristics_MSGS.Q38ReasonEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={data.deathDtWarning}
                                                    message={
                                                      ELCharacteristics_MSGS.deathWarningQ20
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column D: Date of change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "startDateChangeRdElr" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.startDateChangeRd ===
                                                        1
                                                      }
                                                      onChange={(e) =>
                                                        HandleQ382RepeaterFieldChange(
                                                          e,
                                                          "Elrexfio",
                                                          idx,
                                                        )
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`startDateChangeElr-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={
                                                          data.startDateChange
                                                        }
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "startDateChangeRdElr" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.startDateChangeRd ===
                                                          99
                                                        }
                                                        onChange={(e) =>
                                                          HandleQ382RepeaterFieldChange(
                                                            e,
                                                            "Elrexfio",
                                                            idx,
                                                          )
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Start date of dose
                                                        interruption or delay
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.startDateChangeRdEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.General
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.startDateChangeEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.DateChangeEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.invalidStartDateChange
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.startDateChangeOutOfBound
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.DateChangeOutOfBound
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.interruptionStartDateUnknownWarning
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.Q382AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "endDateChangeRdElr" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.endDateChangeRd ===
                                                          1
                                                        }
                                                        onChange={(e) =>
                                                          HandleQ382RepeaterFieldChange(
                                                            e,
                                                            "Elrexfio",
                                                            idx,
                                                          )
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Dose interruption or
                                                        delay ongoing
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "endDateChangeRdElr" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.endDateChangeRd ===
                                                        2
                                                      }
                                                      onChange={(e) =>
                                                        HandleQ382RepeaterFieldChange(
                                                          e,
                                                          "Elrexfio",
                                                          idx,
                                                        )
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`endDateChangeElr-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={
                                                          data.endDateChange
                                                        }
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "endDateChangeRdElr" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.endDateChangeRd ===
                                                          99
                                                        }
                                                        onChange={(e) =>
                                                          HandleQ382RepeaterFieldChange(
                                                            e,
                                                            "Elrexfio",
                                                            idx,
                                                          )
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        End date of dose
                                                        interruption or delay
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.endDateChangeRdEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.General
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.endDateChangeEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.DateChangeEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.invalidEndDateChange
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.endDateChangeOutOfBound
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.DateChangeOutOfBound
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.interruptionEndDateUnknownWarning
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.Q382AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ))}

                            {/* Add button */}
                            {Q382AElrexDetails &&
                              Q382AElrexDetails.length > 0 &&
                              Number(Q382AElrexDetails[0].changeType) !== 1 &&
                              Number(Q382AElrexDetails[0].changeType) !==
                                99 && (
                                <div className="sub-question-bot-sapce-ul mt-2">
                                  <div
                                    className="answer-list-text"
                                    onClick={AddQ382AElrexRow}
                                  >
                                    <a>
                                      <img
                                        width="18px"
                                        src="../Assets/images/plus.png"
                                        alt=""
                                      />
                                    </a>
                                    <a className="radio-text-padding">
                                      Click here to add another dose
                                      interruption/delay
                                    </a>
                                  </div>
                                </div>
                              )}
                          </div>
                        )}
                        {/* Q38.2.A End */}
                        {/* Q38.2 NEw changes */}
                        {isLinvoveySelected && isNewEcrfA == true && (
                          <div className="question question-weight">
                            <span>Q38.2.A</span>
                            <span className="quest-text-pad">
                              Please provide information on any{" "}
                              <i>dose interruptions or dose delays</i>, that
                              occurred from completion of the step-up dosing
                              phase until the end of the line of therapy with{" "}
                              <span
                                style={{
                                  color: PageDesignConstants.fontColor,
                                  fontWeight: "bolder",
                                }}
                              >
                                {isLinvoveySelected && (
                                  <>
                                    LYNOZYFIC<sup>TM</sup> (linvoseltamab-gcpt)
                                  </>
                                )}
                              </span>{" "}
                              Add additional rows for each interruption/delay
                              that occurred.
                              <br />
                            </span>
                          </div>
                        )}
                        {/* Q38.2.A LINVOSELTAMAB */}
                        {isLinvoveySelected && isNewEcrfA && (
                          <div className="dependent-section">
                            {Q382ALinvoDetails &&
                              Q382ALinvoDetails.length > 0 &&
                              Q382ALinvoDetails.map((data, idx) => (
                                <div className="loop-section-ul" key={idx}>
                                  <div className="loop-head">
                                    <span
                                      className="question-weight"
                                      style={{ float: "inline-start" }}
                                    >
                                      {GetOrdinal(idx + 1)} Dose interruptions/
                                      Dose delay
                                    </span>
                                    {idx !== 0 && (
                                      <div
                                        className="delete-btn-div"
                                        style={{ float: "inline-end" }}
                                      >
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            DeleteQ382ALinvoRow(idx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>

                                  {/* LINVOSELTAMAB Table */}
                                  <div className="question-bot-sapce">
                                    <div className="sub-question grid-overflow">
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Treatment
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Type of change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "280px",
                                              }}
                                            >
                                              Reason for change
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Start of dose interruption/delay
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              End of dose interruption/delay
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            {/* Column A: Treatment */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <span className="quest-text-pad">
                                                LYNOZYFIC
                                                <sup className="superscript">
                                                  TM
                                                </sup>{" "}
                                                (linvoquetamab-gcpt)
                                              </span>
                                            </td>

                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={`changeTypeLinvo382A${idx}`}
                                                    value="1"
                                                    checked={
                                                      Number(
                                                        data.changeType,
                                                      ) === 1
                                                    }
                                                    onChange={(e) =>
                                                      HandleQ382RepeaterFieldChange(
                                                        e,
                                                        "Linvo",
                                                        idx,
                                                      )
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    No dose interruption or
                                                    delay occurred
                                                  </span>
                                                </label>
                                              </div>

                                              <div className="option-without-input">
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={`changeTypeLinvo382A${idx}`}
                                                    value="2"
                                                    checked={
                                                      Number(
                                                        data.changeType,
                                                      ) === 2
                                                    }
                                                    onChange={(e) =>
                                                      HandleQ382RepeaterFieldChange(
                                                        e,
                                                        "Linvo",
                                                        idx,
                                                      )
                                                    }
                                                  />
                                                  <span
                                                    className="radio-text-padding"
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "-5px",
                                                    }}
                                                  >
                                                    Dose interruption or delay
                                                  </span>
                                                </label>
                                              </div>

                                              <div
                                                className="option-without-input"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    style={{ marginTop: "6px" }}
                                                    id={idx}
                                                    name={`changeTypeLinvo382A${idx}`}
                                                    value="99"
                                                    checked={
                                                      Number(
                                                        data.changeType,
                                                      ) === 99
                                                    }
                                                    onChange={(e) =>
                                                      HandleQ382RepeaterFieldChange(
                                                        e,
                                                        "Linvo",
                                                        idx,
                                                      )
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Unknown if dose interruption
                                                    or delay occurred
                                                  </span>
                                                </label>
                                              </div>

                                              <ErrorField
                                                show={data.changeTypeEmpty}
                                                message={
                                                  ELCharacteristics_MSGS.ChangeTypeEmpty
                                                }
                                                style={{ paddingLeft: "0px" }}
                                              />
                                            </td>

                                            {/* Column C: Reasons for change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "start",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  {/* Primary Reasons */}
                                                  {data.reasonList?.map(
                                                    (reason, itemidx) => (
                                                      <div
                                                        key={
                                                          reason.bispecifictreatmentdiscontinuationreasonid
                                                        }
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          flexDirection:
                                                            "column",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <input
                                                            type="checkbox"
                                                            id={`reasonLinvo_${idx}_${itemidx}`}
                                                            name={`reasonLinvo_${idx}_${itemidx}`}
                                                            idx={idx}
                                                            itemidx={itemidx}
                                                            value={
                                                              reason.bispecifictreatmentdiscontinuationreasonid
                                                            }
                                                            checked={
                                                              reason.isSelected ||
                                                              false
                                                            }
                                                            onChange={(e) =>
                                                              HandleQ382ARepeaterChange(
                                                                e,
                                                                "Linvo",
                                                                reason.reasonName,
                                                                idx,
                                                                itemidx,
                                                                null,
                                                              )
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            {reason.reasonName}
                                                            {reason.superscripttext && (
                                                              <sup>
                                                                {
                                                                  reason.superscripttext
                                                                }
                                                              </sup>
                                                            )}
                                                          </span>
                                                        </label>

                                                        {/* "Other" text field - Show only if this reason contains "Other" and is selected */}
                                                        {reason.reasonName?.includes(
                                                          "Other",
                                                        ) && (
                                                          <div
                                                            style={{
                                                              paddingLeft:
                                                                "25px",
                                                              marginTop: "5px",
                                                            }}
                                                          >
                                                            <textarea
                                                              className="input-dash"
                                                              id={`reasonTextLinvo_${idx}_${itemidx}`}
                                                              name={`reasonTextLinvo_${idx}_${itemidx}`}
                                                              idx={idx}
                                                              itemidx={itemidx}
                                                              value={
                                                                Q382ALinvoDetails[
                                                                  idx
                                                                ]
                                                                  ?.reasonOtherText ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                HandleQ382ARepeaterChange(
                                                                  e,
                                                                  "Linvo",
                                                                  reason.reasonName,
                                                                  idx,
                                                                  itemidx,
                                                                  null,
                                                                )
                                                              }
                                                              maxLength={300}
                                                              style={{
                                                                width: "100%",
                                                                minHeight:
                                                                  "60px",
                                                                resize:
                                                                  "vertical",
                                                              }}
                                                            />
                                                            <div
                                                              style={{
                                                                fontSize:
                                                                  "11px",
                                                                color: "#666",
                                                                marginTop:
                                                                  "2px",
                                                              }}
                                                            ></div>
                                                            <ErrorField
                                                              show={
                                                                data.reasonOtherTextEmpty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.ReasonOtherTextEmpty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        )}

                                                        {/* AE Sub-reasons - Only show if this is "Adverse event" (ID=2) and it's selected */}
                                                        {reason.bispecifictreatmentdiscontinuationreasonid ===
                                                          2 &&
                                                          reason.isSelected &&
                                                          reason.aeSubReasons
                                                            ?.length > 0 && (
                                                            <div
                                                              style={{
                                                                paddingLeft:
                                                                  "25px",
                                                                marginTop:
                                                                  "5px",
                                                              }}
                                                            >
                                                              {reason.aeSubReasons.map(
                                                                (ae, aeIdx) => {
                                                                  const aeName =
                                                                    ae.reasonName ||
                                                                    ae.bispecifictreatmentdiscontinuationreasonae ||
                                                                    "";
                                                                  const isAEUnknown =
                                                                    aeName
                                                                      .toLowerCase()
                                                                      .includes(
                                                                        "unknown",
                                                                      );

                                                                  return (
                                                                    <div
                                                                      key={
                                                                        ae.bispecifictreatmentdiscontinuationreasonaeid
                                                                      }
                                                                      className="option-without-input"
                                                                    >
                                                                      <label className="option-fbox">
                                                                        <input
                                                                          type={
                                                                            isAEUnknown
                                                                              ? "radio"
                                                                              : "checkbox"
                                                                          }
                                                                          id={`aeReasonLinvo_${idx}_${itemidx}_${aeIdx}`}
                                                                          name={
                                                                            isAEUnknown
                                                                              ? `aeUnknownLinvo_${idx}_${itemidx}`
                                                                              : `aeReasonLinvo_${idx}_${itemidx}_${aeIdx}`
                                                                          }
                                                                          idx={
                                                                            idx
                                                                          }
                                                                          itemidx={
                                                                            itemidx
                                                                          }
                                                                          aeidx={
                                                                            aeIdx
                                                                          }
                                                                          value={
                                                                            ae.bispecifictreatmentdiscontinuationreasonaeid
                                                                          }
                                                                          checked={
                                                                            ae.isSelected ||
                                                                            false
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            HandleQ382ARepeaterChange(
                                                                              e,
                                                                              "Linvo",
                                                                              reason.reasonName,
                                                                              idx,
                                                                              itemidx,
                                                                              aeIdx,
                                                                            )
                                                                          }
                                                                        />
                                                                        <span
                                                                          style={{
                                                                            paddingLeft:
                                                                              "10px",
                                                                          }}
                                                                        >
                                                                          {
                                                                            ae.reasonName
                                                                          }
                                                                          {ae.superscripttext && (
                                                                            <sup>
                                                                              {
                                                                                ae.superscripttext
                                                                              }
                                                                            </sup>
                                                                          )}
                                                                        </span>
                                                                      </label>
                                                                      {ae.reasonName ===
                                                                        DiscontinuationReason.NeurologicalEvent &&
                                                                        ae.isSelected && (
                                                                          <div
                                                                            style={{
                                                                              marginLeft:
                                                                                "28px",
                                                                              marginTop:
                                                                                "8px",
                                                                            }}
                                                                          >
                                                                            {data
                                                                              .neurologicAEReasonList
                                                                              ?.length >
                                                                              0 &&
                                                                              data.neurologicAEReasonList.map(
                                                                                (
                                                                                  aeNeuro,
                                                                                  aeNeuroIdx,
                                                                                ) => {
                                                                                  return (
                                                                                    <div
                                                                                      key={
                                                                                        aeNeuroIdx
                                                                                      }
                                                                                    >
                                                                                      <label
                                                                                        className="d-flex align-items-start"
                                                                                        htmlFor={`adverse_neuro_linvo_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                      >
                                                                                        <input
                                                                                          type="checkbox"
                                                                                          id={`adverse_neuro_linvo_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          name={`adverse_neuro_linvo_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                          checked={
                                                                                            aeNeuro.isSelected
                                                                                          }
                                                                                          onChange={(
                                                                                            e,
                                                                                          ) =>
                                                                                            HandleNeuroRepeaterFieldChange(
                                                                                              e,
                                                                                              "382A",
                                                                                              RRMMCohortTreatment.Linvoseltamab,
                                                                                              aeNeuroIdx,
                                                                                              idx,
                                                                                            )
                                                                                          }
                                                                                          style={{
                                                                                            marginTop:
                                                                                              "6px",
                                                                                          }}
                                                                                        />

                                                                                        <span
                                                                                          style={{
                                                                                            textAlign:
                                                                                              "left",
                                                                                          }}
                                                                                          className="radio-text-padding"
                                                                                        >
                                                                                          {
                                                                                            aeNeuro.reasonName
                                                                                          }
                                                                                        </span>
                                                                                      </label>

                                                                                      {aeNeuro.reasonName.includes(
                                                                                        "Other",
                                                                                      ) && (
                                                                                        <div>
                                                                                          <label
                                                                                            htmlFor={`neuro_reasontxt_linvo_${itemidx}_${aeNeuroIdx}`}
                                                                                          >
                                                                                            <span
                                                                                              style={{
                                                                                                paddingLeft:
                                                                                                  "28px",
                                                                                              }}
                                                                                              className="radio-text-padding"
                                                                                            >
                                                                                              <textarea
                                                                                                style={{
                                                                                                  width:
                                                                                                    "264px",
                                                                                                }}
                                                                                                id={`neuro_reasontxt_linvo_${itemidx}_${aeNeuroIdx}`}
                                                                                                name={`neuro_reasontxt_linvo_${itemidx}_${aeNeuroIdx}`}
                                                                                                type="text"
                                                                                                value={
                                                                                                  aeNeuro.reasonText
                                                                                                }
                                                                                                onChange={(
                                                                                                  e,
                                                                                                ) =>
                                                                                                  HandleNeuroRepeaterFieldChange(
                                                                                                    e,
                                                                                                    "382A",
                                                                                                    RRMMCohortTreatment.Linvoseltamab,
                                                                                                    aeNeuroIdx,
                                                                                                    idx,
                                                                                                  )
                                                                                                }
                                                                                                maxLength={
                                                                                                  300
                                                                                                }
                                                                                              />
                                                                                            </span>
                                                                                          </label>
                                                                                          <ErrorField
                                                                                            show={
                                                                                              data.neuroOtherTextEmpty
                                                                                            }
                                                                                            message={
                                                                                              ELCharacteristics_MSGS.Q38AENeurologicOther
                                                                                            }
                                                                                          />
                                                                                        </div>
                                                                                      )}
                                                                                    </div>
                                                                                  );
                                                                                },
                                                                              )}
                                                                            <ErrorField
                                                                              show={
                                                                                data.neuroReasonEmpty
                                                                              }
                                                                              message={
                                                                                ELCharacteristics_MSGS.Q38AENeurologicEmpty
                                                                              }
                                                                            />
                                                                          </div>
                                                                        )}
                                                                    </div>
                                                                  );
                                                                },
                                                              )}
                                                              <ErrorField
                                                                show={
                                                                  data.aeSubReasonEmpty
                                                                }
                                                                message={
                                                                  ELCharacteristics_MSGS.Q38AEEmpty
                                                                }
                                                                style={{
                                                                  paddingLeft:
                                                                    "0px",
                                                                }}
                                                              />
                                                            </div>
                                                          )}
                                                      </div>
                                                    ),
                                                  )}

                                                  {/* LINVOSELTAMAB - Unknown Option */}
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      marginTop: "5px",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        id={idx}
                                                        name={
                                                          "reasonUnknownLinvo382A" +
                                                          idx
                                                        }
                                                        checked={
                                                          data.reasonUnknown ||
                                                          false
                                                        }
                                                        value={true}
                                                        onChange={(e) =>
                                                          HandleQ382RepeaterFieldChange(
                                                            e,
                                                            "Linvo",
                                                            idx,
                                                          )
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Unknown
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <ErrorField
                                                    show={data.reasonEmpty}
                                                    message={
                                                      ELCharacteristics_MSGS.Q38ReasonEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={data.deathDtWarning}
                                                    message={
                                                      ELCharacteristics_MSGS.deathWarningQ20
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column D: start Date of change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "startDateChangeRdLinvo" +
                                                        idx
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.startDateChangeRd ===
                                                        1
                                                      }
                                                      onChange={(e) =>
                                                        HandleQ382RepeaterFieldChange(
                                                          e,
                                                          "Linvo",
                                                          idx,
                                                        )
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`startDateChangeLinvo-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={
                                                          data.startDateChange
                                                        }
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "startDateChangeRdLinvo" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.startDateChangeRd ===
                                                          99
                                                        }
                                                        onChange={(e) =>
                                                          HandleQ382RepeaterFieldChange(
                                                            e,
                                                            "Linvo",
                                                            idx,
                                                          )
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Start date of dose
                                                        interruption or delay
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.startDateChangeRdEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.General
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.startDateChangeEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.DateChangeEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.invalidStartDateChange
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.startDateChangeOutOfBound
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.DateChangeOutOfBound
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.interruptionStartDateUnknownWarning
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.Q382AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>

                                            {/* Column E: End Date of change */}
                                            <td
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                              }}
                                            >
                                              {data.changeType !== 1 &&
                                              data.changeType !== 99 ? (
                                                <div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "endDateChangeRdLinvo" +
                                                          idx
                                                        }
                                                        value={1}
                                                        checked={
                                                          data.endDateChangeRd ===
                                                          1
                                                        }
                                                        onChange={(e) =>
                                                          HandleQ382RepeaterFieldChange(
                                                            e,
                                                            "Linvo",
                                                            idx,
                                                          )
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Dose interruption or
                                                        delay ongoing
                                                      </span>
                                                    </label>
                                                  </div>

                                                  <div
                                                    className="option-without-input"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "endDateChangeRdLinvo" +
                                                        idx
                                                      }
                                                      value={2}
                                                      checked={
                                                        data.endDateChangeRd ===
                                                        2
                                                      }
                                                      onChange={(e) =>
                                                        HandleQ382RepeaterFieldChange(
                                                          e,
                                                          "Linvo",
                                                          idx,
                                                        )
                                                      }
                                                    />
                                                    <span
                                                      className="radio-text-padding"
                                                      style={{
                                                        paddingLeft: "10px",
                                                        marginLeft: "-5px",
                                                      }}
                                                    >
                                                      <DatePickerComponent
                                                        ctrlId={`endDateChangeLinvo-${idx}`}
                                                        HandleDateChange={
                                                          HandleRepeaterDateChange
                                                        }
                                                        minDate={dayjs(
                                                          "01-01-1920",
                                                        )}
                                                        maxDate={dayjs()}
                                                        locale="en"
                                                        date={
                                                          data.endDateChange
                                                        }
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label className="option-fbox">
                                                      <input
                                                        type="radio"
                                                        style={{
                                                          marginTop: "6px",
                                                        }}
                                                        id={idx}
                                                        name={
                                                          "endDateChangeRdLinvo" +
                                                          idx
                                                        }
                                                        value={99}
                                                        checked={
                                                          data.endDateChangeRd ===
                                                          99
                                                        }
                                                        onChange={(e) =>
                                                          HandleQ382RepeaterFieldChange(
                                                            e,
                                                            "Linvo",
                                                            idx,
                                                          )
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        End date of dose
                                                        interruption or delay
                                                        unknown
                                                      </span>
                                                    </label>
                                                  </div>
                                                  <ErrorField
                                                    show={
                                                      data.endDateChangeRdEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.General
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.endDateChangeEmpty
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.DateChangeEmpty
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.invalidEndDateChange
                                                    }
                                                    message={
                                                      CommonError_Msgs.InvalidDate
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                  <ErrorField
                                                    show={
                                                      data.endDateChangeOutOfBound
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.DateChangeOutOfBound
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />

                                                  <ErrorField
                                                    show={
                                                      data.interruptionEndDateUnknownWarning
                                                    }
                                                    message={
                                                      ELCharacteristics_MSGS.Q382AWarningUnk
                                                    }
                                                    style={{
                                                      paddingLeft: "0px",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                  className="not-applicable"
                                                >
                                                  <b>Not applicable</b>
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              ))}

                            {/* Add button */}
                            {Q382ALinvoDetails &&
                              Q382ALinvoDetails.length > 0 &&
                              Number(Q382ALinvoDetails[0].changeType) !== 1 &&
                              Number(Q382ALinvoDetails[0].changeType) !==
                                99 && (
                                <div className="sub-question-bot-sapce-ul mt-2">
                                  <div
                                    className="answer-list-text"
                                    onClick={AddQ382ALinvoRow}
                                  >
                                    <a>
                                      <img
                                        width="18px"
                                        src="../Assets/images/plus.png"
                                        alt=""
                                      />
                                    </a>
                                    <a className="radio-text-padding">
                                      Click here to add another dose
                                      interruption/delay
                                    </a>
                                  </div>
                                </div>
                              )}
                          </div>
                        )}
                        {/* Q38.2.A End */}
                        {/* Question 39  start*/}
                        {/* show if Elrexfio selected */}
                        <div className="">
                          {isElrexvayliSelected &&
                            Q37ElrexDetails &&
                            Q37ElrexDetails.length > 0 &&
                            Q37ElrexDetails.map((data, idx) => (
                              <React.Fragment key={idx}>
                                <div className="sub-question-bot-sapce ">
                                  <div className="question question-weight">
                                    <span>Q39.</span>
                                    <span className="quest-text-pad">
                                      Which medications were used, if any,
                                      during the <b>step-up dosing phase</b> of{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        ELREXFIO<sup>TM</sup> (elranatamab-bcmm)
                                      </span>{" "}
                                      i.e from
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        {" "}
                                        {showElrDate()}{" "}
                                      </span>
                                      until the end of step-up dosing?{" "}
                                      <i>Select all that apply.</i>
                                      <br />
                                      If you cannot determine if an
                                      administration is part of the{" "}
                                      <strong>Step-Up Dosing Phase, </strong>
                                      please infer the dosing phase using the
                                      ELREXFIO<sup>TM</sup> (elranatamab-bcmm)
                                      dosing label information provided.
                                    </span>
                                  </div>
                                  <div className="radio-text-padding">
                                    <div className="double-dig-answer">
                                      <div className="">
                                        <label>
                                          <input
                                            type="checkbox"
                                            id={idx}
                                            name={"tocilizumab_elr" + idx}
                                            checked={data.tocilizumab_elr}
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Tocilizumab
                                          </span>
                                        </label>
                                      </div>

                                      <div className="">
                                        <label>
                                          <input
                                            type="checkbox"
                                            id={idx}
                                            name={"Granulocyte" + idx}
                                            checked={data.Granulocyte}
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Granulocyte colony-stimulating
                                            factor (G-CSF)
                                          </span>
                                        </label>
                                      </div>
                                      {/* Phase 2  */}
                                      <div className="">
                                        <label>
                                          <input
                                            type="checkbox"
                                            id={idx}
                                            name={"SteroidsElr" + idx}
                                            checked={data.SteroidsElr}
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Steroids
                                          </span>
                                        </label>
                                      </div>

                                      <div className="option-without-input">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={"noneoftheabove_elr" + idx}
                                            value={99}
                                            checked={
                                              data.noneoftheabove_elr === 99
                                            }
                                            onChange={HandleFieldChange}
                                          />

                                          <span className="radio-text-padding">
                                            None of the above{" "}
                                          </span>
                                        </label>
                                      </div>
                                      <ErrorField
                                        show={data.Q39ElrEmptyHard}
                                        message={
                                          ELCharacteristics_MSGS.Q39ElrEmptyHard
                                        }
                                        style={{
                                          paddingLeft: "0px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Q39.1. */}

                                {data.tocilizumab_elr && !isNewEcrfA && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.1.</span>
                                      <span className="quest-text-pad">
                                        Summarize the reasons why Tocilizumab
                                        was used and dosing information while
                                        receiving treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          ELREXFIO<sup>TM</sup>
                                          {"  "}
                                          (elranatamab-bcmm)
                                        </span>
                                        . <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-sub-section">
                                      {/* ELREXFIO® */}
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "20%",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "15%",
                                                  }}
                                                >
                                                  Medication
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "45%",
                                                  }}
                                                >
                                                  Reason for receiving
                                                  medication
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    ELREXFIO<sup>TM</sup>{" "}
                                                    (elranatamab-bcmm)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label className="option-fbox">
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Tocilizumab
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "cytokin_elr" + idx
                                                          }
                                                          checked={
                                                            data.cytokin_elr
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Primary prophylactic
                                                          for cytokine release
                                                          syndrome (CRS)
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_prophylactic_crs_elr" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_prophylactic_crs_elr
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Secondary prophylactic
                                                          for CRS
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={"crs_elr" + idx}
                                                          checked={data.crs_elr}
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Treatment or
                                                          supportive care for
                                                          CRS
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "neurotoxicity_elr" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.neurotoxicity_elr
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Primary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_neurotoxicity_elr" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_neurotoxicity_elr
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Secondary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "tmt_neurotoxicity_elr" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_neurotoxicity_elr
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Treatment or
                                                          supportive care for
                                                          neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tmt_elr_unknown" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_elr_unknown
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.Q39elrReasonHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.Q39elrReasonHard
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* Q39.1.A */}
                                {data.tocilizumab_elr && isNewEcrfA && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.1.A.</span>
                                      <span className="quest-text-pad">
                                        Summarize the reasons why tocilizumab
                                        was used and dosing information while
                                        receiving treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          ELREXFIO<sup>TM</sup>
                                          {"  "}
                                          (elranatamab-bcmm)
                                        </span>
                                        . <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-section">
                                      <ErrorField
                                        show={
                                          q391AElrAdministrationDateOutOfRange
                                        }
                                        message={
                                          ELCharacteristics_MSGS.Q391AAdministrationDateOutOfRange
                                        }
                                        style={{
                                          paddingLeft: "0px",
                                          paddingBottom: "10px",
                                          paddingTop: "0px",
                                        }}
                                      />
                                      {/* ELREXFIO® */}
                                      {q391AElrTocilzumabList?.length > 0 &&
                                        q391AElrTocilzumabList.map(
                                          (itm, index) => (
                                            <div
                                              className="loop-section-ul"
                                              key={index}
                                            >
                                              <div className="loop-head">
                                                <span
                                                  className="question-weight"
                                                  style={{
                                                    float: "inline-start",
                                                  }}
                                                >
                                                  {GetOrdinal(index + 1)}{" "}
                                                  ELREXFIO
                                                  <sup>TM</sup>{" "}
                                                  (elranatamab-bcmm)
                                                </span>
                                                {index !== 0 && (
                                                  <div
                                                    className="delete-btn-div"
                                                    style={{
                                                      float: "inline-end",
                                                    }}
                                                  >
                                                    <img
                                                      width="16px"
                                                      src="../Assets/images/Icon-material-delete.png"
                                                      alt=""
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        DeleteQ391ARow(
                                                          index,
                                                          RRMMCohortTreatment.ELREXFIO,
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              </div>
                                              <div className="question-bot-sapce">
                                                <div className="sub-question grid-overflow">
                                                  <table
                                                    style={{
                                                      border: "1px solid black",
                                                      borderCollapse:
                                                        "collapse",
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <thead>
                                                      <tr>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "20%",
                                                          }}
                                                        >
                                                          Treatment
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "15%",
                                                          }}
                                                        >
                                                          Medication
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "15%",
                                                          }}
                                                        >
                                                          Date of tocilizumab
                                                          administration
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "45%",
                                                          }}
                                                        >
                                                          Reason for receiving
                                                          medication
                                                        </th>
                                                      </tr>
                                                    </thead>

                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <span className="quest-text-pad">
                                                            ELREXFIO
                                                            <sup>TM</sup>{" "}
                                                            (elranatamab-bcmm)
                                                          </span>
                                                        </td>

                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div>
                                                              <div
                                                                className="option-without-input"
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "flex-start",
                                                                }}
                                                              >
                                                                <label className="option-fbox">
                                                                  <span
                                                                    className="radio-text-padding"
                                                                    style={{
                                                                      paddingLeft:
                                                                        "10px",
                                                                    }}
                                                                  >
                                                                    Tocilizumab
                                                                  </span>
                                                                </label>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={index}
                                                                name={
                                                                  "administrationDateRD_elr" +
                                                                  index
                                                                }
                                                                value={1}
                                                                checked={
                                                                  itm.administrationDateRD_elr ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                <DatePickerComponent
                                                                  ctrlId={
                                                                    "administrationDate_elr-" +
                                                                    index
                                                                  }
                                                                  HandleDateChange={
                                                                    HandleRepeaterDateChange
                                                                  }
                                                                  optionId={1}
                                                                  minDate={dayjs(
                                                                    "01-01-1920",
                                                                  )}
                                                                  maxDate={dayjs()}
                                                                  locale="en"
                                                                  date={
                                                                    itm.administrationDate_elr
                                                                  }
                                                                />
                                                              </span>
                                                            </div>

                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="radio"
                                                                  id={index}
                                                                  name={
                                                                    "administrationDateRD_elr" +
                                                                    index
                                                                  }
                                                                  value={99}
                                                                  checked={
                                                                    itm.administrationDateRD_elr ===
                                                                    99
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    paddingLeft:
                                                                      "10px",
                                                                    marginLeft:
                                                                      "-5px",
                                                                  }}
                                                                >
                                                                  Date of
                                                                  administration
                                                                  unknown
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <ErrorField
                                                              show={
                                                                itm.q39ElrAdministrationRDEmpty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.Q40Init_RdHard
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                itm.q39ElrAdministrationDateEmpty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.Q391ATocilizumabAdministrationDateEmty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                itm.q39ElrInvalidAdministrationDate
                                                              }
                                                              message={
                                                                CommonError_Msgs.InvalidDate
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "primaryProphylacticCrs_elr" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.primaryProphylacticCrs_elr
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Primary
                                                                  prophylactic
                                                                  for cytokine
                                                                  release
                                                                  syndrome (CRS)
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "secondaryProphylacticCrs_elr" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.secondaryProphylacticCrs_elr
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Secondary
                                                                  prophylactic
                                                                  for CRS
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "supportiveCareCrs_elr" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.supportiveCareCrs_elr
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Treatment or
                                                                  supportive
                                                                  care for CRS
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "primaryProphylacticNeurologic_elr" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.primaryProphylacticNeurologic_elr
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Primary
                                                                  prophylactic
                                                                  for neurologic
                                                                  events
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "secondaryProphylacticNeurologic_elr" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.secondaryProphylacticNeurologic_elr
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Secondary
                                                                  prophylactic
                                                                  for neurologic
                                                                  events
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "supportiveCareNeurologic_elr" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.supportiveCareNeurologic_elr
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Treatment or
                                                                  supportive
                                                                  care for
                                                                  neurologic
                                                                  events
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="radio"
                                                                  id={index}
                                                                  name={
                                                                    "medicationReasonUnk_elr" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.medicationReasonUnk_elr
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Unknown
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <ErrorField
                                                              show={
                                                                itm.q39ElrReasonEmpty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.Q39elrReasonHard
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          ),
                                        )}

                                      {q391AElrTocilzumabList?.length > 0 &&
                                        q391AElrTocilzumabList?.length <
                                          550 && (
                                          <div className="sub-question-bot-sapce-ul mt-2">
                                            <div
                                              className="answer-list-text"
                                              onClick={() =>
                                                AddQ391ARow(
                                                  RRMMCohortTreatment.ELREXFIO,
                                                )
                                              }
                                            >
                                              <a>
                                                <img
                                                  width="18px"
                                                  src="../Assets/images/plus.png"
                                                  alt=""
                                                />
                                              </a>
                                              <a className="radio-text-padding">
                                                Click here to add another
                                                tocilizumab administration of
                                                elranatamab
                                              </a>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                )}

                                {/* New Phase 39.2  */}
                                {data.SteroidsElr && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.2.</span>
                                      <span className="quest-text-pad">
                                        Summarize the reasons why steroids were
                                        used and dosing information while
                                        receiving treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          ELREXFIO<sup>TM</sup>{" "}
                                          (elranatamab-bcmm)
                                        </span>
                                        . <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-sub-section">
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "5%",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "5%",
                                                  }}
                                                >
                                                  Medication
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "35%",
                                                  }}
                                                >
                                                  Name and dose of the
                                                  steroid(s) used
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "50%",
                                                  }}
                                                >
                                                  Reason for receiving
                                                  medication
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    ELREXFIO<sup>TM</sup>{" "}
                                                    (elranatamab-bcmm)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label>
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Steroids
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>

                                                {/* Start */}

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div>
                                                        <label className="option-fbox">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "betamethasone_elr" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.betamethasone_elr
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Betamethasone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "betamethasone_elrNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.betamethasone_elrNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label className="option-fbox">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "dexamethasone_elr" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.dexamethasone_elr
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Dexamethasone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "dexamethasone_elrNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.dexamethasone_elrNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div className="">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="checkbox"
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            id={idx}
                                                            name={
                                                              "hydrocortisone_elr" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.hydrocortisone_elr
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Hydrocortisone (oral
                                                            or intravenous only)
                                                            <br></br>(total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "hydrocortisone_elrNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.hydrocortisone_elrNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label className="option-fbox">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "methylprednisolone" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.methylprednisolone
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Methylprednisolone
                                                            (total dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "methylprednisoloneNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.methylprednisoloneNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label className="option-fbox">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "prednisolone_elr" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.prednisolone_elr
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Prednisolone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "prednisolone_elrNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.prednisolone_elrNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label className="option-fbox">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "prednisone_elr" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.prednisone_elr
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Prednisone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "prednisone_elrNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.prednisone_elrNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label className="option-fbox">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "triamcinolone_elr" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.triamcinolone_elr
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Triamcinolone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "triamcinolone_elrNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.triamcinolone_elrNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label className="option-fbox">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "dose_name_elr_unknown" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.dose_name_elr_unknown
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.name_dose_steroidsHardEmpty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.name_dose_steroidsHardEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.steroids_elr_txtEmpty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.steroids_elr_txtEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                </td>

                                                {/* End */}

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "steroid_pre_tmt_elr" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.steroid_pre_tmt_elr
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          As a pre-treatment per
                                                          label recommendation
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "cytokin_elr_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.cytokin_elr_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Primary prophylactic
                                                          for cytokine release
                                                          syndrome (CRS)
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_prophylactic_elr_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_prophylactic_elr_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Secondary prophylactic
                                                          for CRS
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "crs_elr_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.crs_elr_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Treatment or
                                                          supportive care for
                                                          CRS
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "neurotoxicity_elr_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.neurotoxicity_elr_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Primary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_neurotoxicity_elr_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_neurotoxicity_elr_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Secondary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "tmt_neurotoxicity_elr_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_neurotoxicity_elr_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Treatment or
                                                          supportive care for
                                                          neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tmt_steroids_elr_unknown" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_steroids_elr_unknown
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.Q39elrSteroidsEmptyHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.Q39elrSteroidsEmptyHard
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {/* 39.3 */}

                                {data.Granulocyte && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.3.</span>
                                      <span className="quest-text-pad">
                                        Why was G-CSF used while receiving
                                        treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          ELREXFIO<sup>TM</sup>{" "}
                                          (elranatamab-bcmm)
                                        </span>
                                        ? <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-sub-section">
                                      {/* ELREXFIO® */}
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "25%",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "25%",
                                                  }}
                                                >
                                                  Medication
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "45%",
                                                  }}
                                                >
                                                  Reason for receiving
                                                  medication
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    ELREXFIO<sup>TM</sup>{" "}
                                                    (elranatamab-bcmm)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label>
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Granulocyte
                                                            colony-stimulating
                                                            factor (G-CSF)
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "prophylactic_use_elr" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.prophylactic_use_elr
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Primary Prophylactic
                                                            use
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "secondary_prophylactic_use_elr" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.secondary_prophylactic_use_elr
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Secondary
                                                            Prophylactic use
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "oth_use_elr" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.oth_use_elr
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Other use
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            value={99}
                                                            name={
                                                              "unknown_elr" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.unknown_elr ===
                                                              99
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.Q39elrGranduloEmptyHard
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.Q39elrGranduloEmptyHard
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </React.Fragment>
                            ))}
                        </div>
                        {/* -------------------- */}
                        {/*Show if Linvoseltamab selected  */}
                        <div className="">
                          {isLinvoveySelected &&
                            Q37LinvoDetails &&
                            Q37LinvoDetails.length > 0 &&
                            Q37LinvoDetails.map((data, idx) => (
                              <React.Fragment key={idx}>
                                <div className="sub-question-bot-sapce">
                                  <div className="question question-weight">
                                    <span>Q39.</span>
                                    <span className="quest-text-pad">
                                      Which medications were used, if any,
                                      during the <b>step-up dosing phase</b> of{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        LYNOZYFIC<sup>TM</sup>{" "}
                                        (linvoquetamab-gcpt)
                                      </span>{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        {" "}
                                        {showLinvoDate()}{" "}
                                      </span>
                                      <span>
                                        until the end of step-up dosing?
                                      </span>{" "}
                                      <i>Select all that apply.</i>
                                      <br />
                                      If you cannot determine if an
                                      administration is part of the{" "}
                                      <strong>Step-Up Dosing Phase, </strong>
                                      please infer the dosing phase using the
                                      LYNOZYFIC<sup>TM</sup>{" "}
                                      (linvoquetamab-gcpt) dosing label
                                      information provided.
                                    </span>
                                  </div>
                                  <div className="radio-text-padding">
                                    <div className="double-dig-answer">
                                      <div className="">
                                        <label>
                                          <input
                                            type="checkbox"
                                            id={idx}
                                            name={"tocilizumab_linvo" + idx}
                                            checked={data.tocilizumab_linvo}
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Tocilizumab
                                          </span>
                                        </label>
                                      </div>
                                      <div className="">
                                        <label>
                                          <input
                                            type="checkbox"
                                            id={idx}
                                            name={"granulocyte_linvo" + idx}
                                            checked={!!data.granulocyte_linvo}
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Granulocyte colony-stimulating
                                            factor (G-CSF)
                                          </span>
                                        </label>
                                      </div>
                                      {/* Phase 2  */}

                                      <div className="">
                                        <label>
                                          <input
                                            type="checkbox"
                                            id={idx}
                                            name={"Steroids" + idx}
                                            checked={data.Steroids}
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Steroids
                                          </span>
                                        </label>
                                      </div>

                                      <div className="option-without-input">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={"noneoftheabove_linvo" + idx}
                                            value={99}
                                            checked={
                                              data.noneoftheabove_linvo === 99
                                            }
                                            onChange={HandleFieldChange}
                                          />

                                          <span className="radio-text-padding">
                                            None of the above{" "}
                                          </span>
                                        </label>
                                      </div>
                                      <ErrorField
                                        show={data.Q39LinvoEmptyHard}
                                        message={
                                          ELCharacteristics_MSGS.Q39LinvoEmptyHard
                                        }
                                        style={{
                                          paddingLeft: "0px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Q39.1 */}
                                {data.tocilizumab_linvo && !isNewEcrfA && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.1.</span>
                                      <span className="quest-text-pad">
                                        Summarize the reasons why Tocilizumab
                                        was used and dosing information while
                                        receiving treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          LYNOZYFIC
                                          <sup className="supscript">
                                            TM
                                          </sup>{" "}
                                          (linvoquetamab-gcpt)
                                        </span>
                                        . <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-sub-section">
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "20%",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "15%",
                                                  }}
                                                >
                                                  Medication
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "45%",
                                                  }}
                                                >
                                                  Reason for receiving
                                                  medication
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    LYNOZYFIC
                                                    <sup>TM</sup>{" "}
                                                    (linvoquetamab-gcpt)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label>
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Tocilizumab
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "cytokin_linvo" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.cytokin_linvo
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Primary prophylactic
                                                          for cytokine release
                                                          syndrome (CRS)
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_prophylactic_crs_linvo" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_prophylactic_crs_linvo
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Secondary prophylactic
                                                          for CRS
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "crs_linvo" + idx
                                                          }
                                                          checked={
                                                            data.crs_linvo
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Treatment or
                                                          supportive care for
                                                          CRS
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "neurotoxicity_linvo" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.neurotoxicity_linvo
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Primary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_neurotoxicity_linvo" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_neurotoxicity_linvo
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Secondary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "tmt_neurotoxicity_linvo" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_neurotoxicity_linvo
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Treatment or
                                                          supportive care for
                                                          neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tmt_linvoseltamab_unknown" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_linvoseltamab_unknown
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.Q39linvoReasonHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.Q39linvoReasonHard
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* Q39.1.A */}
                                {data.tocilizumab_linvo && isNewEcrfA && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.1.A.</span>
                                      <span className="quest-text-pad">
                                        Summarize the reasons why tocilizumab
                                        was used and dosing information while
                                        receiving treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          LYNOZYFIC
                                          <sup className="supscript">TM</sup>
                                          {"  "}
                                          (linvoquetamab-gcpt).
                                        </span>{" "}
                                        <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-section">
                                      <ErrorField
                                        show={
                                          q391ALinvoAdministrationDateOutOfRange
                                        }
                                        message={
                                          ELCharacteristics_MSGS.Q391AAdministrationDateOutOfRange
                                        }
                                        style={{
                                          paddingLeft: "0px",
                                          paddingBottom: "10px",
                                          paddingTop: "0px",
                                        }}
                                      />
                                      {/* ELREXFIO® */}
                                      {q391ALinvoTocilzumabList?.length > 0 &&
                                        q391ALinvoTocilzumabList.map(
                                          (itm, index) => (
                                            <div
                                              className="loop-section-ul"
                                              key={index}
                                            >
                                              <div className="loop-head">
                                                <span
                                                  className="question-weight"
                                                  style={{
                                                    float: "inline-start",
                                                  }}
                                                >
                                                  {GetOrdinal(index + 1)}{" "}
                                                  LYNOZYFIC
                                                  <sup className="supscript">
                                                    TM
                                                  </sup>
                                                  {"  "}
                                                  (linvoquetamab-gcpt)
                                                </span>
                                                {index !== 0 && (
                                                  <div
                                                    className="delete-btn-div"
                                                    style={{
                                                      float: "inline-end",
                                                    }}
                                                  >
                                                    <img
                                                      width="16px"
                                                      src="../Assets/images/Icon-material-delete.png"
                                                      alt=""
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        DeleteQ391ARow(
                                                          index,
                                                          RRMMCohortTreatment.Linvoseltamab,
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              </div>
                                              <div className="question-bot-sapce">
                                                <div className="sub-question grid-overflow">
                                                  <table
                                                    style={{
                                                      border: "1px solid black",
                                                      borderCollapse:
                                                        "collapse",
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <thead>
                                                      <tr>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "20%",
                                                          }}
                                                        >
                                                          Treatment
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "15%",
                                                          }}
                                                        >
                                                          Medication
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "15%",
                                                          }}
                                                        >
                                                          Date of tocilizumab
                                                          administration
                                                        </th>
                                                        <th
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                            textAlign: "center",
                                                            width: "45%",
                                                          }}
                                                        >
                                                          Reason for receiving
                                                          medication
                                                        </th>
                                                      </tr>
                                                    </thead>

                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <span className="quest-text-pad">
                                                            LYNOZYFIC
                                                            <sup className="supscript">
                                                              TM
                                                            </sup>
                                                            {"  "}
                                                            (linvoquetamab-gcpt)
                                                          </span>
                                                        </td>

                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div>
                                                              <div
                                                                className="option-without-input"
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "flex-start",
                                                                }}
                                                              >
                                                                <label className="option-fbox">
                                                                  <span
                                                                    className="radio-text-padding"
                                                                    style={{
                                                                      paddingLeft:
                                                                        "10px",
                                                                    }}
                                                                  >
                                                                    Tocilizumab
                                                                  </span>
                                                                </label>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={index}
                                                                name={
                                                                  "administrationDateRD_linvo" +
                                                                  index
                                                                }
                                                                value={1}
                                                                checked={
                                                                  itm.administrationDateRD_linvo ===
                                                                  1
                                                                }
                                                                onChange={
                                                                  HandleRepeaterFieldChange
                                                                }
                                                              />
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  paddingLeft:
                                                                    "10px",
                                                                  marginLeft:
                                                                    "-5px",
                                                                }}
                                                              >
                                                                <DatePickerComponent
                                                                  ctrlId={
                                                                    "administrationDate_linvo-" +
                                                                    index
                                                                  }
                                                                  HandleDateChange={
                                                                    HandleRepeaterDateChange
                                                                  }
                                                                  optionId={1}
                                                                  minDate={dayjs(
                                                                    "01-01-1920",
                                                                  )}
                                                                  maxDate={dayjs()}
                                                                  locale="en"
                                                                  date={
                                                                    itm.administrationDate_linvo
                                                                  }
                                                                />
                                                              </span>
                                                            </div>

                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <label className="option-fbox">
                                                                <input
                                                                  type="radio"
                                                                  id={index}
                                                                  name={
                                                                    "administrationDateRD_linvo" +
                                                                    index
                                                                  }
                                                                  value={99}
                                                                  checked={
                                                                    itm.administrationDateRD_linvo ===
                                                                    99
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span
                                                                  style={{
                                                                    paddingLeft:
                                                                      "10px",
                                                                    marginLeft:
                                                                      "-5px",
                                                                  }}
                                                                >
                                                                  Date of
                                                                  administration
                                                                  unknown
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <ErrorField
                                                              show={
                                                                itm.q39LinvoAdministrationRDEmpty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.Q40Init_RdHard
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />

                                                            <ErrorField
                                                              show={
                                                                itm.q39LinvoAdministrationDateEmpty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.Q391ATocilizumabAdministrationDateEmty
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                            <ErrorField
                                                              show={
                                                                itm.q39LinvoInvalidAdministrationDate
                                                              }
                                                              message={
                                                                CommonError_Msgs.InvalidDate
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid black",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "primaryProphylacticCrs_linvo" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.primaryProphylacticCrs_linvo
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Primary
                                                                  prophylactic
                                                                  for cytokine
                                                                  release
                                                                  syndrome (CRS)
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "secondaryProphylacticCrs_linvo" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.secondaryProphylacticCrs_linvo
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Secondary
                                                                  prophylactic
                                                                  for CRS
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "supportiveCareCrs_linvo" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.supportiveCareCrs_linvo
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Treatment or
                                                                  supportive
                                                                  care for CRS
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "primaryProphylacticNeurologic_linvo" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.primaryProphylacticNeurologic_linvo
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Primary
                                                                  prophylactic
                                                                  for neurologic
                                                                  events
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "secondaryProphylacticNeurologic_linvo" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.secondaryProphylacticNeurologic_linvo
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Secondary
                                                                  prophylactic
                                                                  for neurologic
                                                                  events
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="checkbox"
                                                                  id={index}
                                                                  name={
                                                                    "supportiveCareNeurologic_linvo" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.supportiveCareNeurologic_linvo
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Treatment or
                                                                  supportive
                                                                  care for
                                                                  neurologic
                                                                  events
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <div className="">
                                                              <label className="checkbox-option">
                                                                <input
                                                                  type="radio"
                                                                  id={index}
                                                                  name={
                                                                    "medicationReasonUnk_linvo" +
                                                                    index
                                                                  }
                                                                  checked={
                                                                    itm.medicationReasonUnk_linvo
                                                                  }
                                                                  onChange={
                                                                    HandleRepeaterFieldChange
                                                                  }
                                                                />
                                                                <span className="radio-text-padding">
                                                                  Unknown
                                                                </span>
                                                              </label>
                                                            </div>

                                                            <ErrorField
                                                              show={
                                                                itm.q39LinvoReasonEmpty
                                                              }
                                                              message={
                                                                ELCharacteristics_MSGS.Q39linvoReasonHard
                                                              }
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            />
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          ),
                                        )}

                                      {q391ALinvoTocilzumabList?.length > 0 &&
                                        q391ALinvoTocilzumabList?.length <
                                          550 && (
                                          <div className="sub-question-bot-sapce-ul mt-2">
                                            <div
                                              className="answer-list-text"
                                              onClick={() =>
                                                AddQ391ARow(
                                                  RRMMCohortTreatment.Linvoseltamab,
                                                )
                                              }
                                            >
                                              <a>
                                                <img
                                                  width="18px"
                                                  src="../Assets/images/plus.png"
                                                  alt=""
                                                />
                                              </a>
                                              <a className="radio-text-padding">
                                                Click here to add another
                                                tocilizumab administration of
                                                linvoseltamab
                                              </a>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                )}

                                {/* Q39.2 */}

                                {data.Steroids && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.2.</span>
                                      <span className="quest-text-pad">
                                        Summarize the reasons why steroids were
                                        used and dosing information while
                                        receiving treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          LYNOZYFIC
                                          <sup className="supscript">
                                            TM
                                          </sup>{" "}
                                          (linvoquetamab-gcpt)
                                        </span>
                                        . <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-sub-section">
                                      {/* ELREXFIO® */}
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "5%",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "5%",
                                                  }}
                                                >
                                                  Medication
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "35%",
                                                  }}
                                                >
                                                  Name and dose of the
                                                  steroid(s) used
                                                </th>

                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "50%",
                                                  }}
                                                >
                                                  Reason for receiving
                                                  medication
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    LYNOZYFIC
                                                    <sup>TM</sup>{" "}
                                                    (linvoquetamab-gcpt)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label>
                                                          <span
                                                            className="radio-text-padding"
                                                            style={{
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            Steroids
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>

                                                {/* Start */}

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div>
                                                      <div className="option-fbox">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "betamethasone_linvo" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.betamethasone_linvo
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Betamethasone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "betamethasone_linvoNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.betamethasone_linvoNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "dexamethasone_linvo" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.dexamethasone_linvo
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Dexamethasone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "dexamethasone_linvoNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.dexamethasone_linvoNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>
                                                      <div className="">
                                                        <label className="option-fbox">
                                                          <input
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "hydrocortisone_linvo" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.hydrocortisone_linvo
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Hydrocortisone (oral
                                                            or intravenous only)
                                                            <br></br>
                                                            (total dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "hydrocortisone_linvoNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.hydrocortisone_linvoNum
                                                              }
                                                              onKeyDown={
                                                                AllowNumericWithDecimal
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "methylprednisolone_linvo" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.methylprednisolone_linvo
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Methylprednisolone
                                                            (total dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "methylprednisolone_linvoNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.methylprednisolone_linvoNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "prednisolone_linvo" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.prednisolone_linvo
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Prednisolone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "prednisolone_linvoNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.prednisolone_linvoNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "prednisone_linvo" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.prednisone_linvo
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Prednisone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "prednisone_linvoNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.prednisone_linvoNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            id={idx}
                                                            name={
                                                              "triamcinolone_linvo" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.triamcinolone_linvo
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              paddingLeft:
                                                                "15px",
                                                            }}
                                                          >
                                                            Triamcinolone (total
                                                            dose:
                                                            <input
                                                              className="sub-input-dash-num"
                                                              id={idx}
                                                              name={
                                                                "triamcinolone_linvoNum" +
                                                                idx
                                                              }
                                                              type="text"
                                                              value={
                                                                data.triamcinolone_linvoNum
                                                              }
                                                              onKeyDown={
                                                                AllowOnlyNonZeroNumeric
                                                              }
                                                              onChange={
                                                                HandleFieldChange
                                                              }
                                                              maxLength={10}
                                                            />
                                                            mg)
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <div className="">
                                                        <label>
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={
                                                              "dose_name_linvo_unknown" +
                                                              idx
                                                            }
                                                            checked={
                                                              data.dose_name_linvo_unknown
                                                            }
                                                            onChange={
                                                              HandleFieldChange
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>

                                                      <ErrorField
                                                        show={
                                                          data.name_dose_steroids_linvoHardEmpty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.name_dose_steroidslinvoHardEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />

                                                      <ErrorField
                                                        show={
                                                          data.steroids_linvo_txtEmpty
                                                        }
                                                        message={
                                                          ELCharacteristics_MSGS.steroids_linvo_txtEmpty
                                                        }
                                                        style={{
                                                          paddingLeft: "0px",
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                </td>

                                                {/* End */}

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "steroid_pre_tmt_linvo" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.steroid_pre_tmt_linvo
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          As a pre-treatment per
                                                          label recommendation
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "cytokin_linvo_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.cytokin_linvo_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Primary prophylactic
                                                          for cytokine release
                                                          syndrome (CRS)
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_prophylactic_linvo_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_prophylactic_linvo_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Secondary prophylactic
                                                          for CRS
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "crs_linvo_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.crs_linvo_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Treatment or
                                                          supportive care for
                                                          CRS
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "neurotoxicity_linvo_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.neurotoxicity_linvo_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Primary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_neurotoxicity_linvo_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_neurotoxicity_linvo_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Secondary prophylactic
                                                          for neurologic events
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label className="checkbox-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "tmt_neurotoxicity_linvo_steroids" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_neurotoxicity_linvo_steroids
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span
                                                          style={{
                                                            paddingLeft: "15px",
                                                          }}
                                                        >
                                                          Treatment or
                                                          supportive care for
                                                          neurologic events
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={
                                                            "tmt_linvo_unknown" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.tmt_linvo_unknown
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.Q39linvoSteroidsEmptyHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.Q39linvoSteroidsEmptyHard
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {data.granulocyte_linvo && (
                                  <div
                                    style={{
                                      marginLeft: "28px",
                                      marginBlock: "6px",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="question question-weight">
                                      <span>Q39.3.</span>
                                      <span className="quest-text-pad">
                                        Why was G-CSF used while receiving
                                        treatment with{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                            fontWeight: "bolder",
                                          }}
                                        >
                                          LYNOZYFIC<sup>TM</sup>{" "}
                                          (linvoseltamab-gcpt)
                                        </span>
                                        ? <i>Select all that apply.</i>
                                      </span>
                                    </div>

                                    <div className="dependent-sub-section">
                                      <div className="question-bot-sapce">
                                        <div className="sub-question grid-overflow">
                                          <table
                                            style={{
                                              border: "1px solid black",
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "5%",
                                                  }}
                                                >
                                                  Treatment
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "5%",
                                                  }}
                                                >
                                                  Medication
                                                </th>
                                                <th
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    width: "50%",
                                                  }}
                                                >
                                                  Reason for receiving
                                                  medication
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <span className="quest-text-pad">
                                                    LYNOZYFIC<sup>TM</sup>{" "}
                                                    (linvoseltamab-gcpt)
                                                  </span>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div
                                                    className="option-without-input"
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <label>
                                                      <span
                                                        className="radio-text-padding"
                                                        style={{
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        Granulocyte
                                                        colony-stimulating
                                                        factor (G-CSF)
                                                      </span>
                                                    </label>
                                                  </div>
                                                </td>

                                                <td
                                                  style={{
                                                    border: "1px solid black",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div>
                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "prophylactic_use_linvo" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.prophylactic_use_linvo
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Primary Prophylactic
                                                          use
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "secondary_prophylactic_use_linvo" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.secondary_prophylactic_use_linvo
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Secondary Prophylactic
                                                          use
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "oth_use_linvo" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.oth_use_linvo
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Other use
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div className="">
                                                      <label>
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          value={99}
                                                          name={
                                                            "unknown_linvo" +
                                                            idx
                                                          }
                                                          checked={
                                                            data.unknown_linvo ===
                                                            99
                                                          }
                                                          onChange={
                                                            HandleFieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          Unknown
                                                        </span>
                                                      </label>
                                                    </div>

                                                    <ErrorField
                                                      show={
                                                        data.Q39linvoGranduloEmptyHard
                                                      }
                                                      message={
                                                        ELCharacteristics_MSGS.Q39linvoGranduloEmptyHard
                                                      }
                                                      style={{
                                                        paddingLeft: "0px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </React.Fragment>
                            ))}
                        </div>
                        {/* Question 39 end */}
                      </>
                    )}

                    {/* 40 start */}
                    {(isElrexvayliSelected || isLinvoveySelected) && (
                      <div>
                        <div className="question question-weight">
                          <span>Q40.</span>
                          <span className="quest-text-pad">
                            Summarize information related to the usage of
                            intravenous immune globulin (IVIG) during the
                            patient’s treatment with{" "}
                            <span
                              style={{
                                color: PageDesignConstants.fontColor,
                                fontWeight: "bolder",
                              }}
                            >
                              {isElrexvayliSelected && (
                                <>
                                  ELREXFIO<sup>TM</sup> (elranatamab-bcmm)
                                </>
                              )}

                              {isElrexvayliSelected &&
                                isLinvoveySelected &&
                                " and "}

                              {isLinvoveySelected && (
                                <>
                                  LYNOZYFIC<sup>TM</sup> (linvoseltamab-gcpt)
                                </>
                              )}
                            </span>
                            .
                          </span>
                        </div>

                        <div className="question-bot-sapce">
                          <div className="sub-question grid-overflow">
                            <table
                              style={{
                                border: "1px solid black",
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Treatment
                                  </th>
                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                      width: "33%",
                                    }}
                                  >
                                    Intended dosing frequency
                                  </th>

                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                      width: "16%",
                                    }}
                                  >
                                    Last IgG level prior to most
                                    <br /> recent IVIG administration
                                  </th>

                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                      width: "15%",
                                    }}
                                  >
                                    Initiation date of IVIG
                                  </th>

                                  <th
                                    style={{
                                      border: "1px solid black",
                                      padding: "8px",
                                      textAlign: "center",
                                      width: "45%",
                                    }}
                                  >
                                    Reason for receiving medication Select all
                                    that apply.
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {isElrexvayliSelected &&
                                  Q37ElrexDetails.length > 0 &&
                                  Q37ElrexDetails.map((data, idx) => (
                                    <tr key={idx}>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <span className="quest-text-pad">
                                          ELREXFIO<sup>TM</sup>{" "}
                                          (elranatamab-bcmm)
                                        </span>
                                      </td>

                                      {/* Dosing freq column */}
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <div>
                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"Q40dosingfreqRd" + idx}
                                                value={1}
                                                checked={
                                                  data.Q40dosingfreqRd === 1
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Patient never received IVIG
                                                during treatment
                                              </span>
                                            </label>
                                          </div>
                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"Q40dosingfreqRd" + idx}
                                                value={2}
                                                checked={
                                                  data.Q40dosingfreqRd === 2
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Biweekly (every 2 weeks)
                                              </span>
                                            </label>
                                          </div>
                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={"Q40dosingfreqRd" + idx}
                                                value={3}
                                                checked={
                                                  data.Q40dosingfreqRd === 3
                                                }
                                                onChange={HandleFieldChange}
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Monthly
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"Q40dosingfreqRd" + idx}
                                                value={4}
                                                checked={
                                                  data.Q40dosingfreqRd === 4
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Bimonthly (every 2 months)
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"Q40dosingfreqRd" + idx}
                                                value={5}
                                                checked={
                                                  data.Q40dosingfreqRd === 5
                                                }
                                                onChange={HandleFieldChange}
                                              />

                                              <span
                                                style={{
                                                  marginLeft: "4px",
                                                  paddingRight: "15px",
                                                  marginBottom: "0px",
                                                  padding: "0",
                                                }}
                                              >
                                                Other frequency, please specify:
                                                <div
                                                  style={{
                                                    paddingLeft: "15px",
                                                    marginBottom: "0px",
                                                    padding: "0",
                                                  }}
                                                >
                                                  <textarea
                                                    name={
                                                      "dosing_freq_oth_txt" +
                                                      idx
                                                    }
                                                    className="input-dash"
                                                    type="text"
                                                    value={
                                                      data.dosing_freq_oth_txt
                                                    }
                                                    onChange={HandleFieldChange}
                                                    maxLength={300}
                                                    id={idx}
                                                  />
                                                </div>
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"Q40dosingfreqRd" + idx}
                                                value={99}
                                                checked={
                                                  data.Q40dosingfreqRd === 99
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Unknown
                                              </span>
                                            </label>
                                          </div>

                                          <ErrorField
                                            show={data.Q40DosingFreqEmptyHard}
                                            message={
                                              ELCharacteristics_MSGS.Q40DosingFreqEmptyHard
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />

                                          <ErrorField
                                            show={
                                              data.Q40DosingFreqTxtEmptyHard
                                            }
                                            message={
                                              ELCharacteristics_MSGS.Q40DosingFreqTxtEmptyHard
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                        </div>
                                      </td>

                                      {/* Last  IgG Level */}
                                      {data.Q40dosingfreqRd !== 1 ? (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  style={{ marginTop: "6px" }}
                                                  id={idx}
                                                  name={"Q40IgILevelRd" + idx}
                                                  value={1}
                                                  checked={
                                                    data.Q40IgILevelRd === 1
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  {"<"} 400 mg/dL
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"Q40IgILevelRd" + idx}
                                                  value={2}
                                                  checked={
                                                    data.Q40IgILevelRd === 2
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  400-500 mg/dL
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"Q40IgILevelRd" + idx}
                                                  value={3}
                                                  checked={
                                                    data.Q40IgILevelRd === 3
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  {">"} 500 mg/dL
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"Q40IgILevelRd" + idx}
                                                  value={99}
                                                  checked={
                                                    data.Q40IgILevelRd === 99
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  Unknown
                                                </span>
                                              </label>
                                            </div>

                                            <ErrorField
                                              show={data.Q40IgGEmptyHard}
                                              message={
                                                ELCharacteristics_MSGS.Q40IgGEmptyHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            textAlign: "center",
                                            padding: "8px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "center",
                                            }}
                                            className="not-applicable"
                                          >
                                            <b>Not applicable</b>
                                          </span>
                                        </td>
                                      )}

                                      {/* IVIG */}
                                      {data.Q40dosingfreqRd !== 1 ? (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"Q40init_dt_Rd" + idx}
                                                value={1}
                                                checked={
                                                  data.Q40init_dt_Rd === 1
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                <DatePickerComponent
                                                  ctrlId={"Q40init_dt-" + idx}
                                                  HandleDateChange={
                                                    HandleRepeaterDateChange
                                                  }
                                                  optionId={1}
                                                  minDate={dayjs("01-01-1920")}
                                                  maxDate={dayjs()}
                                                  locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                  date={data.Q40init_dt}
                                                />
                                              </span>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"Q40init_dt_Rd" + idx}
                                                  value={99}
                                                  checked={
                                                    data.Q40init_dt_Rd === 99
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  // className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  Date of initiation unknown
                                                </span>
                                              </label>
                                            </div>

                                            <ErrorField
                                              show={data.Q40Init_RdHard}
                                              message={
                                                ELCharacteristics_MSGS.Q40Init_RdHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />

                                            <ErrorField
                                              show={data.Q40Init_dtHard}
                                              message={
                                                ELCharacteristics_MSGS.Q40Init_dtHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                            <ErrorField
                                              show={data.InvalidQ40init_dt}
                                              message={
                                                CommonError_Msgs.InvalidDate
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                            <ErrorField
                                              show={data.init_dt_before_eof}
                                              message={
                                                ELCharacteristics_MSGS.Q40DateOutOfRange
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            //alignContent: "flex-start",
                                            textAlign: "center",
                                            padding: "8px",
                                            //textAlign: 'start'
                                          }}
                                        >
                                          <span
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "center",
                                            }}
                                            className="not-applicable"
                                          >
                                            <b>Not applicable</b>
                                          </span>
                                        </td>
                                      )}

                                      {/* Medication Reason */}
                                      {data.Q40dosingfreqRd !== 1 ? (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div className="">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={"primaryProf" + idx}
                                                  checked={data.primaryProf}
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: "6px",
                                                  }}
                                                >
                                                  Primary prophylactic for
                                                  <span className="radio-text-padding">
                                                    infections
                                                  </span>
                                                </span>
                                              </label>
                                            </div>

                                            <div className="">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={"secondaryProf" + idx}
                                                  checked={data.secondaryProf}
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: "6px",
                                                  }}
                                                >
                                                  Secondary prophylactic{" "}
                                                  <span className="radio-text-padding">
                                                    for infections
                                                  </span>
                                                </span>
                                              </label>
                                            </div>

                                            <div className="">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={"otherReson" + idx}
                                                  checked={data.otherReson}
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: "6px",
                                                  }}
                                                >
                                                  Other reason
                                                </span>
                                              </label>
                                            </div>

                                            <ErrorField
                                              show={data.Q40ReasonEmptyHard}
                                              message={
                                                ELCharacteristics_MSGS.Q40ReasonEmptyHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            //alignContent: "flex-start",
                                            textAlign: "center",
                                            padding: "8px",
                                            //textAlign: 'start'
                                          }}
                                        >
                                          <span
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "center",
                                            }}
                                            className="not-applicable"
                                          >
                                            <b>Not applicable</b>
                                          </span>
                                        </td>
                                      )}
                                    </tr>
                                  ))}
                                {isLinvoveySelected &&
                                  Q37LinvoDetails.length > 0 &&
                                  Q37LinvoDetails.map((data, idx) => (
                                    <tr key={idx}>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <span className="quest-text-pad">
                                          ”LYNOZYFIC<sup>TM</sup>{" "}
                                          (elranatamab-bcmm)
                                        </span>
                                      </td>
                                      {/* Dosing freq column */}
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                        }}
                                      >
                                        <div>
                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "q40DosingFreqRd_linvo" + idx
                                                }
                                                value={1}
                                                checked={
                                                  data.q40DosingFreqRd_linvo ===
                                                  1
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Patient never received IVIG
                                                during treatment
                                              </span>
                                            </label>
                                          </div>
                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "q40DosingFreqRd_linvo" + idx
                                                }
                                                value={2}
                                                checked={
                                                  data.q40DosingFreqRd_linvo ===
                                                  2
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Biweekly (every 2 weeks)
                                              </span>
                                            </label>
                                          </div>
                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                style={{ marginTop: "6px" }}
                                                id={idx}
                                                name={
                                                  "q40DosingFreqRd_linvo" + idx
                                                }
                                                value={3}
                                                checked={
                                                  data.q40DosingFreqRd_linvo ===
                                                  3
                                                }
                                                onChange={HandleFieldChange}
                                              />

                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Monthly
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "q40DosingFreqRd_linvo" + idx
                                                }
                                                value={4}
                                                checked={
                                                  data.q40DosingFreqRd_linvo ===
                                                  4
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Bimonthly (every 2 months)
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "q40DosingFreqRd_linvo" + idx
                                                }
                                                value={5}
                                                checked={
                                                  data.q40DosingFreqRd_linvo ===
                                                  5
                                                }
                                                onChange={HandleFieldChange}
                                              />

                                              <span
                                                style={{
                                                  marginLeft: "4px",
                                                  paddingRight: "15px",
                                                  marginBottom: "0px",
                                                  padding: "0",
                                                }}
                                              >
                                                Other frequency, please specify:
                                                <div
                                                  style={{
                                                    paddingLeft: "15px",
                                                    marginBottom: "0px",
                                                    padding: "0",
                                                  }}
                                                >
                                                  <textarea
                                                    name={
                                                      "dosing_Freq_Oth_Txt_linvo" +
                                                      idx
                                                    }
                                                    className="input-dash"
                                                    type="text"
                                                    value={
                                                      data.dosing_Freq_Oth_Txt_linvo
                                                    }
                                                    onChange={HandleFieldChange}
                                                    maxLength={300}
                                                    id={idx}
                                                  />
                                                </div>
                                              </span>
                                            </label>
                                          </div>

                                          <div
                                            className="option-without-input"
                                            style={{ display: "flex" }}
                                          >
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "q40DosingFreqRd_linvo" + idx
                                                }
                                                value={99}
                                                checked={
                                                  data.q40DosingFreqRd_linvo ===
                                                  99
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                Unknown
                                              </span>
                                            </label>
                                          </div>

                                          <ErrorField
                                            show={
                                              data.Q40LinvoDosingFreqEmptyHard
                                            }
                                            message={
                                              ELCharacteristics_MSGS.Q40DosingFreqEmptyHard
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />

                                          <ErrorField
                                            show={
                                              data.Q40LinvoDosingFreqTxtEmptyHard
                                            }
                                            message={
                                              ELCharacteristics_MSGS.Q40DosingFreqTxtEmptyHard
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                        </div>
                                      </td>
                                      {/* Last  IgG Level */}
                                      {data.q40DosingFreqRd_linvo !== 1 ? (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  style={{ marginTop: "6px" }}
                                                  id={idx}
                                                  name={
                                                    "q40IgILevelRd_linvo" + idx
                                                  }
                                                  value={1}
                                                  checked={
                                                    data.q40IgILevelRd_linvo ===
                                                    1
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  {"<"} 400 mg/dL
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "q40IgILevelRd_linvo" + idx
                                                  }
                                                  value={2}
                                                  checked={
                                                    data.q40IgILevelRd_linvo ===
                                                    2
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  400-500 mg/dL
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "q40IgILevelRd_linvo" + idx
                                                  }
                                                  value={3}
                                                  checked={
                                                    data.q40IgILevelRd_linvo ===
                                                    3
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  {">"} 500 mg/dL
                                                </span>
                                              </label>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "q40IgILevelRd_linvo" + idx
                                                  }
                                                  value={99}
                                                  checked={
                                                    data.q40IgILevelRd_linvo ===
                                                    99
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  className="radio-text-padding"
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  Unknown
                                                </span>
                                              </label>
                                            </div>

                                            <ErrorField
                                              show={data.Q40LinvoIgGEmptyHard}
                                              message={
                                                ELCharacteristics_MSGS.Q40IgGEmptyHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            textAlign: "center",
                                            padding: "8px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "center",
                                            }}
                                            className="not-applicable"
                                          >
                                            <b>Not applicable</b>
                                          </span>
                                        </td>
                                      )}
                                      {/* IVIG */}
                                      {data.q40DosingFreqRd_linvo !== 1 ? (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "q40Init_Dt_Rd_linvo" + idx
                                                }
                                                value={1}
                                                checked={
                                                  data.q40Init_Dt_Rd_linvo === 1
                                                }
                                                onChange={HandleFieldChange}
                                              />
                                              <span
                                                className="radio-text-padding"
                                                style={{
                                                  paddingLeft: "10px",
                                                  marginLeft: "-5px",
                                                }}
                                              >
                                                <DatePickerComponent
                                                  ctrlId={
                                                    "q40Init_Dt_linvo-" + idx
                                                  }
                                                  HandleDateChange={
                                                    HandleRepeaterDateChange
                                                  }
                                                  optionId={1}
                                                  minDate={dayjs("01-01-1920")}
                                                  maxDate={dayjs()}
                                                  locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                  date={data.q40Init_Dt_linvo}
                                                />
                                              </span>
                                            </div>

                                            <div
                                              className="option-without-input"
                                              style={{ display: "flex" }}
                                            >
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "q40Init_Dt_Rd_linvo" + idx
                                                  }
                                                  value={99}
                                                  checked={
                                                    data.q40Init_Dt_Rd_linvo ===
                                                    99
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  style={{
                                                    paddingLeft: "10px",
                                                    marginLeft: "-5px",
                                                  }}
                                                >
                                                  Date of initiation unknown
                                                </span>
                                              </label>
                                            </div>

                                            <ErrorField
                                              show={data.Q40LinvoInit_RdHard}
                                              message={
                                                ELCharacteristics_MSGS.Q40Init_RdHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />

                                            <ErrorField
                                              show={data.Q40LinvoInit_dtHard}
                                              message={
                                                ELCharacteristics_MSGS.Q40Init_dtHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                            <ErrorField
                                              show={
                                                data.invalidQ40Init_dt_linvo
                                              }
                                              message={
                                                CommonError_Msgs.InvalidDate
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                            <ErrorField
                                              show={
                                                data.init_dt_before_eof_linvo
                                              }
                                              message={
                                                ELCharacteristics_MSGS.Q40DateOutOfRange
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            textAlign: "center",
                                            padding: "8px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "center",
                                            }}
                                            className="not-applicable"
                                          >
                                            <b>Not applicable</b>
                                          </span>
                                        </td>
                                      )}
                                      {/* Medication Reason */}
                                      {data.q40DosingFreqRd_linvo !== 1 ? (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                          }}
                                        >
                                          <div>
                                            <div className="">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={
                                                    "primaryProf_linvo" + idx
                                                  }
                                                  checked={
                                                    data.primaryProf_linvo
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: "6px",
                                                  }}
                                                >
                                                  Primary prophylactic for
                                                  <span className="radio-text-padding">
                                                    infections
                                                  </span>
                                                </span>
                                              </label>
                                            </div>

                                            <div className="">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={
                                                    "secondaryProf_linvo" + idx
                                                  }
                                                  checked={
                                                    data.secondaryProf_linvo
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: "6px",
                                                  }}
                                                >
                                                  Secondary prophylactic{" "}
                                                  <span className="radio-text-padding">
                                                    for infections
                                                  </span>
                                                </span>
                                              </label>
                                            </div>

                                            <div className="">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  id={idx}
                                                  name={
                                                    "otherReson_linvo" + idx
                                                  }
                                                  checked={
                                                    data.otherReson_linvo
                                                  }
                                                  onChange={HandleFieldChange}
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: "6px",
                                                  }}
                                                >
                                                  Other reason
                                                </span>
                                              </label>
                                            </div>

                                            <ErrorField
                                              show={
                                                data.Q40LinvoReasonEmptyHard
                                              }
                                              message={
                                                ELCharacteristics_MSGS.Q40ReasonEmptyHard
                                              }
                                              style={{ paddingLeft: "0px" }}
                                            />
                                          </div>
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            textAlign: "center",
                                            padding: "8px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "center",
                                            }}
                                            className="not-applicable"
                                          >
                                            <b>Not applicable</b>
                                          </span>
                                        </td>
                                      )}
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* 40 end */}
                  </div>
                </div>
              </div>

              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default ELCharacteristics;
